
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("76rrf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "DashboardsDirectory", () => $7e314b16f81b049a$export$6b6b79c824d04932);
$parcel$export(module.exports, "default", () => $7e314b16f81b049a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("3avtZ");

var $iFYlf = parcelRequire("iFYlf");

var $k5Cox = parcelRequire("k5Cox");

var $4041n = parcelRequire("4041n");

var $kUACW = parcelRequire("kUACW");

var $4yCf0 = parcelRequire("4yCf0");

var $4dRjY = parcelRequire("4dRjY");

var $9OXo1 = parcelRequire("9OXo1");

var $l8ruj = parcelRequire("l8ruj");

var $2YP9W = parcelRequire("2YP9W");
var $1bQGJ = parcelRequire("1bQGJ");

var $7P6O7 = parcelRequire("7P6O7");
const $7e314b16f81b049a$var$useDashboardsDirectoryResource = (0, $kUACW.withSuspense)(()=>(0, $2YP9W.useResource)((0, $4yCf0.dashboardsDirectoryResource)));
const $7e314b16f81b049a$export$6b6b79c824d04932 = ({ location: location })=>{
    const state = $7e314b16f81b049a$var$useDashboardsDirectoryResource();
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k5Cox.default), {
        location: location
    }, ({ query: query, onQueryChanged: onQueryChanged })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4041n.FavoriteChangeConsumer), null, (favoriteChangeContext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
                name: "dashboards-directory"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7P6O7.default), {
                tenantContext: tenantContext,
                prefetchResult: {
                    ...state
                },
                favoriteChangeContext: favoriteChangeContext,
                query: query,
                onQueryChanged: onQueryChanged
            }))));
};
// @ts-expect-error - TS2322 - Type '{ (props: RouteContext & { history: BrowserHistory; }): Element; displayName: string; }' is not assignable to type 'ComponentType<Record<any, any>>'.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7e314b16f81b049a$var$RouterWrapper = (0, $1bQGJ.withRouter)($7e314b16f81b049a$export$6b6b79c824d04932);
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$7e314b16f81b049a$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4dRjY.MarkProductStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iFYlf.default), {
        appNameSuffixForV2Event: "directory.dashboards",
        appNameForV3OperationalEvent: "dashboardsDirectory"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7e314b16f81b049a$var$RouterWrapper, props));

});
parcelRegister("iFYlf", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d4f9fac2e290ba9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $isuse = parcelRequire("isuse");
const $3d4f9fac2e290ba9$var$fireGasV2AndGasV3Analytics = (appNameSuffixForV2Event, appNameForV3OperationalEvent)=>(analyticsEvent)=>{
        (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, `${appNameForV3OperationalEvent} pageInitialised`);
    };
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3d4f9fac2e290ba9$export$2e2bcd8739ae039 = ({ appNameSuffixForV2Event: appNameSuffixForV2Event, appNameForV3OperationalEvent: appNameForV3OperationalEvent })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: ""
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $isuse.MountEvent), {
        onMount: $3d4f9fac2e290ba9$var$fireGasV2AndGasV3Analytics(appNameSuffixForV2Event, appNameForV3OperationalEvent)
    }));

});
// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';


parcelRegister("k5Cox", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8466775b16d84a1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iJPdQ = parcelRequire("iJPdQ");

var $FqCjF = parcelRequire("FqCjF");

var $8Lol0 = parcelRequire("8Lol0");

var $jSGZR = parcelRequire("jSGZR");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e8466775b16d84a1$export$2e2bcd8739ae039 = ({ location: location, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iJPdQ.default), {
        location: location,
        sortFieldToParam: (0, $jSGZR.sortFieldToParam),
        sortFieldFromParam: (0, $jSGZR.sortFieldFromParam),
        filterFromParams: (0, $8Lol0.filterFromParams),
        filterToParams: (0, $8Lol0.filterToParams),
        defaultQuery: (0, $FqCjF.initialQuery)
    }, children);

});
parcelRegister("iJPdQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $34933f66e78f501b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $67TwH = parcelRequire("67TwH");

var $4P5qU = parcelRequire("4P5qU");

var $cd2Ri = parcelRequire("cd2Ri");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$34933f66e78f501b$export$2e2bcd8739ae039 = ({ location: location, children: children, sortFieldFromParam: sortFieldFromParam, filterFromParams: filterFromParams, sortFieldToParam: sortFieldToParam, filterToParams: filterToParams, defaultQuery: defaultQuery })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $67TwH.default), {
        location: location,
        queryFromUrl: (0, $cd2Ri.default)(sortFieldFromParam, filterFromParams),
        queryToUrl: (0, $4P5qU.default)(sortFieldToParam, filterToParams),
        defaultQuery: defaultQuery
    }, children);

});
parcelRegister("67TwH", function(module, exports) {

$parcel$export(module.exports, "default", () => $41e75e9a90d3818a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hJCUd = parcelRequire("hJCUd");

var $8Rkzz = parcelRequire("8Rkzz");

var $ebyGx = parcelRequire("ebyGx");

var $5y0F0 = parcelRequire("5y0F0");

var $6wlPy = parcelRequire("6wlPy");

var $aJXmP = parcelRequire("aJXmP");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$41e75e9a90d3818a$export$2e2bcd8739ae039 = ({ location: location, children: children, queryToUrl: queryToUrl, queryFromUrl: queryFromUrl, defaultQuery: defaultQuery })=>{
    const toQuery = (search)=>(0, (/*@__PURE__*/$parcel$interopDefault($hJCUd)))((0, $6wlPy.default)(queryFromUrl)((0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(search)), defaultQuery);
    const replaceUrl = (// @ts-expect-error - TS2304 - Cannot find name 'Href'.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    replace, query, prevParams)=>replace(`?${(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify({
            ...prevParams,
            ...queryToUrl(query)
        })}`, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5y0F0.RouterActions), null, ({ replace: replace })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aJXmP.AdapterWithState), {
            search: location.search,
            toQuery: (search)=>toQuery(search),
            onChange: false ? (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) : (query, prevParams)=>replaceUrl(replace, query, prevParams)
        }, children));
};

});
parcelRegister("6wlPy", function(module, exports) {

$parcel$export(module.exports, "default", () => $c011c7ab8644dae0$export$2e2bcd8739ae039);

var $basmW = parcelRequire("basmW");

var $dPSWJ = parcelRequire("dPSWJ");
const $c011c7ab8644dae0$var$fromUrlTransformerFactory = (transformer)=>(0, (/*@__PURE__*/$parcel$interopDefault($basmW)))([
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (params)=>(0, (/*@__PURE__*/$parcel$interopDefault($dPSWJ)))(params, (p)=>Array.isArray(p) ? p[0] : p),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (params)=>transformer(params)
    ]);
var $c011c7ab8644dae0$export$2e2bcd8739ae039 = $c011c7ab8644dae0$var$fromUrlTransformerFactory;

});
parcelRegister("dPSWJ", function(module, exports) {

var $1m3dq = parcelRequire("1m3dq");

var $hDnyx = parcelRequire("hDnyx");

var $bxDef = parcelRequire("bxDef");
/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $a12aa8fd8ab9a7da$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $bxDef(iteratee, 3);
    $hDnyx(object, function(value, key, object) {
        $1m3dq(result, key, iteratee(value, key, object));
    });
    return result;
}
module.exports = $a12aa8fd8ab9a7da$var$mapValues;

});


parcelRegister("aJXmP", function(module, exports) {

$parcel$export(module.exports, "AdapterWithState", () => $1acd1d8f1a4e9958$export$2fcc0cb3ae18b63e);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $ebyGx = parcelRequire("ebyGx");
class $1acd1d8f1a4e9958$export$2fcc0cb3ae18b63e extends (0, $5uXOq.Component) {
    static getDerivedStateFromProps(props, state) {
        if (props.search !== state.prevSearch) return {
            query: props.toQuery(props.search),
            prevSearch: props.search
        };
        return null;
    }
    componentDidUpdate(prevProps, prevState) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(prevState.query, this.state.query)) {
            const prevParams = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(prevState.prevSearch);
            this.props.onChange(this.state.query, prevParams);
        }
    }
    render() {
        return this.props.children({
            query: this.state.query,
            onQueryChanged: this.onQueryChanged
        });
    }
    constructor(...args){
        super(...args), this.state = {
            query: this.props.toQuery(this.props.search),
            prevSearch: this.props.search
        }, this.onQueryChanged = (query)=>{
            this.setState({
                query: query
            });
        };
    }
}

});


parcelRegister("4P5qU", function(module, exports) {

$parcel$export(module.exports, "default", () => $053ceb3ca02e043a$export$2e2bcd8739ae039);

var $27NS3 = parcelRequire("27NS3");

var $aud83 = parcelRequire("aud83");
const $053ceb3ca02e043a$var$toUrlTransformerFactory = (sortFieldTransformer, filterTransformer)=>{
    const valueTransformers = {
        // @ts-expect-error - TS7006 - Parameter 'page' implicitly has an 'any' type.
        page: (page)=>({
                page: (0, $aud83.number).stringify(page)
            }),
        // @ts-expect-error - TS7006 - Parameter 'dir' implicitly has an 'any' type.
        sortDirection: (dir)=>({
                sortOrder: (0, $aud83.string).stringify(dir)
            }),
        // @ts-expect-error - TS7006 - Parameter 'field' implicitly has an 'any' type.
        sortField: (field)=>({
                sortKey: sortFieldTransformer(field)
            }),
        filter: filterTransformer
    };
    return (query)=>(0, (/*@__PURE__*/$parcel$interopDefault($27NS3)))(query, (params, value, key)=>// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ page: (page: any) => { page: string; }; sortDirection: (dir: any) => { sortOrder: any; }; sortField: (field: any) => { sortKey: string; }; filter: FilterToParamTransformer<TFilter>; }'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ page: (page: any) => { page: string; }; sortDirection: (dir: any) => { sortOrder: any; }; sortField: (field: any) => { sortKey: string; }; filter: FilterToParamTransformer<TFilter>; }'.
            valueTransformers[key] ? {
                ...params,
                ...valueTransformers[key](value)
            } : params, {});
};
var $053ceb3ca02e043a$export$2e2bcd8739ae039 = $053ceb3ca02e043a$var$toUrlTransformerFactory;

});
parcelRegister("27NS3", function(module, exports) {

var $2YkAc = parcelRequire("2YkAc");

var $e7pfQ = parcelRequire("e7pfQ");

var $bxDef = parcelRequire("bxDef");

var $87mh8 = parcelRequire("87mh8");

var $8LQ84 = parcelRequire("8LQ84");
/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */ function $18c2eb891b6f17d9$var$reduce(collection, iteratee, accumulator) {
    var func = $8LQ84(collection) ? $2YkAc : $87mh8, initAccum = arguments.length < 3;
    return func(collection, $bxDef(iteratee, 4), accumulator, initAccum, $e7pfQ);
}
module.exports = $18c2eb891b6f17d9$var$reduce;

});
parcelRegister("87mh8", function(module, exports) {
/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */ function $5e90419f1ca7764f$var$baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
        accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
}
module.exports = $5e90419f1ca7764f$var$baseReduce;

});



parcelRegister("cd2Ri", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ae9eca70c694773$export$2e2bcd8739ae039);

var $basmW = parcelRequire("basmW");

var $dPSWJ = parcelRequire("dPSWJ");

var $27NS3 = parcelRequire("27NS3");

var $k15gu = parcelRequire("k15gu");

var $aud83 = parcelRequire("aud83");
const $5ae9eca70c694773$var$fromUrlTransformerFactory = (sortFieldTransformer, filterTransformer)=>{
    const transformers = {
        // @ts-expect-error - TS7006 - Parameter 'page' implicitly has an 'any' type.
        page: (page)=>(0, $k15gu.validatePageNumber)((0, $aud83.number).parse(page)) ? {
                page: (0, $aud83.number).parse(page)
            } : {},
        // @ts-expect-error - TS7006 - Parameter 'order' implicitly has an 'any' type.
        sortOrder: (order)=>(0, $k15gu.validateSortDirection)(order) ? {
                sortDirection: order
            } : {},
        // @ts-expect-error - TS7006 - Parameter 'key' implicitly has an 'any' type.
        sortKey: (key)=>sortFieldTransformer(key) ? {
                sortField: sortFieldTransformer(key)
            } : {}
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))([
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (params)=>(0, (/*@__PURE__*/$parcel$interopDefault($dPSWJ)))(params, (p)=>Array.isArray(p) ? p[0] : p),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (params)=>(0, (/*@__PURE__*/$parcel$interopDefault($27NS3)))(params, (query, value, key)=>// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ page: (page: any) => { page: number; } | { page?: undefined; }; sortOrder: (order: any) => { sortDirection: any; } | { sortDirection?: undefined; }; sortKey: (key: any) => { sortField: TSortField | null; } | { ...; }; }'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ page: (page: any) => { page: number; } | { page?: undefined; }; sortOrder: (order: any) => { sortDirection: any; } | { sortDirection?: undefined; }; sortKey: (key: any) => { sortField: TSortField | null; } | { ...; }; }'.
                transformers[key] ? {
                    ...query,
                    ...transformers[key](value)
                } : query, {
                filter: filterTransformer(params)
            })
    ]);
};
var $5ae9eca70c694773$export$2e2bcd8739ae039 = $5ae9eca70c694773$var$fromUrlTransformerFactory;

});
parcelRegister("k15gu", function(module, exports) {

$parcel$export(module.exports, "calculateTotalPages", () => $871ef586a0cb0e22$export$fba88641b8ab6cd8);
$parcel$export(module.exports, "predictPageToRequestAfterItemDeletion", () => $871ef586a0cb0e22$export$3179e82a0f1565e1);
$parcel$export(module.exports, "validatePageNumber", () => $871ef586a0cb0e22$export$231cde03e0d8b537);
$parcel$export(module.exports, "validateSortDirection", () => $871ef586a0cb0e22$export$407c10b4791d7a16);

const $871ef586a0cb0e22$export$fba88641b8ab6cd8 = (totalItems, itemsPerPage)=>Math.max(Math.ceil(totalItems / itemsPerPage), 1);
const $871ef586a0cb0e22$export$3179e82a0f1565e1 = (itemsPerPage, totalItems, currentPage = 1, itemsRemoved = 1)=>{
    const maxPossiblePage = $871ef586a0cb0e22$export$fba88641b8ab6cd8(totalItems - itemsRemoved, itemsPerPage);
    return currentPage > maxPossiblePage ? maxPossiblePage : currentPage;
};
const $871ef586a0cb0e22$export$231cde03e0d8b537 = (input)=>typeof input === 'number' && Number.isInteger(input) && input >= 1;
const $871ef586a0cb0e22$export$407c10b4791d7a16 = (input)=>[
        (0, $2a9e000a443b1a95$export$1dee026a19752d6b),
        (0, $2a9e000a443b1a95$export$b6abcf7fa1d94f65)
    ].includes(input);

});
const $2a9e000a443b1a95$export$1dee026a19752d6b = 'ASC';
const $2a9e000a443b1a95$export$b6abcf7fa1d94f65 = 'DESC';




parcelRegister("FqCjF", function(module, exports) {

$parcel$export(module.exports, "initialQuery", () => $054916e7cab7f066$export$8af7177c92ae79e3);


var $48oUo = parcelRequire("48oUo");
const $054916e7cab7f066$export$8af7177c92ae79e3 = {
    sortField: (0, $48oUo.NAME),
    sortDirection: (0, $2a9e000a443b1a95$export$1dee026a19752d6b),
    page: 1,
    filter: {
        text: undefined,
        project: undefined,
        group: undefined,
        owner: undefined
    }
};

});
parcelRegister("48oUo", function(module, exports) {

$parcel$export(module.exports, "FAVOURITED", () => $ec8c71706ab80050$export$fdb541a0853ce91e);
$parcel$export(module.exports, "NAME", () => $ec8c71706ab80050$export$3c5e605ca7ade9f2);
$parcel$export(module.exports, "OWNER", () => $ec8c71706ab80050$export$8c6af90262e3c6cd);
$parcel$export(module.exports, "POPULARITY", () => $ec8c71706ab80050$export$baf77a5a5061f88f);
$parcel$export(module.exports, "SORT_FIELDS", () => $ec8c71706ab80050$export$5866f21b947884b4);
const $ec8c71706ab80050$export$fdb541a0853ce91e = 'favourite';
const $ec8c71706ab80050$export$3c5e605ca7ade9f2 = 'name';
const $ec8c71706ab80050$export$8c6af90262e3c6cd = 'owner';
const $ec8c71706ab80050$export$baf77a5a5061f88f = 'popularity';
const $ec8c71706ab80050$export$5866f21b947884b4 = {
    [$ec8c71706ab80050$export$3c5e605ca7ade9f2]: 'NAME',
    [$ec8c71706ab80050$export$8c6af90262e3c6cd]: 'OWNER',
    [$ec8c71706ab80050$export$fdb541a0853ce91e]: 'IS_FAVOURITE',
    [$ec8c71706ab80050$export$baf77a5a5061f88f]: 'FAVOURITE_COUNT'
};

});


parcelRegister("8Lol0", function(module, exports) {

$parcel$export(module.exports, "filterToParams", () => $1574ecec5017b426$export$cb128e46cc7ba0f1);
$parcel$export(module.exports, "filterFromParams", () => $1574ecec5017b426$export$f6542f27c27241c6);
const $1574ecec5017b426$export$cb128e46cc7ba0f1 = ({ group: group, owner: owner, project: project, text: text } = {})=>({
        name: text || undefined,
        owner: owner && owner.accountId || undefined,
        selectedProject: project && project.value || 'anything',
        selectedGroup: group && group.value || 'anything'
    });
const $1574ecec5017b426$var$transformSelectedOwner = (input)=>input ? {
        accountId: input
    } : undefined;
const $1574ecec5017b426$var$transformSelectedProject = (input)=>input && input !== 'anything' ? {
        value: input
    } : undefined;
const $1574ecec5017b426$var$transformSelectedGroup = (input)=>input && input !== 'anything' ? {
        value: input,
        name: input
    } : undefined;
const $1574ecec5017b426$export$f6542f27c27241c6 = (params)=>({
        text: params.name || params.searchName || undefined,
        owner: $1574ecec5017b426$var$transformSelectedOwner(params.owner),
        project: $1574ecec5017b426$var$transformSelectedProject(params.selectedProject),
        group: $1574ecec5017b426$var$transformSelectedGroup(params.selectedGroup)
    });

});

parcelRegister("jSGZR", function(module, exports) {

$parcel$export(module.exports, "sortFieldToParam", () => $4e10fb9bc97fb6e0$export$9a7ae3517c7d79c2);
$parcel$export(module.exports, "sortFieldFromParam", () => $4e10fb9bc97fb6e0$export$307ee63ec20d9c92);

var $48oUo = parcelRequire("48oUo");
const $4e10fb9bc97fb6e0$var$sortFieldMap = {
    [(0, $48oUo.NAME).toLowerCase()]: (0, $48oUo.NAME),
    [(0, $48oUo.OWNER).toLowerCase()]: (0, $48oUo.OWNER),
    [(0, $48oUo.POPULARITY).toLowerCase()]: (0, $48oUo.POPULARITY),
    [(0, $48oUo.FAVOURITED).toLowerCase()]: (0, $48oUo.FAVOURITED)
};
const $4e10fb9bc97fb6e0$export$9a7ae3517c7d79c2 = (field)=>field.toLowerCase();
const $4e10fb9bc97fb6e0$export$307ee63ec20d9c92 = (param)=>$4e10fb9bc97fb6e0$var$sortFieldMap[param] ? $4e10fb9bc97fb6e0$var$sortFieldMap[param] : null;

});


parcelRegister("kUACW", function(module, exports) {

$parcel$export(module.exports, "withSuspense", () => $4c5a941fc6e9229e$export$a3bce93d4fb4eda6);
const $4c5a941fc6e9229e$var$isDataEmpty = (data)=>data == null;
function $4c5a941fc6e9229e$export$a3bce93d4fb4eda6(theHook) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (...args)=>{
        const result = theHook(...args);
        if (!false && $4c5a941fc6e9229e$var$isDataEmpty(result.data) && result.loading) throw result.promise;
        return result;
    };
}

});

parcelRegister("4dRjY", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $9953c23a4f71adac$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $9953c23a4f71adac$export$2a999c5f84501025);

var $x9xyg = parcelRequire("x9xyg");
const $9953c23a4f71adac$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $9953c23a4f71adac$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($9953c23a4f71adac$export$8e54fca0a680fdfd);
        (0, $x9xyg.setMark)($9953c23a4f71adac$export$8e54fca0a680fdfd);
    }
    return null;
};

});

parcelRegister("7P6O7", function(module, exports) {

$parcel$export(module.exports, "default", () => $319467e0164dc4de$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9sGI6 = parcelRequire("9sGI6");

var $9dbF6 = parcelRequire("9dbF6");

var $k7sbS = parcelRequire("k7sbS");
const $319467e0164dc4de$export$3386beb5bc3bfa = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9dbF6.SubProductUpdater), {
        subProduct: "platform"
    });
var $319467e0164dc4de$export$2e2bcd8739ae039 = (0, $9sGI6.default)((0, $k7sbS.default), {
    Updater: $319467e0164dc4de$export$3386beb5bc3bfa
});

});
parcelRegister("9dbF6", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $5979c081afa32bfa$export$eb40d3df56aa5c53);

var $5uXOq = parcelRequire("5uXOq");

var $5h5Fg = parcelRequire("5h5Fg");

var $16v4H = parcelRequire("16v4H");

var $3iTiR = parcelRequire("3iTiR");

var $54I24 = parcelRequire("54I24");

var $8OHH4 = parcelRequire("8OHH4");
const $5979c081afa32bfa$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $8OHH4.isSubProductProps)(props) ? props.subProduct : (0, $16v4H.subProductFromProjectTypeForAnalytics)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5h5Fg.default), {
        op: (0, $54I24.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3iTiR.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("3iTiR", function(module, exports) {

$parcel$export(module.exports, "default", () => $1214b0731559b377$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $01Rn4 = parcelRequire("01Rn4");

var $hFChZ = parcelRequire("hFChZ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1214b0731559b377$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $01Rn4.default), {
        op: (0, $hFChZ.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("hFChZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e606430ead76cd8$export$2e2bcd8739ae039);

var $2YZCu = parcelRequire("2YZCu");

var $eusud = parcelRequire("eusud");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0e606430ead76cd8$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $eusud.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("54I24", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcbbcd48ca398ed4$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $7T84i = parcelRequire("7T84i");
var $9B86Q = parcelRequire("9B86Q");
var $cQZXC = parcelRequire("cQZXC");


var $2YZCu = parcelRequire("2YZCu");

var $fjcgS = parcelRequire("fjcgS");
const $bcbbcd48ca398ed4$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bcbbcd48ca398ed4$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $86344d58e71e925a$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $bcbbcd48ca398ed4$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $cQZXC.waitForHeritage)() : null, ()=>(0, $7T84i.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $9B86Q.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $2YZCu.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $86344d58e71e925a$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("8OHH4", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $701d07b56c3e3574$export$c3063d6d7a8c075f);
const $701d07b56c3e3574$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';

});


parcelRegister("k7sbS", function(module, exports) {

$parcel$export(module.exports, "default", () => $b600a91c5a2a23ca$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $jzjy1 = parcelRequire("jzjy1");

var $iO0x0 = parcelRequire("iO0x0");

var $i2Rm5 = parcelRequire("i2Rm5");

var $7iJwP = parcelRequire("7iJwP");


var $8PRuf = parcelRequire("8PRuf");

var $5rqex = parcelRequire("5rqex");

var $cFtGt = parcelRequire("cFtGt");

var $fhVq7 = parcelRequire("fhVq7");

var $dPVaE = parcelRequire("dPVaE");
function $b600a91c5a2a23ca$var$DashboardsDirectory({ Updater: Updater, tenantContext: tenantContext, prefetchResult: prefetchResult, favoriteChangeContext: favoriteChangeContext, query: query, onQueryChanged: onQueryChanged }) {
    const { baseUrl: baseUrl, locale: locale, atlassianAccountId: atlassianAccountId, xsrfToken: xsrfToken } = tenantContext;
    const { error: prefetchError, loading: loading, data: data } = prefetchResult;
    if (prefetchError && !loading) // @ts-expect-error - TS2322 - Type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error)' is not assignable to type 'Error | null'.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i2Rm5.ErrorFlagRenderer), {
        id: "directories-dashboards",
        error: prefetchError
    });
    if (!data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cFtGt.DashboardsDirectorySkeleton), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fhVq7.PageLayout), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iJwP.default), {
        id: "unhandled",
        packageName: "jiraSpaAppsDirectoriesDashboards",
        teamName: "jira-cosmos"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Updater, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iO0x0.default), {
        baseUrl: baseUrl,
        accountId: atlassianAccountId,
        locale: locale,
        query: query,
        favoriteChangeContext: favoriteChangeContext,
        prefetchedData: data,
        onQueryChanged: onQueryChanged,
        onUnmount: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        withPageReadyMetrics: false,
        xsrfToken: xsrfToken
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5rqex.default), {
        metricKey: "jira.directories.dashboards",
        metric: (0, $dPVaE.dashboardsDirectoryPageLoad),
        isExpectedToHaveSsr: true,
        withMarks: [
            (0, $8PRuf.appBundleReadyMark),
            (0, $8PRuf.prefetchApiReadyMark)
        ]
    })));
}
var $b600a91c5a2a23ca$export$2e2bcd8739ae039 = (0, $jzjy1.AnalyticsSource)('dashboards', (0, $4d5e0871c06cee03$export$f636b5b56f1d624a))($b600a91c5a2a23ca$var$DashboardsDirectory);

});
parcelRegister("iO0x0", function(module, exports) {

$parcel$export(module.exports, "default", () => $61e0701fd145a663$export$2e2bcd8739ae039);

var $basmW = parcelRequire("basmW");

var $7CwOv = parcelRequire("7CwOv");

var $gbl0G = parcelRequire("gbl0G");

var $iXhl0 = parcelRequire("iXhl0");

var $az4zD = parcelRequire("az4zD");

var $dldm2 = parcelRequire("dldm2");
var $61e0701fd145a663$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $az4zD.injectIntlV2), (0, $7CwOv.default)({
    CreateButton: $gbl0G.default,
    DashboardsDirectory: $iXhl0.default
}))((0, $dldm2.default));

});
parcelRegister("7CwOv", function(module, exports) {

$parcel$export(module.exports, "default", () => $391d7d0ab8daaa90$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $391d7d0ab8daaa90$var$isEmpty = (s)=>s === undefined || s === null || s === '';
const $391d7d0ab8daaa90$var$getDisplayName = (x)=>{
    // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
    if (!$391d7d0ab8daaa90$var$isEmpty(x.displayName)) return x.displayName;
    if (!$391d7d0ab8daaa90$var$isEmpty(x.name)) return x.name;
    return 'Component';
};
const $391d7d0ab8daaa90$export$19c55c6cefb3b57 = (defaults)=>(Component)=>{
        const displayName = $391d7d0ab8daaa90$var$getDisplayName(Component);
        // @ts-expect-error - TS2698 - Spread types may only be created from object types. | TS2698 - Spread types may only be created from object types.
        const WithProps = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
                ...defaults,
                ...props
            });
        WithProps.displayName = `WithProps(${displayName})`;
        // @ts-expect-error - TS2322 - Type '{ (props: Partial<A> & B): JSX.Element; displayName: string; }' is not assignable to type 'AbstractComponent<Partial<A> & B, unknown>'.
        return WithProps;
    };
var $391d7d0ab8daaa90$export$2e2bcd8739ae039 = $391d7d0ab8daaa90$export$19c55c6cefb3b57;

});

parcelRegister("gbl0G", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ee68a96e8fdc0d6$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $jD5no = parcelRequire("jD5no");

var $lf2Au = parcelRequire("lf2Au");

var $7iJwP = parcelRequire("7iJwP");

var $16FIV = parcelRequire("16FIV");
const $0ee68a96e8fdc0d6$var$CreateButton = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), {
        id: "directories.dashboards-v2.create-button",
        hasErrorBoundary: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iJwP.default), {
        id: "unhandled",
        packageName: "jiraCreateDashboardsButton",
        teamName: "jira-cosmos"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lf2Au.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $16FIV.default), {
        baseUrl: props.baseUrl,
        onClick: props.onClick
    }))));
$0ee68a96e8fdc0d6$var$CreateButton.defaultProps = {
    onClick: undefined
};
var $0ee68a96e8fdc0d6$export$2e2bcd8739ae039 = $0ee68a96e8fdc0d6$var$CreateButton;

});
parcelRegister("16FIV", function(module, exports) {

$parcel$export(module.exports, "default", () => $fdbefc1af8d184e7$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $basmW = parcelRequire("basmW");

var $8Rkzz = parcelRequire("8Rkzz");

var $fVnbM = parcelRequire("fVnbM");

var $3bDjY = parcelRequire("3bDjY");

var $iQv12 = parcelRequire("iQv12");

var $jgE05 = parcelRequire("jgE05");

var $az4zD = parcelRequire("az4zD");

var $jRhyQ = parcelRequire("jRhyQ");

var $9OXo1 = parcelRequire("9OXo1");

var $lVJAU = parcelRequire("lVJAU");

var $4gtCz = parcelRequire("4gtCz");
const $fdbefc1af8d184e7$var$CreateButtonWithModal = ({ onClick: onClick, intl: { formatMessage: formatMessage } })=>{
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const navigateToDashboard = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7006 - Parameter 'id' implicitly has an 'any' type.
    (id)=>{
        push(`/jira/dashboards/${id}/edit`);
    }, [
        push
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>tenantContext.atlassianAccountId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jRhyQ.ModalsContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jRhyQ.ModalsSubscriber), null, (isOpen, { open: open, close: close })=>{
            // @ts-expect-error - TS2304 - Cannot find name 'DashboardOperationData'. | TS7031 - Binding element 'id' implicitly has an 'any' type.
            const onSuccess = (_, { id: id })=>{
                navigateToDashboard(id);
                close();
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                // @ts-expect-error - TS2322 - Type '(e: Event, analyticsEvent: UIAnalyticsEventInterface) => void | Promise<void>' is not assignable to type '(e: MouseEvent<HTMLElement, MouseEvent>, analyticsEvent: UIAnalyticsEvent) => void'.
                onClick: (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))(onClick, open),
                appearance: "primary",
                externalId: "directory.dashboards-v2.create-button" // eslint-disable-next-line jira/integration/test-id-by-folder-structure
                ,
                "data-test-id": "directory.dashboards-v2.create-button"
            }, formatMessage((0, $4gtCz.default).createDashboard)), isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgE05.default), {
                onSuccess: onSuccess,
                onCancel: close
            }));
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: formatMessage((0, $4gtCz.default).notAllowed)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            isDisabled: true,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            appearance: "primary"
        }, formatMessage((0, $4gtCz.default).createDashboard))));
};
const $fdbefc1af8d184e7$export$6d3c345ce7c38fd9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fdbefc1af8d184e7$var$CreateButtonWithModal, props);
$fdbefc1af8d184e7$export$6d3c345ce7c38fd9.defaultProps = {
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
var $fdbefc1af8d184e7$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $iQv12.default)({
    onClick: 'createDashboard'
}), (0, $az4zD.injectIntlV2))($fdbefc1af8d184e7$export$6d3c345ce7c38fd9);

});
parcelRegister("jRhyQ", function(module, exports) {

$parcel$export(module.exports, "ModalsContainer", () => $152d7073d856bfc3$export$5dffa5a5319be22d);
$parcel$export(module.exports, "ModalsSubscriber", () => $152d7073d856bfc3$export$facc296933ebcadf);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $51nlc = parcelRequire("51nlc");

var $kUiaM = parcelRequire("kUiaM");
const $152d7073d856bfc3$export$5dffa5a5319be22d = (0, $gg7kZ.createContainer)((0, $kUiaM.default));
const $152d7073d856bfc3$export$facc296933ebcadf = (0, $51nlc.createSubscriber)((0, $kUiaM.default), {
    displayName: 'ModalsSubscriber',
    selector: (state)=>state.isOpen
});

});
parcelRegister("kUiaM", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec5c09c48029799e$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iXqE5 = parcelRequire("iXqE5");

var $cm0Ue = parcelRequire("cm0Ue");
const $ec5c09c48029799e$var$initialState = {
    isOpen: false
};
var $ec5c09c48029799e$export$2e2bcd8739ae039 = (0, $iXqE5.createStore)({
    name: 'modals',
    initialState: $ec5c09c48029799e$var$initialState,
    actions: $cm0Ue.default
});

});
parcelRegister("cm0Ue", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e9c601ffd9af0af$export$2e2bcd8739ae039);
const $7e9c601ffd9af0af$var$actions = {
    open: ()=>({ setState: setState })=>{
            setState({
                isOpen: true
            });
        },
    close: ()=>({ setState: setState })=>{
            setState({
                isOpen: false
            });
        }
};
var $7e9c601ffd9af0af$export$2e2bcd8739ae039 = $7e9c601ffd9af0af$var$actions;

});



parcelRegister("4gtCz", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c993506042e3368$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2c993506042e3368$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createDashboard: {
        "id": "directories.dashboards-v2.create-button.create-dashboard",
        "defaultMessage": "Create dashboard"
    },
    notAllowed: {
        "id": "directories.dashboards-v2.create-button.not-allowed",
        "defaultMessage": "You must be logged in to create dashboards"
    }
});

});



parcelRegister("iXhl0", function(module, exports) {

$parcel$export(module.exports, "default", () => $925ef9065fef4869$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $hZHze = parcelRequire("hZHze");

var $jD5no = parcelRequire("jD5no");

var $lf2Au = parcelRequire("lf2Au");

var $7iJwP = parcelRequire("7iJwP");

var $FqCjF = parcelRequire("FqCjF");

var $8MGRC = parcelRequire("8MGRC");

var $2n11n = parcelRequire("2n11n");

var $j8zRR = parcelRequire("j8zRR");

var $kLEu8 = parcelRequire("kLEu8");

var $86Nrx = parcelRequire("86Nrx");

var $9XYDI = parcelRequire("9XYDI");

var $eLJM4 = parcelRequire("eLJM4");

var $2EXat = parcelRequire("2EXat");
class $925ef9065fef4869$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            query: undefined,
            withPageReadyMetrics: true,
            prefetchedData: {},
            onUnmount: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onQueryChanged: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    constructor(props){
        super(props);
        this.store = (0, $9XYDI.default)((0, $2n11n.default));
        const { dispatch: dispatch } = this.store;
        const { dashboards: dashboards } = props.prefetchedData;
        dispatch((0, $j8zRR.setAppProps)(props));
        dispatch((0, $86Nrx.setQuery)(props.query || (0, $FqCjF.initialQuery)));
        if (dashboards) dispatch((0, $kLEu8.retrieved)(dashboards));
    }
    componentDidMount() {
        const { dispatch: dispatch } = this.store;
        const { dashboards: dashboards } = this.props.prefetchedData;
        if (!dashboards) dispatch((0, $kLEu8.retrieve)());
    }
    componentDidUpdate() {
        this.store.dispatch((0, $j8zRR.setAppProps)(this.props));
        // @ts-expect-error - TS2345 - Argument of type 'Partial<Query>' is not assignable to parameter of type 'Query'.
        if (this.props.query && (0, $8MGRC.isQueryChanged)(this.props.query, (0, $eLJM4.getQuery)(this.store.getState()))) {
            this.store.dispatch((0, $86Nrx.setQuery)(this.props.query));
            this.store.dispatch((0, $kLEu8.retrieve)());
        }
    }
    componentWillUnmount() {
        this.props.onUnmount();
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), {
            store: this.store,
            hasErrorBoundary: false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iJwP.default), {
            id: "unhandled",
            packageName: "jiraDashboardsMain",
            teamName: "jira-cosmos"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hZHze.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lf2Au.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2EXat.default), null))));
    }
}

});
parcelRegister("8MGRC", function(module, exports) {

$parcel$export(module.exports, "isQueryChanged", () => $f20175a510925d76$export$dcc7e61e8982458d);

var $ajpes = parcelRequire("ajpes");
const $f20175a510925d76$var$getQueryValues = (target)=>{
    const { page: page, sortField: sortField, sortDirection: sortDirection, filter: filter } = target;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const { text: text, owner: owner, project: project, group: group } = filter;
    return {
        page: page,
        sortField: sortField,
        sortDirection: sortDirection,
        filter: {
            text: text,
            owner: owner && owner.accountId,
            project: project && project.value,
            group: group && group.value
        }
    };
};
const $f20175a510925d76$export$dcc7e61e8982458d = (newQuery, prevQuery)=>!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))($f20175a510925d76$var$getQueryValues(newQuery), $f20175a510925d76$var$getQueryValues(prevQuery));

});

parcelRegister("2n11n", function(module, exports) {

$parcel$export(module.exports, "default", () => $75fdb3811d76cfcb$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");

var $gmIGC = parcelRequire("gmIGC");

var $3vRyP = parcelRequire("3vRyP");

var $ba9ZS = parcelRequire("ba9ZS");
var $75fdb3811d76cfcb$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)((0, $3vRyP.default), (0, $ba9ZS.default), (0, $gmIGC.default));

});
parcelRegister("gmIGC", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c0c045c8f1de9b6$export$2e2bcd8739ae039);
parcelRequire("64ZAE");
parcelRequire("hZWgu");

var $6qsVu = parcelRequire("6qsVu");

var $j8zRR = parcelRequire("j8zRR");

var $aDfxw = parcelRequire("aDfxw");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3c0c045c8f1de9b6$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $j8zRR.READY)).do(()=>{
        (0, $aDfxw.isWithPageReadyMetrics)(store.getState()) && (0, $6qsVu.pageReady)();
    }).ignoreElements();

});
parcelRegister("6qsVu", function(module, exports) {

$parcel$export(module.exports, "pageReady", () => $015b524550a76f0e$export$674e3a896edcf7c);
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $015b524550a76f0e$export$674e3a896edcf7c = ()=>{};

});

parcelRegister("j8zRR", function(module, exports) {

$parcel$export(module.exports, "SET_APP_PROPS", () => $75874306aad8fbf1$export$8aefe701a6f431e0);
$parcel$export(module.exports, "setAppProps", () => $75874306aad8fbf1$export$cfda7627848a58cd);
$parcel$export(module.exports, "READY", () => $75874306aad8fbf1$export$4bf05b02be91f13a);
$parcel$export(module.exports, "ready", () => $75874306aad8fbf1$export$28ee1007e174a2a6);
const $75874306aad8fbf1$export$8aefe701a6f431e0 = 'state.actions.app.SET_APP_PROPS';
const $75874306aad8fbf1$export$cfda7627848a58cd = (payload)=>({
        type: $75874306aad8fbf1$export$8aefe701a6f431e0,
        payload: payload
    });
const $75874306aad8fbf1$export$4bf05b02be91f13a = 'state.actions.app.READY';
const $75874306aad8fbf1$export$28ee1007e174a2a6 = ()=>({
        type: $75874306aad8fbf1$export$4bf05b02be91f13a
    });

});

parcelRegister("aDfxw", function(module, exports) {

$parcel$export(module.exports, "getBaseUrl", () => $5cbd0a9baca419de$export$f654b28f82155665);
$parcel$export(module.exports, "getLoggedInUserAccountId", () => $5cbd0a9baca419de$export$a304ee7b66f5d1e);
$parcel$export(module.exports, "getOnQueryChanged", () => $5cbd0a9baca419de$export$59e4f8ebf6520bf7);
$parcel$export(module.exports, "getFavoriteChangeContext", () => $5cbd0a9baca419de$export$6fa121a48411f085);
$parcel$export(module.exports, "isWithPageReadyMetrics", () => $5cbd0a9baca419de$export$29e8a85166eb4498);
const $5cbd0a9baca419de$export$f654b28f82155665 = (state)=>state.app.props.baseUrl;
const $5cbd0a9baca419de$export$a304ee7b66f5d1e = (state)=>state.app.props.accountId;
const $5cbd0a9baca419de$export$59e4f8ebf6520bf7 = (state)=>state.app.props.onQueryChanged;
const $5cbd0a9baca419de$export$14407a25c57e1f92 = (state)=>state.app.props.xsrfToken;
const $5cbd0a9baca419de$export$6fa121a48411f085 = (state)=>state.app.props.favoriteChangeContext;
const $5cbd0a9baca419de$export$29e8a85166eb4498 = (state)=>state.app.props.withPageReadyMetrics;

});


parcelRegister("3vRyP", function(module, exports) {

$parcel$export(module.exports, "default", () => $b81cc772145fa7f9$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");
parcelRequire("6hSeW");
parcelRequire("fPS7b");

var $hJCUd = parcelRequire("hJCUd");

var $kVLXA = parcelRequire("kVLXA");

var $86Nrx = parcelRequire("86Nrx");

var $aDfxw = parcelRequire("aDfxw");

var $eLJM4 = parcelRequire("eLJM4");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b81cc772145fa7f9$var$querySet = (action$, store)=>action$.ofType((0, $86Nrx.SET_QUERY)).mergeMap(({ payload: payload })=>{
        const state = store.getState();
        const callback = (0, $aDfxw.getOnQueryChanged)(state);
        if (typeof callback === 'function') callback(payload);
        return (0, $kVLXA.Observable).empty();
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b81cc772145fa7f9$var$queryPatched = (action$, store)=>action$.ofType((0, $86Nrx.PATCH_QUERY)).mergeMap(({ payload: payload })=>{
        const state = store.getState();
        const callback = (0, $aDfxw.getOnQueryChanged)(state);
        if (typeof callback === 'function') callback((0, (/*@__PURE__*/$parcel$interopDefault($hJCUd)))(payload, (0, $eLJM4.getQuery)(state)));
        return (0, $kVLXA.Observable).empty();
    });
var $b81cc772145fa7f9$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)($b81cc772145fa7f9$var$querySet, $b81cc772145fa7f9$var$queryPatched);

});
parcelRegister("86Nrx", function(module, exports) {

$parcel$export(module.exports, "SET_QUERY", () => $37c729e95cdec9a3$export$11bcea24b35a126f);
$parcel$export(module.exports, "setQuery", () => $37c729e95cdec9a3$export$f3b215b0b382f63b);
$parcel$export(module.exports, "PATCH_QUERY", () => $37c729e95cdec9a3$export$403065a1ff0b1663);
$parcel$export(module.exports, "patchQuery", () => $37c729e95cdec9a3$export$8a4e224aafd3a2bf);
const $37c729e95cdec9a3$export$11bcea24b35a126f = 'state.actions.query.SET_QUERY';
const $37c729e95cdec9a3$export$f3b215b0b382f63b = (payload)=>({
        type: $37c729e95cdec9a3$export$11bcea24b35a126f,
        payload: payload
    });
const $37c729e95cdec9a3$export$403065a1ff0b1663 = 'state.actions.query.PATCH_QUERY';
const $37c729e95cdec9a3$export$8a4e224aafd3a2bf = (payload)=>({
        type: $37c729e95cdec9a3$export$403065a1ff0b1663,
        payload: payload
    });

});

parcelRegister("eLJM4", function(module, exports) {

$parcel$export(module.exports, "getQuery", () => $014d7a454e93a4f0$export$71eec30d9db46a56);
$parcel$export(module.exports, "getSortField", () => $014d7a454e93a4f0$export$9b753af5a9fb5911);
$parcel$export(module.exports, "getSortDirection", () => $014d7a454e93a4f0$export$509e2b9937961873);
$parcel$export(module.exports, "getPage", () => $014d7a454e93a4f0$export$c2a6433281518c91);
$parcel$export(module.exports, "getFilter", () => $014d7a454e93a4f0$export$61ec8404f465cd36);
$parcel$export(module.exports, "getSearchQuery", () => $014d7a454e93a4f0$export$1664b92369554829);
$parcel$export(module.exports, "getSelectedProject", () => $014d7a454e93a4f0$export$1ebc7a42c839af66);
$parcel$export(module.exports, "getSelectedGroup", () => $014d7a454e93a4f0$export$27ee39f0d715ac22);
$parcel$export(module.exports, "getSelectedOwner", () => $014d7a454e93a4f0$export$858444e3fc2798fd);
$parcel$export(module.exports, "isFilterApplied", () => $014d7a454e93a4f0$export$980aed36f19060a5);

var $dGvGJ = parcelRequire("dGvGJ");
const $014d7a454e93a4f0$export$71eec30d9db46a56 = (state)=>state.query;
const $014d7a454e93a4f0$export$9b753af5a9fb5911 = (state)=>state.query.sortField;
const $014d7a454e93a4f0$export$509e2b9937961873 = (state)=>state.query.sortDirection;
const $014d7a454e93a4f0$export$c2a6433281518c91 = (state)=>state.query.page;
const $014d7a454e93a4f0$export$61ec8404f465cd36 = (state)=>state.query.filter;
const $014d7a454e93a4f0$export$1664b92369554829 = (state)=>$014d7a454e93a4f0$export$61ec8404f465cd36(state).text || '';
const $014d7a454e93a4f0$export$1ebc7a42c839af66 = (state)=>$014d7a454e93a4f0$export$61ec8404f465cd36(state).project;
const $014d7a454e93a4f0$export$27ee39f0d715ac22 = (state)=>$014d7a454e93a4f0$export$61ec8404f465cd36(state).group;
const $014d7a454e93a4f0$export$858444e3fc2798fd = (state)=>$014d7a454e93a4f0$export$61ec8404f465cd36(state).owner;
const $014d7a454e93a4f0$export$980aed36f19060a5 = (0, $dGvGJ.createSelector)($014d7a454e93a4f0$export$1664b92369554829, $014d7a454e93a4f0$export$1ebc7a42c839af66, $014d7a454e93a4f0$export$27ee39f0d715ac22, $014d7a454e93a4f0$export$858444e3fc2798fd, (queryValue, projectValue, groupValue, ownerValue)=>!!queryValue || !!projectValue || !!groupValue || !!ownerValue);

});


parcelRegister("ba9ZS", function(module, exports) {

$parcel$export(module.exports, "default", () => $fca6d22252c0ef5e$export$2e2bcd8739ae039);
parcelRequire("fp4O3");
parcelRequire("9o0uh");
parcelRequire("7qVV7");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $jcw0u = parcelRequire("jcw0u");

var $3JH0P = parcelRequire("3JH0P");

var $kLEu8 = parcelRequire("kLEu8");

var $aDfxw = parcelRequire("aDfxw");

var $eLJM4 = parcelRequire("eLJM4");

var $9koEb = parcelRequire("9koEb");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fca6d22252c0ef5e$export$2e2bcd8739ae039 = (action$, store)=>{
    const getDashboardsRequestAction$ = action$.ofType((0, $kLEu8.RETRIEVE));
    return getDashboardsRequestAction$.mergeMap(()=>{
        const state = store.getState();
        const baseUrl = (0, $aDfxw.getBaseUrl)(state);
        const request = (0, $9koEb.getServiceRequest)(state);
        const filter = (0, $eLJM4.getFilter)(state);
        const actionStartTimestamp = Date.now();
        return (0, $kVLXA.Observable).fromPromise((0, $3JH0P.default)(baseUrl, request, filter)).mergeMap((result)=>(0, $kVLXA.Observable).of((0, $kLEu8.retrieved)(result))).takeUntil(getDashboardsRequestAction$).catch((error)=>{
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'retrieveDashboards',
                    packageName: 'jiraDashboardsMain',
                    teamName: 'jira-cosmos'
                },
                attributes: {
                    durationInMs: Date.now() - actionStartTimestamp
                }
            });
            return (0, $kVLXA.Observable).of((0, $kLEu8.retrieveFailed)());
        });
    });
};

});
parcelRegister("3JH0P", function(module, exports) {

$parcel$export(module.exports, "default", () => $4af72b0a769b07c1$export$2e2bcd8739ae039);

var $4DXtg = parcelRequire("4DXtg");

var $IRPyz = parcelRequire("IRPyz");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4af72b0a769b07c1$export$2e2bcd8739ae039 = async (baseUrl, request, filter)=>{
    const restResponse = await (0, $4DXtg.default)(baseUrl, request, filter);
    return (0, $IRPyz.transformDashboards)(baseUrl, restResponse.values, restResponse.total);
};

});
parcelRegister("4DXtg", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6b5ce4df1168669$export$2e2bcd8739ae039);

var $3NMrl = parcelRequire("3NMrl");

var $ebyGx = parcelRequire("ebyGx");

var $8xvPa = parcelRequire("8xvPa");

var $ePCtu = parcelRequire("ePCtu");

var $fsh9d = parcelRequire("fsh9d");


var $5HnTq = parcelRequire("5HnTq");
const $e6b5ce4df1168669$export$20e00d0048bb5104 = ()=>'/rest/api/2/dashboard/search';
const $e6b5ce4df1168669$var$createQueryFilter = (filter)=>({
        dashboardName: filter.text
    });
const $e6b5ce4df1168669$var$createProjectFilter = (filter)=>({
        projectId: filter.project ? filter.project.value : undefined
    });
const $e6b5ce4df1168669$var$createGroupFilter = (filter)=>({
        groupname: filter.group ? filter.group.value : undefined
    });
const $e6b5ce4df1168669$var$createOwnerFilter = (filter)=>({
        accountId: filter.owner ? filter.owner.accountId : undefined
    });
const $e6b5ce4df1168669$var$logError = async (error, currentTry)=>{
    (0, $fsh9d.logSafeErrorWithoutCustomerData)(error, 'ops.rest.dashboards.get', (0, $78fe9cca6e88980b$export$9b6a6f061a8c0c9a), `Cannot fetch dashboards - is SSR: ${String(false)}, attempt: ${currentTry}`);
};
const $e6b5ce4df1168669$export$7138c24907de3954 = (baseUrl, request, filter)=>{
    const queryParams = {
        ...(0, (/*@__PURE__*/$parcel$interopDefault($3NMrl)))(request, 'startAt', 'maxResults', 'orderBy', 'expand'),
        ...filter.text ? $e6b5ce4df1168669$var$createQueryFilter(filter) : undefined,
        ...filter.project ? $e6b5ce4df1168669$var$createProjectFilter(filter) : undefined,
        ...filter.group ? $e6b5ce4df1168669$var$createGroupFilter(filter) : undefined,
        ...filter.owner ? $e6b5ce4df1168669$var$createOwnerFilter(filter) : undefined
    };
    return `${$e6b5ce4df1168669$export$20e00d0048bb5104()}?${(0, $ebyGx.stringify)(queryParams)}`;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e6b5ce4df1168669$export$2e2bcd8739ae039 = async (baseUrl, request, filter)=>{
    const url = $e6b5ce4df1168669$export$7138c24907de3954(baseUrl, request, filter);
    const response = await (0, $ePCtu.fetchWithRetry)(url, (0, $5HnTq.getDefaultOptions)(url), $e6b5ce4df1168669$var$logError);
    if (response.ok) return response.json();
    throw await (0, $8xvPa.getErrorFromResponse)(response, 'Cannot fetch dashboards');
};

});
parcelRegister("8xvPa", function(module, exports) {

$parcel$export(module.exports, "getErrorFromResponse", () => $8065287d9cd7a779$export$7780d7826aafbede);

var $jJZqs = parcelRequire("jJZqs");

var $eusud = parcelRequire("eusud");
const $8065287d9cd7a779$export$7780d7826aafbede = async (response, defaultMessage)=>{
    let errorMessage = defaultMessage;
    try {
        const json = await response.json();
        const { errors: errors, errorMessages: errorMessages } = json;
        if (errors && Object.keys(errors).length) return (0, $eusud.transformValidationErrorFromServer)(json);
        errorMessage = errorMessages[0];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    /**/ }
    return new (0, $jJZqs.default)(response.status, errorMessage);
};

});

parcelRegister("ePCtu", function(module, exports) {

$parcel$export(module.exports, "fetchWithRetry", () => $97da449f15cd9238$export$cffaac380b94df26);

var $5HnTq = parcelRequire("5HnTq");

var $8xvPa = parcelRequire("8xvPa");
const $97da449f15cd9238$export$fbc55f9ab8ae7207 = false ? 1 : 3;
const $97da449f15cd9238$var$logResponseError = async (logSafeErrorWithoutCustomerData, response, currentTry)=>{
    const error = await (0, $8xvPa.getErrorFromResponse)(response, 'Directory fetch with retry failed');
    await logSafeErrorWithoutCustomerData(error, currentTry);
};
const $97da449f15cd9238$export$cffaac380b94df26 = async (url, options, logSafeErrorWithoutCustomerData, currentTry = 1)=>{
    try {
        const response = await fetch(url, (0, $5HnTq.getDefaultOptions)(url));
        if (!response.ok) {
            await $97da449f15cd9238$var$logResponseError(logSafeErrorWithoutCustomerData, response, currentTry);
            if (currentTry < $97da449f15cd9238$export$fbc55f9ab8ae7207) return $97da449f15cd9238$export$cffaac380b94df26(url, options, logSafeErrorWithoutCustomerData, currentTry + 1);
        }
        return response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        await logSafeErrorWithoutCustomerData(error, currentTry);
        if (currentTry < $97da449f15cd9238$export$fbc55f9ab8ae7207) return $97da449f15cd9238$export$cffaac380b94df26(url, options, logSafeErrorWithoutCustomerData, currentTry + 1);
        throw error;
    }
};

});

const $78fe9cca6e88980b$export$9b6a6f061a8c0c9a = 'directories.dashboards.error';


parcelRegister("IRPyz", function(module, exports) {

$parcel$export(module.exports, "transformDashboards", () => $6664466d13a93b2f$export$71617175ef5c22ee);

var $4Xk2W = parcelRequire("4Xk2W");

var $dPSWJ = parcelRequire("dPSWJ");

var $6NNub = parcelRequire("6NNub");
const $6664466d13a93b2f$export$71617175ef5c22ee = (baseUrl, dashboards, total)=>{
    const order = dashboards.map((i)=>i.id);
    const responsesById = (0, (/*@__PURE__*/$parcel$interopDefault($4Xk2W)))(dashboards, (dashboard)=>dashboard.id);
    const page = (0, (/*@__PURE__*/$parcel$interopDefault($dPSWJ)))(responsesById, (response)=>(0, $6NNub.transformDashboard)(baseUrl, response));
    return {
        page: page,
        order: order,
        total: total
    };
};

});
parcelRegister("4Xk2W", function(module, exports) {

var $1m3dq = parcelRequire("1m3dq");

var $4CZTG = parcelRequire("4CZTG");
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */ var $39bc38f0156cacc0$var$keyBy = $4CZTG(function(result, value, key) {
    $1m3dq(result, key, value);
});
module.exports = $39bc38f0156cacc0$var$keyBy;

});

parcelRegister("6NNub", function(module, exports) {

$parcel$export(module.exports, "transformDashboard", () => $cce8403b8af9079b$export$4e6ec9d8b34b3fb);

var $knvh6 = parcelRequire("knvh6");
const $cce8403b8af9079b$export$4e6ec9d8b34b3fb = (baseUrl, item)=>({
        id: item.id,
        name: item.name,
        viewUrl: `/jira/dashboards/${item.id}`,
        owner: item.owner ? (0, $knvh6.transformUser)(baseUrl, item.owner) : null,
        isFavourite: item.isFavourite,
        popularity: item.popularity || 0,
        shares: item.sharePermissions ? item.sharePermissions.map((0, $knvh6.transformSharePermission)).filter(Boolean) : [],
        edits: item.editPermissions ? item.editPermissions.map((0, $knvh6.transformSharePermission)).filter(Boolean) : [],
        description: item.description,
        isWritable: item.isWritable === true,
        systemDashboard: item.systemDashboard === true
    });

});
parcelRegister("knvh6", function(module, exports) {

$parcel$export(module.exports, "transformUser", () => $879c58d3b16279dc$export$88dcd5c1adae8021);
$parcel$export(module.exports, "transformSharePermission", () => $879c58d3b16279dc$export$443a799045209d52);
$parcel$export(module.exports, "transformSharePermissionsToServer", () => $879c58d3b16279dc$export$e05899da868da914);


var $EVhLF = parcelRequire("EVhLF");

var $4R6GH = parcelRequire("4R6GH");

const $879c58d3b16279dc$var$assertUnreachable = (_x)=>{
    throw new Error("Didn't expect to get here");
};
const $879c58d3b16279dc$export$88dcd5c1adae8021 = (baseUrl, user)=>{
    let profileUrl;
    if ((0, $4R6GH.fg)('jira-adopt-teams-nav-config')) {
        const { href: href } = (0, $EVhLF.getNavigateToTeamsApp)({
            type: 'USER',
            payload: {
                userId: user.accountId
            }
        });
        profileUrl = href;
    } else profileUrl = `/jira/people/${user.accountId}`;
    return {
        displayName: user.displayName,
        avatarUrl: user.avatarUrls && user.avatarUrls['48x48'],
        accountId: user.accountId,
        profileUrl: profileUrl
    };
};
const $879c58d3b16279dc$export$443a799045209d52 = (sharePermission)=>{
    switch(sharePermission.type){
        case 0, $a889b3091d5309c7$export$86517eb0163ef745:
            return {
                type: (0, $a889b3091d5309c7$export$86517eb0163ef745)
            };
        case 0, $a889b3091d5309c7$export$b0a0e62d9b1a8269:
            return {
                type: (0, $a889b3091d5309c7$export$b0a0e62d9b1a8269)
            };
        case 0, $a889b3091d5309c7$export$b02d7412182d1bce:
            return {
                type: (0, $a889b3091d5309c7$export$b02d7412182d1bce),
                group: {
                    ...sharePermission.group
                }
            };
        case 0, $a889b3091d5309c7$export$5ef95a67b8fd1ff6:
            {
                const { project: project, role: role } = sharePermission;
                return {
                    type: (0, $a889b3091d5309c7$export$5ef95a67b8fd1ff6),
                    project: {
                        id: project.id,
                        name: project.name,
                        avatarUrl: project.avatarUrls['48x48']
                    },
                    role: role && {
                        id: role.id,
                        name: role.name
                    }
                };
            }
        case 0, $a889b3091d5309c7$export$487da0972e3459fe:
            return sharePermission;
        case 0, $a889b3091d5309c7$export$aea0835048e1c730:
            {
                const { user: user } = sharePermission;
                return {
                    type: (0, $a889b3091d5309c7$export$aea0835048e1c730),
                    user: {
                        accountId: user.accountId,
                        displayName: user.displayName,
                        avatarUrl: user.avatarUrls['48x48']
                    }
                };
            }
        default:
            $879c58d3b16279dc$var$assertUnreachable(sharePermission);
            return null;
    }
};
const $879c58d3b16279dc$export$e05899da868da914 = (sharePermissions, shouldReturnGroupIdForGroupIfAvailable = false)=>sharePermissions.map((sharePermission)=>{
        switch(sharePermission.type){
            case 0, $a889b3091d5309c7$export$b02d7412182d1bce:
                {
                    let group = {
                        name: sharePermission.group.name
                    };
                    if (shouldReturnGroupIdForGroupIfAvailable && sharePermission.group.groupId) group = {
                        groupId: sharePermission.group.groupId
                    };
                    return {
                        type: sharePermission.type,
                        group: group
                    };
                }
            case 0, $a889b3091d5309c7$export$aea0835048e1c730:
                return {
                    type: sharePermission.type,
                    user: {
                        accountId: sharePermission.user.accountId
                    }
                };
            case 0, $a889b3091d5309c7$export$5ef95a67b8fd1ff6:
                {
                    const permission = {
                        type: sharePermission.role ? (0, $3f2163233a19a685$export$4d955b5fb0c1d4d7) : (0, $a889b3091d5309c7$export$5ef95a67b8fd1ff6),
                        project: {
                            id: sharePermission.project.id
                        }
                    };
                    if (sharePermission.role) permission.role = {
                        id: sharePermission.role.id
                    };
                    return permission;
                }
            case 0, $a889b3091d5309c7$export$487da0972e3459fe:
                return sharePermission;
            case 0, $a889b3091d5309c7$export$b0a0e62d9b1a8269:
                return {
                    type: (0, $3f2163233a19a685$export$e2fe9963c33d5918)
                };
            case 0, $a889b3091d5309c7$export$86517eb0163ef745:
                return sharePermission;
            default:
                $879c58d3b16279dc$var$assertUnreachable(sharePermission);
                return sharePermission;
        }
    });

});
const $a889b3091d5309c7$export$b02d7412182d1bce = 'group';
const $a889b3091d5309c7$export$5ef95a67b8fd1ff6 = 'project';
const $a889b3091d5309c7$export$487da0972e3459fe = 'project-unknown';
const $a889b3091d5309c7$export$b0a0e62d9b1a8269 = 'loggedin';
const $a889b3091d5309c7$export$86517eb0163ef745 = 'global';
const $a889b3091d5309c7$export$aea0835048e1c730 = 'user';
 // this is what can come from backend

const $3f2163233a19a685$export$e2fe9963c33d5918 = 'authenticated';
const $3f2163233a19a685$export$4d955b5fb0c1d4d7 = 'projectRole';





parcelRegister("kLEu8", function(module, exports) {

$parcel$export(module.exports, "RETRIEVE", () => $3433b7eeac9e614b$export$7bf2c28a4e08c796);
$parcel$export(module.exports, "retrieve", () => $3433b7eeac9e614b$export$8a4d17b6e8486e66);
$parcel$export(module.exports, "RETRIEVED", () => $3433b7eeac9e614b$export$1a07e8ff5bab976c);
$parcel$export(module.exports, "retrieved", () => $3433b7eeac9e614b$export$4058166ec369dd8);
$parcel$export(module.exports, "RETRIEVE_FAILED", () => $3433b7eeac9e614b$export$26e5d507c83e3d5a);
$parcel$export(module.exports, "retrieveFailed", () => $3433b7eeac9e614b$export$1c9b9c3d8868d26f);
$parcel$export(module.exports, "PATCH", () => $3433b7eeac9e614b$export$54950d96c4d7b0);
$parcel$export(module.exports, "patch", () => $3433b7eeac9e614b$export$b76953f99ab2be78);
const $3433b7eeac9e614b$export$7bf2c28a4e08c796 = 'state.actions.dashboards.RETRIEVE';
const $3433b7eeac9e614b$export$8a4d17b6e8486e66 = ()=>({
        type: $3433b7eeac9e614b$export$7bf2c28a4e08c796
    });
const $3433b7eeac9e614b$export$1a07e8ff5bab976c = 'state.actions.dashboards.RETRIEVED';
const $3433b7eeac9e614b$export$4058166ec369dd8 = (payload)=>({
        type: $3433b7eeac9e614b$export$1a07e8ff5bab976c,
        payload: payload
    });
const $3433b7eeac9e614b$export$26e5d507c83e3d5a = 'state.actions.dashboards.RETRIEVE_FAILED';
const $3433b7eeac9e614b$export$1c9b9c3d8868d26f = ()=>({
        type: $3433b7eeac9e614b$export$26e5d507c83e3d5a
    });
const $3433b7eeac9e614b$export$54950d96c4d7b0 = 'state.actions.dashboards.PATCH';
const $3433b7eeac9e614b$export$b76953f99ab2be78 = (payload)=>({
        type: $3433b7eeac9e614b$export$54950d96c4d7b0,
        payload: payload
    });

});

parcelRegister("9koEb", function(module, exports) {

$parcel$export(module.exports, "getServiceRequest", () => $2785276956f2f9cd$export$d7889f7cae5c51ff);

var $b3NWe = parcelRequire("b3NWe");

var $fOd11 = parcelRequire("fOd11");

var $48oUo = parcelRequire("48oUo");


var $eLJM4 = parcelRequire("eLJM4");
const $2785276956f2f9cd$var$getSort = (state)=>({
        direction: (0, $eLJM4.getSortDirection)(state),
        field: (0, $48oUo.SORT_FIELDS)[(0, $eLJM4.getSortField)(state)]
    });
const $2785276956f2f9cd$export$d7889f7cae5c51ff = (state)=>(0, $b3NWe.createPageRequest)((0, $eLJM4.getPage)(state), (0, $12103d1d16a39db9$export$ec93a669a20aa982), $2785276956f2f9cd$var$getSort(state), (0, $fOd11.EXPAND_PARAMETERS));

});
parcelRegister("b3NWe", function(module, exports) {

$parcel$export(module.exports, "createPageRequest", () => $76f67021d51b1075$export$6c268d1798324d1);
const $76f67021d51b1075$export$a2b44ae778ac3391 = (startAt, maxResults, order, expand)=>{
    const pageRequest = {
        maxResults: maxResults,
        startAt: startAt
    };
    if (order) {
        const orderString = `${order.direction === 'ASC' ? '+' : '-'}${order.field}`;
        pageRequest.orderBy = orderString;
    }
    if (expand && expand.length) pageRequest.expand = expand.join(',');
    return pageRequest;
};
const $76f67021d51b1075$export$2db35c6ee4729a76 = (startAt, maxResults, order, expand, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
searchBy)=>{
    const pageRequest = {
        maxResults: maxResults,
        startAt: startAt
    };
    if (order) {
        const orderString = `${order.direction === 'ASC' ? '+' : '-'}${order.field}`;
        pageRequest.orderBy = orderString;
    }
    if (expand && expand.length) pageRequest.expand = expand.join(',');
    if (searchBy && searchBy.length) pageRequest.searchBy = searchBy.join(',');
    return pageRequest;
};
const $76f67021d51b1075$export$6c268d1798324d1 = (page, itemsPerPage, order, expand)=>$76f67021d51b1075$export$a2b44ae778ac3391(itemsPerPage * (page - 1), itemsPerPage, order, expand);
const $76f67021d51b1075$export$98ffd4f2a2fa32d7 = (page, itemsPerPage, order, expand, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
searchBy)=>$76f67021d51b1075$export$2db35c6ee4729a76(itemsPerPage * (page - 1), itemsPerPage, order, expand, searchBy);

});

parcelRegister("fOd11", function(module, exports) {

$parcel$export(module.exports, "EXPAND_PARAMETERS", () => $1c42907237e17b24$export$ac5ed0fd17aacb1c);
const $1c42907237e17b24$export$ac5ed0fd17aacb1c = [
    'owner',
    'favourite',
    'favouritedCount',
    'sharePermissions',
    'editPermissions',
    'description',
    'isWritable',
    'systemDashboard'
];

});

const $12103d1d16a39db9$export$ec93a669a20aa982 = 25;




parcelRegister("9XYDI", function(module, exports) {

$parcel$export(module.exports, "default", () => $6889b4e82e9efc1e$export$2e2bcd8739ae039);

var $F2Mxm = parcelRequire("F2Mxm");

var $4AI0f = parcelRequire("4AI0f");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6889b4e82e9efc1e$export$2e2bcd8739ae039 = (rootEpic)=>(0, $F2Mxm.default)({
        appName: 'directories/dashboards',
        rootReducer: $4AI0f.default,
        rootEpic: rootEpic
    });

});
parcelRegister("4AI0f", function(module, exports) {

$parcel$export(module.exports, "default", () => $f34d1a180287b284$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $ahQkP = parcelRequire("ahQkP");

var $bDiU4 = parcelRequire("bDiU4");

var $dAqsJ = parcelRequire("dAqsJ");
var $f34d1a180287b284$export$2e2bcd8739ae039 = (0, $3f2cs.combineReducers)({
    app: $ahQkP.default,
    dashboards: $bDiU4.default,
    query: $dAqsJ.default
});

});
parcelRegister("ahQkP", function(module, exports) {

$parcel$export(module.exports, "default", () => $032f59d6a44d05c5$export$2e2bcd8739ae039);

var $fr1K2 = parcelRequire("fr1K2");

var $j8zRR = parcelRequire("j8zRR");
const $032f59d6a44d05c5$export$d4c72bab9d6cc13a = {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    props: undefined
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$032f59d6a44d05c5$export$2e2bcd8739ae039 = (state = $032f59d6a44d05c5$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $j8zRR.SET_APP_PROPS:
            return {
                ...state,
                props: (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(action.payload, 'query')
            };
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};

});

parcelRegister("bDiU4", function(module, exports) {

$parcel$export(module.exports, "default", () => $d742f2737acb1601$export$2e2bcd8739ae039);

var $kLEu8 = parcelRequire("kLEu8");
const $d742f2737acb1601$export$d4c72bab9d6cc13a = {
    page: {},
    order: [],
    total: 0,
    isLoading: true,
    isError: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d742f2737acb1601$export$2e2bcd8739ae039 = (state = $d742f2737acb1601$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $kLEu8.RETRIEVE:
            return {
                ...state,
                isLoading: true
            };
        case 0, $kLEu8.RETRIEVED:
            return {
                ...state,
                page: action.payload.page,
                order: action.payload.order,
                total: action.payload.total,
                isLoading: false,
                isError: false
            };
        case 0, $kLEu8.RETRIEVE_FAILED:
            return {
                ...state,
                isLoading: false,
                isError: true
            };
        case 0, $kLEu8.PATCH:
            return {
                ...state,
                page: {
                    ...state.page,
                    [action.payload.id]: {
                        ...state.page[action.payload.id],
                        ...action.payload.patch
                    }
                }
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("dAqsJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5014184ecaf8c00$export$2e2bcd8739ae039);

var $FqCjF = parcelRequire("FqCjF");

var $86Nrx = parcelRequire("86Nrx");
const $f5014184ecaf8c00$export$d4c72bab9d6cc13a = (0, $FqCjF.initialQuery);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f5014184ecaf8c00$export$2e2bcd8739ae039 = (state = $f5014184ecaf8c00$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $86Nrx.SET_QUERY:
            return action.payload;
        case 0, $86Nrx.PATCH_QUERY:
            return {
                ...state,
                ...action.payload,
                filter: {
                    ...state.filter,
                    ...action.payload.filter ? action.payload.filter : undefined
                }
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});



parcelRegister("2EXat", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6c1bcb524a87217$export$2e2bcd8739ae039);

var $eHTfV = parcelRequire("eHTfV");

var $bC2fB = parcelRequire("bC2fB");


var $j8zRR = parcelRequire("j8zRR");

var $kLEu8 = parcelRequire("kLEu8");

var $86Nrx = parcelRequire("86Nrx");

var $dIWFt = parcelRequire("dIWFt");

var $eLJM4 = parcelRequire("eLJM4");

var $aQEP9 = parcelRequire("aQEP9");

var $82A9p = parcelRequire("82A9p");

var $bnQis = parcelRequire("bnQis");

var $lQRKF = parcelRequire("lQRKF");
const $c6c1bcb524a87217$var$mapStateToProps = (state)=>({
        // data
        entityIds: (0, $dIWFt.getIds)(state),
        totalItems: (0, $dIWFt.getTotal)(state),
        itemsPerPage: (0, $12103d1d16a39db9$export$ec93a669a20aa982),
        isLoading: (0, $dIWFt.isLoading)(state),
        isError: (0, $dIWFt.isError)(state),
        page: (0, $eLJM4.getPage)(state),
        sortField: (0, $eLJM4.getSortField)(state),
        sortDirection: (0, $eLJM4.getSortDirection)(state),
        filter: (0, $eLJM4.isFilterApplied)(state) ? (0, $eLJM4.getFilter)(state) : undefined,
        // ui
        firstColumnHeadingAlignment: 'center',
        lastColumnHeadingAlignment: 'right',
        FilterView: // views
        $bnQis.default,
        tableConfiguration: (0, $lQRKF.getTableConfiguration)(state),
        tableLabel: (0, $lQRKF.getTableLabel)(),
        resultsAnnouncerMessage: (0, $lQRKF.getResultsAnnouncerMessage)(),
        emptyFilterResultConfiguration: $lQRKF.emptyFilterResultConfiguration,
        operationModals: $lQRKF.operationModals,
        EmptyView: $aQEP9.default,
        ErrorView: $82A9p.default
    });
const $c6c1bcb524a87217$var$mapDispatchToProps = (dispatch)=>({
        // @ts-expect-error - TS7031 - Binding element 'id' implicitly has an 'any' type. | TS7031 - Binding element 'patch' implicitly has an 'any' type.
        onPatch: ({ id: id, patch: patch })=>dispatch((0, $kLEu8.patch)({
                id: id,
                patch: patch
            })),
        onReload: (query)=>{
            dispatch((0, $86Nrx.patchQuery)(query));
            dispatch((0, $kLEu8.retrieve)());
        },
        onFirstRender: ()=>dispatch((0, $j8zRR.ready)())
    });
var // @ts-expect-error - TS2345 - Argument of type 'typeof Directory' is not assignable to parameter of type 'Component<{ entityIds: string[]; totalItems: number; itemsPerPage: number; isLoading: boolean; isError: boolean; page: number; sortField: SortField; sortDirection: SortDirection; ... 8 more ...; ErrorView: ComponentClass<...> & { ...; }; } & { ...; }>'.
$c6c1bcb524a87217$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($c6c1bcb524a87217$var$mapStateToProps, $c6c1bcb524a87217$var$mapDispatchToProps)((0, $eHTfV.default));

});
parcelRegister("eHTfV", function(module, exports) {

$parcel$export(module.exports, "default", () => $68b9ede2efb547aa$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $2YZCu = parcelRequire("2YZCu");

var $dZw8H = parcelRequire("dZw8H");

var $j1FRT = parcelRequire("j1FRT");

var $6E8KZ = parcelRequire("6E8KZ");

var $2g1f1 = parcelRequire("2g1f1");

var $5wSMM = parcelRequire("5wSMM");

var $iqNVX = parcelRequire("iqNVX");

var $iOBt9 = parcelRequire("iOBt9");

const $68b9ede2efb547aa$var$defaultEntityIds = [];
class $68b9ede2efb547aa$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isOnboardingEnabled: false,
            headerConfiguration: undefined,
            FilterView: undefined,
            TableMaskView: undefined,
            CreateModal: undefined,
            metrics: {
                tableMounted: undefined
            },
            entityIds: $68b9ede2efb547aa$var$defaultEntityIds,
            dataProvider: undefined,
            renderOnboardingSpotlight: ()=>null,
            tableLabel: undefined,
            onboardingSpotlightTargets: [],
            onFirstRender: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    constructor(props){
        super(props);
        if (props.entityIds !== $68b9ede2efb547aa$var$defaultEntityIds && props.dataProvider) (0, $2YZCu.default).safeErrorWithoutCustomerData('directory.base', 'Please provide only one of props: [entityIds] or [dataProvider], dataProvider will be used');
        this.store = (0, $iqNVX.default)((0, $2g1f1.default));
        this.store.dispatch((0, $5wSMM.setAppProps)(props));
    }
    componentDidUpdate() {
        this.store.dispatch((0, $5wSMM.setAppProps)(this.props));
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6E8KZ.Provider), {
            store: this.store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j1FRT.default), {
            onFirstMount: this.props.onFirstRender
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iOBt9.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZw8H.SpaStatePageReady), null)));
    }
}

});
parcelRegister("j1FRT", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1db2b6388142380$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $bKLSv = parcelRequire("bKLSv");
class $b1db2b6388142380$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bKLSv.default).Provider, {
            value: {
                reportMount: this.onSubtreeMount
            }
        }, children);
    }
    constructor(...args){
        super(...args), this.onSubtreeMount = ()=>{
            if (!this.hasAnyMounted) {
                this.hasAnyMounted = true;
                this.props.onFirstMount();
            }
        }, this.hasAnyMounted = false;
    }
}

});
parcelRegister("bKLSv", function(module, exports) {

$parcel$export(module.exports, "default", () => $78841c2f4061c1bf$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");
var $78841c2f4061c1bf$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    reportMount: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
});

});


parcelRegister("6E8KZ", function(module, exports) {

$parcel$export(module.exports, "useDirectoryDispatch", () => $faa45d572897b119$export$98942df89ffbd315);
$parcel$export(module.exports, "storeOptions", () => $faa45d572897b119$export$12cf63d9f5bd0793);
$parcel$export(module.exports, "Provider", () => $faa45d572897b119$export$2881499e37b75b9a);
$parcel$export(module.exports, "connect", () => $faa45d572897b119$export$64605811ab45167f);

var $5uXOq = parcelRequire("5uXOq");

var $kVVL1 = parcelRequire("kVVL1");

var $bC2fB = parcelRequire("bC2fB");
const $faa45d572897b119$var$STORE_KEY = 'project-directories.directory.story';
const $faa45d572897b119$export$d03cc44e35038f93 = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $faa45d572897b119$export$98942df89ffbd315 = (0, $kVVL1.createDispatchHook)($faa45d572897b119$export$d03cc44e35038f93);
const $faa45d572897b119$export$12cf63d9f5bd0793 = {
    storeKey: $faa45d572897b119$var$STORE_KEY,
    context: $faa45d572897b119$export$d03cc44e35038f93
};
const $faa45d572897b119$export$2881499e37b75b9a = (0, $bC2fB.createProvider)($faa45d572897b119$export$d03cc44e35038f93);
const $faa45d572897b119$export$64605811ab45167f = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
mapStateToProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
mapDispatchToProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
mergeProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
options = Object.freeze({}))=>(0, $bC2fB.connect)(mapStateToProps, mapDispatchToProps, mergeProps, {
        ...options,
        context: $faa45d572897b119$export$d03cc44e35038f93,
        storeKey: $faa45d572897b119$var$STORE_KEY
    });

});

parcelRegister("2g1f1", function(module, exports) {

$parcel$export(module.exports, "default", () => $98259b1e80972783$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");

var $gcE5m = parcelRequire("gcE5m");

var $eh8lN = parcelRequire("eh8lN");
var $98259b1e80972783$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)((0, $gcE5m.default), (0, $eh8lN.default));

});
parcelRegister("gcE5m", function(module, exports) {

$parcel$export(module.exports, "default", () => $dab58ae642be3a4d$export$2e2bcd8739ae039);
parcelRequire("6hSeW");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $26mQL = parcelRequire("26mQL");

var $eVVoZ = parcelRequire("eVVoZ");
var // flow can't deal with the generics here
// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$dab58ae642be3a4d$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $26mQL.ENTITY_CREATED)).mergeMap(()=>{
        const state = store.getState();
        const page = (0, $eVVoZ.getPage)(state);
        (0, $eVVoZ.getOnReload)(state)({
            page: page
        });
        return (0, $kVLXA.Observable).empty();
    });

});
parcelRegister("26mQL", function(module, exports) {

$parcel$export(module.exports, "INITIATE", () => $fd2eed6f29a3dd08$export$643daa42aa3148d5);
$parcel$export(module.exports, "initiate", () => $fd2eed6f29a3dd08$export$b14c4413e822aa8d);
$parcel$export(module.exports, "ENTITY_CREATED", () => $fd2eed6f29a3dd08$export$61bc72c2b62d14ed);
$parcel$export(module.exports, "entityCreated", () => $fd2eed6f29a3dd08$export$5e2c0a0dc191dd3e);
$parcel$export(module.exports, "ENTITY_CREATE_FAILED", () => $fd2eed6f29a3dd08$export$ac0dd97afb285388);
$parcel$export(module.exports, "entityCreateFailed", () => $fd2eed6f29a3dd08$export$b71626a5d7099742);
$parcel$export(module.exports, "CANCELLED", () => $fd2eed6f29a3dd08$export$6b4658081fcf1aed);
$parcel$export(module.exports, "cancelled", () => $fd2eed6f29a3dd08$export$b108ea1063c657e3);
const $fd2eed6f29a3dd08$export$643daa42aa3148d5 = 'state.actions.create.INITIATE';
const $fd2eed6f29a3dd08$export$b14c4413e822aa8d = ()=>({
        type: $fd2eed6f29a3dd08$export$643daa42aa3148d5
    });
const $fd2eed6f29a3dd08$export$61bc72c2b62d14ed = 'state.actions.create.ENTITY_CREATED';
const $fd2eed6f29a3dd08$export$5e2c0a0dc191dd3e = (payload)=>({
        type: $fd2eed6f29a3dd08$export$61bc72c2b62d14ed,
        payload: payload
    });
const $fd2eed6f29a3dd08$export$ac0dd97afb285388 = 'state.actions.create.ENTITY_CREATE_FAILED';
const $fd2eed6f29a3dd08$export$b71626a5d7099742 = (payload)=>({
        type: $fd2eed6f29a3dd08$export$ac0dd97afb285388,
        payload: payload
    });
const $fd2eed6f29a3dd08$export$6b4658081fcf1aed = 'state.actions.create.CANCELLED';
const $fd2eed6f29a3dd08$export$b108ea1063c657e3 = ()=>({
        type: $fd2eed6f29a3dd08$export$6b4658081fcf1aed
    });

});

parcelRegister("eVVoZ", function(module, exports) {

$parcel$export(module.exports, "getEntityIds", () => $6cea3ab9141d1142$export$1fe43832be7d1fcb);
$parcel$export(module.exports, "getDataProvider", () => $6cea3ab9141d1142$export$add6bf8e4261fead);
$parcel$export(module.exports, "getTotalItems", () => $6cea3ab9141d1142$export$cbc4bdd6c02fac4d);
$parcel$export(module.exports, "getPage", () => $6cea3ab9141d1142$export$c2a6433281518c91);
$parcel$export(module.exports, "getItemsPerPage", () => $6cea3ab9141d1142$export$347447940701b338);
$parcel$export(module.exports, "getSortField", () => $6cea3ab9141d1142$export$9b753af5a9fb5911);
$parcel$export(module.exports, "getSortDirection", () => $6cea3ab9141d1142$export$509e2b9937961873);
$parcel$export(module.exports, "getFilter", () => $6cea3ab9141d1142$export$61ec8404f465cd36);
$parcel$export(module.exports, "getHeaderConfiguration", () => $6cea3ab9141d1142$export$60b0ef02721854ed);
$parcel$export(module.exports, "getFilterView", () => $6cea3ab9141d1142$export$4a62b01f13af161e);
$parcel$export(module.exports, "getTableConfiguration", () => $6cea3ab9141d1142$export$6847365bea1c5392);
$parcel$export(module.exports, "getTableLabel", () => $6cea3ab9141d1142$export$b2d196af18e06ad6);
$parcel$export(module.exports, "getResultsAnnouncerMessage", () => $6cea3ab9141d1142$export$64df75861e57fb7f);
$parcel$export(module.exports, "getEmptyView", () => $6cea3ab9141d1142$export$6ad7beec028137c);
$parcel$export(module.exports, "getErrorView", () => $6cea3ab9141d1142$export$67942d5525c28c28);
$parcel$export(module.exports, "getEmptyFilterResultConfiguration", () => $6cea3ab9141d1142$export$dae3c68be4c9569d);
$parcel$export(module.exports, "getTableMaskView", () => $6cea3ab9141d1142$export$7a35128187f8245c);
$parcel$export(module.exports, "getCreateModal", () => $6cea3ab9141d1142$export$be5bc82ccf7ca5ca);
$parcel$export(module.exports, "getOperationModal", () => $6cea3ab9141d1142$export$3f5ae3b2bfec9457);
$parcel$export(module.exports, "getOnReload", () => $6cea3ab9141d1142$export$7158eb69f7a0b59);
$parcel$export(module.exports, "getOnPatch", () => $6cea3ab9141d1142$export$944f52419ab8e737);
$parcel$export(module.exports, "isLoading", () => $6cea3ab9141d1142$export$20bb0d907fbbe433);
$parcel$export(module.exports, "isError", () => $6cea3ab9141d1142$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "getTotalPages", () => $6cea3ab9141d1142$export$652b307566494a6);
$parcel$export(module.exports, "getFirstColumnHeadingAlignment", () => $6cea3ab9141d1142$export$22b039be773dbf63);
$parcel$export(module.exports, "getLastColumnHeadingAlignment", () => $6cea3ab9141d1142$export$affaf5a34a669e16);
$parcel$export(module.exports, "isCreateOpen", () => $6cea3ab9141d1142$export$996a71275221ab9e);
$parcel$export(module.exports, "getOperations", () => $6cea3ab9141d1142$export$acc17f62bededcaf);
$parcel$export(module.exports, "getOperationInitializationStatusPerEntity", () => $6cea3ab9141d1142$export$69a0d9b5be75b55d);
$parcel$export(module.exports, "getIsOnboardingEnabled", () => $6cea3ab9141d1142$export$65890ce3309e3ccf);
$parcel$export(module.exports, "getRenderOnboardingSpotlight", () => $6cea3ab9141d1142$export$98db60f26810390);
$parcel$export(module.exports, "getSpotlightForCell", () => $6cea3ab9141d1142$export$1faee8e10b588885);
$parcel$export(module.exports, "getAvailableSpotlightTargets", () => $6cea3ab9141d1142$export$7eda79d5ce9a0b8b);

var $dGvGJ = parcelRequire("dGvGJ");

var $4Xk2W = parcelRequire("4Xk2W");

var $dPSWJ = parcelRequire("dPSWJ");

var $k15gu = parcelRequire("k15gu");
const $6cea3ab9141d1142$export$876089ea65adc54 = (state)=>state.app.props;
const $6cea3ab9141d1142$export$1fe43832be7d1fcb = (state)=>state.app.props.entityIds;
const $6cea3ab9141d1142$export$add6bf8e4261fead = (state)=>state.app.props.dataProvider || undefined;
const $6cea3ab9141d1142$export$cbc4bdd6c02fac4d = (state)=>state.app.props.totalItems;
const $6cea3ab9141d1142$export$c2a6433281518c91 = (state)=>state.app.props.page;
const $6cea3ab9141d1142$export$347447940701b338 = (state)=>state.app.props.itemsPerPage;
const $6cea3ab9141d1142$export$9b753af5a9fb5911 = (state)=>state.app.props.sortField;
const $6cea3ab9141d1142$export$509e2b9937961873 = (state)=>state.app.props.sortDirection;
const $6cea3ab9141d1142$export$61ec8404f465cd36 = (state)=>state.app.props.filter;
const $6cea3ab9141d1142$export$60b0ef02721854ed = (state)=>state.app.props.headerConfiguration;
const $6cea3ab9141d1142$export$4a62b01f13af161e = (state)=>state.app.props.FilterView;
const $6cea3ab9141d1142$export$6847365bea1c5392 = (state)=>state.app.props.tableConfiguration;
const $6cea3ab9141d1142$export$b2d196af18e06ad6 = (state)=>state.app.props.tableLabel;
const $6cea3ab9141d1142$export$64df75861e57fb7f = (state)=>state.app.props.resultsAnnouncerMessage;
const $6cea3ab9141d1142$export$6ad7beec028137c = (state)=>state.app.props.EmptyView;
const $6cea3ab9141d1142$export$67942d5525c28c28 = (state)=>state.app.props.ErrorView;
const $6cea3ab9141d1142$export$dae3c68be4c9569d = (state)=>state.app.props.emptyFilterResultConfiguration;
const $6cea3ab9141d1142$export$7a35128187f8245c = (state)=>state.app.props.TableMaskView;
const $6cea3ab9141d1142$export$be5bc82ccf7ca5ca = (state)=>state.app.props.CreateModal;
const $6cea3ab9141d1142$export$3f5ae3b2bfec9457 = (state, operation)=>state.app.props.operationModals[operation];
const $6cea3ab9141d1142$export$7158eb69f7a0b59 = (state)=>state.app.props.onReload;
const $6cea3ab9141d1142$export$944f52419ab8e737 = (state)=>state.app.props.onPatch;
const $6cea3ab9141d1142$export$20bb0d907fbbe433 = (state)=>state.app.props.isLoading;
const $6cea3ab9141d1142$export$e6127cc7fe7395c3 = (state)=>state.app.props.isError;
const $6cea3ab9141d1142$var$getTotalPagesInternal = (0, $dGvGJ.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$6cea3ab9141d1142$export$cbc4bdd6c02fac4d, $6cea3ab9141d1142$export$347447940701b338, (totalItems, itemsOnPage)=>(0, $k15gu.calculateTotalPages)(totalItems, itemsOnPage));
const $6cea3ab9141d1142$export$652b307566494a6 = (state)=>$6cea3ab9141d1142$var$getTotalPagesInternal(state);
const $6cea3ab9141d1142$export$22b039be773dbf63 = (state)=>state.app.props.firstColumnHeadingAlignment;
const $6cea3ab9141d1142$export$affaf5a34a669e16 = (state)=>state.app.props.lastColumnHeadingAlignment;
const $6cea3ab9141d1142$export$996a71275221ab9e = (state)=>state.create.isOpen;
const $6cea3ab9141d1142$export$acc17f62bededcaf = (state)=>state.operations;
const $6cea3ab9141d1142$var$getOperationInitializationStatusPerEntityInternal = (0, $dGvGJ.createSelector)(// @ts-expect-error - TS2571 - Object is of type 'unknown'.
(state)=>state.operations, (operations)=>(0, (/*@__PURE__*/$parcel$interopDefault($dPSWJ)))((0, (/*@__PURE__*/$parcel$interopDefault($4Xk2W)))(operations, ({ id: id })=>id), ({ isInitializing: isInitializing })=>isInitializing));
const $6cea3ab9141d1142$export$69a0d9b5be75b55d = (state)=>$6cea3ab9141d1142$var$getOperationInitializationStatusPerEntityInternal(state);
const $6cea3ab9141d1142$export$65890ce3309e3ccf = (state)=>state.app.props.isOnboardingEnabled;
const $6cea3ab9141d1142$export$ee9bc95b4b33fe7b = (state)=>state.app.props.onboardingSpotlightTargets;
const $6cea3ab9141d1142$export$98db60f26810390 = (state)=>state.app.props.renderOnboardingSpotlight;
const $6cea3ab9141d1142$export$1faee8e10b588885 = (state)=>(id, colIndex)=>$6cea3ab9141d1142$export$ee9bc95b4b33fe7b(state).find((c)=>c.entityId === id && c.colIndex === colIndex);
const $6cea3ab9141d1142$export$7eda79d5ce9a0b8b = (state)=>// @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'string[]'.
    (0, $dGvGJ.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
    $6cea3ab9141d1142$export$6847365bea1c5392, $6cea3ab9141d1142$export$add6bf8e4261fead, $6cea3ab9141d1142$export$1fe43832be7d1fcb, $6cea3ab9141d1142$export$1faee8e10b588885, (tableConfig, dataProvider, entitiesIds, getSpotlightCellTarget)=>{
        const availableSpotlightTargets = [];
        const ids = dataProvider ? dataProvider.getData().map((entity)=>dataProvider.idSelector(entity)) : entitiesIds;
        if (ids && tableConfig) ids.forEach((entityId)=>{
            for(let i = 0; i < tableConfig.length; i += 1){
                const cellMatch = getSpotlightCellTarget(entityId, i);
                if (cellMatch && cellMatch.spotlightId) availableSpotlightTargets.push(entityId);
            }
        });
        return availableSpotlightTargets;
    })(state);

});


parcelRegister("eh8lN", function(module, exports) {

$parcel$export(module.exports, "default", () => $37ecadf93c93225f$export$2e2bcd8739ae039);
parcelRequire("6hSeW");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $k15gu = parcelRequire("k15gu");


var $lxmKy = parcelRequire("lxmKy");

var $eVVoZ = parcelRequire("eVVoZ");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$37ecadf93c93225f$export$2e2bcd8739ae039 = (action$, store)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    action$.ofType((0, $lxmKy.ENTITY_UPDATED)).mergeMap((action)=>{
        const { id: id, operation: operation, patch: patch } = action.payload;
        const state = store.getState();
        const currentPage = (0, $eVVoZ.getPage)(state);
        if (patch) {
            (0, $eVVoZ.getOnPatch)(state)({
                id: id,
                patch: patch
            }); // change page's state with a patch instead of reloading a table's page
            return (0, $kVLXA.Observable).empty();
        }
        if (operation === (0, $088bf273559ead46$export$4bd2facc4a3e6aa1)) {
            const itemsPerPage = (0, $eVVoZ.getItemsPerPage)(state);
            const totalItems = (0, $eVVoZ.getTotalItems)(state);
            const predictedPage = (0, $k15gu.predictPageToRequestAfterItemDeletion)(itemsPerPage, totalItems, currentPage);
            (0, $eVVoZ.getOnReload)(state)({
                page: predictedPage
            });
        } else (0, $eVVoZ.getOnReload)(state)({
            page: currentPage
        });
        return (0, $kVLXA.Observable).empty();
    });

});
const $088bf273559ead46$export$250171a898bf7ef = 'EDIT';
const $088bf273559ead46$export$4bd2facc4a3e6aa1 = 'DELETE';
const $088bf273559ead46$export$257be95a51c84145 = 'DUPLICATE';
const $088bf273559ead46$export$a7c1ec142e70d69d = 'ARCHIVE';
const $088bf273559ead46$export$92f9e1ed9114d3a6 = 'COPY';
const $088bf273559ead46$export$346f08c1f0d0fe41 = 'MOVE';
const $088bf273559ead46$export$bbf2495ca7d54c9f = 'SHOW_DETAILS';
const $088bf273559ead46$export$39d2a7fb21967424 = 'CHANGE_OWNER';
const $088bf273559ead46$export$2b848a0670941e75 = 'TRASH';
const $088bf273559ead46$export$aeed50488a8a79d7 = 'RESTORE';

parcelRegister("lxmKy", function(module, exports) {

$parcel$export(module.exports, "INITIATE", () => $7c27857a14ac40bb$export$643daa42aa3148d5);
$parcel$export(module.exports, "initiate", () => $7c27857a14ac40bb$export$b14c4413e822aa8d);
$parcel$export(module.exports, "ENTITY_DATA_RETRIEVE_FAILED", () => $7c27857a14ac40bb$export$d5657bfeb6a06769);
$parcel$export(module.exports, "entityDataRetrieveFailed", () => $7c27857a14ac40bb$export$7771a5f3a1cb2756);
$parcel$export(module.exports, "DIALOG_SHOWN", () => $7c27857a14ac40bb$export$54e32bf20c0b405b);
$parcel$export(module.exports, "dialogShown", () => $7c27857a14ac40bb$export$7aca9ee5930fa3ea);
$parcel$export(module.exports, "ENTITY_UPDATED", () => $7c27857a14ac40bb$export$93e8e914b5b8b20d);
$parcel$export(module.exports, "entityUpdated", () => $7c27857a14ac40bb$export$c0932263cb70e08f);
$parcel$export(module.exports, "ENTITY_UPDATE_FAILED", () => $7c27857a14ac40bb$export$d2d41c22dcb7b1db);
$parcel$export(module.exports, "entityUpdateFailed", () => $7c27857a14ac40bb$export$fbb84be2ae83b4ed);
$parcel$export(module.exports, "CANCELLED", () => $7c27857a14ac40bb$export$6b4658081fcf1aed);
$parcel$export(module.exports, "cancelled", () => $7c27857a14ac40bb$export$b108ea1063c657e3);
// initiate
const $7c27857a14ac40bb$export$643daa42aa3148d5 = 'state.actions.operation.INITIATE';
const $7c27857a14ac40bb$export$b14c4413e822aa8d = (payload)=>({
        type: $7c27857a14ac40bb$export$643daa42aa3148d5,
        payload: payload
    });
const $7c27857a14ac40bb$export$d5657bfeb6a06769 = 'state.actions.operation.ENTITY_DATA_RETRIEVE_FAILED';
const $7c27857a14ac40bb$export$7771a5f3a1cb2756 = (payload)=>({
        type: $7c27857a14ac40bb$export$d5657bfeb6a06769,
        payload: payload
    });
const $7c27857a14ac40bb$export$54e32bf20c0b405b = 'state.actions.operation.DIALOG_SHOWN';
const $7c27857a14ac40bb$export$7aca9ee5930fa3ea = (payload)=>({
        type: $7c27857a14ac40bb$export$54e32bf20c0b405b,
        payload: payload
    });
const $7c27857a14ac40bb$export$93e8e914b5b8b20d = 'state.actions.operation.ENTITY_UPDATED';
const $7c27857a14ac40bb$export$c0932263cb70e08f = (payload)=>({
        type: $7c27857a14ac40bb$export$93e8e914b5b8b20d,
        payload: payload
    });
const $7c27857a14ac40bb$export$d2d41c22dcb7b1db = 'state.actions.operation.ENTITY_UPDATE_FAILED';
const $7c27857a14ac40bb$export$fbb84be2ae83b4ed = (payload)=>({
        type: $7c27857a14ac40bb$export$d2d41c22dcb7b1db,
        payload: payload
    });
const $7c27857a14ac40bb$export$6b4658081fcf1aed = 'state.actions.operation.CANCELLED';
const $7c27857a14ac40bb$export$b108ea1063c657e3 = (payload)=>({
        type: $7c27857a14ac40bb$export$6b4658081fcf1aed,
        payload: payload
    });

});



parcelRegister("5wSMM", function(module, exports) {

$parcel$export(module.exports, "SET_APP_PROPS", () => $2b3ff44e59fa5c9c$export$8aefe701a6f431e0);
$parcel$export(module.exports, "setAppProps", () => $2b3ff44e59fa5c9c$export$cfda7627848a58cd);
const $2b3ff44e59fa5c9c$export$8aefe701a6f431e0 = 'state.actions.app.SET_APP_PROPS';
const $2b3ff44e59fa5c9c$export$cfda7627848a58cd = (payload)=>({
        type: $2b3ff44e59fa5c9c$export$8aefe701a6f431e0,
        payload: payload
    });

});

parcelRegister("iqNVX", function(module, exports) {

$parcel$export(module.exports, "default", () => $908bc238b7ffec6c$export$2e2bcd8739ae039);

var $F2Mxm = parcelRequire("F2Mxm");

var $1EQqh = parcelRequire("1EQqh");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$908bc238b7ffec6c$export$2e2bcd8739ae039 = (rootEpic)=>{
    // @ts-expect-error - TS2322 - Type 'Reducer<unknown>' is not assignable to type 'Reducer<TState>'.
    const fixedTypeRootReducer = (0, $1EQqh.default);
    // @ts-expect-error - TS2344 - Type 'TAction' does not satisfy the constraint '{ type: any; }'.
    return (0, $F2Mxm.default)({
        appName: 'directory-base',
        rootReducer: fixedTypeRootReducer,
        rootEpic: rootEpic
    });
};

});
parcelRegister("1EQqh", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7f8876305395d63$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $bDEL5 = parcelRequire("bDEL5");

var $grerf = parcelRequire("grerf");

var $9Oh3c = parcelRequire("9Oh3c");
var $b7f8876305395d63$export$2e2bcd8739ae039 = (0, $3f2cs.combineReducers)({
    app: $bDEL5.default,
    create: $grerf.default,
    operations: $9Oh3c.default
});

});
parcelRegister("bDEL5", function(module, exports) {

$parcel$export(module.exports, "default", () => $6089ea8d621e8008$export$2e2bcd8739ae039);

var $5wSMM = parcelRequire("5wSMM");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6089ea8d621e8008$export$2e2bcd8739ae039 = (state = {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    props: undefined
}, action)=>{
    switch(action.type){
        case 0, $5wSMM.SET_APP_PROPS:
            return {
                ...state,
                props: action.payload
            };
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};

});

parcelRegister("grerf", function(module, exports) {

$parcel$export(module.exports, "default", () => $e84fac704b397d4d$export$2e2bcd8739ae039);

var $26mQL = parcelRequire("26mQL");
const $e84fac704b397d4d$var$initialState = {
    isOpen: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e84fac704b397d4d$export$2e2bcd8739ae039 = (state = $e84fac704b397d4d$var$initialState, action)=>{
    switch(action.type){
        case 0, $26mQL.INITIATE:
            return {
                isOpen: true
            };
        case 0, $26mQL.ENTITY_CREATED:
        case 0, $26mQL.ENTITY_CREATE_FAILED:
        case 0, $26mQL.CANCELLED:
            return {
                isOpen: false
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("9Oh3c", function(module, exports) {

$parcel$export(module.exports, "default", () => $32f9982687de3ac1$export$2e2bcd8739ae039);

var $lxmKy = parcelRequire("lxmKy");
const $32f9982687de3ac1$var$reducer = (state = [], action)=>{
    switch(action.type){
        case 0, $lxmKy.INITIATE:
            // adding new operation to array will render new <OperationModal>, showing new dialog/modal in UI
            return [
                ...state,
                {
                    ...action.payload,
                    isInitializing: true
                }
            ];
        case 0, $lxmKy.DIALOG_SHOWN:
            // change isInitializing from true to false
            return [
                ...state.filter(({ id: id, operation: operation })=>id !== action.payload.id || operation !== action.payload.operation),
                {
                    ...action.payload,
                    isInitializing: false
                }
            ];
        case 0, $lxmKy.ENTITY_DATA_RETRIEVE_FAILED:
        case 0, $lxmKy.ENTITY_UPDATED:
        case 0, $lxmKy.ENTITY_UPDATE_FAILED:
        case 0, $lxmKy.CANCELLED:
            return state.filter(({ id: id, operation: operation })=>id !== action.payload.id || operation !== action.payload.operation);
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};
var $32f9982687de3ac1$export$2e2bcd8739ae039 = $32f9982687de3ac1$var$reducer;

});



parcelRegister("iOBt9", function(module, exports) {

$parcel$export(module.exports, "default", () => $63bf7e60b7f91719$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $6E8KZ = parcelRequire("6E8KZ");

var $lm3g2 = parcelRequire("lm3g2");

var $gZxo5 = parcelRequire("gZxo5");

var $1Evzn = parcelRequire("1Evzn");
var $63bf7e60b7f91719$export$2e2bcd8739ae039 = (0, $bC2fB.connect)(()=>({
        Content: $lm3g2.default,
        Modals: $gZxo5.default
    }), null, null, (0, $6E8KZ.storeOptions))((0, $1Evzn.default));

});
parcelRegister("lm3g2", function(module, exports) {

$parcel$export(module.exports, "default", () => $cdf0f9e385dafe4e$export$2e2bcd8739ae039);

var $8QpSo = parcelRequire("8QpSo");

var $bC2fB = parcelRequire("bC2fB");

var $6dDSs = parcelRequire("6dDSs");

var $l3DlM = parcelRequire("l3DlM");

var $6E8KZ = parcelRequire("6E8KZ");

var $26mQL = parcelRequire("26mQL");

var $eVVoZ = parcelRequire("eVVoZ");

var $hLegl = parcelRequire("hLegl");

var $gSSqP = parcelRequire("gSSqP");

var $geyiO = parcelRequire("geyiO");

var $fjCWQ = parcelRequire("fjCWQ");

var $1zjdB = parcelRequire("1zjdB");

var $do0bP = parcelRequire("do0bP");

var $gO9Up = parcelRequire("gO9Up");
const $cdf0f9e385dafe4e$var$getEmptyViewSelectorMemoized = ()=>(0, $6dDSs.createSelector)((state)=>(0, $l3DlM.withMountReporting)((0, $eVVoZ.getEmptyView)(state)), (res)=>res);
const $cdf0f9e385dafe4e$var$getErrorViewSelectorMemoized = ()=>(0, $6dDSs.createSelector)((state)=>(0, $l3DlM.withMountReporting)((0, $eVVoZ.getErrorView)(state)), (res)=>res);
const $cdf0f9e385dafe4e$var$getAvailableSpotlightTargetsSelectorMemoized = ()=>(0, $6dDSs.createSelector)((state)=>(0, $eVVoZ.getAvailableSpotlightTargets)(state), (res)=>res);
const $cdf0f9e385dafe4e$var$mapStateToPropsFactory = ()=>{
    const getEmptyViewSelectorInstance = $cdf0f9e385dafe4e$var$getEmptyViewSelectorMemoized();
    const getErrorViewSelectorInstance = $cdf0f9e385dafe4e$var$getErrorViewSelectorMemoized();
    const getAvailableSpotlightTargetsSelectorInstance = $cdf0f9e385dafe4e$var$getAvailableSpotlightTargetsSelectorMemoized();
    const onRetryFactory = (0, $8QpSo.default)((state)=>()=>(0, $eVVoZ.getOnReload)(state)({}));
    return (state)=>{
        let Header;
        const FilterView = (0, $eVVoZ.getFilterView)(state);
        if (FilterView) Header = (0, $gSSqP.default);
        else {
            const headerConfiguration = (0, $eVVoZ.getHeaderConfiguration)(state);
            if (headerConfiguration) {
                // @ts-expect-error - TS2339 - Property 'View' does not exist on type 'HeaderConfiguration<TFilter>'.
                if (headerConfiguration.View) Header = (0, $fjCWQ.default);
                else Header = (0, $geyiO.default);
            }
        }
        return {
            Header: Header,
            Table: $do0bP.default,
            Paginator: $1zjdB.default,
            Empty: getEmptyViewSelectorInstance(state),
            Error: getErrorViewSelectorInstance(state),
            status: (0, $hLegl.getStatus)(state),
            onRetry: onRetryFactory(state),
            isOnboardingEnabled: (0, $eVVoZ.getIsOnboardingEnabled)(state),
            renderOnboardingSpotlight: (0, $eVVoZ.getRenderOnboardingSpotlight)(state),
            availableSpotlightTargets: getAvailableSpotlightTargetsSelectorInstance(state)
        };
    };
};
const $cdf0f9e385dafe4e$var$mapDispatchToProps = {
    onAdd: (0, $26mQL.initiate)
};
var $cdf0f9e385dafe4e$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($cdf0f9e385dafe4e$var$mapStateToPropsFactory, $cdf0f9e385dafe4e$var$mapDispatchToProps, null, (0, $6E8KZ.storeOptions))((0, $gO9Up.default));

});
parcelRegister("l3DlM", function(module, exports) {

$parcel$export(module.exports, "withMountReporting", () => $626145856bfd7724$export$95fa4b7a60ebef6);
$parcel$export(module.exports, "default", () => $626145856bfd7724$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gAeCk = parcelRequire("gAeCk");

var $bKLSv = parcelRequire("bKLSv");
// eslint-disable-next-line jira/react/no-class-components
class $626145856bfd7724$var$Reporter extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            performanceMarkKey: undefined
        };
    }
    componentDidMount() {
        this.props.onMounted();
    }
    render() {
        const { performanceMarkKey: performanceMarkKey } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, performanceMarkKey && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gAeCk.default), {
            metricKey: performanceMarkKey
        }), this.props.children);
    }
}
function $626145856bfd7724$export$95fa4b7a60ebef6(Wrapped) {
    return (props)=>{
        const { performanceMarkKey: performanceMarkKey, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bKLSv.default).Consumer, null, ({ reportMount: reportMount })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($626145856bfd7724$var$Reporter, {
                onMounted: reportMount,
                performanceMarkKey: performanceMarkKey
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Wrapped, rest)));
    };
}
const $626145856bfd7724$var$MountReporter = $626145856bfd7724$export$95fa4b7a60ebef6(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null));
var $626145856bfd7724$export$2e2bcd8739ae039 = $626145856bfd7724$var$MountReporter;

});

parcelRegister("hLegl", function(module, exports) {

$parcel$export(module.exports, "getStatus", () => $2846182b2726a0e3$export$b70265791d2079d4);

var $eVVoZ = parcelRequire("eVVoZ");
const $2846182b2726a0e3$export$b70265791d2079d4 = (state)=>{
    if ((0, $eVVoZ.isError)(state)) return 'error';
    if ((0, $eVVoZ.isLoading)(state)) return 'has-entities';
    const dataProvider = (0, $eVVoZ.getDataProvider)(state);
    const elementsCount = dataProvider ? dataProvider.getData().length : (0, $eVVoZ.getEntityIds)(state).length;
    return elementsCount === 0 && (0, $eVVoZ.getFilter)(state) === undefined && (0, $eVVoZ.getPage)(state) === 1 ? 'empty' : 'has-entities';
};

});

parcelRegister("gSSqP", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebd0a798fbf431b0$export$2e2bcd8739ae039);

var $8QpSo = parcelRequire("8QpSo");

var $6E8KZ = parcelRequire("6E8KZ");

var $eVVoZ = parcelRequire("eVVoZ");

var $hLegl = parcelRequire("hLegl");

var $6Wj1D = parcelRequire("6Wj1D");
const $ebd0a798fbf431b0$var$mapStateToPropsFactory = ()=>{
    const onFilterFactory = (0, $8QpSo.default)((state)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (filter)=>(0, $eVVoZ.getOnReload)(state)({
                page: 1,
                filter: filter
            }));
    return (state)=>({
            FilterView: (0, $eVVoZ.getFilterView)(state),
            onFilter: onFilterFactory(state),
            hasEntities: (0, $hLegl.getStatus)(state) === 'has-entities'
        });
};
var // @ts-expect-error - TS2554 - Expected 3-4 arguments, but got 2. | TS2345 - Argument of type '<T>(props: Props<T>) => false | Element' is not assignable to parameter of type 'Component<DispatchProp<any>>'.
$ebd0a798fbf431b0$export$2e2bcd8739ae039 = (0, $6E8KZ.connect)($ebd0a798fbf431b0$var$mapStateToPropsFactory, {})((0, $6Wj1D.default));

});
parcelRegister("6Wj1D", function(module, exports) {

$parcel$export(module.exports, "default", () => $5eb63d55477b9357$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
function $5eb63d55477b9357$export$2e2bcd8739ae039(props) {
    const { hasEntities: hasEntities, FilterView: FilterView, onFilter: onFilter } = props;
    return hasEntities ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $5eb63d55477b9357$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FilterView, {
        onFilter: onFilter
    })) : null;
}
const $5eb63d55477b9357$var$wrapperStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.200'
});

});


parcelRegister("geyiO", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef20ad5474450900$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $6E8KZ = parcelRequire("6E8KZ");

var $eVVoZ = parcelRequire("eVVoZ");

var $hLegl = parcelRequire("hLegl");

var $kBSkq = parcelRequire("kBSkq");

var $9WoAf = parcelRequire("9WoAf");

var $gg466 = parcelRequire("gg466");
const $ef20ad5474450900$var$mapStateToProps = (state)=>{
    const headerConfiguration = (0, $eVVoZ.getHeaderConfiguration)(state);
    // @ts-expect-error - TS2339 - Property 'View' does not exist on type 'HeaderConfiguration<TFilter>'.
    if (!headerConfiguration || headerConfiguration.View) throw new Error('Invalid state - Default Header view must not be mounted');
    return {
        Filter: $9WoAf.default,
        // @ts-expect-error - TS2339 - Property 'ActionsView' does not exist on type 'HeaderConfiguration<TFilter>'.
        Actions: headerConfiguration.ActionsView || (0, $kBSkq.default),
        hasEntities: (0, $hLegl.getStatus)(state) === 'has-entities',
        // @ts-expect-error - TS2339 - Property 'caption' does not exist on type 'HeaderConfiguration<TFilter>'.
        caption: headerConfiguration.caption || null
    };
};
var // @ts-expect-error - TS2345 - Argument of type 'ComponentType<Diff<Record<any, any> | (Record<any, any> & { children?: ReactNode; }), InjectIntlVoidProps>>' is not assignable to parameter of type 'Component<DispatchProp<any> & { Filter: ComponentClass<Omit<DispatchProp<any>, "dispatch">> & { WrappedComponent: Component<DispatchProp<any>>; }; Actions: any; hasEntities: boolean; caption: any; }>'.
$ef20ad5474450900$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($ef20ad5474450900$var$mapStateToProps, null, null, (0, $6E8KZ.storeOptions))((0, $gg466.default));

});
parcelRegister("kBSkq", function(module, exports) {

$parcel$export(module.exports, "default", () => $665d045383a33008$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $6E8KZ = parcelRequire("6E8KZ");

var $26mQL = parcelRequire("26mQL");

var $eVVoZ = parcelRequire("eVVoZ");

var $k0n1b = parcelRequire("k0n1b");
const $665d045383a33008$var$mapStateToProps = (state)=>{
    const headerConfiguration = (0, $eVVoZ.getHeaderConfiguration)(state);
    // @ts-expect-error - TS2339 - Property 'View' does not exist on type 'HeaderConfiguration<TFilter>'. | TS2339 - Property 'ActionsView' does not exist on type 'HeaderConfiguration<TFilter>'.
    if (headerConfiguration && !headerConfiguration.View && !headerConfiguration.ActionsView) {
        // @ts-expect-error - TS2339 - Property 'isAddAllowed' does not exist on type 'HeaderConfiguration<TFilter>'. | TS2339 - Property 'addButtonCaption' does not exist on type 'HeaderConfiguration<TFilter>'.
        const { isAddAllowed: isAddAllowed, addButtonCaption: addButtonCaption } = headerConfiguration;
        return {
            canAdd: isAddAllowed,
            caption: addButtonCaption
        };
    }
    return {};
};
const $665d045383a33008$var$mapDispatchToProps = {
    onAdd: (0, $26mQL.initiate)
};
var $665d045383a33008$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($665d045383a33008$var$mapStateToProps, $665d045383a33008$var$mapDispatchToProps, null, (0, $6E8KZ.storeOptions))((0, $k0n1b.default));

});
parcelRegister("k0n1b", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e2628b3f0abf572$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $koVbs = parcelRequire("koVbs");
function $5e2628b3f0abf572$var$Add(props) {
    const { canAdd: canAdd, caption: caption, onAdd: onAdd } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return canAdd ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "primary",
        onClick: onAdd
    }, caption && formatMessage(caption)) : null;
}
$5e2628b3f0abf572$var$Add.defaultProps = {
    canAdd: false
};
var $5e2628b3f0abf572$export$2e2bcd8739ae039 = $5e2628b3f0abf572$var$Add;

});


parcelRegister("9WoAf", function(module, exports) {

$parcel$export(module.exports, "default", () => $900e6ddadbcb8d02$export$2e2bcd8739ae039);

var $8QpSo = parcelRequire("8QpSo");

var $6E8KZ = parcelRequire("6E8KZ");

var $eVVoZ = parcelRequire("eVVoZ");

var $fwdEW = parcelRequire("fwdEW");
const $900e6ddadbcb8d02$var$mapStateToPropsFactory = ()=>{
    const onFilterFactory = (0, $8QpSo.default)((state)=>(filter)=>(0, $eVVoZ.getOnReload)(state)({
                page: 1,
                filter: filter
            }));
    return (state)=>{
        const headerConfiguration = (0, $eVVoZ.getHeaderConfiguration)(state);
        // @ts-expect-error - TS2339 - Property 'FilterView' does not exist on type 'HeaderConfiguration<TFilter>'.
        if (!headerConfiguration || !headerConfiguration.FilterView) throw new Error('Invalid state - Filter wrapper must not be mounted');
        return {
            // @ts-expect-error - TS2339 - Property 'FilterView' does not exist on type 'HeaderConfiguration<TFilter>'.
            FilterView: headerConfiguration.FilterView,
            onFilter: onFilterFactory(state)
        };
    };
};
var // @ts-expect-error - TS2554 - Expected 3-4 arguments, but got 2. | TS2345 - Argument of type 'typeof Filter' is not assignable to parameter of type 'Component<DispatchProp<any>>'.
$900e6ddadbcb8d02$export$2e2bcd8739ae039 = (0, $6E8KZ.connect)($900e6ddadbcb8d02$var$mapStateToPropsFactory, {})((0, $fwdEW.default));

});
parcelRegister("fwdEW", function(module, exports) {

$parcel$export(module.exports, "default", () => $2acfb424a6da5ad8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $2acfb424a6da5ad8$export$2e2bcd8739ae039(props) {
    const { FilterView: FilterView, onFilter: onFilter } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FilterView, {
        onFilter: onFilter
    });
}

});


parcelRegister("gg466", function(module, exports) {

$parcel$export(module.exports, "default", () => $c60de6ef876d0e76$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cS37j = parcelRequire("cS37j");

var $az4zD = parcelRequire("az4zD");
function $c60de6ef876d0e76$var$Default(props) {
    const { Filter: Filter, Actions: Actions, caption: caption, hasEntities: hasEntities, intl: { formatMessage: formatMessage } } = props;
    let searchBar = null;
    let actions = null;
    if (hasEntities) {
        searchBar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Filter, null);
        actions = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Actions, null);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cS37j.default), {
        truncateTitle: true,
        actions: actions,
        bottomBar: searchBar
    }, caption ? formatMessage(caption) : '');
}
var $c60de6ef876d0e76$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($c60de6ef876d0e76$var$Default);

});


parcelRegister("fjCWQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $06b8144acd42bd1f$export$2e2bcd8739ae039);

var $8QpSo = parcelRequire("8QpSo");

var $6E8KZ = parcelRequire("6E8KZ");

var $26mQL = parcelRequire("26mQL");

var $eVVoZ = parcelRequire("eVVoZ");

var $hLegl = parcelRequire("hLegl");

var $1F2yg = parcelRequire("1F2yg");
const $06b8144acd42bd1f$var$mapStateToPropsFactory = ()=>{
    const onFilterFactory = (0, $8QpSo.default)((state)=>(filter)=>(0, $eVVoZ.getOnReload)(state)({
                page: 1,
                filter: filter
            }));
    return (state)=>{
        const headerConfiguration = (0, $eVVoZ.getHeaderConfiguration)(state);
        // @ts-expect-error - TS2339 - Property 'View' does not exist on type 'HeaderConfiguration<TFilter>'.
        if (!headerConfiguration || !headerConfiguration.View) throw new Error('Invalid state - Header wrapper must not be mounted');
        return {
            // @ts-expect-error - TS2339 - Property 'View' does not exist on type 'HeaderConfiguration<TFilter>'.
            HeaderView: headerConfiguration.View,
            hasEntities: (0, $hLegl.getStatus)(state) === 'has-entities',
            onFilter: onFilterFactory(state)
        };
    };
};
const $06b8144acd42bd1f$var$mapDispatchToProps = {
    onAdd: (0, $26mQL.initiate)
};
var // @ts-expect-error - TS2554 - Expected 3-4 arguments, but got 2. | TS2345 - Argument of type 'typeof Wrapper' is not assignable to parameter of type 'Component<DispatchProp<any>>'.
$06b8144acd42bd1f$export$2e2bcd8739ae039 = (0, $6E8KZ.connect)($06b8144acd42bd1f$var$mapStateToPropsFactory, $06b8144acd42bd1f$var$mapDispatchToProps)((0, $1F2yg.default));

});
parcelRegister("1F2yg", function(module, exports) {

$parcel$export(module.exports, "default", () => $197bfc3e7904115c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $197bfc3e7904115c$export$2e2bcd8739ae039(props) {
    const { HeaderView: HeaderView, hasEntities: hasEntities, onAdd: onAdd, onFilter: onFilter } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(HeaderView, {
        hasEntities: hasEntities,
        onAdd: onAdd,
        onFilter: onFilter
    });
}

});


parcelRegister("1zjdB", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c7e92938aa45f06$export$2e2bcd8739ae039);

var $8QpSo = parcelRequire("8QpSo");

var $bC2fB = parcelRequire("bC2fB");

var $6E8KZ = parcelRequire("6E8KZ");

var $eVVoZ = parcelRequire("eVVoZ");

var $hNlad = parcelRequire("hNlad");
const $6c7e92938aa45f06$var$mapStateToPropsFactory = ()=>{
    const onPageChangeFactory = (0, $8QpSo.default)(// @ts-expect-error - TS7006 - Parameter 'event' implicitly has an 'any' type. | TS7006 - Parameter 'page' implicitly has an 'any' type.
    (state)=>(event, page)=>(0, $eVVoZ.getOnReload)(state)({
                page: page
            }));
    return (state)=>({
            currentPage: (0, $eVVoZ.getPage)(state),
            totalPages: (0, $eVVoZ.getTotalPages)(state),
            onPageChange: onPageChangeFactory(state)
        });
};
var $6c7e92938aa45f06$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($6c7e92938aa45f06$var$mapStateToPropsFactory, {}, null, (0, $6E8KZ.storeOptions))((0, $hNlad.default));

});
parcelRegister("hNlad", function(module, exports) {

$parcel$export(module.exports, "default", () => $83c4a3856827caa5$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $iASWI = parcelRequire("iASWI");

var $xBgAj = parcelRequire("xBgAj");

var $bUmQV = parcelRequire("bUmQV");

var $az4zD = parcelRequire("az4zD");

var $8zOmE = parcelRequire("8zOmE");

var $dCm1o = parcelRequire("dCm1o");

var $4iWLf = parcelRequire("4iWLf");
function $83c4a3856827caa5$var$Paginator(props) {
    const { currentPage: currentPage, totalPages: totalPages, intl: { formatMessage: formatMessage } } = props;
    const onPageChange = (data, event, analyticsEvent)=>{
        props.onPageChange(data, event);
        if (analyticsEvent) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'pagination');
    };
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $xBgAj.default), {
        selectedIndex: currentPage - 1,
        onChange: onPageChange,
        pages: (0, (/*@__PURE__*/$parcel$interopDefault($iASWI)))(1, totalPages + 1),
        previousLabel: formatMessage((0, $4iWLf.default).previousButton),
        nextLabel: formatMessage((0, $4iWLf.default).nextButton)
    });
    if (totalPages > 1) return (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUmQV.default), {
        alignItems: "center",
        justifyContent: "center",
        xcss: $83c4a3856827caa5$var$styles.paginationContainer,
        testId: "global-pages.directories.directory-base.content.paginator.container"
    }, content) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($83c4a3856827caa5$var$Container, {
        "data-test-id": "global-pages.directories.directory-base.content.paginator.container"
    }, content);
    return null;
}
var $83c4a3856827caa5$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($83c4a3856827caa5$var$Paginator);
const $83c4a3856827caa5$var$styles = {
    paginationContainer: "_n3td1ejb _18u0xmi2"
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $83c4a3856827caa5$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_n3td1ejb _18u0xmi2",
            __cmplp.className
        ])
    });
});

});
parcelRegister("xBgAj", function(module, exports) {

$parcel$export(module.exports, "default", () => $8aaadfaafd170b3c$export$2e2bcd8739ae039);
/* pagination.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $33etG = parcelRequire("33etG");

var $3zBQA = parcelRequire("3zBQA");

var $14Kfa = parcelRequire("14Kfa");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");

var $5HBW9 = parcelRequire("5HBW9");

var $15F6T = parcelRequire("15F6T");

var $lmPue = parcelRequire("lmPue");

var $fc5SA = parcelRequire("fc5SA");

var $gRWrA = parcelRequire("gRWrA");
const $8aaadfaafd170b3c$var$styles = {
    paginationMenu: "_ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t",
    paginationMenuItem: "_1pfhze3t _ect41gqc",
    navigatorIconWrapper: "_18zr12x7"
};
const $8aaadfaafd170b3c$var$analyticsAttributes = {
    componentName: 'pagination',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
function $8aaadfaafd170b3c$var$NavigatorIcon({ chevronDirection: chevronDirection }) {
    const Chevron = chevronDirection === 'left' ? (0, (/*@__PURE__*/$parcel$interopDefault($3zBQA))) : (0, (/*@__PURE__*/$parcel$interopDefault($14Kfa)));
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "span",
        xcss: $8aaadfaafd170b3c$var$styles.navigatorIconWrapper,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)(Chevron, {
            label: "",
            LEGACY_margin: `0 ${"var(--ds-space-negative-075, -6px)"}`,
            color: "currentColor",
            size: "small"
        })
    });
}
function $8aaadfaafd170b3c$var$InnerPagination({ components: components = (0, $fc5SA.emptyObject), defaultSelectedIndex: defaultSelectedIndex = 0, selectedIndex: selectedIndex, label: label = 'pagination', pageLabel: pageLabel = 'page', previousLabel: previousLabel = 'previous', nextLabel: nextLabel = 'next', style: style = (0, $fc5SA.emptyObject), max: max = 7, onChange: onChange = (0, $eGmKJ.default), pages: pages, getPageLabel: getPageLabel, renderEllipsis: renderEllipsis = (0, $lmPue.default), analyticsContext: analyticsContext, testId: testId, isDisabled: isDisabled }, ref) {
    const [selectedIndexValue, setSelectedIndexValue] = (0, $33etG.default)(selectedIndex, ()=>defaultSelectedIndex || 0);
    const onChangeWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            const { event: event, selectedPageIndex: selectedPageIndex } = value;
            if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
            if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
        },
        action: 'changed',
        actionSubject: 'pageNumber',
        analyticsData: analyticsContext,
        ...$8aaadfaafd170b3c$var$analyticsAttributes
    });
    const transform = (page, currPageIndex, testId)=>{
        const selectedPage = pages[selectedIndexValue];
        const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
        const isCurrentPage = page === selectedPage;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c0aEF.default), {
            as: "li",
            xcss: $8aaadfaafd170b3c$var$styles.paginationMenuItem,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $15F6T.default), {
                component: components.Page,
                onClick: (event)=>onChangeWithAnalytics({
                        event: event,
                        selectedPageIndex: currPageIndex
                    }),
                "aria-current": isCurrentPage ? 'page' : undefined,
                "aria-label": pageIndexLabel,
                isSelected: isCurrentPage,
                isDisabled: isDisabled,
                page: page,
                testId: testId && `${testId}--${isCurrentPage ? 'current-' : ''}page-${currPageIndex}`,
                children: getPageLabel ? getPageLabel(page, currPageIndex) : page
            })
        }, `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`);
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        testId: testId,
        style: style,
        ref: ref,
        "aria-label": label,
        as: "nav",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
            space: "space.0",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5HBW9.default), {
                    component: components.Previous,
                    onClick: (event)=>onChangeWithAnalytics({
                            event: event,
                            selectedPageIndex: selectedIndexValue - 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === 0,
                    iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)($8aaadfaafd170b3c$var$NavigatorIcon, {
                        chevronDirection: "left"
                    }),
                    "aria-label": previousLabel,
                    testId: testId && `${testId}--left-navigator`
                }, "left-navigator"),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c0aEF.default), {
                    space: "space.0",
                    alignBlock: "baseline",
                    as: "ul",
                    xcss: $8aaadfaafd170b3c$var$styles.paginationMenu,
                    children: (0, $gRWrA.default)(pages, selectedIndexValue, {
                        max: max,
                        ellipsis: renderEllipsis,
                        transform: transform
                    }, testId)
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5HBW9.default), {
                    component: components.Next,
                    onClick: (event)=>onChangeWithAnalytics({
                            event: event,
                            selectedPageIndex: selectedIndexValue + 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
                    iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)($8aaadfaafd170b3c$var$NavigatorIcon, {
                        chevronDirection: "right"
                    }),
                    "aria-label": nextLabel,
                    testId: testId && `${testId}--right-navigator`
                }, "right-navigator")
            ]
        })
    }));
}
/**
 * __Pagination__
 *
 * Pagination allows you to divide large amounts of content into smaller chunks across multiple pages.
 *
 * - [Examples](https://atlassian.design/components/pagination/examples)
 * - [Code](https://atlassian.design/components/pagination/code)
 * - [Usage](https://atlassian.design/components/pagination/usage)
 */ const $8aaadfaafd170b3c$var$Pagination = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)($8aaadfaafd170b3c$var$InnerPagination));
var $8aaadfaafd170b3c$export$2e2bcd8739ae039 = $8aaadfaafd170b3c$var$Pagination;

});
parcelRegister("3zBQA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e34bc8237f35d48455854b605c0f874a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $29a1ffa1f260b277$var$_react = $29a1ffa1f260b277$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $29a1ffa1f260b277$var$_chevronLeft = $29a1ffa1f260b277$var$_interopRequireDefault((parcelRequire("ks8FD")));

var $29a1ffa1f260b277$var$_chevronLeftLarge = $29a1ffa1f260b277$var$_interopRequireDefault((parcelRequire("a88oa")));
function $29a1ffa1f260b277$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronLeftIcon.
 * This component is ChevronLeftIcon, with `UNSAFE_fallbackIcon` set to "ChevronLeftLargeIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Navigate back, show previous page of pagination results
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $29a1ffa1f260b277$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $29a1ffa1f260b277$var$_react.default.createElement($29a1ffa1f260b277$var$_chevronLeft.default, Object.assign({
        LEGACY_fallbackIcon: $29a1ffa1f260b277$var$_chevronLeftLarge.default
    }, props));
$29a1ffa1f260b277$var$ChevronLeftIcon.Name = 'ChevronLeftIconMigration';
var $29a1ffa1f260b277$var$_default = module.exports.default = $29a1ffa1f260b277$var$ChevronLeftIcon;

});
parcelRegister("ks8FD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4b851fec559156e1edca3c5f214f4a7f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ee3d25fb52825f26$var$_react = $ee3d25fb52825f26$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ee3d25fb52825f26$var$_baseNew = $ee3d25fb52825f26$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $ee3d25fb52825f26$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Navigate back, show previous page of pagination results
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ee3d25fb52825f26$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $ee3d25fb52825f26$var$_react.default.createElement($ee3d25fb52825f26$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m9.97 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L5.56 8l5.47-5.47z"/>`
    }, props));
$ee3d25fb52825f26$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $ee3d25fb52825f26$var$_default = module.exports.default = $ee3d25fb52825f26$var$ChevronLeftIcon;

});

parcelRegister("a88oa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7601289634e055f6$var$_react = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $7601289634e055f6$var$_chevronLeft = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("ks8FD")));
function $7601289634e055f6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7601289634e055f6$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $7601289634e055f6$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props, {
        newIcon: $7601289634e055f6$var$_chevronLeft.default
    }));
$7601289634e055f6$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $7601289634e055f6$var$_default = module.exports.default = $7601289634e055f6$var$ChevronLeftLargeIcon;

});


parcelRegister("14Kfa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0d4724a1e5dc4e8ab6ea5bb133724929>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0c8a092ead4633f0$var$_react = $0c8a092ead4633f0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0c8a092ead4633f0$var$_chevronRight = $0c8a092ead4633f0$var$_interopRequireDefault((parcelRequire("bpC55")));

var $0c8a092ead4633f0$var$_chevronRightLarge = $0c8a092ead4633f0$var$_interopRequireDefault((parcelRequire("h1toL")));
function $0c8a092ead4633f0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronRightIcon.
 * This component is ChevronRightIcon, with `UNSAFE_fallbackIcon` set to "ChevronRightLargeIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Next page of pagination results, collapsed tree item, expand tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0c8a092ead4633f0$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $0c8a092ead4633f0$var$_react.default.createElement($0c8a092ead4633f0$var$_chevronRight.default, Object.assign({
        LEGACY_fallbackIcon: $0c8a092ead4633f0$var$_chevronRightLarge.default
    }, props));
$0c8a092ead4633f0$var$ChevronRightIcon.Name = 'ChevronRightIconMigration';
var $0c8a092ead4633f0$var$_default = module.exports.default = $0c8a092ead4633f0$var$ChevronRightIcon;

});
parcelRegister("h1toL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c6495598d3d7027d$var$_react = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $c6495598d3d7027d$var$_chevronRight = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("bpC55")));
function $c6495598d3d7027d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c6495598d3d7027d$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $c6495598d3d7027d$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
    }, props, {
        newIcon: $c6495598d3d7027d$var$_chevronRight.default
    }));
$c6495598d3d7027d$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $c6495598d3d7027d$var$_default = module.exports.default = $c6495598d3d7027d$var$ChevronRightLargeIcon;

});


parcelRegister("5HBW9", function(module, exports) {

$parcel$export(module.exports, "default", () => $63acbbc2953d9b5a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");
function $63acbbc2953d9b5a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
        "aria-label": props['aria-label'],
        isDisabled: props.isDisabled,
        iconBefore: props.iconBefore,
        testId: props.testId,
        onClick: props.onClick,
        component: props.component,
        appearance: "subtle"
    });
}

});

parcelRegister("15F6T", function(module, exports) {

$parcel$export(module.exports, "default", () => $097dd42f19f41562$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");
function $097dd42f19f41562$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
        ...props,
        appearance: "subtle"
    });
}

});

parcelRegister("lmPue", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d144cd0d91a90ab$export$2e2bcd8739ae039);
/* render-ellipsis.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
var $dS3PR = parcelRequire("dS3PR");

var $jldZL = parcelRequire("jldZL");
const $3d144cd0d91a90ab$var$styles = {
    container: "_1e0c1txw _kqswh2mm"
};
function $3d144cd0d91a90ab$export$2e2bcd8739ae039({ key: key, testId: testId, from: from, to: to }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "li",
        testId: testId,
        xcss: $3d144cd0d91a90ab$var$styles.container,
        paddingInline: "space.100",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dS3PR.default), {
            testId: testId && `${testId}-text`,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $jldZL.default), {
                    children: [
                        "Skipped pages from ",
                        from,
                        " to ",
                        to
                    ]
                }),
                "\u2026"
            ]
        })
    }, key);
}

});

parcelRegister("fc5SA", function(module, exports) {

$parcel$export(module.exports, "emptyObject", () => $cbef1c2cfb373aca$export$3f860eba1218f8d3);
const $cbef1c2cfb373aca$export$3f860eba1218f8d3 = {};

});

parcelRegister("gRWrA", function(module, exports) {

$parcel$export(module.exports, "default", () => $48fbac64848b775a$export$2e2bcd8739ae039);

var $8QpSo = parcelRequire("8QpSo");
// TODO: comma needed after generic declaration below, or the .tsx file thinks
// it is a JSX element. Tidy up in a future refactor.
const $48fbac64848b775a$var$collapseRange = (pages, current, { max: max, ellipsis: ellipsis, transform: transform }, testId)=>{
    const total = pages.length;
    // only need ellipsis if we have more pages than we can display
    const needEllipsis = total > max;
    // show start ellipsis if the current page is further away than max - 4 from the first page
    const hasStartEllipsis = needEllipsis && max - 4 < current;
    // show end ellipsis if the current page is further than total - max + 3 from the last page
    const hasEndEllipsis = needEllipsis && current < total - max + 3;
    const getPageComponents = (0, $8QpSo.default)((startIndex = 0, lastIndex = total)=>{
        return pages.slice(startIndex, lastIndex).map((page, index)=>transform(page, startIndex + index, testId));
    });
    if (!needEllipsis) return getPageComponents(0, total);
    if (hasStartEllipsis && !hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, 1),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: 2,
                to: total - pageCount
            }),
            ...getPageComponents(total - pageCount)
        ];
    }
    if (!hasStartEllipsis && hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, pageCount),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: pageCount + 1,
                to: total - 1
            }),
            ...getPageComponents(total - 1)
        ];
    }
    // we have both start and end ellipsis
    const pageCount = max - 4;
    return [
        ...getPageComponents(0, 1),
        ellipsis({
            key: 'ellipsis-1',
            testId: testId && `${testId}-ellipsis`,
            from: 2,
            to: current - Math.floor(pageCount / 2)
        }),
        ...getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1),
        ellipsis({
            key: 'ellipsis-2',
            testId: testId && `${testId}-ellipsis`,
            from: current + 3,
            to: total - 1
        }),
        ...getPageComponents(total - 1)
    ];
};
var $48fbac64848b775a$export$2e2bcd8739ae039 = $48fbac64848b775a$var$collapseRange;

});


parcelRegister("4iWLf", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f9b7bf6876a52ce$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3f9b7bf6876a52ce$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    previousButton: {
        "id": "directory-base.content.paginator.previous-button",
        "defaultMessage": "Previous page"
    },
    nextButton: {
        "id": "directory-base.content.paginator.next-button",
        "defaultMessage": "Next page"
    }
});

});



parcelRegister("do0bP", function(module, exports) {

$parcel$export(module.exports, "default", () => $cca8b4269a3eb958$export$2e2bcd8739ae039);

var $dGvGJ = parcelRequire("dGvGJ");

var $8QpSo = parcelRequire("8QpSo");

var $6E8KZ = parcelRequire("6E8KZ");

var $lxmKy = parcelRequire("lxmKy");

var $eVVoZ = parcelRequire("eVVoZ");

var $d0BRN = parcelRequire("d0BRN");

var $c3kRB = parcelRequire("c3kRB");

var $joT8a = parcelRequire("joT8a");
const $cca8b4269a3eb958$var$getSpotlightForCellSelectorMemoized = ()=>(0, $dGvGJ.createSelector)((state)=>(0, $eVVoZ.getSpotlightForCell)(state), (res)=>res);
const $cca8b4269a3eb958$var$mapStateToPropsFactory = ()=>{
    const getSpotlightForCellSelectorInstance = $cca8b4269a3eb958$var$getSpotlightForCellSelectorMemoized();
    const onSortFactory = (0, $8QpSo.default)(// @ts-expect-error - TS7006 - Parameter 'sort' implicitly has an 'any' type.
    (state)=>(sort)=>(0, $eVVoZ.getOnReload)(state)({
                page: 1,
                ...sort
            }));
    return (state)=>{
        // @ts-expect-error - TS2339 - Property 'View' does not exist on type 'EmptyFilterResultConfiguration'.
        const EmptyView = (0, $eVVoZ.getEmptyFilterResultConfiguration)(state).View || (0, $c3kRB.default);
        const TableMaskView = (0, $eVVoZ.getTableMaskView)(state);
        const filter = (0, $eVVoZ.getFilter)(state);
        const filterQuery = filter ? filter.query : '';
        return {
            tableConfiguration: (0, $eVVoZ.getTableConfiguration)(state),
            tableLabel: (0, $eVVoZ.getTableLabel)(state),
            resultsAnnouncerMessage: (0, $eVVoZ.getResultsAnnouncerMessage)(state),
            EmptyView: EmptyView,
            TableMaskView: TableMaskView,
            dataProvider: (0, $eVVoZ.getDataProvider)(state),
            entityIds: (0, $eVVoZ.getEntityIds)(state),
            totalItems: (0, $eVVoZ.getTotalItems)(state),
            operationInitializationStatusPerEntity: (0, $eVVoZ.getOperationInitializationStatusPerEntity)(state),
            isLoading: (0, $eVVoZ.isLoading)(state),
            sortField: (0, $eVVoZ.getSortField)(state),
            sortDirection: (0, $eVVoZ.getSortDirection)(state),
            onSort: onSortFactory(state),
            mountMetricKey: (0, $d0BRN.getTableMountedMetricKey)(state),
            getSpotlightForCell: getSpotlightForCellSelectorInstance(state),
            firstColumnHeadingAlignment: (0, $eVVoZ.getFirstColumnHeadingAlignment)(state),
            lastColumnHeadingAlignment: (0, $eVVoZ.getLastColumnHeadingAlignment)(state),
            filterQuery: filterQuery
        };
    };
};
const $cca8b4269a3eb958$var$mapDispatchToProps = {
    onOperationRequested: (0, $lxmKy.initiate)
};
var // @ts-expect-error - TS2554 - Expected 3-4 arguments, but got 2.
$cca8b4269a3eb958$export$2e2bcd8739ae039 = (0, $6E8KZ.connect)($cca8b4269a3eb958$var$mapStateToPropsFactory, $cca8b4269a3eb958$var$mapDispatchToProps)((0, $joT8a.default));

});
parcelRegister("d0BRN", function(module, exports) {

$parcel$export(module.exports, "getTableMountedMetricKey", () => $fda68c97331475d3$export$b6c1493984bb04f9);
const $fda68c97331475d3$export$b6c1493984bb04f9 = (state)=>state.app.props.metrics.tableMounted;

});

parcelRegister("c3kRB", function(module, exports) {

$parcel$export(module.exports, "default", () => $68cb0124d97ea366$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $6E8KZ = parcelRequire("6E8KZ");

var $eVVoZ = parcelRequire("eVVoZ");

var $dh6ia = parcelRequire("dh6ia");
const $68cb0124d97ea366$var$mapStateToProps = (state)=>{
    const configuration = (0, $eVVoZ.getEmptyFilterResultConfiguration)(state);
    // @ts-expect-error - TS2339 - Property 'message' does not exist on type 'EmptyFilterResultConfiguration'.
    if (!configuration.message) throw new Error('Invalid state - Default empty view should not be mounted');
    return {
        // @ts-expect-error - TS2339 - Property 'message' does not exist on type 'EmptyFilterResultConfiguration'.
        message: configuration.message
    };
};
var $68cb0124d97ea366$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($68cb0124d97ea366$var$mapStateToProps, null, null, (0, $6E8KZ.storeOptions))((0, $dh6ia.default));

});
parcelRegister("dh6ia", function(module, exports) {

$parcel$export(module.exports, "default", () => $d730ce5cb03c7be1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hTEpF = parcelRequire("hTEpF");

var $8RXs9 = parcelRequire("8RXs9");

var $k0yDo = parcelRequire("k0yDo");

var $dCm1o = parcelRequire("dCm1o");

var $jzUVR = parcelRequire("jzUVR");
function $d730ce5cb03c7be1$var$DefaultEmptyView(props) {
    const { message: message } = props;
    const { intl: { formatMessage: formatMessage } } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-test-id": "global-pages.directories.directory-base.content.table.default-empty-view.empty-state"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        imageUrl: (0, $dCm1o.isVisualRefreshEnabled)() ? (0, (/*@__PURE__*/$parcel$interopDefault($k0yDo))) : (0, (/*@__PURE__*/$parcel$interopDefault($jzUVR))),
        header: formatMessage(message),
        width: "narrow",
        headingLevel: 2
    }));
}
var $d730ce5cb03c7be1$export$2e2bcd8739ae039 = (0, $8RXs9.default)($d730ce5cb03c7be1$var$DefaultEmptyView);

});
parcelRegister("k0yDo", function(module, exports) {
module.exports = new URL("search-no-results.1d478205.svg", import.meta.url).toString();

});

parcelRegister("jzUVR", function(module, exports) {
module.exports = new URL("generic-no-results.fb302821.svg", import.meta.url).toString();

});



parcelRegister("joT8a", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c01d48f0796d7f8$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $8Rkzz = parcelRequire("8Rkzz");

var $7Jxgt = parcelRequire("7Jxgt");

var $dHbUn = parcelRequire("dHbUn");

var $5Fk4Z = parcelRequire("5Fk4Z");

var $MHKc7 = parcelRequire("MHKc7");
var $bUmQV = parcelRequire("bUmQV");
var $dS3PR = parcelRequire("dS3PR");

var $fraBZ = parcelRequire("fraBZ");


var $az4zD = parcelRequire("az4zD");

var $8zOmE = parcelRequire("8zOmE");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

var $l3DlM = parcelRequire("l3DlM");

var $8Tb2p = parcelRequire("8Tb2p");
class $5c01d48f0796d7f8$var$Table extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isLoading: false,
            entityIds: [],
            totalItems: 0,
            sortDirection: (0, $2a9e000a443b1a95$export$1dee026a19752d6b),
            mountMetricKey: undefined,
            getSpotlightForCell: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            TableMaskView: undefined,
            firstColumnHeadingAlignment: 'left',
            lastColumnHeadingAlignment: 'left',
            filterQuery: '',
            tableLabel: undefined,
            resultsAnnouncerMessage: (0, $8Tb2p.default).filterResultsAnnouncement,
            onSort: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onOperationRequested: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    componentDidUpdate(prevProps) {
        if (prevProps.sortDirection !== this.props.sortDirection || prevProps.sortField !== this.props.sortField) this.state.hasSortingChanged = true;
        if (!prevProps.isLoading && this.props.isLoading) this.state.shouldAnnounceResults = !this.state.hasSortingChanged;
        else if (prevProps.isLoading && !this.props.isLoading) this.state.hasSortingChanged = false;
        if (this.state.returnFocusTo && (0, $4R6GH.fg)('blu-7774_fix_focus_bug_table_header_in_directories')) {
            // Find the index of the sort field that we should put focus on, then go through all the headers and find the one that matches the sort field index
            const sortFieldIndex = this.props.tableConfiguration.findIndex((config)=>config.sortField === this.state.returnFocusTo);
            if (sortFieldIndex >= 0) {
                const allHeaders = globalThis.document.querySelectorAll('thead th');
                if (sortFieldIndex < allHeaders.length) {
                    const targetHeader = allHeaders[sortFieldIndex];
                    const sortButton = targetHeader.querySelector('button[aria-roledescription="Sort button"]');
                    if (sortButton instanceof HTMLElement) sortButton.focus();
                }
            }
        }
    }
    render() {
        const { tableConfiguration: tableConfiguration, entityIds: entityIds, totalItems: totalItems, EmptyView: EmptyView, isLoading: isLoading, operationInitializationStatusPerEntity: operationInitializationStatusPerEntity, sortField: sortField, sortDirection: sortDirection, mountMetricKey: mountMetricKey, getSpotlightForCell: getSpotlightForCell, TableMaskView: TableMaskView, dataProvider: dataProvider, firstColumnHeadingAlignment: firstColumnHeadingAlignment, lastColumnHeadingAlignment: lastColumnHeadingAlignment, intl: { formatMessage: formatMessage }, tableLabel: tableLabel, resultsAnnouncerMessage: resultsAnnouncerMessage } = this.props;
        const headCells = tableConfiguration.map(({ title: title, width: width, sortField: cellSortField, dataTestId: dataTestId, isIconOnlyHeader: isIconOnlyHeader, ascendingSortTooltip: ascendingSortTooltip, descendingSortTooltip: descendingSortTooltip })=>{
            let content = '';
            const wrapperProps = dataTestId ? {
                'data-test-id': dataTestId
            } : {};
            if (dataTestId) // @ts-expect-error - TS2322 - Type 'Element' is not assignable to type 'string'.
            content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5c01d48f0796d7f8$var$NonBreakingCell, wrapperProps);
            if (typeof title === 'function') {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const HeaderCell = title; // @ts-expect-error - TS2322 - Type 'Element' is not assignable to type 'string'.
                content = (()=>{
                    if (!(0, $dCm1o.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5c01d48f0796d7f8$var$HeaderWrapper, wrapperProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(HeaderCell, null));
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
                        xcss: $5c01d48f0796d7f8$var$styles.headerWrapper,
                        testId: dataTestId
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(HeaderCell, null));
                })();
            } else if (typeof title !== 'undefined') {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                const message = title; // @ts-expect-error - TS2322 - Type 'Element' is not assignable to type 'string'.
                content = (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUmQV.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
                    testId: dataTestId,
                    color: "color.text.subtle",
                    maxLines: 1,
                    weight: "bold",
                    size: "small"
                }, formatMessage(message))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5c01d48f0796d7f8$var$NonBreakingCell, wrapperProps, formatMessage(message));
            }
            return {
                key: cellSortField || (0, $7Jxgt.v1)(),
                isSortable: !!cellSortField,
                content: content,
                width: width,
                isIconOnlyHeader: (0, $dCm1o.isVisualRefreshEnabled)() ? !!isIconOnlyHeader : undefined,
                ascendingSortTooltip: ascendingSortTooltip && (0, $dCm1o.isVisualRefreshEnabled)() ? formatMessage(ascendingSortTooltip) : undefined,
                descendingSortTooltip: descendingSortTooltip && (0, $dCm1o.isVisualRefreshEnabled)() ? formatMessage(descendingSortTooltip) : undefined
            };
        });
        const head = {
            cells: headCells
        };
        const ids = dataProvider ? dataProvider.getData().map((entity)=>dataProvider.idSelector(entity)) : entityIds;
        const tableAriaLabel = tableLabel ? formatMessage(tableLabel) : undefined;
        const rowCells = ids.map((entityId, rowIndex)=>{
            // the page is already sorted (by the API), so fake key,
            // so that DynamicTable won't destroy it
            const key = sortDirection === 'DESC' ? -(rowIndex + 1) : rowIndex + 1;
            const entity = dataProvider ? dataProvider.getData()[rowIndex] : undefined;
            const cells = tableConfiguration.map(({ Cell: Cell }, colIndex)=>{
                const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Cell, {
                    id: entityId,
                    entity: entity,
                    isOperationInProgress: !!operationInitializationStatusPerEntity[entityId],
                    onOperationRequested: (operation, operationParams)=>this.props.onOperationRequested({
                            id: entityId,
                            childEntityId: operationParams && operationParams.childEntityId,
                            operation: operation
                        })
                });
                const getVisuallyRefreshedContent = (visuallyRefreshedContent)=>{
                    return visuallyRefreshedContent;
                };
                const cellMatch = getSpotlightForCell(entityId, colIndex);
                if (cellMatch && cellMatch.spotlightId) {
                    const onboardingContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
                        name: cellMatch.spotlightId
                    }, getVisuallyRefreshedContent(content));
                    return {
                        content: onboardingContent,
                        key: key
                    };
                }
                return {
                    content: getVisuallyRefreshedContent(content),
                    key: key
                };
            });
            return {
                cells: cells
            };
        });
        return(// Note: the data-test-id attribute is used by Pollinator checks in Jalapeno so avoid changing if possible
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5c01d48f0796d7f8$var$Container, {
            "data-test-id": "global-pages.directories.directory-base.content.table.container",
            firstColumnHeadingAlignment: firstColumnHeadingAlignment,
            lastColumnHeadingAlignment: lastColumnHeadingAlignment,
            visualRefreshEnabled: (0, $dCm1o.isVisualRefreshEnabled)(),
            visuallyRefreshedHeight: (0, $dCm1o.isVisualRefreshEnabled)()
        }, !isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l3DlM.default), {
            performanceMarkKey: mountMetricKey
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fraBZ.AnnouncerV2), {
            message: formatMessage(resultsAnnouncerMessage || (0, $8Tb2p.default).filterResultsAnnouncement, {
                itemCount: totalItems
            }),
            shouldAnnounce: !isLoading && this.state.shouldAnnounceResults
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dHbUn.default), {
            isFixedSize: true,
            isLoading: isLoading,
            head: head,
            rows: rowCells,
            onSort: this.onSort,
            sortKey: sortField,
            sortOrder: sortDirection,
            emptyView: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5c01d48f0796d7f8$var$EmptyLoadingView, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(EmptyView, null),
            label: tableAriaLabel
        }), TableMaskView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TableMaskView, null)));
    }
    constructor(...args){
        super(...args), this.state = {
            hasSortingChanged: false,
            shouldAnnounceResults: false,
            returnFocusTo: null
        }, /**
   * We very much wish that `attrs` is an object of this type {| key: string, sortOrder: string |}
   * but unfortunately @atlaskit/dynamic-table types do not give any guarantee of that
   * so we should be handling mixed here.
   */ this.onSort = (attrs, analyticsEvent)=>{
            // @ts-expect-error - TS2339 - Property 'key' does not exist on type 'unknown'. | TS2339 - Property 'sortOrder' does not exist on type 'unknown'.
            const { key: key, sortOrder: sortOrder } = attrs;
            const { onSort: onSort } = this.props;
            if (analyticsEvent) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'tableHeader', {
                key: key
            });
            onSort({
                sortField: key,
                sortDirection: sortOrder
            });
            if ((0, $4R6GH.fg)('blu-7774_fix_focus_bug_table_header_in_directories')) this.setState({
                returnFocusTo: key
            });
        };
    }
}
var // @ts-expect-error - Argument of type 'typeof Table' is not assignable to parameter of type 'ComponentType<WithIntlProvided<Props<unknown, string, unknown, unknown>>> & typeof Table'.
$5c01d48f0796d7f8$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($5c01d48f0796d7f8$var$Table);
const $5c01d48f0796d7f8$var$TABLE_ROW_HEIGHT = '40px'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5c01d48f0796d7f8$var$NonBreakingCell = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_o5721q9c",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5c01d48f0796d7f8$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { firstColumnHeadingAlignment: firstColumnHeadingAlignment, visuallyRefreshedHeight: visuallyRefreshedHeight, visualRefreshEnabled: visualRefreshEnabled, lastColumnHeadingAlignment: lastColumnHeadingAlignment, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1bgnkvw": (0, $lD23V.default)(__cmplp.firstColumnHeadingAlignment),
            "--_xer3jx": (0, $lD23V.default)(__cmplp.visuallyRefreshedHeight ? '16px' : '14px'),
            "--_w6gjp2": (0, $lD23V.default)(__cmplp.visualRefreshEnabled ? '16px' : '14px'),
            "--_jlq5ur": (0, $lD23V.default)(__cmplp.lastColumnHeadingAlignment)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _2ws7jp4b _p4liidpf _6autidpf _7dd61ux8 _13jcr73l _496i159m _9yen1pfg _10wbnkob _jwot4jg8",
            __cmplp.visualRefreshEnabled && "_19ibi2wt _y4wot94y _oaa6nqa1 _10okmuej _cnoh1vhk _1o7fzgxb _1m2zqbzx _1cuj1ylp _4lbnglyw _1ttwzgxb _qassi2wt _1g00i2wt",
            __cmplp.className
        ])
    });
});
const $5c01d48f0796d7f8$var$styles = {
    headerWrapper: "_19bvu2gc _u5f31b66 _ca0q1b66 _n3td1b66",
    headerWrapperOld: "_18zr1b66 _1rjcu2gc _4cvr1h6o _1bah1h6o _1bsbzwfg"
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5c01d48f0796d7f8$var$EmptyLoadingView = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1w81",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5c01d48f0796d7f8$var$HeaderWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dHbUn", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb6422faa785b221$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");


var $gS5Cm = parcelRequire("gS5Cm");

var $hiWL0 = parcelRequire("hiWL0");

var $kF3yx = parcelRequire("kF3yx");

var $fkvnY = parcelRequire("fkvnY");

var $hK8cd = parcelRequire("hK8cd");

var $dDBI6 = parcelRequire("dDBI6");

var $dk72m = parcelRequire("dk72m");

var $50Tma = parcelRequire("50Tma");

var $jlnvO = parcelRequire("jlnvO");
function $cb6422faa785b221$var$toggleSortOrder(currentSortOrder) {
    switch(currentSortOrder){
        case 0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65:
            return 0, $d43e0bb5a9200c87$export$1dee026a19752d6b;
        case 0, $d43e0bb5a9200c87$export$1dee026a19752d6b:
            return 0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65;
        default:
            return currentSortOrder;
    }
}
const $cb6422faa785b221$var$DynamicTable = ({ caption: caption, head: head, highlightedRowIndex: highlightedRowIndex, rows: rows, sortKey: sortKey, sortOrder: sortOrder, loadingLabel: loadingLabel, onPageRowsUpdate: onPageRowsUpdate, testId: testId, totalRows: passedDownTotalRows, label: label, isLoading: isLoading = false, isFixedSize: isFixedSize = false, rowsPerPage: rowsPerPage = Infinity, onSetPage: onSetPage = (0, $eGmKJ.default), onSort: providedOnSort = (0, $eGmKJ.default), page: page = 1, emptyView: emptyView, isRankable: isRankable = false, isRankingDisabled: isRankingDisabled = false, onRankStart: onRankStart = (0, $eGmKJ.default), onRankEnd: providedOnRankEnd = (0, $eGmKJ.default), loadingSpinnerSize: loadingSpinnerSize, paginationi18n: paginationi18n = {
    prev: 'Previous Page',
    next: 'Next Page',
    label: 'Pagination',
    pageLabel: 'Page'
} })=>{
    const [isRanking, setIsRanking] = (0, $5uXOq.useState)(false);
    const tableBodyRef = (0, $5uXOq.useRef)(null);
    const onSort = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: providedOnSort,
        action: 'sorted',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const onRankEnd = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: providedOnRankEnd,
        action: 'ranked',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    (0, $5uXOq.useEffect)(()=>{
        (0, $gS5Cm.validateSortKey)(sortKey, head);
        (0, $gS5Cm.assertIsSortable)(head);
    }, [
        sortKey,
        head
    ]);
    const onSortHandler = (item)=>()=>{
            const { key: key } = item;
            if (!key) return;
            if (onSort && isRankable && key === sortKey && sortOrder === (0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65)) {
                onSort({
                    key: null,
                    sortOrder: null,
                    item: item
                });
                return;
            }
            const sortOrderFormatted = key !== sortKey ? (0, $d43e0bb5a9200c87$export$1dee026a19752d6b) : $cb6422faa785b221$var$toggleSortOrder(sortOrder);
            if (onSort) onSort({
                key: key,
                item: item,
                sortOrder: sortOrderFormatted
            });
        };
    const onSetPageHandler = (page, event)=>{
        onSetPage(page, event);
    };
    const onRankStartHandler = (params)=>{
        setIsRanking(true);
        onRankStart(params);
    };
    const onRankEndHandler = (params)=>{
        setIsRanking(false);
        onRankEnd(params);
    };
    const getSpinnerSize = ()=>{
        if (loadingSpinnerSize) return loadingSpinnerSize;
        return (0, $gS5Cm.getPageRows)(rows || [], page, rowsPerPage).length > 2 ? (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3) : (0, $d43e0bb5a9200c87$export$71dd4c8ecd45e95f);
    };
    const renderEmptyBody = ()=>{
        if (isLoading) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kF3yx.EmptyViewWithFixedHeight), {
            testId: testId
        });
        return emptyView && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kF3yx.EmptyViewContainer), {
            testId: testId,
            children: emptyView
        });
    };
    const rowsLength = rows && rows.length;
    let totalPages;
    // set a flag to denote the dynamic table might get only one page of data
    // for paginated data
    let isTotalPagesControlledExternally = false;
    if (passedDownTotalRows && Number.isInteger(passedDownTotalRows) && rowsPerPage && rowsLength && rowsLength <= passedDownTotalRows) {
        /**
     * If total number of rows / records have been passed down as prop
     * Then table is being fed paginated data from server or other sources
     * In this case, we want to respect information passed down by server or external source
     * Rather than relying on our computation based on number of rows
     */ totalPages = Math.ceil(passedDownTotalRows / rowsPerPage);
        isTotalPagesControlledExternally = true;
    } else totalPages = rowsLength && rowsPerPage ? Math.ceil(rowsLength / rowsPerPage) : 0;
    totalPages = totalPages < 1 ? 1 : totalPages;
    const getPageNumber = page > totalPages ? totalPages : page; // page! required, because typescript can't yet see defaultProps to know that this won't be undefined
    const rowsExist = !!rowsLength;
    const spinnerSize = getSpinnerSize();
    const emptyBody = renderEmptyBody();
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dk72m.default), {
                isLoading: isLoading && rowsExist,
                spinnerSize: spinnerSize,
                targetRef: ()=>tableBodyRef.current,
                testId: testId,
                loadingLabel: loadingLabel,
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $hiWL0.Table), {
                    isFixedSize: isFixedSize,
                    "aria-label": label,
                    hasDataRow: rowsExist,
                    testId: testId,
                    isLoading: isLoading,
                    children: [
                        !!caption && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hiWL0.Caption), {
                            children: caption
                        }),
                        head && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jlnvO.default), {
                            head: head,
                            onSort: onSortHandler,
                            sortKey: sortKey,
                            sortOrder: sortOrder,
                            isRanking: isRanking,
                            isRankable: isRankable,
                            testId: testId
                        }),
                        rowsExist && /*#__PURE__*/ (0, $2OMIu.jsx)($cb6422faa785b221$var$TableBody, {
                            ref: tableBodyRef,
                            highlightedRowIndex: highlightedRowIndex,
                            rows: rows,
                            head: head,
                            sortKey: sortKey,
                            sortOrder: sortOrder,
                            rowsPerPage: rowsPerPage,
                            page: getPageNumber,
                            isFixedSize: isFixedSize || false,
                            onPageRowsUpdate: onPageRowsUpdate,
                            isTotalPagesControlledExternally: isTotalPagesControlledExternally,
                            testId: testId,
                            isRankable: isRankable,
                            isRanking: isRanking,
                            onRankStart: onRankStartHandler,
                            onRankEnd: onRankEndHandler,
                            isRankingDisabled: isRankingDisabled || isLoading || false
                        })
                    ]
                })
            }),
            totalPages <= 1 ? null : // only show pagination if there's MORE than 1 page
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hiWL0.PaginationWrapper), {
                testId: testId,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $50Tma.default), {
                    value: getPageNumber,
                    onChange: onSetPageHandler,
                    total: totalPages,
                    i18n: paginationi18n,
                    isDisabled: isLoading,
                    testId: testId
                })
            }),
            !rowsExist && emptyBody && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dDBI6.default), {
                isLoading: isLoading,
                spinnerSize: (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3),
                testId: testId,
                loadingLabel: loadingLabel,
                children: emptyBody
            })
        ]
    });
};

const $cb6422faa785b221$var$RankableTableBody = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("hcItm")));
const $cb6422faa785b221$var$TableBody = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function TableBody({ isRankable: isRankable = false, isRanking: isRanking, onRankStart: onRankStart, onRankEnd: onRankEnd, isRankingDisabled: isRankingDisabled, ...bodyProps }, ref) {
    const canRank = isRankable && !bodyProps.sortKey;
    /**
   * React 16 does not support SSR for lazy components,
   * so we avoid rendering the `Suspense` on the server.
   */ const [canRenderRankable, setCanRenderRankable] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (canRank) setCanRenderRankable(true);
    }, [
        canRank
    ]);
    const nonRankableBody = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fkvnY.default), {
        ref: ref,
        ...bodyProps
    });
    return canRank && canRenderRankable ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hK8cd.ErrorBoundary), {
        fallback: nonRankableBody,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
            fallback: nonRankableBody,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($cb6422faa785b221$var$RankableTableBody, {
                ref: ref,
                ...bodyProps,
                isRanking: isRanking,
                onRankStart: onRankStart,
                onRankEnd: onRankEnd,
                isRankingDisabled: isRankingDisabled
            })
        })
    }) : nonRankableBody;
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$cb6422faa785b221$export$2e2bcd8739ae039 = $cb6422faa785b221$var$DynamicTable;

});
const $d43e0bb5a9200c87$export$1dee026a19752d6b = 'ASC';
const $d43e0bb5a9200c87$export$b6abcf7fa1d94f65 = 'DESC';
const $d43e0bb5a9200c87$export$71dd4c8ecd45e95f = 'small';
const $d43e0bb5a9200c87$export$7b93a10c0fefe3e3 = 'large';
const $d43e0bb5a9200c87$export$3843c586a90b9cbf = 0.22;

parcelRegister("gS5Cm", function(module, exports) {

$parcel$export(module.exports, "getPageRows", () => $7f55105045703159$export$3987dc24b734dcab);
$parcel$export(module.exports, "assertIsSortable", () => $7f55105045703159$export$5eb35a4771ec4090);
$parcel$export(module.exports, "validateSortKey", () => $7f55105045703159$export$9133f5a8bfe8a200);
$parcel$export(module.exports, "inlineStylesIfRanking", () => $7f55105045703159$export$a601f1775e10043f);
$parcel$export(module.exports, "reorderRows", () => $7f55105045703159$export$c476bbe5da59992d);
const $7f55105045703159$export$3987dc24b734dcab = (allRows, pageNumber, rowsPerPage)=>{
    if (!pageNumber || !rowsPerPage || !allRows.length) return [];
    return allRows.slice((pageNumber - 1) * rowsPerPage, pageNumber * rowsPerPage);
};
const $7f55105045703159$export$5eb35a4771ec4090 = (head)=>{
    if (!head || !head.cells) return;
    head.cells.forEach((cell)=>{
        if (cell.isSortable && !cell.key) try {
            throw Error("isSortable can't be set to true, if the 'key' prop is missing.");
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    });
};
const $7f55105045703159$export$9133f5a8bfe8a200 = (sortKey, head)=>{
    if (!sortKey) return;
    const headHasKey = head && head.cells.map((cell)=>cell.key).includes(sortKey);
    if (!headHasKey) try {
        throw Error(`Cell with ${sortKey} key not found in head.`);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
};
const $7f55105045703159$export$a601f1775e10043f = (isRanking, width, height)=>{
    if (!isRanking) return {};
    if (height) return {
        width: width,
        height: height
    };
    return {
        width: width
    };
};
const $7f55105045703159$export$92bcb1ed38b134a1 = (index, page, rowsPerPage)=>{
    const itemOnPreviousPages = rowsPerPage && isFinite(rowsPerPage) ? (page - 1) * rowsPerPage : 0;
    return index + itemOnPreviousPages;
};
const $7f55105045703159$export$c476bbe5da59992d = (rankEnd, rows, page = 1, rowsPerPage)=>{
    const { destination: destination, sourceIndex: sourceIndex } = rankEnd;
    if (!destination) return rows;
    const fromIndex = $7f55105045703159$export$92bcb1ed38b134a1(sourceIndex, page, rowsPerPage);
    const toIndex = $7f55105045703159$export$92bcb1ed38b134a1(destination.index, page, rowsPerPage);
    const reordered = rows.slice();
    const [removed] = reordered.splice(fromIndex, 1);
    reordered.splice(toIndex, 0, removed);
    return reordered;
};

});

parcelRegister("hiWL0", function(module, exports) {

$parcel$export(module.exports, "Table", () => $3b29b0d00cd7b5c6$export$54ec01a60f47d33d);
$parcel$export(module.exports, "Caption", () => $3b29b0d00cd7b5c6$export$32fbfacc5d962e0c);
$parcel$export(module.exports, "PaginationWrapper", () => $3b29b0d00cd7b5c6$export$3e5e12dc01f20a43);
/* dynamic-table.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

const $3b29b0d00cd7b5c6$var$fixedSizeTableStyles = null;
const $3b29b0d00cd7b5c6$var$tableStyles = null;
const $3b29b0d00cd7b5c6$var$bodyBorder = null;
const $3b29b0d00cd7b5c6$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ isFixedSize: isFixedSize, hasDataRow: hasDataRow, children: children, testId: testId, isLoading: isLoading, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("table", {
        inert: isLoading ? '' : undefined,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-hover-bg': `var(--ds-background-neutral-subtle-hovered, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-highlighted-bg': `var(--ds-background-selected, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-hover-highlighted-bg': `var(--ds-background-selected-hovered, ${(0, $829f609a65d26a98$export$8c13c2ee36917869)})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-row-focus-outline': `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`
        },
        ref: ref,
        ...rest,
        "data-testid": testId && `${testId}--table`,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _yq5h18uv _btyzidpf _ect41gqc",
            isFixedSize && "_1kqm1n9t",
            hasDataRow && "_179r1on0"
        ]),
        children: children
    });
});
const $3b29b0d00cd7b5c6$var$captionStyles = null;
const $3b29b0d00cd7b5c6$export$32fbfacc5d962e0c = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)("caption", {
        className: (0, $bwpsq.default)([
            "_11c8lodh _6rthu2gc _1pfh1ejb _m6k41e03"
        ]),
        children: children
    });
const $3b29b0d00cd7b5c6$var$paginationWrapperStyles = null;
const $3b29b0d00cd7b5c6$export$3e5e12dc01f20a43 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId && `${testId}--pagination--container`,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o"
        ]),
        children: children
    });

});
var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
// Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';


parcelRegister("kF3yx", function(module, exports) {

$parcel$export(module.exports, "EmptyViewWithFixedHeight", () => $0852c529eaab7231$export$8f45b9407d4090d7);
$parcel$export(module.exports, "EmptyViewContainer", () => $0852c529eaab7231$export$381ea436de119582);
/* empty-body.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $0852c529eaab7231$var$fixedHeightStyles = null;
const $0852c529eaab7231$export$8f45b9407d4090d7 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId && `${testId}--empty-view-with-fixed-height`,
        className: (0, $bwpsq.default)([
            "_4t3i1jdh"
        ]),
        children: children
    });
const $0852c529eaab7231$var$emptyViewContainerStyles = null;
const $0852c529eaab7231$export$381ea436de119582 = (props)=>{
    const { children: children, testId: testId } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId && `${testId}--empty-view-container`,
        className: (0, $bwpsq.default)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _ca0q19bv _u5f319bv _n3td19bv _19bv19bv _1bsb1ssb _y3gn1h6o"
        ]),
        children: children
    });
};

});

parcelRegister("fkvnY", function(module, exports) {

$parcel$export(module.exports, "default", () => $32bba7afdbc8736a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7bJDt = parcelRequire("7bJDt");

var $ggqAE = parcelRequire("ggqAE");
class $32bba7afdbc8736a$var$BodyComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { pageRows: pageRows, head: head, isFixedSize: isFixedSize, highlightedRowIndex: highlightedRowIndex, testId: testId, forwardedRef: forwardedRef } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)("tbody", {
            "data-testid": testId && `${testId}--body`,
            ref: forwardedRef,
            children: pageRows.map((row, rowIndex)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $ggqAE.default), {
                    head: head,
                    isFixedSize: isFixedSize,
                    row: row,
                    isHighlighted: row.isHighlighted || !!highlightedRowIndex && (typeof highlightedRowIndex === 'number' ? highlightedRowIndex === rowIndex : highlightedRowIndex.indexOf(rowIndex) > -1),
                    testId: testId
                }, row.key || rowIndex))
        });
    }
}
const $32bba7afdbc8736a$var$Body = (0, $7bJDt.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)($32bba7afdbc8736a$var$BodyComponent, {
        ...props,
        forwardedRef: ref
    });
}));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$32bba7afdbc8736a$export$2e2bcd8739ae039 = $32bba7afdbc8736a$var$Body;

});
parcelRegister("7bJDt", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc6eeecb3dc05edd$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");


var $gS5Cm = parcelRequire("gS5Cm");
const $dc6eeecb3dc05edd$var$getSortingCellValue = (cells, head, sortKey)=>{
    for(let i = 0; i < cells.length; i++){
        if (head.cells[i] && head.cells[i]?.key === sortKey) return cells[i]?.key;
    }
    return undefined;
};
// sort all rows based on sort key and order
const $dc6eeecb3dc05edd$var$getSortedRows = (head, rows, sortKey, sortOrder)=>{
    if (!sortKey || !head) return rows;
    if (!rows) return [];
    const modifier = sortOrder === (0, $d43e0bb5a9200c87$export$1dee026a19752d6b) ? 1 : -1;
    // Re-initialising an I18n Collator on every sort is performance intensive, thus constructed outside
    const collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: 'accent'
    });
    // Get copy of rows to avoid sorting prop in place
    const sortableRows = Array.from(rows);
    // Reorder rows in table based on sorting cell value
    // Algorithm will sort numerics or strings, but not both
    return sortableRows.sort((a, b)=>{
        const valA = $dc6eeecb3dc05edd$var$getSortingCellValue(a.cells, head, sortKey);
        const valB = $dc6eeecb3dc05edd$var$getSortingCellValue(b.cells, head, sortKey);
        if (valA === undefined || valB === undefined) return modifier;
        if (typeof valA !== typeof valB) {
            // numbers are always grouped higher in the sort
            if (typeof valA === 'number') return -1;
            if (typeof valB === 'number') return 1;
            // strings are grouped next
            if (typeof valA === 'string') return -1;
            if (typeof valB === 'string') return 1;
        }
        if (typeof valA === 'string' && typeof valB === 'string') return modifier * collator.compare(valA, valB);
        if (!valA && valA !== 0 || valA < valB) return -modifier;
        if (!valB && valB !== 0 || valA > valB) return modifier;
        if (valA === valB) return 0;
        return 1;
    });
};
function $dc6eeecb3dc05edd$export$2e2bcd8739ae039(WrappedComponent) {
    class WithSortedPageRows extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
        static getDerivedStateFromProps(props, state) {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, page: page, rowsPerPage: rowsPerPage, isTotalPagesControlledExternally: isTotalPagesControlledExternally } = props;
            (0, $gS5Cm.validateSortKey)(sortKey, head);
            let sortedRows;
            let pageRows;
            if (isTotalPagesControlledExternally) {
                sortedRows = rows;
                pageRows = rows;
            } else {
                sortedRows = $dc6eeecb3dc05edd$var$getSortedRows(head, rows, sortKey, sortOrder) || [];
                pageRows = (0, $gS5Cm.getPageRows)(sortedRows, page, rowsPerPage);
            }
            return {
                ...state,
                pageRows: pageRows
            };
        }
        componentDidMount() {
            this.props.onPageRowsUpdate && this.props.onPageRowsUpdate(this.state.pageRows);
        }
        componentDidUpdate(_prevProps, prevState) {
            if (this.props.onPageRowsUpdate && this.state.pageRows !== prevState.pageRows) this.props.onPageRowsUpdate(this.state.pageRows);
        }
        render() {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, rowsPerPage: rowsPerPage, page: page, forwardedRef: forwardedRef, ...restProps } = this.props;
            return /*#__PURE__*/ (0, $2OMIu.jsx)(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                pageRows: this.state.pageRows,
                head: head,
                ...restProps,
                ref: forwardedRef
            });
        }
        constructor(...args){
            super(...args), this.state = {
                pageRows: []
            };
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)(WithSortedPageRows, {
            ...props,
            forwardedRef: ref
        });
    });
}

});

parcelRegister("ggqAE", function(module, exports) {

$parcel$export(module.exports, "default", () => $136b57fea50cecd2$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $1g0dL = parcelRequire("1g0dL");

var $d9WgS = parcelRequire("d9WgS");
const $136b57fea50cecd2$var$Row = ({ row: row, head: head, testId: testId, isFixedSize: isFixedSize, isHighlighted: isHighlighted })=>{
    const { cells: cells, ...restRowProps } = row;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $d9WgS.TableBodyRow), {
        ...restRowProps,
        isHighlighted: isHighlighted,
        ...isHighlighted ? {
            'data-ts--dynamic-table--table-row--highlighted': true
        } : null,
        testId: row.testId || testId && `${testId}--row-${restRowProps.key}`,
        children: cells.map((cell, cellIndex)=>{
            const { content: content, testId: cellTestId, ...restCellProps } = cell;
            const { shouldTruncate: shouldTruncate, width: width } = (head || {
                cells: []
            }).cells[cellIndex] || {};
            return /*#__PURE__*/ (0, $5uXOq.createElement)((0, $1g0dL.TableBodyCell), {
                "data-testid": cellTestId || testId && `${testId}--cell-${cellIndex}`,
                ...restCellProps,
                isFixedSize: isFixedSize,
                key: cellIndex,
                shouldTruncate: shouldTruncate,
                width: width
            }, content);
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$136b57fea50cecd2$export$2e2bcd8739ae039 = $136b57fea50cecd2$var$Row;

});
parcelRegister("1g0dL", function(module, exports) {

$parcel$export(module.exports, "TableBodyCell", () => $11c3ea74eda01ab8$export$948e91fcef170792);
/* table-cell.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $9GQPi = parcelRequire("9GQPi");
const $11c3ea74eda01ab8$var$fixedSizeTruncateStyles = null;
const $11c3ea74eda01ab8$var$overflowTruncateStyles = null;
const $11c3ea74eda01ab8$var$truncationWidthStyles = null;
const $11c3ea74eda01ab8$var$cellStyles = null;
const $11c3ea74eda01ab8$export$948e91fcef170792 = ({ width: width, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, innerRef: innerRef, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("td", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: (0, $9GQPi.getTruncationStyleVars)({
            width: width
        }),
        // HOC withDimensions complains about the types but it is working fine
        // @ts-ignore
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_1bsb8a2a",
            isFixedSize && shouldTruncate && "_1bto1l2s _o5721q9c",
            isFixedSize && "_1reo15vq _18m915vq",
            "_19itglyw _85i51b66 _1q511b66 _y4tiu2gc _bozgu2gc _y3gn1e5h _1s37ze3t _uupyze3t",
            props.className
        ]),
        ...props
    });

});
parcelRegister("9GQPi", function(module, exports) {

$parcel$export(module.exports, "getTruncationStyleVars", () => $99c9652c1fab2b08$export$5e6497a652ae30b5);
const $99c9652c1fab2b08$var$CSS_VAR_WIDTH = '--local-dynamic-table-width';
const $99c9652c1fab2b08$export$5e6497a652ae30b5 = ({ width: width })=>typeof width !== 'undefined' ? {
        [$99c9652c1fab2b08$var$CSS_VAR_WIDTH]: `${width}%`
    } : undefined;

});


parcelRegister("d9WgS", function(module, exports) {

$parcel$export(module.exports, "TableBodyRow", () => $ba9cb59faf06ce7f$export$45f39d9c38b886d5);
/* table-row.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $ba9cb59faf06ce7f$var$rowStyles = null;
const $ba9cb59faf06ce7f$var$rowBackgroundStyles = null;
const $ba9cb59faf06ce7f$var$rowHighlightedBackgroundStyles = null;
const $ba9cb59faf06ce7f$export$45f39d9c38b886d5 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ isHighlighted: isHighlighted, children: children, style: style, testId: testId, className: className, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("tr", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        /**
   * We rely on this `className` for the `RankableTableBodyRow` to apply extra styles.
   * With Compiled it needs to be statically analyzable. It does not get applied via spread props.
   */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_bfhk1w7a _1ygbi9un _1ah312gs",
            isHighlighted ? "_bfhktkjs _irr31ae3" : "_irr3s8ts",
            className
        ]),
        ...rest,
        ref: ref,
        "data-testid": testId,
        children: children
    });
});

});



parcelRegister("hK8cd", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $883137116243a6a0$export$e926676385687eaf);

var $5uXOq = parcelRequire("5uXOq");
class $883137116243a6a0$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    render() {
        if (this.state.hasError) // You can render any custom fallback UI
        return this.props.fallback;
        return this.props.children;
    }
}

});

parcelRegister("dDBI6", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e4b90b361173610$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eZJjh = parcelRequire("eZJjh");


var $lLAKY = parcelRequire("lLAKY");
class $2e4b90b361173610$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            isLoading: true,
            spinnerSize: (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3),
            contentsOpacity: (0, $d43e0bb5a9200c87$export$3843c586a90b9cbf),
            loadingLabel: 'Loading table'
        };
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, contentsOpacity: contentsOpacity, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $lLAKY.Container), {
            testId: testId,
            children: [
                !isLoading ? children : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lLAKY.ContentsContainer), {
                    contentsOpacity: contentsOpacity,
                    testId: testId,
                    children: children
                }),
                isLoading && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lLAKY.SpinnerContainer), {
                    testId: testId,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {
                        size: spinnerSize,
                        testId: testId && `${testId}--loadingSpinner`,
                        label: loadingLabel
                    })
                })
            ]
        });
    }
}

});
parcelRegister("lLAKY", function(module, exports) {

$parcel$export(module.exports, "Container", () => $d0e2766ad96d94ad$export$42a852a2b6b56249);
$parcel$export(module.exports, "ContentsContainer", () => $d0e2766ad96d94ad$export$67c29eae8ae2137a);
$parcel$export(module.exports, "SpinnerContainer", () => $d0e2766ad96d94ad$export$a5e06607a5ac6158);
/* loading-container.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $d0e2766ad96d94ad$export$c335a80381ec61f5 = '--contents-opacity';
const $d0e2766ad96d94ad$var$containerStyles = null;
const $d0e2766ad96d94ad$export$42a852a2b6b56249 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId && `${testId}--container`,
        className: (0, $bwpsq.default)([
            "_kqswh2mm"
        ]),
        children: children
    });
const $d0e2766ad96d94ad$var$contentsContainerStyles = null;
const $d0e2766ad96d94ad$export$67c29eae8ae2137a = ({ children: children, contentsOpacity: contentsOpacity, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        style: {
            [$d0e2766ad96d94ad$export$c335a80381ec61f5]: contentsOpacity
        },
        "data-testid": testId && `${testId}--contents--container`,
        className: (0, $bwpsq.default)([
            "_tzy4saf5 _lcxvglyw"
        ]),
        children: children
    });
const $d0e2766ad96d94ad$var$spinnerContainerStyles = null;
const $d0e2766ad96d94ad$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId && `${testId}--spinner--container`,
        className: (0, $bwpsq.default)([
            "_1r04idpf _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o"
        ]),
        children: children
    });

});


parcelRegister("dk72m", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba39c903b39a83b1$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eZJjh = parcelRequire("eZJjh");


var $4xXH4 = parcelRequire("4xXH4");
class $ba39c903b39a83b1$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            isLoading: true,
            spinnerSize: (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3),
            contentsOpacity: `var(--ds-opacity-loading, ${`${0, $d43e0bb5a9200c87$export$3843c586a90b9cbf}`})`,
            loadingLabel: 'Loading table'
        };
    }
    attachListeners() {
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleResize);
    }
    detachListeners() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
    }
    updateSpinnerPosition() {
        const viewportHeight = window.innerHeight;
        const targetNode = this.getTargetNode();
        const spinnerNode = this.spinnerRef?.current;
        if (!targetNode || typeof targetNode.getBoundingClientRect !== 'function' || !spinnerNode) return;
        const targetRect = targetNode.getBoundingClientRect();
        const spinnerRect = spinnerNode.getBoundingClientRect();
        const spinnerHeight = spinnerRect.height;
        const isInViewport = this.isVerticallyVisible(targetRect, viewportHeight);
        const { top: top, bottom: bottom, height: height } = targetRect;
        if (isInViewport) {
            // The spinner may follow the element only if there is enough space:
            // Let's say the element can fit at least three spinners (vertically)
            const canFollow = height >= spinnerHeight * 3;
            if (canFollow && !this.isFullyVerticallyVisible(targetRect, viewportHeight)) {
                if (top >= 0) {
                    // Only the head of the element is visible
                    const viewportSpaceTakenByElement = viewportHeight - top;
                    const diff = viewportSpaceTakenByElement / 2 + top - spinnerHeight / 2;
                    const y = viewportSpaceTakenByElement < spinnerHeight * 3 ? top + spinnerHeight : diff;
                    this.translateSpinner(spinnerNode, y, true);
                } else if (top < 0 && bottom > viewportHeight) {
                    // The element takes all viewport, nor its head nor tail are visible
                    const y = viewportHeight / 2 - spinnerHeight / 2;
                    this.translateSpinner(spinnerNode, y, true);
                } else {
                    // Only the tail of the element is visible
                    const diff = bottom / 2 - spinnerHeight / 2;
                    const y = diff < spinnerHeight ? diff - (spinnerHeight - diff) : diff;
                    this.translateSpinner(spinnerNode, y, true);
                }
                return;
            }
        } else {
            // If both the element and the spinner are off screen - quit
            if (!this.isVerticallyVisible(spinnerRect, viewportHeight)) return;
        }
        // Three options here:
        // 1) the element is fully visible
        // 2) the element is too small for the spinner to follow
        // 3) the spinner might still be visible while the element isn't
        const containerNode = this.containerRef?.current;
        if (containerNode && typeof containerNode.getBoundingClientRect === 'function') {
            const thisTop = containerNode.getBoundingClientRect().top;
            const y = (top - thisTop) / 2;
            this.translateSpinner(spinnerNode, y, false);
        }
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $4xXH4.Container), {
            testId: testId && `${testId}--loading--container--advanced`,
            ref: this.containerRef,
            children: [
                children,
                isLoading && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4xXH4.SpinnerBackdrop), {
                    testId: testId,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4xXH4.SpinnerContainer), {
                        ref: this.spinnerRef,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {
                            size: spinnerSize,
                            testId: testId && `${testId}--loadingSpinner`,
                            label: loadingLabel
                        })
                    })
                })
            ]
        });
    }
    constructor(...args){
        super(...args), this.spinnerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.componentDidMount = ()=>{
            if (this.props.isLoading && this.hasTargetNode()) {
                this.attachListeners();
                this.updateTargetAppearance();
                this.updateSpinnerPosition();
            }
        }, this.UNSAFE_componentWillReceiveProps = (nextProps)=>{
            if (!nextProps.isLoading || !this.hasTargetNode(nextProps)) this.detachListeners();
            else if (!this.props.isLoading) this.attachListeners();
        }, this.componentDidUpdate = ()=>{
            if (this.hasTargetNode()) {
                this.updateTargetAppearance();
                if (this.props.isLoading) this.updateSpinnerPosition();
            }
        }, this.componentWillUnmount = ()=>{
            this.detachListeners();
        }, this.getTargetNode = (nextProps = this.props)=>{
            const { targetRef: targetRef } = nextProps;
            const target = targetRef?.();
            return target || this.containerRef.current;
        }, this.hasTargetNode = (nextProps)=>!!this.getTargetNode(nextProps), this.isVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            if (bottom <= 0) return false;
            return top < viewportHeight;
        }, this.isFullyVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            return top >= 0 && bottom <= viewportHeight;
        }, this.handleResize = ()=>{
            this.updateSpinnerPosition();
        }, this.handleScroll = ()=>{
            this.updateSpinnerPosition();
        }, this.translateSpinner = (spinnerNode, transformY, isFixed)=>{
            spinnerNode.style.position = isFixed ? 'fixed' : '';
            spinnerNode.style.transform = transformY !== 0 ? `translate3d(0, ${transformY}px, 0)` : '';
        }, this.updateTargetAppearance = ()=>{
            const targetNode = this.getTargetNode();
            const { isLoading: isLoading, contentsOpacity: contentsOpacity } = this.props;
            if (targetNode && targetNode.style && typeof targetNode.style === 'object') {
                targetNode.style.pointerEvents = isLoading ? 'none' : '';
                targetNode.style.opacity = isLoading ? contentsOpacity.toString() : '';
            }
        };
    }
}

});
parcelRegister("4xXH4", function(module, exports) {

$parcel$export(module.exports, "Container", () => $48301faf1109874f$export$42a852a2b6b56249);
$parcel$export(module.exports, "SpinnerBackdrop", () => $48301faf1109874f$export$aa207050321b0c53);
$parcel$export(module.exports, "SpinnerContainer", () => $48301faf1109874f$export$a5e06607a5ac6158);
/* loading-container-advanced.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $48301faf1109874f$var$containerStyles = null;
const $48301faf1109874f$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { children: children, testId: testId, ...rest } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ...rest,
        "data-testid": testId,
        ref: ref,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _6rth1ejb"
        ]),
        children: children
    });
});
const $48301faf1109874f$var$spinnerBackdropStyles = null;
const $48301faf1109874f$export$aa207050321b0c53 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId && `${testId}--spinner-backdrop`,
        className: (0, $bwpsq.default)([
            "_1r04idpf _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _lcxvglyw"
        ]),
        children: children
    });
const $48301faf1109874f$var$spinnerContainerStyles = null;
const $48301faf1109874f$export$a5e06607a5ac6158 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children }, ref)=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: ref,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _152tidpf"
        ]),
        children: children
    }));

});


parcelRegister("50Tma", function(module, exports) {

$parcel$export(module.exports, "default", () => $21d5ee5c6331aeb9$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $xBgAj = parcelRequire("xBgAj");
class $21d5ee5c6331aeb9$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { total: total, value: value = 1, i18n: i18n, testId: testId, isDisabled: isDisabled } = this.props;
        const pages = [
            ...Array(total)
        ].map((_, index)=>index + 1);
        // Pagination accepts array now thus selectedIndex starts with 0
        // So, we are substracting value by one thus not breaking dynamic table
        const selectedIndex = value - 1;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $xBgAj.default), {
            selectedIndex: selectedIndex,
            isDisabled: isDisabled,
            label: i18n?.label,
            nextLabel: i18n?.next,
            previousLabel: i18n?.prev,
            pageLabel: i18n?.pageLabel,
            onChange: this.onChange,
            pages: pages,
            testId: testId && `${testId}--pagination`
        });
    }
    constructor(...args){
        super(...args), this.onChange = (_event, newValue, analyticsEvent)=>{
            this.props.onChange(newValue, analyticsEvent);
        };
    }
}

});

parcelRegister("jlnvO", function(module, exports) {

$parcel$export(module.exports, "default", () => $097ee65829e33b82$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $gS5Cm = parcelRequire("gS5Cm");

var $9Ooyy = parcelRequire("9Ooyy");

var $a41RA = parcelRequire("a41RA");

var $7gEwE = parcelRequire("7gEwE");

var $dpXLF = parcelRequire("dpXLF");

var $BQUUh = parcelRequire("BQUUh");
class $097ee65829e33b82$var$TableHead extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    constructor(props){
        super(props);
        this.state = {
            activeSortButtonId: null
        };
    }
    UNSAFE_componentWillMount() {
        (0, $gS5Cm.validateSortKey)(this.props.sortKey, this.props.head);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) (0, $gS5Cm.validateSortKey)(nextProps.sortKey, nextProps.head);
    }
    render() {
        const { head: head, sortKey: sortKey, sortOrder: sortOrder, isFixedSize: isFixedSize, onSort: onSort, isRanking: isRanking, isRankable: isRankable, testId: testId } = this.props;
        const { activeSortButtonId: activeSortButtonId } = this.state;
        if (!head) return null;
        const HeadCellComponentOld = isRankable ? (0, $7gEwE.default) : (0, $BQUUh.default);
        const HeadCellComponent = isRankable ? (0, $a41RA.default) : (0, $dpXLF.default);
        // TODO: Remove `rest` props and use only what is explicitly in the API.
        // Some tests use this to pass in onClick and other stuff within the `head`
        // variable here, but considering it's not in the API, it should probably
        // be removed.
        const { cells: cells, ...rest } = head;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Ooyy.Head), {
            ...rest,
            isRanking: isRanking,
            testId: testId && `${testId}--head`,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("tr", {
                children: cells.map((cell, index)=>{
                    const { ascendingSortTooltip: ascendingSortTooltip, buttonAriaRoleDescription: buttonAriaRoleDescription, colSpan: colSpan, content: content, descendingSortTooltip: descendingSortTooltip, isIconOnlyHeader: isIconOnlyHeader, isSortable: isSortable, key: key, shouldTruncate: shouldTruncate, testId: cellTestId, width: width, // TODO: Remove `rest` props and use only what is explicitly in
                    // the API.
                    ...restCellProps } = cell;
                    const headCellId = `head-cell-${index}`;
                    const handleClick = ()=>{
                        this.setState({
                            activeSortButtonId: headCellId
                        });
                        if (isSortable) onSort(cell)();
                    };
                    return (0, $VSDnB.fg)('platform-component-visual-refresh') ? /*#__PURE__*/ (0, $2OMIu.jsx)(HeadCellComponent, {
                        colSpan: colSpan,
                        content: content,
                        isFixedSize: isFixedSize,
                        isIconOnlyHeader: isIconOnlyHeader,
                        isSortable: !!isSortable,
                        isRanking: isRanking,
                        headCellId: headCellId,
                        activeSortButtonId: activeSortButtonId,
                        onClick: handleClick,
                        testId: cellTestId || testId,
                        shouldTruncate: shouldTruncate,
                        sortOrder: key === sortKey ? sortOrder : undefined,
                        width: width,
                        ascendingSortTooltip: ascendingSortTooltip,
                        descendingSortTooltip: descendingSortTooltip,
                        buttonAriaRoleDescription: buttonAriaRoleDescription,
                        ...restCellProps
                    }, key || index) : /*#__PURE__*/ (0, $2OMIu.jsx)(HeadCellComponentOld, {
                        colSpan: colSpan,
                        content: content,
                        isFixedSize: isFixedSize,
                        isSortable: !!isSortable,
                        isRanking: isRanking,
                        onClick: isSortable ? onSort(cell) : undefined,
                        testId: cellTestId || testId,
                        shouldTruncate: shouldTruncate,
                        sortOrder: key === sortKey ? sortOrder : undefined,
                        width: width,
                        ...restCellProps
                    }, key || index);
                })
            })
        });
    }
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$097ee65829e33b82$export$2e2bcd8739ae039 = $097ee65829e33b82$var$TableHead;

});
parcelRegister("9Ooyy", function(module, exports) {

$parcel$export(module.exports, "Head", () => $e002e0403dc403bb$export$e93312b7773dfcac);
$parcel$export(module.exports, "HeadCell", () => $e002e0403dc403bb$export$4e8024263ace498b);
/* table-head.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");



var $9GQPi = parcelRequire("9GQPi");
const $e002e0403dc403bb$var$CSS_VAR_TEXT_COLOR = '--local-dynamic-table-text-color';
const $e002e0403dc403bb$var$rankingStyles = null;
const $e002e0403dc403bb$var$headStyles = null;
const $e002e0403dc403bb$var$overflowTruncateStyles = null;
const $e002e0403dc403bb$var$truncationWidthStyles = null;
const $e002e0403dc403bb$var$fixedSizeTruncateStyles = null;
const $e002e0403dc403bb$var$cellStyles = null;
const $e002e0403dc403bb$export$e93312b7773dfcac = ({ isRanking: isRanking, testId: testId, ...props })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("thead", {
        "data-testid": testId,
        ...props,
        className: (0, $bwpsq.default)([
            "_179rglyw",
            isRanking && "_1e0c1ule"
        ])
    });
};
const $e002e0403dc403bb$var$headCellBaseStyles = null;
const $e002e0403dc403bb$var$headCellBaseStylesOld = null;
const $e002e0403dc403bb$var$onClickStyles = null;
const $e002e0403dc403bb$var$baseStyles = null;
const $e002e0403dc403bb$var$ascendingStyles = null;
const $e002e0403dc403bb$var$descendingStyles = null;
const $e002e0403dc403bb$export$4e8024263ace498b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ width: width, children: children, isSortable: isSortable, sortOrder: sortOrder, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, onClick: onClick, style: style, testId: testId, ...rest }, ref)=>{
    const mergedStyles = {
        ...style,
        ...width && (0, $9GQPi.getTruncationStyleVars)({
            width: width
        }),
        [$e002e0403dc403bb$var$CSS_VAR_TEXT_COLOR]: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$e2ef2124cf4024b1)})`
    };
    const isASC = sortOrder === (0, $d43e0bb5a9200c87$export$1dee026a19752d6b);
    const isDESC = sortOrder === (0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65);
    const getFormattedSortOrder = ()=>{
        if (isASC) return 'ascending';
        else if (isDESC) return 'descending';
    };
    // If there is no content in the cell, it should be rendered as an empty `td`, not a `th`.
    // https://dequeuniversity.com/rules/axe/4.7/empty-table-header
    const Component = children ? 'th' : 'td';
    const isVisuallyRefreshed = (0, $VSDnB.fg)('platform-component-visual-refresh');
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        "aria-sort": getFormattedSortOrder(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: mergedStyles,
        onClick: !isVisuallyRefreshed ? onClick : undefined,
        ref: ref,
        "data-testid": testId,
        ...rest,
        className: (0, $bwpsq.default)([
            "_izbqglyw _h7alglyw _85i51b66 _1q511b66 _y4tiu2gc _bozgu2gc _y3gn1e5h _1s37ze3t _uupyze3t",
            isVisuallyRefreshed ? "_11c8dcr7 _179r1on0 _mqm2glyw _kqswh2mm _syaz34id _k48pmoej _y3gn1e5h _s7n4nkob _1ygbvd8c" : "_11c8dcr7 _179r1on0 _mqm2glyw _t51zglyw _191wglyw _vchhusvi _kqswh2mm _syaz34id _k48pmoej _y3gn1e5h _s7n4jp4b _1ygbvd8c",
            !isVisuallyRefreshed && onClick && "_irr3yw9d _d0altlke",
            "_1bsb8a2a",
            isFixedSize && shouldTruncate && "_1bto1l2s _o5721q9c",
            isFixedSize && "_1reo15vq _18m915vq",
            !isVisuallyRefreshed && isSortable && "_173zglyw _pw6dglyw _1xgk3acm _1wfn3acm _y9yonqa1 _997wnqa1 _sklb1l7b _1j091l7b _19w61ule _1w611ule _1hvvidpf _n56nidpf _wyc4idpf _1d4oidpf _no7mstnw _qh32stnw _4b5mb3bt _hn3bb3bt _14gsx0bf _cigmx0bf _c77kvia6 _qzvtu2gc _f473via6 _1fpyidpf _a04fh2mm _xv14glyw _58ej1kw7 _1ay31kw7 _mdbq1kw7 _10pp1kw7 _1yw3ze3t _n2fdze3t _8607ze3t _szhwze3t _1g2wwc43 _ze9fwc43 _1lcgnqa1 _at5qnqa1 _o4d71l7b _npl51l7b _1rp11onz _1iornqa1 _oi051l7b _1ehx1onz _19t8nqa1 _1bog1l7b",
            !isVisuallyRefreshed && isASC && "_c77k1thn _142s94yt",
            !isVisuallyRefreshed && isDESC && "_f4731thn _17x894yt"
        ]),
        children: children
    });
});

});

parcelRegister("a41RA", function(module, exports) {

$parcel$export(module.exports, "default", () => $669a06e89a9827f7$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cVljL = parcelRequire("cVljL");

var $gS5Cm = parcelRequire("gS5Cm");

var $dpXLF = parcelRequire("dpXLF");
class $669a06e89a9827f7$var$RankableTableHeadCellComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
        const inlineStyles = (0, $gS5Cm.inlineStylesIfRanking)(isRanking, refWidth);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dpXLF.default), {
            inlineStyles: inlineStyles,
            ...restProps
        });
    }
}
const $669a06e89a9827f7$var$RankableTableHeadCell = (0, $cVljL.default)($669a06e89a9827f7$var$RankableTableHeadCellComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$669a06e89a9827f7$export$2e2bcd8739ae039 = $669a06e89a9827f7$var$RankableTableHeadCell;

});
parcelRegister("cVljL", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3e49a9b167764eb$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
function $a3e49a9b167764eb$export$2e2bcd8739ae039(WrappedComponent) {
    return class WithDimensions extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
        UNSAFE_componentWillReceiveProps(nextProps) {
            const wasRanking = this.props.isRanking;
            const willRanking = nextProps.isRanking;
            if (willRanking && !wasRanking) this.updateDimensions();
        }
        render() {
            const { refWidth: refWidth, refHeight: refHeight } = this.state;
            return /*#__PURE__*/ (0, $2OMIu.jsx)(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refWidth: refWidth,
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refHeight: refHeight,
                innerRef: this.innerRef,
                ...this.props
            });
        }
        constructor(...args){
            super(...args), this.state = {
                refWidth: 0,
                refHeight: 0
            }, this.innerRef = (ref)=>{
                if (ref && !this.props.isRanking) this.ref = ref;
            }, this.updateDimensions = ()=>{
                if (!this.ref) return;
                const clientRect = this.ref.getBoundingClientRect();
                const { width: width } = clientRect;
                const { height: height } = clientRect;
                if (width !== this.state.refWidth || height !== this.state.refHeight) this.setState({
                    refWidth: width,
                    refHeight: height
                });
            };
        }
    };
}

});

parcelRegister("dpXLF", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9c80f4a483cfd6a$export$2e2bcd8739ae039);
/* table-head-cell.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $cC5ib = parcelRequire("cC5ib");

var $kcHZS = parcelRequire("kcHZS");

var $MHKc7 = parcelRequire("MHKc7");
var $bUmQV = parcelRequire("bUmQV");
var $3Lty3 = parcelRequire("3Lty3");

var $3bDjY = parcelRequire("3bDjY");


var $9Ooyy = parcelRequire("9Ooyy");
const $d9c80f4a483cfd6a$var$styles = {
    buttonWrapper: "_1e0c1txw _bfhk18uv _4cvr1h6o _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _d0altlke",
    sortIconHiddenWrapper: "_1e0c1txw _tzy4idpf _bfhk18uv _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1h7hkb7n",
    sortIconVisibleWrapper: "_1e0c1txw _tzy4kb7n _bfhk18uv _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
    hideIconHeaderWrapper: "_tzy4idpf _18u010v4",
    visibleHeaderWrapper: "_tzy4kb7n _u5f31b66"
};
const $d9c80f4a483cfd6a$var$headCellStyles = {
    headCellContainer: "_1e0c1txw _4cvr1h6o",
    text: "_11c81o8v _syaz1gjq _k48pmoej"
};
const $d9c80f4a483cfd6a$var$TableHeadCell = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, sortOrder: sortOrder, onClick: onClick, headCellId: headCellId, activeSortButtonId: activeSortButtonId, ascendingSortTooltip: ascendingSortTooltip = 'Sort ascending', descendingSortTooltip: descendingSortTooltip = 'Sort descending', buttonAriaRoleDescription: buttonAriaRoleDescription = 'Sort button', isIconOnlyHeader: isIconOnlyHeader, ...rest })=>{
    const [isHovered, setIsHovered] = (0, $5uXOq.useState)(false);
    const [isFocused, setIsFocused] = (0, $5uXOq.useState)(false);
    const isActive = headCellId === activeSortButtonId || sortOrder !== undefined;
    const isSortIconVisible = isHovered || isActive || isFocused;
    const isVisibleIconOnlyHeader = isSortIconVisible && isIconOnlyHeader;
    const shouldRenderSortIcon = !isIconOnlyHeader || isSortIconVisible || isIconOnlyHeader && !isFocused;
    const handleFocus = (0, $5uXOq.useCallback)(()=>{
        setIsFocused?.(true);
    }, [
        setIsFocused
    ]);
    const handleBlur = (0, $5uXOq.useCallback)(()=>{
        setIsFocused?.(false);
    }, [
        setIsFocused
    ]);
    const handleMouseEnter = (0, $5uXOq.useCallback)(()=>{
        setIsHovered(true);
    }, [
        setIsHovered
    ]);
    const handleMouseLeave = (0, $5uXOq.useCallback)(()=>{
        setIsHovered(false);
    }, [
        setIsHovered
    ]);
    const visuallyRefreshedButton = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: $d9c80f4a483cfd6a$var$headCellStyles.headCellContainer,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
            content: sortOrder === (0, $d43e0bb5a9200c87$export$1dee026a19752d6b) ? ascendingSortTooltip : descendingSortTooltip,
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $3Lty3.default), {
                onClick: onClick,
                xcss: $d9c80f4a483cfd6a$var$styles.buttonWrapper,
                "aria-roledescription": buttonAriaRoleDescription,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bUmQV.default), {
                        xcss: isVisibleIconOnlyHeader ? $d9c80f4a483cfd6a$var$styles.hideIconHeaderWrapper : $d9c80f4a483cfd6a$var$styles.visibleHeaderWrapper,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                            className: (0, $bwpsq.default)([
                                $d9c80f4a483cfd6a$var$headCellStyles.text
                            ]),
                            children: content
                        })
                    }),
                    shouldRenderSortIcon && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bUmQV.default), {
                        xcss: isSortIconVisible ? $d9c80f4a483cfd6a$var$styles.sortIconVisibleWrapper : $d9c80f4a483cfd6a$var$styles.sortIconHiddenWrapper,
                        children: sortOrder === (0, $d43e0bb5a9200c87$export$1dee026a19752d6b) ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kcHZS))), {
                            label: "",
                            color: "var(--ds-text-subtle, #44546F)",
                            testId: testId && `${testId}--up--icon`
                        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cC5ib))), {
                            label: "",
                            color: "var(--ds-text-subtle, #44546F)",
                            testId: testId && `${testId}--down--icon`
                        })
                    })
                ]
            })
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Ooyy.HeadCell), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: inlineStyles,
        testId: testId && `${testId}--head--cell`,
        ref: typeof innerRef !== 'string' ? innerRef : null,
        ...rest,
        isSortable: isSortable,
        sortOrder: sortOrder,
        children: isSortable ? visuallyRefreshedButton : content
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d9c80f4a483cfd6a$export$2e2bcd8739ae039 = $d9c80f4a483cfd6a$var$TableHeadCell;

});
parcelRegister("cC5ib", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d7f5a6659a6d5dd6eaa41936b6c8533f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $92ed238f23140736$var$_react = $92ed238f23140736$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $92ed238f23140736$var$_baseNew = $92ed238f23140736$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $92ed238f23140736$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Know uses: sorting table headers or Bitbucket code difference.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $92ed238f23140736$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $92ed238f23140736$var$_react.default.createElement($92ed238f23140736$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v11.44l3.72-3.72 1.06 1.06-5 5a.75.75 0 0 1-1.06 0l-5-5 1.06-1.06 3.72 3.72V1z" clip-rule="evenodd"/>`
    }, props));
$92ed238f23140736$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $92ed238f23140736$var$_default = module.exports.default = $92ed238f23140736$var$ArrowDownIcon;

});

parcelRegister("kcHZS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd7e8572b743336ba9352499cfa665f1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eb570e807ab2e210$var$_react = $eb570e807ab2e210$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $eb570e807ab2e210$var$_baseNew = $eb570e807ab2e210$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $eb570e807ab2e210$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to top.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eb570e807ab2e210$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $eb570e807ab2e210$var$_react.default.createElement($eb570e807ab2e210$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 15V3.56l3.72 3.72 1.06-1.06-5-5a.75.75 0 0 0-1.06 0l-5 5 1.06 1.06 3.72-3.72V15z" clip-rule="evenodd"/>`
    }, props));
$eb570e807ab2e210$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $eb570e807ab2e210$var$_default = module.exports.default = $eb570e807ab2e210$var$ArrowUpIcon;

});



parcelRegister("7gEwE", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fc2a0c6e4ccfbc5$export$2e2bcd8739ae039);
// Delete this file when cleaning up platform-component-visual-refresh FG

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cVljL = parcelRequire("cVljL");

var $gS5Cm = parcelRequire("gS5Cm");

var $BQUUh = parcelRequire("BQUUh");
class $5fc2a0c6e4ccfbc5$var$RankableTableHeadCellComponentOld extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
        const inlineStyles = (0, $gS5Cm.inlineStylesIfRanking)(isRanking, refWidth);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $BQUUh.default), {
            inlineStyles: inlineStyles,
            ...restProps
        });
    }
}
const $5fc2a0c6e4ccfbc5$var$RankableTableHeadCellOld = (0, $cVljL.default)($5fc2a0c6e4ccfbc5$var$RankableTableHeadCellComponentOld);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5fc2a0c6e4ccfbc5$export$2e2bcd8739ae039 = $5fc2a0c6e4ccfbc5$var$RankableTableHeadCellOld;

});
parcelRegister("BQUUh", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bd2f57a58531c0d$export$2e2bcd8739ae039);
// Delete this file when cleaning up platform-component-visual-refresh FG

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $9Ooyy = parcelRequire("9Ooyy");
const $4bd2f57a58531c0d$var$TableHeadCellOld = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, onClick: onClick, ...rest })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Ooyy.HeadCell), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: inlineStyles,
        testId: testId && `${testId}--head--cell`,
        ref: typeof innerRef !== 'string' ? innerRef : null,
        ...rest,
        onClick: onClick,
        isSortable: isSortable,
        children: isSortable ? /*#__PURE__*/ (0, $2OMIu.jsx)("button", {
            type: "button",
            "aria-roledescription": "Sort button",
            children: content
        }) : content
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4bd2f57a58531c0d$export$2e2bcd8739ae039 = $4bd2f57a58531c0d$var$TableHeadCellOld;

});



parcelRegister("hcItm", function(module, exports) {

let $c8660dfa442bff40$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $c8660dfa442bff40$var$load("76n7a"),
    $c8660dfa442bff40$var$load("l253H"),
    $c8660dfa442bff40$var$load("etJKP")
]).then(()=>parcelRequire('4THp8'));

});


parcelRegister("8Tb2p", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ccc3b7593e6b203$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3ccc3b7593e6b203$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    filterResultAnnounce: {
        "id": "directory-base.content.table.filter-result-announce",
        "defaultMessage": "{itemCount, plural, one {One item was found after filtering.} other {{itemCount} items were found after filtering.}}"
    },
    filterResultsAnnouncement: {
        "id": "directory-base.content.table.filter-results-announcement",
        "defaultMessage": "{itemCount, plural, =0 {No results were found that match your search} one {{itemCount} result found} other {{itemCount} results found}}"
    }
});

});



parcelRegister("gO9Up", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c83f1ab25cac0ee$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $imZsD = parcelRequire("imZsD");

var $3HwlS = parcelRequire("3HwlS");
const $8c83f1ab25cac0ee$var$styles = {
    pageContainerNav3: "_7opz1wug",
    pageContainerNav3inner: "_1ul94na8"
};
function $8c83f1ab25cac0ee$export$2e2bcd8739ae039(props) {
    const { Header: Header, Table: Table, Paginator: Paginator, Empty: Empty, Error: Error, status: status, onAdd: onAdd, onRetry: onRetry, isOnboardingEnabled: isOnboardingEnabled, renderOnboardingSpotlight: renderOnboardingSpotlight, availableSpotlightTargets: availableSpotlightTargets } = props;
    let main = null;
    let spotlight = null;
    let expectOverflow = false;
    switch(status){
        case 'has-entities':
            expectOverflow = true;
            main = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Table, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Paginator, null));
            spotlight = isOnboardingEnabled && renderOnboardingSpotlight && renderOnboardingSpotlight(availableSpotlightTargets);
            break;
        case 'empty':
            main = Empty ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Empty, {
                onAdd: onAdd
            }) : null;
            break;
        case 'error':
            main = Error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Error, {
                onRetry: onRetry
            }) : null;
            break;
        default:
            break;
    }
    if ((0, $3HwlS.getWillShowNav4)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, spotlight, Header ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Header, null) : null, main));
    if (expectOverflow) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), null, spotlight, Header ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Header, null) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $8c83f1ab25cac0ee$var$styles.pageContainerNav3
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $8c83f1ab25cac0ee$var$styles.pageContainerNav3inner
        ])
    }, main)));
    return expectOverflow ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $8c83f1ab25cac0ee$var$styles.pageContainerNav3
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $8c83f1ab25cac0ee$var$styles.pageContainerNav3inner
        ])
    }, spotlight, Header ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Header, null) : null, main))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, spotlight, Header ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Header, null) : null, main));
}
$8c83f1ab25cac0ee$export$2e2bcd8739ae039.defaultProps = {
    isOnboardingEnabled: false,
    renderOnboardingSpotlight: ()=>null,
    availableSpotlightTargets: [],
    onAdd: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onRetry: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};

});


parcelRegister("gZxo5", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad9e30bbc17bbf06$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $6E8KZ = parcelRequire("6E8KZ");

var $eVVoZ = parcelRequire("eVVoZ");

var $7vDsW = parcelRequire("7vDsW");

var $dXqrk = parcelRequire("dXqrk");

var $jd28H = parcelRequire("jd28H");
const $ad9e30bbc17bbf06$var$mapStateToProps = (state)=>({
        isCreateModalShown: (0, $eVVoZ.isCreateOpen)(state),
        CreateModal: $7vDsW.default,
        operations: (0, $eVVoZ.getOperations)(state),
        OperationModal: $dXqrk.default
    });
var // @ts-expect-error - TS2554 - Expected 3-4 arguments, but got 2. | TS2345 - Argument of type 'typeof Modals' is not assignable to parameter of type 'Component<DispatchProp<any>>'.
$ad9e30bbc17bbf06$export$2e2bcd8739ae039 = (0, $6E8KZ.connect)($ad9e30bbc17bbf06$var$mapStateToProps, {})((0, $jd28H.default));

});
parcelRegister("7vDsW", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7d32de1c8b6343c$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $6E8KZ = parcelRequire("6E8KZ");

var $26mQL = parcelRequire("26mQL");

var $eVVoZ = parcelRequire("eVVoZ");

var $k3e3M = parcelRequire("k3e3M");
const $f7d32de1c8b6343c$var$mapStateToProps = (state)=>{
    const CreateModal = (0, $eVVoZ.getCreateModal)(state);
    if (!CreateModal) throw new Error('Invalid state - no Create Modal provided');
    return {
        CreateModal: CreateModal
    };
};
const $f7d32de1c8b6343c$var$mapDispatchToProps = {
    onCreated: (0, $26mQL.entityCreated),
    onCreateFailed: (0, $26mQL.entityCreateFailed),
    onCancel: (0, $26mQL.cancelled)
};
var $f7d32de1c8b6343c$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($f7d32de1c8b6343c$var$mapStateToProps, $f7d32de1c8b6343c$var$mapDispatchToProps, null, (0, $6E8KZ.storeOptions))((0, $k3e3M.default));

});
parcelRegister("k3e3M", function(module, exports) {

$parcel$export(module.exports, "default", () => $4842467b44d7e63d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $4842467b44d7e63d$export$2e2bcd8739ae039(props) {
    const { CreateModal: CreateModal, onCreated: onCreated, onCreateFailed: onCreateFailed, onCancel: onCancel } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CreateModal, {
        onCreated: onCreated,
        onCreateFailed: onCreateFailed,
        onCancel: onCancel
    });
}

});


parcelRegister("dXqrk", function(module, exports) {

$parcel$export(module.exports, "default", () => $5dde6756d9548826$export$2e2bcd8739ae039);

var $8QpSo = parcelRequire("8QpSo");

var $6E8KZ = parcelRequire("6E8KZ");

var $lxmKy = parcelRequire("lxmKy");

var $eVVoZ = parcelRequire("eVVoZ");

var $1jyVQ = parcelRequire("1jyVQ");
const $5dde6756d9548826$var$mapStateToPropsFactory = ()=>{
    const onDataRetrievedFactory = (0, $8QpSo.default)((state, id)=>// @ts-expect-error - TS7031 - Binding element 'patch' implicitly has an 'any' type.
        ({ patch: patch })=>(0, $eVVoZ.getOnPatch)(state)({
                id: id,
                patch: patch
            }));
    return (state, ownProps)=>{
        const { id: id, operation: operation } = ownProps;
        return {
            OperationModal: (0, $eVVoZ.getOperationModal)(state, operation),
            onDataRetrieved: onDataRetrievedFactory(state, id)
        };
    };
};
const $5dde6756d9548826$var$mapDispatchToProps = (dispatch, ownProps)=>{
    const { id: id, operation: operation, childEntityId: childEntityId, isInitializing: isInitializing } = ownProps;
    return {
        entityId: id,
        isInitializing: isInitializing,
        onDialogShown: ()=>dispatch((0, $lxmKy.dialogShown)({
                id: id,
                operation: operation,
                childEntityId: childEntityId
            })),
        onDataRetrieveFailed: ()=>dispatch((0, $lxmKy.entityDataRetrieveFailed)({
                id: id,
                operation: operation
            })),
        // @ts-expect-error - TS2525 - Initializer provides no value for this binding element and the binding element has no default value.
        onUpdated: ({ patch: patch } = {})=>dispatch((0, $lxmKy.entityUpdated)({
                id: id,
                operation: operation,
                patch: patch
            })),
        onUpdateFailed: ()=>dispatch((0, $lxmKy.entityUpdateFailed)({
                id: id,
                operation: operation
            })),
        onCancel: ()=>dispatch((0, $lxmKy.cancelled)({
                id: id,
                operation: operation
            }))
    };
};
var // @ts-expect-error - TS2554 - Expected 3-4 arguments, but got 2. | TS2345 - Argument of type 'typeof Operation' is not assignable to parameter of type 'Component<DispatchProp<any>>'.
$5dde6756d9548826$export$2e2bcd8739ae039 = (0, $6E8KZ.connect)($5dde6756d9548826$var$mapStateToPropsFactory, $5dde6756d9548826$var$mapDispatchToProps)((0, $1jyVQ.default));

});
parcelRegister("1jyVQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd144476f98eada3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $bd144476f98eada3$export$2e2bcd8739ae039(props) {
    const { OperationModal: OperationModal, ...modalProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(OperationModal, modalProps);
}

});


parcelRegister("jd28H", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5c2b4eef0dc70b8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $a5c2b4eef0dc70b8$export$2e2bcd8739ae039(props) {
    const { isCreateModalShown: isCreateModalShown, CreateModal: CreateModal, operations: operations, OperationModal: OperationModal } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, isCreateModalShown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CreateModal, null), operations.map(({ id: id, operation: operation, childEntityId: childEntityId, isInitializing: isInitializing })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(OperationModal, {
            key: id,
            id: id,
            operation: operation,
            childEntityId: childEntityId,
            isInitializing: isInitializing
        })));
}

});


parcelRegister("1Evzn", function(module, exports) {

$parcel$export(module.exports, "default", () => $17f4de78934b94b3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $17f4de78934b94b3$export$2e2bcd8739ae039(props) {
    const { Content: Content, Modals: Modals } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Content, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Modals, null));
}

});



parcelRegister("dIWFt", function(module, exports) {

$parcel$export(module.exports, "getIds", () => $f716dc7717044b0c$export$24b60fe7179439bc);
$parcel$export(module.exports, "getTotal", () => $f716dc7717044b0c$export$94860ac4a286a8d9);
$parcel$export(module.exports, "isLoading", () => $f716dc7717044b0c$export$20bb0d907fbbe433);
$parcel$export(module.exports, "isError", () => $f716dc7717044b0c$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "getName", () => $f716dc7717044b0c$export$7d9f7e9c1c02b41e);
$parcel$export(module.exports, "getOwner", () => $f716dc7717044b0c$export$5f4ed0d56c2c0edf);
$parcel$export(module.exports, "getIsWritable", () => $f716dc7717044b0c$export$8e04de5241998cf7);
$parcel$export(module.exports, "getViewUrl", () => $f716dc7717044b0c$export$bdccd6a672e4a607);
$parcel$export(module.exports, "getShares", () => $f716dc7717044b0c$export$3b3cfad4475f6525);
$parcel$export(module.exports, "getEdits", () => $f716dc7717044b0c$export$ade2933f0cc600b);
$parcel$export(module.exports, "getSystemDashboard", () => $f716dc7717044b0c$export$3123e858ea4af38b);
$parcel$export(module.exports, "isFavorite", () => $f716dc7717044b0c$export$70b3463aa7e3e514);
$parcel$export(module.exports, "isPending", () => $f716dc7717044b0c$export$872dec21e9a69476);
$parcel$export(module.exports, "getPopularity", () => $f716dc7717044b0c$export$34145270e160ba15);
$parcel$export(module.exports, "getChangeFavorite", () => $f716dc7717044b0c$export$85b24bd43a2bd6cf);

var $aDfxw = parcelRequire("aDfxw");
const $f716dc7717044b0c$export$dd1bc94b04021eeb = (state)=>state.dashboards.order.length === 0;
const $f716dc7717044b0c$export$24b60fe7179439bc = (state)=>state.dashboards.order;
const $f716dc7717044b0c$export$94860ac4a286a8d9 = (state)=>state.dashboards.total;
const $f716dc7717044b0c$export$20bb0d907fbbe433 = (state)=>state.dashboards.isLoading;
const $f716dc7717044b0c$export$e6127cc7fe7395c3 = (state)=>state.dashboards.isError;
const $f716dc7717044b0c$export$889a4d2bde32b973 = (state, id)=>Boolean(state.dashboards.page[id]);
const $f716dc7717044b0c$export$7d9f7e9c1c02b41e = (state, id)=>state.dashboards.page[id]?.name;
const $f716dc7717044b0c$export$5f4ed0d56c2c0edf = (state, id)=>state.dashboards.page[id]?.owner;
const $f716dc7717044b0c$export$8e04de5241998cf7 = (state, id)=>state.dashboards.page[id]?.isWritable;
const $f716dc7717044b0c$export$bdccd6a672e4a607 = (state, id)=>state.dashboards.page[id]?.viewUrl;
const $f716dc7717044b0c$export$3b3cfad4475f6525 = (state, id)=>state.dashboards.page[id]?.shares;
const $f716dc7717044b0c$export$ade2933f0cc600b = (state, id)=>state.dashboards.page[id]?.edits;
const $f716dc7717044b0c$export$3123e858ea4af38b = (state, id)=>state.dashboards.page[id]?.systemDashboard;
const $f716dc7717044b0c$var$getFavoriteChangeContextItem = (state, id)=>(0, $aDfxw.getFavoriteChangeContext)(state).items.dashboards?.[id];
const $f716dc7717044b0c$export$70b3463aa7e3e514 = (state, id)=>{
    const itemChanged = $f716dc7717044b0c$var$getFavoriteChangeContextItem(state, id);
    return itemChanged ? itemChanged.value : state.dashboards.page[id]?.isFavourite;
};
const $f716dc7717044b0c$export$872dec21e9a69476 = (state, id)=>{
    const item = $f716dc7717044b0c$var$getFavoriteChangeContextItem(state, id);
    return !!(item && item.pending);
};
const $f716dc7717044b0c$export$34145270e160ba15 = (state, id)=>{
    const popularityInState = state.dashboards.page[id]?.popularity;
    const isFavoriteInState = state.dashboards.page[id]?.isFavourite;
    const item = $f716dc7717044b0c$var$getFavoriteChangeContextItem(state, id);
    if (!item) return popularityInState;
    if (item.value && !isFavoriteInState) return popularityInState + 1;
    if (!item.value && isFavoriteInState) return popularityInState - 1;
    return popularityInState;
};
const $f716dc7717044b0c$export$85b24bd43a2bd6cf = (state)=>(0, $aDfxw.getFavoriteChangeContext)(state).changeFavorite;

});

parcelRegister("aQEP9", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b0da00335ff1698$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8b0da00335ff1698$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);

});

parcelRegister("82A9p", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d208b972d083e49$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $dIWFt = parcelRequire("dIWFt");

var $9dG1D = parcelRequire("9dG1D");
const $0d208b972d083e49$var$mapStateToProps = (state)=>({
        isLoading: (0, $dIWFt.isLoading)(state)
    });
var $0d208b972d083e49$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($0d208b972d083e49$var$mapStateToProps, {})((0, $9dG1D.default));

});
parcelRegister("9dG1D", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbd90aabf9b57fe6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eae50 = parcelRequire("eae50");

var $koVbs = parcelRequire("koVbs");

var $7ftDc = parcelRequire("7ftDc");
function $fbd90aabf9b57fe6$var$Error(props) {
    const { isLoading: isLoading, onRetry: onRetry } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eae50.default), {
        header: formatMessage((0, $7ftDc.default).header),
        description: formatMessage((0, $7ftDc.default).description),
        isLoading: isLoading,
        onRetry: onRetry
    });
}
$fbd90aabf9b57fe6$var$Error.defaultProps = {
    isLoading: false
};
var $fbd90aabf9b57fe6$export$2e2bcd8739ae039 = $fbd90aabf9b57fe6$var$Error;

});
parcelRegister("eae50", function(module, exports) {

$parcel$export(module.exports, "default", () => $da809c0c454ce05f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $hTEpF = parcelRequire("hTEpF");

var $az4zD = parcelRequire("az4zD");

var $97INH = parcelRequire("97INH");

var $lNvSq = parcelRequire("lNvSq");

var $63TJV = parcelRequire("63TJV");
function $da809c0c454ce05f$export$edf27be85e5f6da0(props) {
    const { header: header, description: description, size: size, onRetry: onRetry, isLoading: isLoading, intl: { formatMessage: formatMessage }, errorImage: errorImage, isSubtle: isSubtle, imageWidth: imageWidth, maxImageHeight: maxImageHeight, retryMessage: retryMessage, renderErrorImage: renderErrorImage, headingLevel: headingLevel } = props;
    const buttonAppearance = isSubtle ? 'default' : 'primary';
    const defaultImageUrl = isSubtle ? (0, (/*@__PURE__*/$parcel$interopDefault($97INH))) : (0, (/*@__PURE__*/$parcel$interopDefault($lNvSq)));
    const fallbackImage = errorImage || defaultImageUrl;
    let imageUrl;
    if (renderErrorImage) imageUrl = undefined;
    else imageUrl = fallbackImage;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        testId: "common-components-error-state.empty-state",
        width: size,
        imageWidth: imageWidth,
        imageUrl: imageUrl,
        header: header,
        description: description,
        isLoading: isLoading,
        maxImageHeight: maxImageHeight,
        primaryAction: !onRetry ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: buttonAppearance,
            isDisabled: isLoading,
            onClick: onRetry
        }, formatMessage(retryMessage)),
        renderImage: renderErrorImage,
        headingLevel: headingLevel
    });
}
$da809c0c454ce05f$export$edf27be85e5f6da0.defaultProps = {
    header: '',
    size: 'wide',
    isLoading: false,
    isSubtle: false,
    retryMessage: (0, $63TJV.default).retry
};
var $da809c0c454ce05f$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($da809c0c454ce05f$export$edf27be85e5f6da0);

});
parcelRegister("97INH", function(module, exports) {
module.exports = new URL("error-subtle.580d9941.svg", import.meta.url).toString();

});

parcelRegister("lNvSq", function(module, exports) {
module.exports = new URL("error.4fa1b24b.svg", import.meta.url).toString();

});

parcelRegister("63TJV", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbeb04399739f055$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $cbeb04399739f055$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    retry: {
        "id": "common.components.error-state.retry-action",
        "defaultMessage": "Try again"
    }
});

});


parcelRegister("7ftDc", function(module, exports) {

$parcel$export(module.exports, "default", () => $aea94fa4ede4734f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $aea94fa4ede4734f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    header: {
        "id": "directories.dashboards-v2.main.content.error.header",
        "defaultMessage": "We couldn't load your dashboards"
    },
    description: {
        "id": "directories.dashboards-v2.main.content.error.description",
        "defaultMessage": "Give it another try. If you run into more trouble, contact your admin for help."
    }
});

});



parcelRegister("bnQis", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c596d11dea0980d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $iQv12 = parcelRequire("iQv12");

var $5JMh5 = parcelRequire("5JMh5");

var $lMdZA = parcelRequire("lMdZA");

var $fs8YG = parcelRequire("fs8YG");

var $bC2fB = parcelRequire("bC2fB");

var $imOJb = parcelRequire("imOJb");

var $FqCjF = parcelRequire("FqCjF");

var $aDfxw = parcelRequire("aDfxw");

var $eLJM4 = parcelRequire("eLJM4");

var $2Qtku = parcelRequire("2Qtku");

var $k0uL3 = parcelRequire("k0uL3");
const $0c596d11dea0980d$var$SearchWithAnalytics = (0, $iQv12.default)({
    onChange: 'search'
})((0, $5JMh5.default));
const $0c596d11dea0980d$var$OwnerPickerWithAnalytics = (0, $iQv12.default)({
    onChange: 'owner'
})((0, $imOJb.default));
const $0c596d11dea0980d$var$ProjectTypePickerWithAnalytics = (0, $iQv12.default)({
    onChange: 'project'
})((0, $fs8YG.default));
const $0c596d11dea0980d$var$GroupPickerWithAnalytics = (0, $iQv12.default)({
    onChange: 'group'
})((0, $lMdZA.default));
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0c596d11dea0980d$var$renderFilterSearch = (state)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0c596d11dea0980d$var$SearchWithAnalytics, {
            ...props,
            value: (0, $eLJM4.getSearchQuery)(state),
            isAlwaysExpanded: true,
            placeholderAlwaysVisible: true,
            shouldFitContainerWidth: true
        });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0c596d11dea0980d$var$renderOwnerPicker = (state)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0c596d11dea0980d$var$OwnerPickerWithAnalytics, {
            ...props,
            selectedUser: (0, $eLJM4.getSelectedOwner)(state),
            suggestedAccountId: (0, $aDfxw.getLoggedInUserAccountId)(state),
            baseUrl: (0, $aDfxw.getBaseUrl)(state),
            inputId: "dashboard-filters-owner-picker-select",
            isCompact: true,
            shouldFitContainer: true
        });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0c596d11dea0980d$var$renderProjectPicker = (state)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0c596d11dea0980d$var$ProjectTypePickerWithAnalytics, {
            ...props,
            selectedProject: (0, $eLJM4.getSelectedProject)(state),
            baseUrl: (0, $aDfxw.getBaseUrl)(state),
            isCompact: true,
            inputId: "dashboard-filters-project-picker-select",
            width: "100%"
        });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0c596d11dea0980d$var$renderGroupPicker = (state)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0c596d11dea0980d$var$GroupPickerWithAnalytics, {
            ...props,
            selectedGroup: (0, $eLJM4.getSelectedGroup)(state),
            baseUrl: (0, $aDfxw.getBaseUrl)(state),
            isCompact: true,
            inputId: "dashboard-filters-group-picker-select",
            width: "100%"
        });
const $0c596d11dea0980d$var$renderClear = (state)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (props)=>(0, $eLJM4.isFilterApplied)(state) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Qtku.default), props);
const $0c596d11dea0980d$var$mapStateToPropsFactory = ()=>{
    const renderFilterSearchFactory = (0, $8QpSo.default)($0c596d11dea0980d$var$renderFilterSearch);
    const renderOwnerPickerFactory = (0, $8QpSo.default)($0c596d11dea0980d$var$renderOwnerPicker);
    const renderProjectPickerFactory = (0, $8QpSo.default)($0c596d11dea0980d$var$renderProjectPicker);
    const renderGroupPickerFactory = (0, $8QpSo.default)($0c596d11dea0980d$var$renderGroupPicker);
    const renderClearFactory = (0, $8QpSo.default)($0c596d11dea0980d$var$renderClear);
    return (state, ownProps)=>({
            renderFilterSearch: renderFilterSearchFactory(state),
            renderOwnerPicker: renderOwnerPickerFactory(state),
            renderProjectPicker: renderProjectPickerFactory(state),
            renderGroupPicker: renderGroupPickerFactory(state),
            renderClear: renderClearFactory(state),
            initialFilter: (0, $FqCjF.initialQuery).filter,
            value: (0, $eLJM4.getFilter)(state),
            onChange: ownProps.onFilter
        });
};
var $0c596d11dea0980d$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($0c596d11dea0980d$var$mapStateToPropsFactory, {})((0, $k0uL3.default));

});
parcelRegister("5JMh5", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c6c98eab5c64edc$export$2e2bcd8739ae039);

var $8oe80 = parcelRequire("8oe80");

var $3as6V = parcelRequire("3as6V");
var $1c6c98eab5c64edc$export$2e2bcd8739ae039 = (0, $8oe80.default)('filterSearch', {
    onChange: 'changed'
})((0, $3as6V.default));

});
parcelRegister("3as6V", function(module, exports) {

$parcel$export(module.exports, "default", () => $466d610aa4e058b2$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $2xSAL = parcelRequire("2xSAL");

var $dCm1o = parcelRequire("dCm1o");
const $466d610aa4e058b2$export$4c4c11a6ab1f5b09 = 1000;
const $466d610aa4e058b2$var$debouncedSearch = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((value, callback)=>callback(value), $466d610aa4e058b2$export$4c4c11a6ab1f5b09);
// eslint-disable-next-line jira/react/no-class-components
class $466d610aa4e058b2$var$Filter extends (0, $5uXOq.PureComponent) {
    static{
        this.defaultProps = {
            value: '',
            placeholder: '',
            describedById: '',
            hasAutoFocus: false,
            isCompact: true,
            increasedWidth: false,
            placeholderAlwaysVisible: false
        };
    }
    getSearchValue(value) {
        const searchValue = value === this.prevSearchValue ? this.prevQueryValue : value;
        if (value !== this.prevSearchValue) {
            this.prevSearchValue = value;
            this.prevQueryValue = value;
        }
        return searchValue;
    }
    render() {
        const searchValue = this.getSearchValue(this.props.value);
        const { hasAutoFocus: autoFocus, ariaLabelText: ariaLabelText, ...props } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2xSAL.SearchField), {
            ...props,
            autoFocus: autoFocus,
            value: searchValue,
            onChange: this.handleOnChange,
            onEnter: this.handleNewValue,
            ariaLabelText: ariaLabelText,
            showIconBeforeInput: (0, $dCm1o.isVisualRefreshEnabled)()
        });
    }
    constructor(...args){
        super(...args), this.prevQueryValue = this.props.value, this.prevSearchValue = this.props.value, this.handleNewValue = (newValue)=>{
            $466d610aa4e058b2$var$debouncedSearch.cancel();
            if (newValue !== this.props.value) this.props.onChange(newValue);
        }, this.handleOnChange = (newValue)=>{
            this.prevQueryValue = newValue;
            newValue === '' ? this.handleNewValue(newValue) : $466d610aa4e058b2$var$debouncedSearch(newValue, this.handleNewValue);
        };
    }
}
var $466d610aa4e058b2$export$2e2bcd8739ae039 = $466d610aa4e058b2$var$Filter;

});
parcelRegister("2xSAL", function(module, exports) {

$parcel$export(module.exports, "SearchField", () => $f115db1c327fbbaa$export$b94867ecbd698f21);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $fW62l = parcelRequire("fW62l");

var $2NMNM = parcelRequire("2NMNM");

var $kY99m = parcelRequire("kY99m");

var $3bDjY = parcelRequire("3bDjY");

var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $7mPT9 = parcelRequire("7mPT9");

var $4R6GH = parcelRequire("4R6GH");

var $6cG4N = parcelRequire("6cG4N");

var $a2e2Q = parcelRequire("a2e2Q");

var $lmBAt = parcelRequire("lmBAt");

var $cBssJ = parcelRequire("cBssJ");

var $hJBhl = parcelRequire("hJBhl");

var $5yLnO = parcelRequire("5yLnO");
function $f115db1c327fbbaa$export$41946885a418e1(object) {
    return 'ref' in object && 'data-test-id' in object;
}
// This class prevents filled in input field causing confirmation dialog
// when user wants to navigate away. This functionality is coming from Jira monolith.
const $f115db1c327fbbaa$var$className = 'ajs-dirty-warning-exempt';
const $f115db1c327fbbaa$var$SearchFieldContainer = ({ shouldFitContainerWidth: shouldFitContainerWidth, reducedHeight: reducedHeight, children: children })=>{
    const { isSoftwareFullTheming: isSoftwareFullTheming } = (0, $a2e2Q.useSoftwareProjectTheming)();
    return (0, $lmBAt.getIsSoftwareThemingM2Enabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: [
            shouldFitContainerWidth && $f115db1c327fbbaa$var$fitContainerStyles,
            (0, $dCm1o.isVisualRefreshEnabled)() && reducedHeight && $f115db1c327fbbaa$var$reducedHeightStyles,
            isSoftwareFullTheming && $f115db1c327fbbaa$var$themedBgStyles
        ]
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f115db1c327fbbaa$var$Container, {
        shouldFitContainerWidth: shouldFitContainerWidth,
        ...(0, $dCm1o.isVisualRefreshEnabled)() ? {
            reducedHeight: reducedHeight
        } : {}
    }, children);
};
const $f115db1c327fbbaa$var$SearchFieldUnmemoized = ({ onEnter: onEnter, onChange: onChange, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder = '', inputRef: inputRef, value: externalValue, autoFocus: autoFocus = false, isCompact: isCompact = false, isDisabled: isDisabled = false, shouldFitContainerWidth: shouldFitContainerWidth = false, isAutocompleteDisabled: isAutocompleteDisabled = false, placeholderAlwaysVisible: placeholderAlwaysVisible = false, searchIconVisible: searchIconVisible = true, isAlwaysExpanded: isAlwaysExpanded = false, increasedWidth: increasedWidth = false, reducedHeight: reducedHeight = false, maxLength: maxLength, describedById: describedById = '', ariaLabelText: ariaLabelText, id: id, renderCustomSearchField: renderCustomSearchField, searchIconPrimaryColor: searchIconPrimaryColor, testId: testId, inputProps: inputProps = {}, isResponsive: isResponsive = false, showIconBeforeInput: showIconBeforeInput = false, renderTooltipContent: renderTooltipContent = null })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [isFocused, setIsFocused] = (0, $5uXOq.useState)(false);
    const [value, setValue] = (0, $5uXOq.useState)(externalValue || '');
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const textInput = (0, $5uXOq.useRef)(null);
    const previousValueRef = (0, $5uXOq.useRef)();
    const previousValue = previousValueRef.current;
    if (externalValue !== previousValue && externalValue !== value) // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'SetStateAction<string>'.
    setValue(externalValue);
    previousValueRef.current = externalValue;
    const handleOnFocus = (0, $5uXOq.useCallback)((event)=>{
        setIsFocused(true);
        onFocus && onFocus(event);
    }, [
        onFocus
    ]);
    const handleOnBlur = (0, $5uXOq.useCallback)((event)=>{
        onBlur && onBlur(event);
        setIsFocused(false);
    }, [
        onBlur
    ]);
    const handleOnChange = (0, $5uXOq.useCallback)(({ currentTarget: currentTarget })=>{
        const { value: val } = currentTarget;
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed'
        });
        setValue(val);
        onChange(val, analyticsEvent);
    }, [
        createAnalyticsEvent,
        onChange
    ]);
    const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed'
        });
        if (event.key === 'Escape') {
            setValue('');
            onChange('', analyticsEvent);
        }
        if (onEnter && event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('enter')) {
            event.preventDefault();
            onEnter(event.currentTarget && event.currentTarget.value);
        }
    }, [
        createAnalyticsEvent,
        onChange,
        onEnter
    ]);
    const handleOnClear = (0, $5uXOq.useCallback)(()=>{
        if (value !== '') {
            const analyticsEvent = createAnalyticsEvent({
                action: 'changed'
            });
            setValue('');
            onChange('', analyticsEvent);
        }
        if (inputRef && inputRef.current !== null) inputRef.current.blur();
        if (textInput.current !== null) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        textInput.current.blur();
    }, [
        createAnalyticsEvent,
        inputRef,
        onChange,
        value
    ]);
    const isExpanded = isFocused || value !== '' || isAlwaysExpanded;
    const textFieldProps = (0, $4R6GH.fg)('filter_refinement_search_field_tooltip') ? // condition is because of fg
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useMemo)(()=>{
        return {
            ...inputProps,
            'aria-label': ariaLabelText || placeholder || formatMessage((0, $cBssJ.messages).search),
            'aria-describedby': describedById,
            type: 'text',
            'data-test-id': 'searchfield',
            testId: testId ?? 'searchfield',
            name: 'search',
            className: $f115db1c327fbbaa$var$className,
            placeholder: placeholder,
            onFocus: handleOnFocus,
            onBlur: handleOnBlur,
            width: '120px',
            onChange: handleOnChange,
            onKeyDown: handleKeyDown,
            ref: inputRef || textInput,
            isCompact: isCompact,
            autoFocus: autoFocus,
            autoComplete: isAutocompleteDisabled ? 'off' : 'on',
            value: value,
            maxLength: maxLength,
            isDisabled: isDisabled
        };
    }, [
        ariaLabelText,
        autoFocus,
        describedById,
        formatMessage,
        handleKeyDown,
        handleOnBlur,
        handleOnChange,
        handleOnFocus,
        inputProps,
        inputRef,
        isAutocompleteDisabled,
        isCompact,
        isDisabled,
        maxLength,
        placeholder,
        testId,
        value
    ]) : {
        ...inputProps,
        'aria-label': ariaLabelText || placeholder || formatMessage((0, $cBssJ.messages).search),
        'aria-describedby': describedById,
        type: 'text',
        'data-test-id': 'searchfield',
        testId: testId ?? 'searchfield',
        name: 'search',
        className: $f115db1c327fbbaa$var$className,
        placeholder: placeholder,
        onFocus: handleOnFocus,
        onBlur: handleOnBlur,
        width: '120px',
        onChange: handleOnChange,
        onKeyDown: handleKeyDown,
        ref: inputRef || textInput,
        isCompact: isCompact,
        autoFocus: autoFocus,
        autoComplete: isAutocompleteDisabled ? 'off' : 'on',
        value: value,
        maxLength: maxLength,
        isDisabled: isDisabled
    };
    const searchIconDynamic = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5yLnO.SearchFieldIconDynamic), {
        onClear: handleOnClear,
        hasValue: value !== '',
        clearIconLabel: formatMessage((0, $cBssJ.messages).clear),
        searchIconVisible: searchIconVisible,
        primaryColor: (0, $dCm1o.isVisualRefreshEnabled)() ? undefined : searchIconPrimaryColor,
        onlyIconSpacing: isResponsive && !isExpanded
    });
    const searchIcon = showIconBeforeInput ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5yLnO.SearchFieldIcon), {
        searchIconVisible: searchIconVisible,
        onlyIconSpacing: isResponsive && !isExpanded
    }) : undefined;
    const clearIcon = showIconBeforeInput && value !== '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hJBhl.ClearFieldIcon), {
        onClear: handleOnClear,
        clearIconLabel: formatMessage((0, $cBssJ.messages).clear)
    }) : undefined;
    if ($f115db1c327fbbaa$export$41946885a418e1(textFieldProps) && (0, $4R6GH.fg)('filter_refinement_search_field_tooltip')) {
        const { onFocus: onFocusTextField, ref: textFieldRef, 'aria-describedby': textfieldAriaDescription, onBlur: onBlurTextField, ...restTextFieldProps } = textFieldProps; // condition is just because of fg
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const showTooltip = (0, $5uXOq.useMemo)(()=>{
            return renderTooltipContent !== null && renderTooltipContent !== undefined && value === '';
        }, [
            renderTooltipContent,
            value
        ]); // condition is because of fg - remove disabled eslint rule once fg is removed
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const useShowTooltip = (0, $5uXOq.useCallback)(()=>showTooltip, [
            showTooltip
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f115db1c327fbbaa$var$SearchFieldContainer, {
            shouldFitContainerWidth: shouldFitContainerWidth,
            reducedHeight: reducedHeight
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f115db1c327fbbaa$var$InputWrapper, {
            isExpanded: isExpanded,
            shouldFitContainerWidth: shouldFitContainerWidth,
            maxWidth: increasedWidth ? 328 : 184,
            placeholderAlwaysVisible: placeholderAlwaysVisible,
            isResponsive: isResponsive
        }, renderCustomSearchField !== undefined ? renderCustomSearchField({
            textFieldProps: textFieldProps,
            searchIcon: searchIconDynamic
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: renderTooltipContent,
            canAppear: useShowTooltip,
            position: "bottom-start",
            hideTooltipOnClick: true,
            ignoreTooltipPointerEvents: true
        }, ({ onFocus: onFocusTooltip, ref: tooltipRef, 'aria-describedby': tooltipAriaDescription, onBlur: onBlurTooltip, ...tooltipProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
                ...tooltipProps,
                ...restTextFieldProps,
                elemBeforeInput: searchIcon,
                elemAfterInput: !showIconBeforeInput ? searchIconDynamic : clearIcon,
                ...id !== undefined ? {
                    id: id
                } : {},
                // eslint-disable-next-line react-hooks/rules-of-hooks
                onFocus: (0, $5uXOq.useCallback)((event)=>{
                    onFocusTextField && onFocusTextField(event);
                    onFocusTooltip(event);
                }, [
                    onFocusTooltip
                ]),
                // eslint-disable-next-line react-hooks/rules-of-hooks
                onBlur: (0, $5uXOq.useCallback)((event)=>{
                    onBlurTextField && onBlurTextField(event);
                    onBlurTooltip(event);
                }, [
                    onBlurTooltip
                ]),
                ref: (0, $7mPT9.mergeRefs)(textFieldRef, tooltipRef),
                "aria-describedby": tooltipAriaDescription || textfieldAriaDescription
            }))));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f115db1c327fbbaa$var$SearchFieldContainer, {
        shouldFitContainerWidth: shouldFitContainerWidth,
        reducedHeight: reducedHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f115db1c327fbbaa$var$InputWrapper, {
        isExpanded: isExpanded,
        shouldFitContainerWidth: shouldFitContainerWidth,
        maxWidth: increasedWidth ? 328 : 184,
        placeholderAlwaysVisible: placeholderAlwaysVisible,
        isResponsive: isResponsive
    }, renderCustomSearchField !== undefined ? renderCustomSearchField({
        textFieldProps: textFieldProps,
        searchIcon: searchIconDynamic
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
        ...textFieldProps,
        elemBeforeInput: searchIcon,
        elemAfterInput: !showIconBeforeInput ? searchIconDynamic : clearIcon,
        ...id !== undefined ? {
            id: id
        } : {}
    })));
};
$f115db1c327fbbaa$var$SearchFieldUnmemoized.displayName = 'Search';
$f115db1c327fbbaa$var$SearchFieldUnmemoized.whyDidYouRender = true;
const $f115db1c327fbbaa$export$b94867ecbd698f21 = /*#__PURE__*/ (0, $5uXOq.memo)($f115db1c327fbbaa$var$SearchFieldUnmemoized);
$f115db1c327fbbaa$export$b94867ecbd698f21.displayName = 'Search';
const $f115db1c327fbbaa$var$fitContainerStyles = (0, $8CUq3.xcss)({
    width: '100%'
});
const $f115db1c327fbbaa$var$reducedHeightStyles = (0, $8CUq3.xcss)({
    height: '32px'
});
const $f115db1c327fbbaa$var$themedBgStyles = (0, $8CUq3.xcss)({
    // @ts-expect-error - Apply the dominant colour behind the search input for image background themes
    backgroundColor: (0, $6cG4N.Tokens).COLOR_ELEVATION_SURFACE /* eslint-disable-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values */ ,
    borderRadius: "var(--ds-border-radius, 4px)"
}); // Delete when cleaning up getIsSoftwareThemingM2Enabled
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f115db1c327fbbaa$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldFitContainerWidth: shouldFitContainerWidth, reducedHeight: reducedHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.shouldFitContainerWidth && "_1bsb1osq",
            __cmplp.reducedHeight && "_4t3izwfg",
            __cmplp.className
        ])
    });
});
const $f115db1c327fbbaa$var$InputWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { placeholderAlwaysVisible: placeholderAlwaysVisible, isResponsive: isResponsive, maxWidth: maxWidth, isExpanded: isExpanded, shouldFitContainerWidth: shouldFitContainerWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1et2rhb": (0, $lD23V.default)(__cmplp.maxWidth, "px"),
            "--_47juog": (0, $lD23V.default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '30px'),
            "--_5cv8rq": (0, $lD23V.default)(__cmplp.isExpanded ? 'auto' : '32px'),
            "--_jy5l88": (0, $lD23V.default)(__cmplp.isExpanded ? `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}` : "var(--ds-space-0, 0px)"),
            "--_1skyi4s": (0, $lD23V.default)(__cmplp.isExpanded ? 'auto' : 0),
            "--_1qenfck": (0, $lD23V.default)(__cmplp.isExpanded ? 1 : 0),
            "--_1b7586u": (0, $lD23V.default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '120px'),
            "--_1b72lxu": (0, $lD23V.default)(__cmplp.shouldFitContainerWidth ? '100%' : `${__cmplp.isExpanded ? __cmplp.maxWidth : 120}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_v564zpk5 _1e0c1txw _166qglyw _101ad2bq _i2ybkb7n",
            __cmplp.placeholderAlwaysVisible ? "_lav0kb7n" : "_lav0idpf",
            __cmplp.isResponsive ? "_1bsb1ayu _1s4pflvl _1kneabdv _odci1sf5 _ffa416hp _5xde1wic _1hr27bcq" : "_1bsb1di6",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cBssJ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $08273d4fc2a6d6da$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $08273d4fc2a6d6da$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    clear: {
        "id": "searchfield.clear",
        "defaultMessage": "Clear"
    },
    search: {
        "id": "searchfield.search",
        "defaultMessage": "Search"
    }
});

});

parcelRegister("hJBhl", function(module, exports) {

$parcel$export(module.exports, "ClearFieldIcon", () => $99940a7c159b00c0$export$84038b503874befa);

var $5uXOq = parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");

var $1EekA = parcelRequire("1EekA");

var $dC5iT = parcelRequire("dC5iT");
var $h9kUS = parcelRequire("h9kUS");
var $8CUq3 = parcelRequire("8CUq3");
const $99940a7c159b00c0$export$84038b503874befa = ({ onClear: onClear, clearIconLabel: clearIconLabel })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $99940a7c159b00c0$var$wrapperStylesCloseIcon
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        appearance: "subtle",
        testId: "searchfield.ui.clearfield-icon.clear-button",
        onClick: onClear,
        label: clearIconLabel,
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1EekA)))
    }));
const $99940a7c159b00c0$var$wrapperStylesCloseIcon = (0, $8CUq3.xcss)({
    display: 'flex',
    marginRight: 'space.025',
    [(0, $h9kUS.media).above.md]: {
        marginRight: 'space.050'
    }
});

});

parcelRegister("5yLnO", function(module, exports) {

$parcel$export(module.exports, "SearchFieldIconDynamic", () => $71cc18983db63a0d$export$9eef03e91cdeba14);
$parcel$export(module.exports, "SearchFieldIcon", () => $71cc18983db63a0d$export$8a82bff895521bd9);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $1IoOM = parcelRequire("1IoOM");

var $26g7Y = parcelRequire("26g7Y");

var $hyOJh = parcelRequire("hyOJh");

var $dC5iT = parcelRequire("dC5iT");
var $h9kUS = parcelRequire("h9kUS");
var $8CUq3 = parcelRequire("8CUq3");
const $71cc18983db63a0d$export$9eef03e91cdeba14 = ({ onClear: onClear, hasValue: hasValue, searchIconVisible: searchIconVisible, clearIconLabel: clearIconLabel, primaryColor: primaryColor, onlyIconSpacing: onlyIconSpacing = false })=>{
    const akSearchIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($26g7Y))), {
        LEGACY_size: "small",
        label: "",
        LEGACY_primaryColor: primaryColor,
        color: "currentColor"
    });
    const searchIcon = searchIconVisible ? akSearchIcon : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $71cc18983db63a0d$var$wrapperStyles,
            onlyIconSpacing && $71cc18983db63a0d$var$spacingStyles
        ]
    }, hasValue ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle",
        spacing: "none",
        "data-test-id": "searchfield.ui.searchfield-icon.clear-button",
        testId: "searchfield.ui.searchfield-icon.clear-button",
        onClick: onClear,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1IoOM))), {
            LEGACY_size: "small",
            label: clearIconLabel,
            LEGACY_primaryColor: primaryColor,
            color: "currentColor"
        })
    }) : searchIcon);
};
const $71cc18983db63a0d$export$8a82bff895521bd9 = ({ searchIconVisible: searchIconVisible, onlyIconSpacing: onlyIconSpacing = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $71cc18983db63a0d$var$wrapperStylesBefore,
            onlyIconSpacing && $71cc18983db63a0d$var$spacingStylesBefore
        ]
    }, searchIconVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hyOJh))), {
        spacing: "none",
        label: "",
        color: "var(--ds-icon, #44546F)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null));
const $71cc18983db63a0d$var$wrapperStyles = (0, $8CUq3.xcss)({
    color: 'color.text.accent.gray',
    marginTop: 'space.0',
    marginRight: 'space.100',
    marginBottom: 'space.0',
    marginLeft: 'space.0',
    height: '16px',
    display: 'flex'
});
const $71cc18983db63a0d$var$spacingStyles = (0, $8CUq3.xcss)({
    marginRight: 'space.075',
    [(0, $h9kUS.media).above.md]: {
        marginRight: 'space.100'
    }
});
const $71cc18983db63a0d$var$wrapperStylesBefore = (0, $8CUq3.xcss)({
    display: 'flex',
    marginRight: 'space.0',
    marginLeft: 'space.075',
    [(0, $h9kUS.media).above.md]: {
        marginLeft: 'space.100'
    }
});
const $71cc18983db63a0d$var$spacingStylesBefore = (0, $8CUq3.xcss)({
    marginLeft: 'space.075',
    [(0, $h9kUS.media).above.md]: {
        marginLeft: 'space.100'
    }
});

});
parcelRegister("1IoOM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::40d49d14e43276e4147396a05e9540f1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $13fd26dab9ed6f93$var$_react = $13fd26dab9ed6f93$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $13fd26dab9ed6f93$var$_cross = $13fd26dab9ed6f93$var$_interopRequireDefault((parcelRequire("1EekA")));

var $13fd26dab9ed6f93$var$_cross2 = $13fd26dab9ed6f93$var$_interopRequireDefault((parcelRequire("lLLkM")));
function $13fd26dab9ed6f93$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossIcon.
 * This component is CrossIcon, with `UNSAFE_fallbackIcon` set to "CrossIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $13fd26dab9ed6f93$var$CrossIcon = (props)=>/*#__PURE__*/ $13fd26dab9ed6f93$var$_react.default.createElement($13fd26dab9ed6f93$var$_cross.default, Object.assign({
        LEGACY_fallbackIcon: $13fd26dab9ed6f93$var$_cross2.default
    }, props));
$13fd26dab9ed6f93$var$CrossIcon.Name = 'CrossIconMigration';
var $13fd26dab9ed6f93$var$_default = module.exports.default = $13fd26dab9ed6f93$var$CrossIcon;

});





parcelRegister("lMdZA", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab630e8f21974ebe$export$2e2bcd8739ae039);

var $8oe80 = parcelRequire("8oe80");

var $cz6xH = parcelRequire("cz6xH");
var $ab630e8f21974ebe$export$2e2bcd8739ae039 = (0, $8oe80.default)('GroupPicker', {
    onChange: 'changed'
})((0, $cz6xH.default));

});
parcelRegister("cz6xH", function(module, exports) {

$parcel$export(module.exports, "default", () => $407c71fa53420c90$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $ckyDP = parcelRequire("ckyDP");

var $4USKh = parcelRequire("4USKh");

var $az4zD = parcelRequire("az4zD");

var $iTyDa = parcelRequire("iTyDa");

var $frWNK = parcelRequire("frWNK");
class $407c71fa53420c90$export$471c4c2b52766e8d extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isRequired: false,
            isDisabled: false,
            isClearable: true,
            isCompact: false,
            fetchOnce: false,
            width: 200
        };
    }
    constructor(props){
        super(props), this.state = {
            options: [],
            selectedGroup: this.props.selectedGroup,
            prevSelectedGroup: this.props.selectedGroup
        }, this.onSelected = (selectedOption)=>{
            this.setState({
                selectedGroup: selectedOption
            });
            this.props.onChange(selectedOption);
        }, /* eslint-disable jira/react-arrow-function-property-naming */ this.formatOptionDataTransformer = (group)=>({
                // @ts-expect-error - TS2769 - No overload matches this call.
                avatar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ckyDP))), {
                    LEGACY_size: "small"
                }),
                label: group.name
            }), /* eslint-disable jira/react-arrow-function-property-naming */ this.fetchAllGroups = (searchQuery)=>(0, $iTyDa.getAllGroups)(searchQuery), /* eslint-disable jira/react-arrow-function-property-naming */ this.fetchUserGroups = (searchQuery)=>this.props.withMember ? (0, $iTyDa.getUserGroups)(this.props.withMember, searchQuery) : Promise.resolve();
        this.groupPickerId = `group-picker.label.id-${(0, $7Jxgt.v4)()}`;
    }
    static getDerivedStateFromProps(props, state) {
        const currentGroup = props.selectedGroup && props.selectedGroup.value;
        const prevGroup = state.prevSelectedGroup && state.prevSelectedGroup.value;
        if (currentGroup !== prevGroup) return {
            ...state,
            selectedGroup: props.selectedGroup,
            prevSelectedGroup: props.selectedGroup
        };
        return null;
    }
    componentDidMount() {
        const { fetchOnce: fetchOnce } = this.props;
        if (fetchOnce === true) {
            const getOptions = this.getFetchOptionsFunction();
            getOptions('').then((groups)=>this.setState({
                    // @ts-expect-error - TS2322 - Type 'void | Group[]' is not assignable to type 'Group[]'.
                    options: groups
                }));
        }
    }
    getFetchOptionsFunction() {
        return this.props.withMember ? this.fetchUserGroups : this.fetchAllGroups;
    }
    render() {
        const { intl: { formatMessage: formatMessage }, placeholder: placeholder = this.props.placeholder || formatMessage((0, $frWNK.default).placeholder), onChange: onChange, fetchOnce: fetchOnce, ...props } = this.props;
        const { selectedGroup: selectedGroup } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4USKh.PickerWithAvatar), {
            "aria-label": !this.props.label ? formatMessage((0, $frWNK.default).labelText) : undefined,
            inputId: this.groupPickerId,
            ...props,
            errorMessage: formatMessage((0, $frWNK.default).error),
            placeholder: placeholder,
            onSelected: this.onSelected,
            // @ts-expect-error - TS2769 - No overload matches this call.
            options: fetchOnce === true ? this.state.options : this.getFetchOptionsFunction(),
            formatOptionDataTransformer: this.formatOptionDataTransformer,
            value: selectedGroup && selectedGroup.name ? selectedGroup : null
        });
    }
}
var $407c71fa53420c90$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($407c71fa53420c90$export$471c4c2b52766e8d);

});
parcelRegister("ckyDP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d4ce7dd41e05f3ded01848e6f06d1f7d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8fa2395aa4b4a70e$var$_react = $8fa2395aa4b4a70e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8fa2395aa4b4a70e$var$_peopleGroup = $8fa2395aa4b4a70e$var$_interopRequireDefault((parcelRequire("fptva")));

var $8fa2395aa4b4a70e$var$_peopleGroup2 = $8fa2395aa4b4a70e$var$_interopRequireDefault((parcelRequire("kFO36")));
function $8fa2395aa4b4a70e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PeopleGroupIcon.
 * This component is PeopleGroupIcon, with `UNSAFE_fallbackIcon` set to "PeopleGroupIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8fa2395aa4b4a70e$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $8fa2395aa4b4a70e$var$_react.default.createElement($8fa2395aa4b4a70e$var$_peopleGroup.default, Object.assign({
        LEGACY_fallbackIcon: $8fa2395aa4b4a70e$var$_peopleGroup2.default
    }, props));
$8fa2395aa4b4a70e$var$PeopleGroupIcon.Name = 'PeopleGroupIconMigration';
var $8fa2395aa4b4a70e$var$_default = module.exports.default = $8fa2395aa4b4a70e$var$PeopleGroupIcon;

});
parcelRegister("kFO36", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f0ce75b3f6725a8c$var$_react = $f0ce75b3f6725a8c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $f0ce75b3f6725a8c$var$_peopleGroup = $f0ce75b3f6725a8c$var$_interopRequireDefault((parcelRequire("fptva")));
function $f0ce75b3f6725a8c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f0ce75b3f6725a8c$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $f0ce75b3f6725a8c$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M8.13 10H4a2 2 0 0 0-2 2v3.73c0 1.31 1.87 2.05 4 2.23V15a3 3 0 0 1 3-3h.35a4 4 0 0 1-1.23-2m7.75 0H20c1.11 0 2 .89 2 2v3.73c0 1.31-1.87 2.05-4 2.23V15a3 3 0 0 0-3-3h-.35a4 4 0 0 0 1.23-2M9.97 5.55a3 3 0 1 0-1.96 3.27 4 4 0 0 1 1.96-3.27M16 8.83a3 3 0 1 0-1.96-3.28A4 4 0 0 1 16 8.83"/><path d="M7 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0z"/><circle cx="12" cy="9" r="3"/></g></svg>`
    }, props, {
        newIcon: $f0ce75b3f6725a8c$var$_peopleGroup.default
    }));
$f0ce75b3f6725a8c$var$PeopleGroupIcon.displayName = 'PeopleGroupIcon';
var $f0ce75b3f6725a8c$var$_default = module.exports.default = $f0ce75b3f6725a8c$var$PeopleGroupIcon;

});


parcelRegister("4USKh", function(module, exports) {

$parcel$export(module.exports, "PickerWithAvatar", () => $63c33924209c0872$export$e6b8a87858f7afd1);
$parcel$export(module.exports, "PickerWithAvatarAndAnalytics", () => $63c33924209c0872$export$3d409af828769e2e);
/**
 * This is the base for Picker that can be used to create any type of component:
 * 1) with a list of predefined options
 * 2) that dynamically fetches its options from external resource.
 */ 
var $8oe80 = parcelRequire("8oe80");

var $4U4qk = parcelRequire("4U4qk");

var $9M5Oz = parcelRequire("9M5Oz");
const $63c33924209c0872$export$e6b8a87858f7afd1 = (0, $9M5Oz.default);
const $63c33924209c0872$export$3d409af828769e2e = (0, $8oe80.default)('picker', {
    onSelected: 'changed',
    onMultiSelected: 'multi-changed'
})((0, $9M5Oz.default));
const $63c33924209c0872$export$d8d9f25d80d89b16 = (0, $8oe80.default)('picker', {
    onSelected: 'changed',
    onMultiSelected: 'multi-changed'
})((0, $4U4qk.default));

});
parcelRegister("4U4qk", function(module, exports) {

$parcel$export(module.exports, "getOptionBaseStyles", () => $0d1a93ba35d548ba$export$cef6e25059b681a);
$parcel$export(module.exports, "Picker", () => $0d1a93ba35d548ba$export$ba25329847403e11);
$parcel$export(module.exports, "default", () => $0d1a93ba35d548ba$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $lFKmC = parcelRequire("lFKmC");

var $8Rkzz = parcelRequire("8Rkzz");

var $fVnbM = parcelRequire("fVnbM");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $1ZftP = parcelRequire("1ZftP");
var $94bNw = parcelRequire("94bNw");
var $bChGW = parcelRequire("bChGW");
var $iOwNT = parcelRequire("iOwNT");
var $7K5PP = parcelRequire("7K5PP");

var $3bDjY = parcelRequire("3bDjY");

var $4R6GH = parcelRequire("4R6GH");

var $VgvL1 = parcelRequire("VgvL1");

var $fVAPR = parcelRequire("fVAPR");

var $gwIPs = parcelRequire("gwIPs");

var $eHJxW = parcelRequire("eHJxW");

var $az4zD = parcelRequire("az4zD");

var $e239o = parcelRequire("e239o");
const $0d1a93ba35d548ba$export$3a3072dd741f354b = 500;
const $0d1a93ba35d548ba$export$cef6e25059b681a = (optionState)=>({
        ...optionState.isDisabled ? {
            cursor: 'not-allowed',
            color: "var(--ds-text-subtlest, #626F86)",
            '&, :active': {
                backgroundColor: 'transparent'
            }
        } : {
            cursor: 'pointer'
        },
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    });
class $0d1a93ba35d548ba$export$ba25329847403e11 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isRequired: false,
            isDisabled: false,
            isClearable: false,
            isCompact: false,
            isCreatable: false,
            isMulti: false,
            noPortal: false,
            isCheckbox: false,
            label: undefined,
            defaultValue: undefined,
            width: 'auto',
            onSelected: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onMultiSelected: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    static getDerivedStateFromProps(props) {
        if (props.menuIsOpen !== undefined) return {
            menuIsOpen: props.menuIsOpen
        };
        return null;
    }
    constructor(props){
        super(props), this.state = {
            validationState: 'default',
            showErrorMessage: false,
            menuWasOpen: false,
            menuIsOpen: false,
            initialFocusHandled: false
        }, this.onSelected = (selection, action, analyticsEvent)=>{
            this.setState(()=>({
                    menuIsOpen: false
                }));
            const { isMulti: isMulti } = this.props;
            if (Array.isArray(selection)) {
                if (isMulti) // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
                this.props.onMultiSelected(selection, analyticsEvent);
                else // When the selection is cleared in single select mode, selection is an array.
                this.props.onSelected(undefined, analyticsEvent);
            } else // @ts-expect-error - TS2339 - Property 'value' does not exist on type 'SelectOption'.
            selection && selection.value ? this.props.onSelected(selection, analyticsEvent) : this.props.onSelected(undefined, analyticsEvent);
        }, this.onMenuOpen = ()=>{
            this.setState(()=>({
                    menuIsOpen: true,
                    menuWasOpen: true
                }));
        }, this.onMenuClose = ()=>{
            this.setState(()=>({
                    menuIsOpen: false
                }));
        }, this.onBlur = (event)=>{
            this.hideErrorMessage();
            const { onBlur: onBlur } = this.props;
            if (onBlur && typeof onBlur === 'function') onBlur(event);
        }, this.onFocus = (event)=>{
            this.showErrorMessage();
            const { onFocus: onFocus } = this.props;
            if (onFocus && typeof onFocus === 'function') onFocus(event);
        }, this.setErrorState = ()=>{
            this.setState({
                showErrorMessage: true,
                validationState: 'error'
            });
        }, this.showErrorMessage = ()=>this.setState({
                showErrorMessage: true
            }), this.hideErrorMessage = ()=>this.setState({
                showErrorMessage: false
            }) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        , this.loadOptions = (filter, callback)=>{
            this.setState({
                validationState: 'default'
            });
            this.debouncedLoadOptions(filter, callback);
        }, this.renderOption = (props)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const propsData = props.data;
            const disableReason = props.isDisabled && propsData && propsData.disableReason || null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                position: "right",
                content: disableReason
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Option // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            , props));
        } // Will remove this renderMenuList when clean up FG since it's no longer needed
        , this.renderMenuList = (menuListProps)=>{
            const { isClearable: isClearable, intl: { formatMessage: formatMessage } } = this.props;
            return(// @ts-expect-error - TS2740 - Type '{ children: (Element | ReactNode)[]; hasValue: boolean; clearValue: () => void; }' is missing the following properties from type 'CommonProps<OptionTypeBase, boolean, GroupTypeBase<OptionTypeBase>>': cx, getStyles, getValue, isMulti, and 6 more.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).MenuList, menuListProps, isClearable && menuListProps.hasValue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $0d1a93ba35d548ba$var$clearButtonWrapperStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                appearance: "link",
                shouldFitContainer: true,
                onClick: menuListProps.clearValue
            }, formatMessage((0, $e239o.default).clearSelected))), menuListProps.children));
        }, this.renderValueContainer = (props)=>{
            const { onValueContainerClick: onValueContainerClick } = props.selectProps;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0d1a93ba35d548ba$var$StyledValueContainer, {
                "data-testid": "common-components-picker.base.react-dnd-and-select-focus-bug-fix",
                onClick: onValueContainerClick
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).ValueContainer, props));
        }; // This is initialized in constructor because when it is a class property then flow gets confused about the generic type in callback.
        // That is a known bug: https://github.com/facebook/flow/issues/6978
        this.debouncedLoadOptions = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (filter, callback)=>{
            // @ts-expect-error - TS2349 - This expression is not callable.
            this.props.options(filter).then(callback, ()=>{
                callback([]);
                this.setErrorState();
            });
        }, $0d1a93ba35d548ba$export$3a3072dd741f354b); // @ts-expect-error - Property 'selectRef' does not exist on type 'Picker<SelectOption>'
        this.selectRef = /*#__PURE__*/ (0, $5uXOq.createRef)();
    }
    getSelectComponent(isAsync) {
        if (this.props.isCreatable) return isAsync ? (0, $1ZftP.default) : (0, $iOwNT.default);
        if (isAsync) return 0, $VgvL1.AsyncSelectWithAnalytics;
        return this.props.isCheckbox ? (0, $94bNw.default) : (0, $7K5PP.default);
    }
    getComponentOverrides() {
        const { menuWasOpen: menuWasOpen } = this.state;
        const Option = {
            Option: this.renderOption
        }; // Remove MenuList when clean up FG since we no longer need to override to add `Clear Selected` button
        const MenuList = (0, $4R6GH.fg)('jfp-a11y-team_update_legacy_select_clear_fuction') ? {} : {
            MenuList: this.renderMenuList
        };
        const LoadingIndicator = menuWasOpen ? {} : {
            LoadingIndicator: null
        };
        return {
            ...this.props.components,
            ...Option,
            ...MenuList,
            ...LoadingIndicator
        };
    }
    render() {
        const { showErrorMessage: showErrorMessage, validationState: validationState, menuIsOpen: menuIsOpen } = this.state;
        const { intl: { formatMessage: formatMessage } } = this.props;
        const { label: label, listItemCustomStyles: listItemCustomStyles, placeholder: placeholder = formatMessage((0, $e239o.default).defaultPlaceholder), defaultValue: defaultValue, isRequired: isRequired, isDisabled: isDisabled, isCompact: isCompact, isClearableWithCrossIcon: isClearableWithCrossIcon, errorMessage: errorMessage, options: options, width: width, minWidth: minWidth, noPortal: noPortal, isCheckbox: isCheckbox, hasDraggableParentComponent: hasDraggableParentComponent } = this.props;
        const isAsync = typeof options === 'function';
        const SelectComponent = this.getSelectComponent(isAsync);
        const isErrorMessageOpened = showErrorMessage && validationState === 'error';
        let selectParams = {
            placeholder: placeholder,
            isDisabled: isDisabled,
            isClearable: isClearableWithCrossIcon || false,
            defaultValue: defaultValue,
            defaultOptions: true,
            autoFocus: !!this.props.autoFocus,
            loadOptions: isAsync && this.loadOptions,
            options: !isAsync && options,
            onChange: this.onSelected,
            noOptionsMessage: ()=>this.props.noOptionsMessage ?? formatMessage((0, $e239o.default).noOptions),
            loadingMessage: ()=>formatMessage((0, $e239o.default).loading),
            validationState: this.state.validationState,
            onBlur: this.onBlur,
            onFocus: this.onFocus,
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            menuPortalTarget: noPortal ? null : document.body,
            spacing: isCompact ? 'compact' : 'default',
            styles: {
                ...this.props.styles,
                // without properly set zIndex value dropdown with options is cut inside modal dialogs
                // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type.
                menuPortal: (base)=>({
                        ...base,
                        zIndex: (0, $gwIPs.layers).modal
                    }),
                // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type.
                container: (base)=>({
                        ...base,
                        width: width,
                        minWidth: minWidth
                    }),
                // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type. | TS7006 - Parameter 'optionState' implicitly has an 'any' type.
                option: (base, optionState)=>({
                        ...base,
                        ...$0d1a93ba35d548ba$export$cef6e25059b681a(optionState),
                        ...listItemCustomStyles
                    })
            }
        };
        if (!isCheckbox) selectParams = {
            ...selectParams,
            menuIsOpen: // @ts-expect-error - TS2322 - Type '{ menuIsOpen: boolean; onMenuOpen: () => void; onMenuClose: () => void; components: { LoadingIndicator?: undefined; MenuList: (menuListProps: MenuListProps) => JSX.Element; Option: (props: CommonProps<...> & ... 1 more ... & { ...; }) => JSX.Element; } | { ...; }; ... 16 more ...; styles: { ...; }; }' is not assignable to type '{ placeholder: string; isDisabled: boolean | undefined; isClearable: boolean; defaultValue: SelectOption | undefined; defaultOptions: boolean; autoFocus: boolean; loadOptions: false | ((filter: string, callback: (arg1: SelectOption[]) => Record<...>) => void); ... 9 more ...; styles: { ...; }; }'.
            menuIsOpen,
            onMenuOpen: this.onMenuOpen,
            onMenuClose: this.onMenuClose,
            components: this.getComponentOverrides()
        };
         // When "hasDraggableParentComponent" is true, this means <Select /> is nested inside <Draggable /> from react-beautiful-dnd
        // This relationship prevents the dropdown menu from opening because of bugs in the default focus state and clicking in a particular area of <Select />
        // Context: https://hello.atlassian.net/wiki/spaces/~989411314/pages/2861097485/Investigation+Notes+for+atlaskit+select+react-beautiful-dnd#Temporary-Solution
        if (hasDraggableParentComponent) {
            const { initialFocusHandled: initialFocusHandled } = this.state;
            const handleClick = ()=>{
                if (initialFocusHandled) // As <Select /> is already focused, calling this.selectRef.current.focus() again no longer triggers its own handlers (i.e. onMenuOpen, onMenuClose)
                // We have to manually handle the open and close states of the dropdown menu based on a user's click from this point onwards to prevent the bug
                this.setState((state)=>({
                        menuIsOpen: !state.menuIsOpen
                    }));
                else if (!menuIsOpen) {
                    // Trigger focus state when ValueContainer is clicked for the first time
                    // The focused state will then invoke <Select /> instance's own handlers (e.g. onMenuOpen, onMenuClose)
                    // to manage the state of the dropdown menu
                    // @ts-expect-error - Property 'selectRef' does not exist on type 'Picker<SelectOption>'
                    this.selectRef.current.focus();
                    this.setState(()=>({
                            initialFocusHandled: true
                        }));
                }
            };
            selectParams = {
                ...selectParams,
                // @ts-expect-error - Object literal may only specify known properties, and 'ref' does not exist in type '{ placeholder: string; isDisabled: boolean | undefined; isClearable: boolean; defaultValue: SelectOption | undefined; defaultOptions: boolean; autoFocus: boolean; loadOptions: false | ((filter: string, callback: (arg1: SelectOption[]) => Record<...>) => void); ... 9 more ...; styles: { ...; }; }'
                // + Property 'selectRef' does not exist on type 'Picker<SelectOption>'
                ref: this.selectRef,
                components: {
                    ...this.getComponentOverrides,
                    ValueContainer: this.renderValueContainer
                },
                onValueContainerClick: handleClick,
                openMenuOnFocus: true
            };
        }
        const { isClearable: isClearable } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVAPR.FieldLabel), {
            htmlFor: this.props.inputId,
            label: label,
            isRequired: isRequired
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eHJxW.JiraInlineDialog), {
            content: errorMessage,
            isOpen: isErrorMessageOpened,
            messageId: `common-components-picker.base.jira-inline-dialog.pickerErrorMessage.${this.props.inputId ?? 'unnamedInputId'}`,
            messageType: "transactional",
            placement: "right"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SelectComponent, {
            inputId: this.props.inputId,
            ...this.props,
            ...selectParams,
            ...(0, $4R6GH.fg)('jfp-a11y-team_update_legacy_select_clear_fuction') ? {
                isClearable: isClearable
            } : {},
            options: isAsync ? undefined : this.props.options
        })));
    }
}
const $0d1a93ba35d548ba$var$PickerWithIntl = (0, $az4zD.injectIntlV2)($0d1a93ba35d548ba$export$ba25329847403e11);
const $0d1a93ba35d548ba$var$DefaultPicker = (props)=>{
    // this function exists only to "preserve" generic on the Picker that is lost at injectIntl
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0d1a93ba35d548ba$var$PickerWithIntl, props);
};
$0d1a93ba35d548ba$var$DefaultPicker.defaultProps = $0d1a93ba35d548ba$export$ba25329847403e11.defaultProps;
var $0d1a93ba35d548ba$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $0d1a93ba35d548ba$var$DefaultPicker;
const $0d1a93ba35d548ba$var$StyledValueContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n",
            __cmplp.className
        ])
    });
});
const $0d1a93ba35d548ba$var$clearButtonWrapperStyles = (0, $8CUq3.xcss)({
    borderBottom: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #091E4224)"}`
});

});
parcelRegister("1ZftP", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffe39b95a8bd43db$export$2e2bcd8739ae039);

var $isgat = parcelRequire("isgat");

var $3c98u = parcelRequire("3c98u");
const $ffe39b95a8bd43db$var$AsyncCreatableSelect = (0, $3c98u.default)((0, $isgat.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ffe39b95a8bd43db$export$2e2bcd8739ae039 = $ffe39b95a8bd43db$var$AsyncCreatableSelect;

});
parcelRegister("isgat", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6ce0d05b9e97e68$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2QhWf = parcelRequire("2QhWf");

var $iaInK = parcelRequire("iaInK");

var $2HH7Y = parcelRequire("2HH7Y");

var $9uJ4X = parcelRequire("9uJ4X");
const $d6ce0d05b9e97e68$var$AsyncCreatableSelect = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const stateManagerProps = (0, $iaInK.default)(props);
    const creatableProps = (0, $9uJ4X.default)(stateManagerProps);
    const selectProps = (0, $2HH7Y.default)(creatableProps);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2QhWf.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d6ce0d05b9e97e68$export$2e2bcd8739ae039 = $d6ce0d05b9e97e68$var$AsyncCreatableSelect;

});


parcelRegister("94bNw", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebf832c571222d72$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $itpgN = parcelRequire("itpgN");

var $7K5PP = parcelRequire("7K5PP");
const $ebf832c571222d72$var$CheckboxSelectInternal = ({ components: components, ...props })=>{
    const mergedComponents = (0, $5uXOq.useMemo)(()=>({
            ...components,
            Option: (0, $itpgN.CheckboxOption)
        }), [
        components
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7K5PP.default), {
        closeMenuOnSelect: false,
        hideSelectedOptions: false,
        isMulti: true,
        ...props,
        components: mergedComponents
    });
};
const $ebf832c571222d72$var$CheckboxSelect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo($ebf832c571222d72$var$CheckboxSelectInternal);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ebf832c571222d72$export$2e2bcd8739ae039 = $ebf832c571222d72$var$CheckboxSelect;

});
parcelRegister("itpgN", function(module, exports) {

$parcel$export(module.exports, "CheckboxOption", () => $f5875245cd0ad0c1$export$d40cc97ecda916f9);
$parcel$export(module.exports, "RadioOption", () => $f5875245cd0ad0c1$export$82ab7168879267a7);
/* input-options.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6aY6N = parcelRequire("6aY6N");

var $iQHJo = parcelRequire("iQHJo");

var $dV6Te = parcelRequire("dV6Te");

var $VSDnB = parcelRequire("VSDnB");
const $f5875245cd0ad0c1$var$optionStyles = {
    default: "_1e0c1txw _4cvr1h6o _1bsb1osq _uiztglyw _18ql1j7p _vchhusvi _85i51b66 _1q511b66 _bozgpxbi _y4tiutpp _bfhk18uv _16qs1kw7 _syaz1kw7 _1di61dty",
    focused: "_bfhk166n _16qsn8hf _112ej1ic",
    disabled: "_syaz15gi"
};
// the primary color represents the outer or background element
const $f5875245cd0ad0c1$var$getPrimaryColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    if (isDisabled) return "var(--ds-background-disabled, #091E4208)";
    else if (isSelected && isActive) return "var(--ds-background-selected-bold-pressed, #09326C)";
    else if (isActive) return "var(--ds-background-selected-pressed, #85B8FF)";
    else if (isFocused && isSelected) return "var(--ds-background-selected-bold-hovered, #0055CC)";
    else if (isFocused) return "var(--ds-surface, #FFFFFF)";
    else if (isSelected) return "var(--ds-background-selected-bold, #0C66E4)";
    return "var(--ds-background-neutral, #091E420F)";
};
// the secondary color represents the radio dot or checkmark
const $f5875245cd0ad0c1$var$getSecondaryColor = ({ isDisabled: isDisabled, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return "var(--ds-text-disabled, #091E424F)";
    else if (!isSelected) return 'transparent';
    return "var(--ds-surface, #FFFFFF)";
};
const $f5875245cd0ad0c1$var$iconStyles = {
    inherit: "_1u9j1r31 _1gqp1r31",
    default: "_1u9j1elr _1gqp1elr"
};
const $f5875245cd0ad0c1$var$baseIconStyles = null;
const $f5875245cd0ad0c1$var$baseOptionStyles = null;
const $f5875245cd0ad0c1$var$ControlOption = (props)=>{
    const [isActive, setIsActive] = (0, $5uXOq.useState)(false);
    const onMouseDown = (0, $5uXOq.useCallback)(()=>setIsActive(true), []);
    const onMouseUp = (0, $5uXOq.useCallback)(()=>setIsActive(false), []);
    const { Icon: Icon, children: children, innerProps: innerProps, innerRef: innerRef, cx: cx, className: className, isDisabled: isDisabled, isSelected: isSelected, isFocused: isFocused } = props;
    const classNames = (0, $5uXOq.useMemo)(()=>cx({
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected
        }, className), [
        cx,
        isDisabled,
        isFocused,
        isSelected,
        className
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            $f5875245cd0ad0c1$var$optionStyles.default,
            isFocused && $f5875245cd0ad0c1$var$optionStyles.focused,
            isDisabled && $f5875245cd0ad0c1$var$optionStyles.disabled,
            classNames
        ]),
        ref: innerRef,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseLeave: onMouseUp,
        ...innerProps,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: (0, $bwpsq.default)([
                    "_1e0c1txw _4cvr1h6o _1o9zidpf _y4ti1b66 _16cu892t _1xci892t _59qxe4h9 _8y3xe4h9",
                    isSelected || isActive || isDisabled ? $f5875245cd0ad0c1$var$iconStyles.inherit : $f5875245cd0ad0c1$var$iconStyles.default
                ]),
                children: !!Icon ? /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                    label: "",
                    primaryColor: $f5875245cd0ad0c1$var$getPrimaryColor({
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        isFocused: isFocused,
                        isActive: isActive
                    }),
                    secondaryColor: $f5875245cd0ad0c1$var$getSecondaryColor({
                        isDisabled: isDisabled,
                        isSelected: isSelected
                    }),
                    isFacadeDisabled: true
                }) : null
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: (0, $bwpsq.default)([
                    "_16jlkb7n _1reo15vq _1bto1l2s _o5721q9c"
                ]),
                children: children
            })
        ]
    });
};
const $f5875245cd0ad0c1$var$NewCheckboxIcon = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dV6Te.default), {
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
                    fill: "inherit"
                })
            ]
        })
    });
const $f5875245cd0ad0c1$var$NewRadioIcon = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dV6Te.default), {
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "6.75",
                    fill: "currentColor",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "3",
                    fill: "inherit"
                })
            ]
        })
    });
const $f5875245cd0ad0c1$export$d40cc97ecda916f9 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)($f5875245cd0ad0c1$var$ControlOption, {
        Icon: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        (0, $VSDnB.fg)('platform-visual-refresh-icons') ? $f5875245cd0ad0c1$var$NewCheckboxIcon : // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        (0, (/*@__PURE__*/$parcel$interopDefault($6aY6N))),
        ...props
    });
const $f5875245cd0ad0c1$export$82ab7168879267a7 = (props)=>// TODO https://product-fabric.atlassian.net/browse/DSP-20769
    /*#__PURE__*/ (0, $2OMIu.jsx)($f5875245cd0ad0c1$var$ControlOption, {
        Icon: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        (0, $VSDnB.fg)('platform-visual-refresh-icons') ? $f5875245cd0ad0c1$var$NewRadioIcon : // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        (0, (/*@__PURE__*/$parcel$interopDefault($iQHJo))),
        ...props
    });

});
parcelRegister("6aY6N", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $47f24d9003b82760$var$_react = $47f24d9003b82760$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $47f24d9003b82760$var$_checkboxChecked = $47f24d9003b82760$var$_interopRequireDefault((parcelRequire("aoKYM")));
function $47f24d9003b82760$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $47f24d9003b82760$var$CheckboxIcon = (props)=>/*#__PURE__*/ $47f24d9003b82760$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><rect width="12" height="12" x="6" y="6" fill="currentcolor" rx="2"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $47f24d9003b82760$var$_checkboxChecked.default
    }));
$47f24d9003b82760$var$CheckboxIcon.displayName = 'CheckboxIcon';
var $47f24d9003b82760$var$_default = module.exports.default = $47f24d9003b82760$var$CheckboxIcon;

});
parcelRegister("aoKYM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f3359cfcb124b9edec9402a579fa9711>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $79209663d32c0c44$var$_react = $79209663d32c0c44$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $79209663d32c0c44$var$_baseNew = $79209663d32c0c44$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $79209663d32c0c44$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckboxChecked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Reserved for interactive checkbox experiences. Consider using the checkbox component.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $79209663d32c0c44$var$CheckboxCheckedIcon = (props)=>/*#__PURE__*/ $79209663d32c0c44$var$_react.default.createElement($79209663d32c0c44$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm9.326 4.48-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$79209663d32c0c44$var$CheckboxCheckedIcon.displayName = 'CheckboxCheckedIcon';
var $79209663d32c0c44$var$_default = module.exports.default = $79209663d32c0c44$var$CheckboxCheckedIcon;

});


parcelRegister("iQHJo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $db8f016a0af5fda9$var$_react = $db8f016a0af5fda9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $db8f016a0af5fda9$var$_radioChecked = $db8f016a0af5fda9$var$_interopRequireDefault((parcelRequire("kqGQn")));
function $db8f016a0af5fda9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $db8f016a0af5fda9$var$RadioIcon = (props)=>/*#__PURE__*/ $db8f016a0af5fda9$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="6" fill="currentcolor"/><circle cx="12" cy="12" r="2" fill="inherit"/></g></svg>`
    }, props, {
        newIcon: $db8f016a0af5fda9$var$_radioChecked.default
    }));
$db8f016a0af5fda9$var$RadioIcon.displayName = 'RadioIcon';
var $db8f016a0af5fda9$var$_default = module.exports.default = $db8f016a0af5fda9$var$RadioIcon;

});
parcelRegister("kqGQn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2f37934c6709a990262261073c8d0052>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $edf7783e719984ba$var$_react = $edf7783e719984ba$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $edf7783e719984ba$var$_baseNew = $edf7783e719984ba$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $edf7783e719984ba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "RadioChecked".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for the selected state of radio controls.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $edf7783e719984ba$var$RadioCheckedIcon = (props)=>/*#__PURE__*/ $edf7783e719984ba$var$_react.default.createElement($edf7783e719984ba$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6" clip-rule="evenodd"/>`
    }, props));
$edf7783e719984ba$var$RadioCheckedIcon.displayName = 'RadioCheckedIcon';
var $edf7783e719984ba$var$_default = module.exports.default = $edf7783e719984ba$var$RadioCheckedIcon;

});




parcelRegister("VgvL1", function(module, exports) {

$parcel$export(module.exports, "AsyncSelectWithAnalytics", () => $462c399840da3e1c$export$ee664e5add893f9);

var $d7FF4 = parcelRequire("d7FF4");

var $8oe80 = parcelRequire("8oe80");
const $462c399840da3e1c$export$ee664e5add893f9 = (0, $8oe80.default)('select', {
    onChange: 'changed'
})((0, $d7FF4.default));

});

parcelRegister("fVAPR", function(module, exports) {

$parcel$export(module.exports, "FieldLabel", () => $97462970d1593b07$export$1acdcf5a973a8414);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $l1N8i = parcelRequire("l1N8i");
const $97462970d1593b07$export$1acdcf5a973a8414 = ({ label: label, htmlFor: htmlFor, isRequired: isRequired = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($97462970d1593b07$var$Label, {
        htmlFor: htmlFor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xxsmall",
        as: "h2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz131l _1e0c1ule _ca0qv47k _u5f3idpf _n3td1b66 _19bvidpf _ect41gqc"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, label), isRequired ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        role: "presentation",
        className: (0, $bwpsq.default)([
            "_syaz1tmw _19bvv77o _ect41gqc"
        ])
    }, "*") : null)));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $97462970d1593b07$var$Label = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1ule",
            __cmplp.className
        ])
    });
});
const $97462970d1593b07$var$labelStyle = null;
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $97462970d1593b07$var$requiredIndicatorStyle = null;

});

parcelRegister("eHJxW", function(module, exports) {

$parcel$export(module.exports, "JiraInlineDialog", () => $51c10262cffee11f$export$7ab52478615504b3);

var $5uXOq = parcelRequire("5uXOq");

var $ctg8C = parcelRequire("ctg8C");

var $10xFf = parcelRequire("10xFf");

var $c0dQj = parcelRequire("c0dQj");

var $5uVz7 = parcelRequire("5uVz7");
const $51c10262cffee11f$export$7ab52478615504b3 = (props)=>{
    if ((0, $10xFf.shouldBeChoreographed)(props)) {
        if ((0, $c0dQj.isMobileAndInViewPanelIterationExperiment)()) return null;
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uVz7.ChoreographerInlineDialog), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctg8C.default), rest);
};

});
parcelRegister("5uVz7", function(module, exports) {

$parcel$export(module.exports, "ChoreographerInlineDialog", () => $aa901de21f3fc2ba$export$44a404f218b0e66e);

var $ctg8C = parcelRequire("ctg8C");

var $fG5AJ = parcelRequire("fG5AJ");
const $aa901de21f3fc2ba$export$44a404f218b0e66e = (0, $fG5AJ.withChoreographedToggle)((0, $ctg8C.default), 'isOpen', 'content');

});


parcelRegister("e239o", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c6849afedcc0fa8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1c6849afedcc0fa8$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noOptions: {
        "id": "common.components.picker.base.no-options",
        "defaultMessage": "No results"
    },
    loading: {
        "id": "common.components.picker.base.loading",
        "defaultMessage": "Searching..."
    },
    defaultPlaceholder: {
        "id": "common.components.picker.base.default-placeholder",
        "defaultMessage": "Select..."
    },
    clearSelected: {
        "id": "common.components.picker.base.clear-selected",
        "defaultMessage": "Clear selected"
    }
});

});


parcelRegister("9M5Oz", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae2cb265c5b0a53f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ujWmd = parcelRequire("ujWmd");

var $bUmQV = parcelRequire("bUmQV");

var $4U4qk = parcelRequire("4U4qk");
class $ae2cb265c5b0a53f$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            showFocusedAvatar: false
        };
    }
    render() {
        const { formatOptionDataTransformer: formatOptionDataTransformer, showFocusedAvatar: showFocusedAvatar, ...props } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4U4qk.default), {
            ...props,
            onBlur: this.onBlur,
            onFocus: this.onFocus,
            formatOptionLabel: this.renderOption
        });
    }
    constructor(...args){
        super(...args), this.state = {
            canShowAvatar: true
        }, this.onBlur = (event)=>{
            this.setState(()=>({
                    canShowAvatar: true
                }));
            this.props.onBlur && this.props.onBlur(event);
        }, this.onFocus = (event)=>{
            if (!this.props.showFocusedAvatar) this.setState(()=>({
                    canShowAvatar: false
                }));
            this.props.onFocus && this.props.onFocus(event);
        }, this.renderOption = (option, { context: context // eslint-disable-next-line @typescript-eslint/no-explicit-any
         })=>{
            const { avatar: avatar, label: label } = this.props.formatOptionDataTransformer(option);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ae2cb265c5b0a53f$var$OptionWrapper, null, typeof avatar !== 'undefined' && (context !== 'value' || this.state.canShowAvatar) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUmQV.default), null, typeof avatar === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
                src: avatar,
                size: "xsmall"
            }) : avatar) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ae2cb265c5b0a53f$var$LabelWrapper, null, label));
        };
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ae2cb265c5b0a53f$var$OptionWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $ae2cb265c5b0a53f$var$LabelWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});

});


parcelRegister("iTyDa", function(module, exports) {

$parcel$export(module.exports, "getAllGroups", () => $3f576979452c6c2a$export$c243565349cba18c);
$parcel$export(module.exports, "getUserGroups", () => $3f576979452c6c2a$export$bda937ecc753b1f3);

var $aDmD8 = parcelRequire("aDmD8");

var $48hcp = parcelRequire("48hcp");
const $3f576979452c6c2a$export$c243565349cba18c = (searchQuery, maxResults)=>(0, $aDmD8.getAllGroups)(searchQuery, maxResults).then((0, $48hcp.transformAllGroups));
const $3f576979452c6c2a$export$bda937ecc753b1f3 = (accountId, searchQuery)=>{
    if (!accountId) return Promise.resolve([]);
    return (0, $aDmD8.getUserGroups)(accountId).then((response)=>{
        const filteredGroups = (0, $48hcp.filterUserGroups)(response, searchQuery);
        return (0, $48hcp.transformUserGroups)(filteredGroups);
    });
};

});
parcelRegister("aDmD8", function(module, exports) {

$parcel$export(module.exports, "getAllGroups", () => $76137711d5dac9f8$export$c243565349cba18c);
$parcel$export(module.exports, "getUserGroups", () => $76137711d5dac9f8$export$bda937ecc753b1f3);

var $7f4tk = parcelRequire("7f4tk");
// Get all groups (including ones user is not a member of)
const $76137711d5dac9f8$var$MAX_GROUPS = 5;
const $76137711d5dac9f8$export$dc22b2cc8b5a1431 = ()=>'/rest/api/2/groups/picker';
const $76137711d5dac9f8$var$getAllGroupsUrl = (query, maxResults = $76137711d5dac9f8$var$MAX_GROUPS)=>`${$76137711d5dac9f8$export$dc22b2cc8b5a1431()}?maxResults=${maxResults}&query=${encodeURIComponent(query)}`;
const $76137711d5dac9f8$export$c243565349cba18c = (query = '', maxResults = $76137711d5dac9f8$var$MAX_GROUPS)=>(0, $7f4tk.default)($76137711d5dac9f8$var$getAllGroupsUrl(query, maxResults));
const $76137711d5dac9f8$export$a1f49428f96f52c7 = ()=>'/rest/api/3/user/groups';
const $76137711d5dac9f8$var$getUserGroupsUrl = (accountId)=>`${$76137711d5dac9f8$export$a1f49428f96f52c7()}?accountId=${accountId}`;
const $76137711d5dac9f8$export$bda937ecc753b1f3 = (accountId)=>(0, $7f4tk.default)($76137711d5dac9f8$var$getUserGroupsUrl(accountId));

});

parcelRegister("48hcp", function(module, exports) {

$parcel$export(module.exports, "transformAllGroups", () => $aaa6afc95e0ce151$export$b53a6053f3a37f82);
$parcel$export(module.exports, "filterUserGroups", () => $aaa6afc95e0ce151$export$3803c0f966c39ffc);
$parcel$export(module.exports, "transformUserGroups", () => $aaa6afc95e0ce151$export$3e297671f207b321);
const $aaa6afc95e0ce151$export$b53a6053f3a37f82 = (response)=>response && response.groups && response.groups.map(({ name: name, groupId: groupId })=>({
            name: name,
            label: name,
            value: name,
            groupId: groupId
        }));
const $aaa6afc95e0ce151$export$3803c0f966c39ffc = (groupsRest, searchQuery)=>{
    if (!searchQuery) return groupsRest;
    return groupsRest.filter((group)=>group.name.includes(searchQuery || '')); // `|| ''` check is just for Flow
};
const $aaa6afc95e0ce151$export$3e297671f207b321 = (groupsRest)=>groupsRest.map(({ name: name, groupId: groupId })=>({
            name: name,
            label: name,
            value: name,
            groupId: groupId
        }));

});


parcelRegister("frWNK", function(module, exports) {

$parcel$export(module.exports, "default", () => $62452bef71d985c7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $62452bef71d985c7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    error: {
        "id": "group-picker.error",
        "defaultMessage": "We couldn't retrieve groups"
    },
    placeholder: {
        "id": "group-picker.placeholder",
        "defaultMessage": "Group"
    },
    labelText: {
        "id": "group-picker.label-text",
        "defaultMessage": "Group"
    }
});

});



parcelRegister("fs8YG", function(module, exports) {

$parcel$export(module.exports, "default", () => $90f47b7198869b8c$export$2e2bcd8739ae039);

var $8oe80 = parcelRequire("8oe80");

var $59ECx = parcelRequire("59ECx");
var $90f47b7198869b8c$export$2e2bcd8739ae039 = (0, $8oe80.default)('ProjectPicker', {
    onChange: 'changed'
})((0, $59ECx.default));

});
parcelRegister("59ECx", function(module, exports) {

$parcel$export(module.exports, "default", () => $1af03db95f8cb63b$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $4USKh = parcelRequire("4USKh");

var $az4zD = parcelRequire("az4zD");

var $5gPNV = parcelRequire("5gPNV");

var $2oK1T = parcelRequire("2oK1T");
class $1af03db95f8cb63b$export$a4519235a2ef9605 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isRequired: false,
            isDisabled: false,
            isClearable: true,
            isCompact: false,
            detailed: false,
            width: '200px',
            requireBrowsePermission: false,
            requireEditPermission: false,
            label: undefined,
            inputId: undefined,
            projectType: undefined
        };
    }
    constructor(props){
        super(props), this.state = {
            selectedProject: this.props.selectedProject,
            projects: [],
            prevSelectedProject: this.props.selectedProject
        }, this.onSelected = (selectedOption)=>{
            this.setState({
                selectedProject: selectedOption
            });
            this.props.onChange(selectedOption);
        }, /* eslint-disable jira/react-arrow-function-property-naming */ this.formatOptionDataTransformer = (project)=>{
            const { avatarUrl: avatarUrl, name: name } = project;
            const avatar = this.props.renderAvatar ? this.props.renderAvatar(avatarUrl) : avatarUrl;
            return {
                avatar: avatar,
                label: name
            };
        }, /* eslint-disable jira/react-arrow-function-property-naming */ this.fetchOptions = async (filter)=>{
            const projects = await (0, $5gPNV.requestProjects)(filter, {
                detailed: this.props.detailed,
                requireBrowsePermission: this.props.requireBrowsePermission,
                requireEditPermission: this.props.requireEditPermission,
                projectType: this.props.projectType
            });
            this.setState({
                projects: projects
            });
            return projects;
        };
        this.projectPickerId = `project-picker.label.id-${(0, $7Jxgt.v4)()}`;
    }
    static getDerivedStateFromProps(props, state) {
        const currentProjectId = props.selectedProject && props.selectedProject.value;
        const prevProjectId = state.prevSelectedProject && state.prevSelectedProject.value;
        if (currentProjectId !== prevProjectId) return {
            ...state,
            selectedProject: props.selectedProject,
            prevSelectedProject: props.selectedProject
        };
        return null;
    }
    componentDidMount() {
        const { selectedProject: selectedProject } = this.state;
        if (selectedProject && !selectedProject.name) this.fetchProject(selectedProject);
    }
    componentDidUpdate() {
        const { selectedProject: selectedProject } = this.state;
        if (selectedProject && !selectedProject.name) this.fetchProject(selectedProject);
    }
    fetchProject(selectedProject) {
        const projectValue = selectedProject.value;
        // @ts-expect-error - TS7006 - Parameter 'newProject' implicitly has an 'any' type.
        const updateSelectedProject = (newProject)=>{
            const currentProject = this.state.selectedProject;
            const currentProjectValue = currentProject && currentProject.value;
            // Update the state only in case the project wasn't changed
            if (currentProjectValue === projectValue) {
                this.setState({
                    selectedProject: newProject
                });
                this.props.onChange(newProject);
            }
        };
        return (0, $5gPNV.requestProject)(projectValue).then((project)=>updateSelectedProject(project)).catch(()=>updateSelectedProject(undefined));
    }
    render() {
        const { intl: { formatMessage: formatMessage }, selectedProject: selectedProject, onChange: onChange, ...props } = this.props;
        const { selectedProject: project, projects: projects } = this.state;
        // the selected option needs to have same object reference to be correctly announced by screen readers
        const selectedOptionWithObjectReference = projects?.find((projectInList)=>projectInList.value === project?.value);
        const selectedOption = selectedOptionWithObjectReference || (project && project.name ? project : null);
        return(// @ts-expect-error - TS2769 - No overload matches this call.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4USKh.PickerWithAvatar), {
            "aria-label": !this.props.label ? formatMessage((0, $2oK1T.default).labelText) : undefined,
            ...props,
            inputId: !this.props.inputId ? this.projectPickerId : this.props.inputId,
            errorMessage: formatMessage((0, $2oK1T.default).error),
            placeholder: this.props.placeholder || formatMessage((0, $2oK1T.default).placeholder),
            onSelected: this.onSelected,
            options: this.fetchOptions,
            formatOptionDataTransformer: this.formatOptionDataTransformer,
            value: selectedOption,
            showFocusedAvatar: true
        }));
    }
}
var $1af03db95f8cb63b$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($1af03db95f8cb63b$export$a4519235a2ef9605);

});
parcelRegister("5gPNV", function(module, exports) {

$parcel$export(module.exports, "requestProjects", () => $cc6820a29e56f420$export$fd47004f2da106d6);
$parcel$export(module.exports, "requestProject", () => $cc6820a29e56f420$export$5fc96122a11240fa);

var $4SXEu = parcelRequire("4SXEu");

var $9V0kk = parcelRequire("9V0kk");
const $cc6820a29e56f420$export$fd47004f2da106d6 = (filter, { detailed: detailed, requireBrowsePermission: requireBrowsePermission, requireEditPermission: requireEditPermission, maxResults: maxResults, projectType: projectType })=>(0, $4SXEu.getProjects)(filter, detailed, requireBrowsePermission, requireEditPermission, maxResults, projectType).then((0, $9V0kk.transformProjects));
const $cc6820a29e56f420$export$5fc96122a11240fa = (projectId)=>(0, $4SXEu.getProject)(projectId).then((0, $9V0kk.transformProject));

});
parcelRegister("4SXEu", function(module, exports) {

$parcel$export(module.exports, "getProjects", () => $7b7f1e9303cf186f$export$b00a271f69f3d728);
$parcel$export(module.exports, "getProject", () => $7b7f1e9303cf186f$export$637b60a42bb03f06);

var $7f4tk = parcelRequire("7f4tk");
const $7b7f1e9303cf186f$var$MAX_PROJECTS = 5;
const $7b7f1e9303cf186f$var$VALID_PROJECT_TYPES = [
    'business',
    'service_desk',
    'software'
];
const $7b7f1e9303cf186f$export$897983d170945c20 = ()=>'/rest/api/2/project/search';
const $7b7f1e9303cf186f$export$40e632ede9793c84 = ()=>'/rest/api/2/project';
const $7b7f1e9303cf186f$export$3675f59ca23820db = (filter, detailed, requireBrowsePermission, requireEditPermission, maxResults = $7b7f1e9303cf186f$var$MAX_PROJECTS, projectType = '')=>{
    const urlSearchParams = new URLSearchParams();
    urlSearchParams.set('orderBy', 'NAME');
    urlSearchParams.set('startAt', '0');
    urlSearchParams.set('query', filter);
    urlSearchParams.set('maxResults', maxResults.toString());
    if (detailed) urlSearchParams.set('expand', 'lead,issueTypes');
    const actions = [];
    if (requireBrowsePermission) actions.push('browse');
    if (requireEditPermission) actions.push('edit');
    if (actions.length > 0) urlSearchParams.set('action', actions.join(','));
    if ($7b7f1e9303cf186f$var$VALID_PROJECT_TYPES.includes(projectType)) urlSearchParams.set('typeKey', projectType);
    const urlParams = `?${urlSearchParams.toString()}`;
    return `${$7b7f1e9303cf186f$export$897983d170945c20()}${urlParams}`;
};
const $7b7f1e9303cf186f$export$42f2db4bad372151 = (projectId)=>`${$7b7f1e9303cf186f$export$40e632ede9793c84()}/${encodeURIComponent(projectId)}`;
const $7b7f1e9303cf186f$export$b00a271f69f3d728 = (filter = '', detailed = false, requireBrowsePermission = false, requireEditPermission = false, maxResults = $7b7f1e9303cf186f$var$MAX_PROJECTS, projectType = '')=>(0, $7f4tk.default)($7b7f1e9303cf186f$export$3675f59ca23820db(filter, detailed, requireBrowsePermission, requireEditPermission, maxResults, projectType));
const $7b7f1e9303cf186f$export$637b60a42bb03f06 = (projectId = '')=>(0, $7f4tk.default)($7b7f1e9303cf186f$export$42f2db4bad372151(projectId));

});

parcelRegister("9V0kk", function(module, exports) {

$parcel$export(module.exports, "transformProject", () => $6541540d335a62b4$export$e179869ce707f546);
$parcel$export(module.exports, "transformProjects", () => $6541540d335a62b4$export$227473965d2e27db);
const $6541540d335a62b4$var$transformLead = (leadResponse)=>leadResponse && {
        key: leadResponse.key,
        name: leadResponse.name,
        displayName: leadResponse.displayName,
        avatarUrl: leadResponse.avatarUrls['24x24']
    };
const $6541540d335a62b4$var$transformIssueTypes = (types)=>types.map((t)=>({
            id: t.id,
            name: t.name,
            description: t.description,
            iconUrl: t.iconUrl,
            subtask: t.subtask
        }));
const $6541540d335a62b4$var$transformDetails = (restResponse)=>({
        id: restResponse.id,
        key: restResponse.key,
        lead: $6541540d335a62b4$var$transformLead(restResponse.lead),
        issueTypes: restResponse.issueTypes ? $6541540d335a62b4$var$transformIssueTypes(restResponse.issueTypes) : [],
        projectTypeKey: restResponse.projectTypeKey,
        simplified: restResponse.simplified
    });
const $6541540d335a62b4$export$e179869ce707f546 = (restResponse)=>restResponse && {
        value: restResponse.id,
        name: restResponse.name,
        label: restResponse.name,
        avatarUrl: restResponse.avatarUrls['24x24'],
        details: $6541540d335a62b4$var$transformDetails(restResponse)
    };
const $6541540d335a62b4$export$227473965d2e27db = (restResponse)=>restResponse && restResponse.values && restResponse.values.map($6541540d335a62b4$export$e179869ce707f546);

});


parcelRegister("2oK1T", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a2fad71e32e9ef5$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5a2fad71e32e9ef5$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    error: {
        "id": "project-picker.error",
        "defaultMessage": "We couldn't retrieve projects"
    },
    placeholder: {
        "id": "project-picker.placeholder",
        "defaultMessage": "Project"
    },
    labelText: {
        "id": "project-picker.label-text",
        "defaultMessage": "Project"
    }
});

});



parcelRegister("imOJb", function(module, exports) {

$parcel$export(module.exports, "default", () => $66ffec577315758c$export$2e2bcd8739ae039);

var $8oe80 = parcelRequire("8oe80");

var $7ffSD = parcelRequire("7ffSD");
var $66ffec577315758c$export$2e2bcd8739ae039 = (0, $8oe80.default)('UserPicker', {
    onChange: 'changed'
})((0, $7ffSD.default));

});
parcelRegister("7ffSD", function(module, exports) {

$parcel$export(module.exports, "default", () => $63ea91f281eaff85$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $4USKh = parcelRequire("4USKh");

var $2YZCu = parcelRequire("2YZCu");

var $az4zD = parcelRequire("az4zD");

var $6GCo0 = parcelRequire("6GCo0");

var $8jpCj = parcelRequire("8jpCj");
class $63ea91f281eaff85$export$83e0c73b09b3a9cd extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isRequired: false,
            isDisabled: false,
            isClearable: true,
            isClearableWithCrossIcon: false,
            isCompact: false,
            shouldFitContainer: false,
            width: '200px'
        };
    }
    constructor(props){
        super(props), this.state = {
            selectedUser: this.props.selectedUser,
            prevSelectedUser: this.props.selectedUser
        }, this.onSelected = (selectedUser)=>{
            this.setState({
                selectedUser: selectedUser
            });
            this.props.onChange(selectedUser);
        }, /* eslint-disable jira/react-arrow-function-property-naming */ this.formatOptionDataTransformer = (user)=>({
                avatar: user.avatarUrl,
                label: user.displayName
            }), this.fetchOptions = (query)=>{
            const { suggestedAccountId: suggestedAccountId } = this.props;
            if (query) return (0, $6GCo0.requestUsers)(query);
            if (suggestedAccountId) return new Promise((resolve)=>{
                (0, $6GCo0.requestUser)(suggestedAccountId).then((user)=>resolve([
                        user
                    ])).catch(()=>resolve([]));
            });
            return Promise.resolve([]);
        };
        this.userPickerId = `group-picker.label.id-${(0, $7Jxgt.v4)()}`;
    }
    static getDerivedStateFromProps(props, state) {
        const currentAccountId = props.selectedUser && props.selectedUser.accountId;
        const prevAccountId = state.prevSelectedUser && state.prevSelectedUser.accountId;
        if (currentAccountId !== prevAccountId) return {
            ...state,
            selectedUser: props.selectedUser,
            prevSelectedUser: props.selectedUser
        };
        return null;
    }
    componentDidMount() {
        this.ensureSelectedUserInfoPresent();
    }
    componentDidUpdate(prevProps) {
        this.ensureSelectedUserInfoPresent();
        if (prevProps.suggestedAccountId !== this.props.suggestedAccountId) // Good to know:
        // react-select caches resolved Promise value for an empty filter so
        // there is no way to change the suggestion other then replacing the component with a new one
        (0, $2YZCu.default).safeErrorWithoutCustomerData('user-picker.prop-update', "suggestedAccountId prop change won't be applied, you have to replace the component with a new one");
    }
    ensureSelectedUserInfoPresent() {
        const { selectedUser: selectedUser } = this.state;
        if (!selectedUser || selectedUser.displayName) return;
        const { accountId: accountId } = selectedUser;
        // @ts-expect-error - TS7006 - Parameter 'newUser' implicitly has an 'any' type.
        const updateSelectedUser = (newUser)=>{
            const currentUser = this.state.selectedUser;
            const currentAccountId = currentUser && currentUser.accountId;
            // Update the state only in case the user wasn't changed
            if (currentAccountId === accountId) this.setState({
                selectedUser: newUser
            });
        };
        (0, $6GCo0.requestUser)(accountId).then((user)=>updateSelectedUser(user)).catch(()=>updateSelectedUser(undefined));
    }
    render() {
        const { intl: { formatMessage: formatMessage }, suggestedAccountId: suggestedAccountId, selectedUser: selectedUser, placeholder: placeholder = this.props.placeholder || formatMessage((0, $8jpCj.default).placeholder), onChange: onChange, shouldFitContainer: shouldFitContainer, width: width, isClearableWithCrossIcon: isClearableWithCrossIcon, ...props } = this.props;
        const { selectedUser: user } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4USKh.PickerWithAvatar), {
            "aria-label": !this.props.label ? formatMessage((0, $8jpCj.default).labelText) : undefined,
            inputId: this.userPickerId,
            ...props,
            errorMessage: formatMessage((0, $8jpCj.default).error),
            placeholder: placeholder,
            onSelected: this.onSelected,
            options: this.fetchOptions,
            formatOptionDataTransformer: this.formatOptionDataTransformer,
            value: user && user.displayName ? user : null,
            width: shouldFitContainer ? undefined : width,
            isClearableWithCrossIcon: isClearableWithCrossIcon
        });
    }
}
var $63ea91f281eaff85$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($63ea91f281eaff85$export$83e0c73b09b3a9cd);

});
parcelRegister("6GCo0", function(module, exports) {

$parcel$export(module.exports, "requestUser", () => $c396037537d957cc$export$949646a1c1731536);
$parcel$export(module.exports, "requestUsers", () => $c396037537d957cc$export$55b721778f931cc1);

var $i4N0u = parcelRequire("i4N0u");

var $bQgxR = parcelRequire("bQgxR");
const $c396037537d957cc$export$949646a1c1731536 = (accountId)=>(0, $i4N0u.getUser)(accountId).then((0, $bQgxR.transformUser));
const $c396037537d957cc$export$55b721778f931cc1 = (query)=>(0, $i4N0u.getUsers)(query).then((0, $bQgxR.transformUsers));

});
parcelRegister("i4N0u", function(module, exports) {

$parcel$export(module.exports, "getUser", () => $de20a383ad0b74fc$export$7cbf767827cd68ba);
$parcel$export(module.exports, "getUsers", () => $de20a383ad0b74fc$export$925a4945a6cd0f3e);

var $7f4tk = parcelRequire("7f4tk");
const $de20a383ad0b74fc$export$e45b57f6c6c40475 = 5;
const $de20a383ad0b74fc$export$7eaa662f51e316ae = ()=>'/rest/api/2/user';
const $de20a383ad0b74fc$export$8df721f926f55c9a = (accountId = '')=>`${$de20a383ad0b74fc$export$7eaa662f51e316ae()}?accountId=${encodeURIComponent(accountId)}`;
const $de20a383ad0b74fc$export$715964ba85b11e2b = ()=>'/rest/api/2/user/picker';
const $de20a383ad0b74fc$export$977bdbd87001f83 = (query = '')=>`${$de20a383ad0b74fc$export$715964ba85b11e2b()}?showAvatar=true&maxResults=${$de20a383ad0b74fc$export$e45b57f6c6c40475}&query=${query}`;
const $de20a383ad0b74fc$export$7cbf767827cd68ba = (accountId = '')=>(0, $7f4tk.default)($de20a383ad0b74fc$export$8df721f926f55c9a(accountId));
const $de20a383ad0b74fc$export$925a4945a6cd0f3e = (query = '')=>(0, $7f4tk.default)($de20a383ad0b74fc$export$977bdbd87001f83(query));

});

parcelRegister("bQgxR", function(module, exports) {

$parcel$export(module.exports, "transformUser", () => $c04a8a4571b1f523$export$88dcd5c1adae8021);
$parcel$export(module.exports, "transformUsers", () => $c04a8a4571b1f523$export$fb8c90bfc4beaa59);
const $c04a8a4571b1f523$export$88dcd5c1adae8021 = ({ accountId: accountId, displayName: displayName, avatarUrls: avatarUrls })=>({
        accountId: accountId,
        value: accountId,
        displayName: displayName,
        label: displayName,
        avatarUrl: avatarUrls['24x24']
    });
const $c04a8a4571b1f523$export$fb8c90bfc4beaa59 = (response)=>response.users.map(({ accountId: accountId, avatarUrl: avatarUrl, displayName: displayName })=>({
            accountId: accountId,
            value: accountId,
            displayName: displayName,
            label: displayName,
            avatarUrl: avatarUrl
        }));

});


parcelRegister("8jpCj", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2a1beea71a0796f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e2a1beea71a0796f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    error: {
        "id": "user-picker.error",
        "defaultMessage": "We couldn't retrieve users"
    },
    placeholder: {
        "id": "user-picker.placeholder",
        "defaultMessage": "User"
    },
    labelText: {
        "id": "user-picker.label-text",
        "defaultMessage": "User"
    }
});

});



parcelRegister("2Qtku", function(module, exports) {

$parcel$export(module.exports, "default", () => $72ea72e33094f40c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $basmW = parcelRequire("basmW");

var $eCeGD = parcelRequire("eCeGD");

var $iQv12 = parcelRequire("iQv12");

var $az4zD = parcelRequire("az4zD");

var $6SywE = parcelRequire("6SywE");
function $72ea72e33094f40c$export$47d037774b685574(props) {
    const { onClick: onClick, intl: { formatMessage: formatMessage } } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        appearance: "subtle",
        onClick: onClick,
        shouldFitContainer: true
    }, formatMessage((0, $6SywE.default).label));
}
var $72ea72e33094f40c$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $iQv12.default)({
    onClick: 'clearFilters'
}), (0, $az4zD.injectIntlV2))($72ea72e33094f40c$export$47d037774b685574);

});
parcelRegister("6SywE", function(module, exports) {

$parcel$export(module.exports, "default", () => $a738855fbfb5ad8d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a738855fbfb5ad8d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "directories.dashboards-v2.main.content.filter.clear.label",
        "defaultMessage": "Clear filters"
    }
});

});


parcelRegister("k0uL3", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fdec369a98f4276$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $eneeA = parcelRequire("eneeA");

var $ijnJK = parcelRequire("ijnJK");

var $az4zD = parcelRequire("az4zD");

var $dCm1o = parcelRequire("dCm1o");

var $6VFCM = parcelRequire("6VFCM");
class $0fdec369a98f4276$export$ec91da630f36d5ea extends (0, $5uXOq.Component) {
    render() {
        const { renderFilterSearch: renderFilterSearch, renderOwnerPicker: renderOwnerPicker, renderProjectPicker: renderProjectPicker, renderGroupPicker: renderGroupPicker, renderClear: renderClear, intl: { formatMessage: formatMessage } } = this.props;
        const isVisualRefresh = (0, $dCm1o.isVisualRefreshEnabled)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eneeA.FilterBar), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ijnJK.FilterItem), {
            expandOnSmall: true
        }, renderFilterSearch({
            onChange: this.onSearchChange,
            placeholder: formatMessage((0, $6VFCM.default).searchPlaceholder)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ijnJK.FilterItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: !isVisualRefresh && $0fdec369a98f4276$var$itemInnerStyles
        }, renderOwnerPicker({
            onChange: this.onOwnerChange,
            placeholder: isVisualRefresh ? formatMessage((0, $6VFCM.default).ownerLabel) : formatMessage((0, $6VFCM.default).ownerPlaceholder),
            label: isVisualRefresh ? undefined : formatMessage((0, $6VFCM.default).ownerLabel)
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ijnJK.FilterItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: !isVisualRefresh && $0fdec369a98f4276$var$itemInnerStyles
        }, renderProjectPicker({
            onChange: this.onProjectChange,
            placeholder: isVisualRefresh ? formatMessage((0, $6VFCM.default).projectLabel) : formatMessage((0, $6VFCM.default).projectPlaceholder),
            label: isVisualRefresh ? undefined : formatMessage((0, $6VFCM.default).projectLabel)
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ijnJK.FilterItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: !isVisualRefresh && $0fdec369a98f4276$var$itemInnerStyles
        }, renderGroupPicker({
            onChange: this.onGroupChange,
            placeholder: isVisualRefresh ? formatMessage((0, $6VFCM.default).groupLabel) : formatMessage((0, $6VFCM.default).groupPlaceholder),
            label: isVisualRefresh ? undefined : formatMessage((0, $6VFCM.default).groupLabel)
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ijnJK.FilterItem), {
            expandOnSmall: true
        }, renderClear({
            onClick: this.onClear
        })));
    }
    constructor(...args){
        super(...args), // @ts-expect-error - TS2322 - Type 'undefined' is not assignable to type 'string'.
        this.onSearchChange = (text, analyticsEvent)=>{
            this.props.onChange({
                ...this.props.value,
                text: text
            }, analyticsEvent);
        }, this.onOwnerChange = (owner, analyticsEvent)=>{
            this.props.onChange({
                ...this.props.value,
                owner: owner
            }, analyticsEvent);
        }, this.onProjectChange = (project, analyticsEvent)=>{
            this.props.onChange({
                ...this.props.value,
                project: project
            }, analyticsEvent);
        }, this.onGroupChange = (group, analyticsEvent)=>{
            this.props.onChange({
                ...this.props.value,
                group: group
            }, analyticsEvent);
        }, this.onClear = (analyticsEvent)=>{
            this.props.onChange({
                ...this.props.initialFilter
            }, analyticsEvent);
        };
    }
}
var $0fdec369a98f4276$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($0fdec369a98f4276$export$ec91da630f36d5ea);
const $0fdec369a98f4276$var$itemInnerStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.negative.250'
});

});
parcelRegister("eneeA", function(module, exports) {

$parcel$export(module.exports, "FilterBar", () => $b95c1e2c9fc07d20$export$56a20ec2552ffba2);

var $5uXOq = parcelRequire("5uXOq");

var $34ck9 = parcelRequire("34ck9");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $gJlZe = parcelRequire("gJlZe");

var $dCm1o = parcelRequire("dCm1o");

const $b95c1e2c9fc07d20$export$56a20ec2552ffba2 = ({ children: children })=>{
    const [containerWidth, setContainerWidth] = (0, $5uXOq.useState)(900);
    const handleWidth = (0, (/*@__PURE__*/$parcel$interopDefault($34ck9)))(setContainerWidth, 50);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $b95c1e2c9fc07d20$var$relativeWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gJlZe.WidthObserver), {
        setWidth: handleWidth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $b95c1e2c9fc07d20$var$filterBarSharedStyles,
            (0, $dCm1o.isVisualRefreshEnabled)() && $b95c1e2c9fc07d20$var$filterBarSharedStylesVisualRefresh,
            containerWidth > (0, $3ab203d2ecb98f35$export$9cc428d7e02a0e8b) && $b95c1e2c9fc07d20$var$filterBarLargeStyles,
            containerWidth <= (0, $3ab203d2ecb98f35$export$9cc428d7e02a0e8b) && containerWidth > (0, $3ab203d2ecb98f35$export$99041d531d62aef9) && $b95c1e2c9fc07d20$var$filterBarMidStyles,
            containerWidth <= (0, $3ab203d2ecb98f35$export$99041d531d62aef9) && containerWidth > (0, $3ab203d2ecb98f35$export$54280d191a58e9f6) && $b95c1e2c9fc07d20$var$filterBarSmallStyles
        ]
    }, children));
};
const $b95c1e2c9fc07d20$var$relativeWrapperStyles = (0, $8CUq3.xcss)({
    position: 'relative'
});
const $b95c1e2c9fc07d20$var$filterBarSharedStyles = (0, $8CUq3.xcss)({
    width: '100%',
    display: 'grid',
    columnGap: 'space.200',
    rowGap: 'space.100',
    alignItems: 'flex-end'
});
const $b95c1e2c9fc07d20$var$filterBarSharedStylesVisualRefresh = (0, $8CUq3.xcss)({
    columnGap: 'space.100'
});
const $b95c1e2c9fc07d20$var$filterBarSmallStyles = (0, $8CUq3.xcss)({
    gridTemplateColumns: 'repeat(2, 1fr)'
});
const $b95c1e2c9fc07d20$var$filterBarMidStyles = (0, $8CUq3.xcss)({
    gridTemplateColumns: 'repeat(3, 1fr)'
});
const $b95c1e2c9fc07d20$var$filterBarLargeStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    flexWrap: 'wrap'
});

});
parcelRegister("gJlZe", function(module, exports) {

$parcel$export(module.exports, "WidthObserver", () => $f3c667de71b5760d$export$b2ad68b9bc407b80);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jWz2c = parcelRequire("jWz2c");
const $f3c667de71b5760d$export$b2ad68b9bc407b80 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo((props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jWz2c.WidthDetectorObserver), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});
var $f3c667de71b5760d$export$2e2bcd8739ae039 = $f3c667de71b5760d$export$b2ad68b9bc407b80;

});
parcelRegister("jWz2c", function(module, exports) {

$parcel$export(module.exports, "WidthDetectorObserver", () => $76470ef26276f9f4$export$ff983d2a2b6112ea);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $1LwQL = parcelRequire("1LwQL");
const $76470ef26276f9f4$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ setWidth: setWidth, offscreen: offscreen })=>{
    const [inViewRef, inView, target] = (0, $1LwQL.useInView)({
        /* Optional options */ threshold: 0
    });
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(()=>{
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        // @ts-ignore
        return new ResizeObserver((entries)=>{
            if (!Array.isArray(entries) || !entries.length) return;
            const { width: width } = entries[0].contentRect;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        const { current: currentObserver } = observer;
        const resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        ref: inViewRef
    });
});

});
parcelRegister("1LwQL", function(module, exports) {

$parcel$export(module.exports, "useInView", () => $1dfb7d23cdbb03d0$export$2f62ee6831462844);

var $5uXOq = parcelRequire("5uXOq");
function $1dfb7d23cdbb03d0$export$2f62ee6831462844(options = {}) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    });
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    const setRef = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((node)=>{
        observerInstance.current = new IntersectionObserver((entries)=>{
            if (entries && entries.length) {
                const intersection = entries[0];
                const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                if (intersectionRatio >= 0) {
                    // Note: `0` will be used here when an array of numbers is passed as the threshold, which doesn't feel right
                    const numericThreshold = typeof threshold === 'number' ? threshold : 0;
                    let inView = intersectionRatio >= numericThreshold;
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
	 * Unsubscribe IntersectionObserver before unmounting a component.
	 */ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        return ()=>{
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
}

});



const $3ab203d2ecb98f35$export$54280d191a58e9f6 = 420;
const $3ab203d2ecb98f35$export$99041d531d62aef9 = 640;
const $3ab203d2ecb98f35$export$9cc428d7e02a0e8b = 850;
const $3ab203d2ecb98f35$export$a4477e829bcd1e02 = 200;


parcelRegister("ijnJK", function(module, exports) {

$parcel$export(module.exports, "FilterItem", () => $82ad612f888d18b7$export$3cf161fcd24b6b4f);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $82ad612f888d18b7$export$3cf161fcd24b6b4f = ({ expandOnSmall: expandOnSmall, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: expandOnSmall ? [
            $82ad612f888d18b7$var$filterItemContainerStyles,
            $82ad612f888d18b7$var$filterItemContainerExpandedStyles
        ] : $82ad612f888d18b7$var$filterItemContainerStyles
    }, children);
};
const $82ad612f888d18b7$var$filterItemContainerStyles = (0, $8CUq3.xcss)({
    // 200px is the width commonly used for directory filters, so including it here helps
    // to ensure consistency with the existing design and gives us predictability for responsive behaviour
    minWidth: '200px'
});
const $82ad612f888d18b7$var$filterItemContainerExpandedStyles = (0, $8CUq3.xcss)({
    gridColumn: '1 / -1'
});

});

parcelRegister("6VFCM", function(module, exports) {

$parcel$export(module.exports, "default", () => $971e527be19fd2ef$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $971e527be19fd2ef$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    searchFilterAriaSearchDescription: {
        "id": "directories.dashboards-v2.main.content.filter.search-filter-aria-search-description",
        "defaultMessage": "The table will be filtered below as you type into the field"
    },
    searchPlaceholder: {
        "id": "directories.dashboards-v2.main.content.filter.search-placeholder",
        "defaultMessage": "Search dashboards"
    },
    ownerPlaceholder: {
        "id": "directories.dashboards-v2.main.content.filter.owner-placeholder",
        "defaultMessage": "Select owner"
    },
    projectPlaceholder: {
        "id": "directories.dashboards-v2.main.content.filter.project-placeholder",
        "defaultMessage": "Select project"
    },
    groupPlaceholder: {
        "id": "directories.dashboards-v2.main.content.filter.group-placeholder",
        "defaultMessage": "Select group"
    },
    searchLabel: {
        "id": "directories.dashboards-v2.main.content.filter.search-label",
        "defaultMessage": "Search"
    },
    ownerLabel: {
        "id": "directories.dashboards-v2.main.content.filter.owner-label",
        "defaultMessage": "Owner"
    },
    projectLabel: {
        "id": "directories.dashboards-v2.main.content.filter.project-label",
        "defaultMessage": "Project"
    },
    groupLabel: {
        "id": "directories.dashboards-v2.main.content.filter.group-label",
        "defaultMessage": "Group"
    }
});

});



parcelRegister("lQRKF", function(module, exports) {

$parcel$export(module.exports, "operationModals", () => $6b435257b6357de2$export$fee8081fa482dfbf);
$parcel$export(module.exports, "emptyFilterResultConfiguration", () => $6b435257b6357de2$export$972f54d0cb76a888);
$parcel$export(module.exports, "getTableConfiguration", () => $6b435257b6357de2$export$6847365bea1c5392);
$parcel$export(module.exports, "getTableLabel", () => $6b435257b6357de2$export$b2d196af18e06ad6);
$parcel$export(module.exports, "getResultsAnnouncerMessage", () => $6b435257b6357de2$export$64df75861e57fb7f);

var $dGvGJ = parcelRequire("dGvGJ");

var $epVKM = parcelRequire("epVKM");


var $4R6GH = parcelRequire("4R6GH");

var $dCm1o = parcelRequire("dCm1o");

var $48oUo = parcelRequire("48oUo");

var $aDfxw = parcelRequire("aDfxw");

var $aXJFW = parcelRequire("aXJFW");

var $9aswz = parcelRequire("9aswz");

var $7IGKJ = parcelRequire("7IGKJ");

var $bFDqU = parcelRequire("bFDqU");

var $kLMvA = parcelRequire("kLMvA");

var $cHbtV = parcelRequire("cHbtV");

var $b8vgn = parcelRequire("b8vgn");

var $f95M9 = parcelRequire("f95M9");

var $i2pg9 = parcelRequire("i2pg9");

var $2jr3k = parcelRequire("2jr3k");

var $cHCoE = parcelRequire("cHCoE");

var $bUIoU = parcelRequire("bUIoU");

var $lvzW5 = parcelRequire("lvzW5");
const $6b435257b6357de2$export$fee8081fa482dfbf = {
    [(0, $088bf273559ead46$export$92f9e1ed9114d3a6)]: (0, $2jr3k.default),
    [(0, $088bf273559ead46$export$250171a898bf7ef)]: (0, $bUIoU.default),
    [(0, $088bf273559ead46$export$4bd2facc4a3e6aa1)]: (0, $cHCoE.default),
    [(0, $088bf273559ead46$export$39d2a7fb21967424)]: (0, $i2pg9.default)
};
const $6b435257b6357de2$export$972f54d0cb76a888 = {
    message: (0, $lvzW5.default).emptyFilterResultMessage
};
const $6b435257b6357de2$export$6847365bea1c5392 = (0, $dGvGJ.createSelector)((0, $aDfxw.getLoggedInUserAccountId), (accountId)=>[
        accountId !== null ? {
            title: (0, $epVKM.default),
            Cell: (0, $bFDqU.default),
            sortField: (0, $48oUo.FAVOURITED),
            width: 3,
            isIconOnlyHeader: (0, $dCm1o.isVisualRefreshEnabled)(),
            ascendingSortTooltip: (0, $dCm1o.isVisualRefreshEnabled)() ? (0, $lvzW5.default).starredToUnstarredOrder : undefined,
            descendingSortTooltip: (0, $dCm1o.isVisualRefreshEnabled)() ? (0, $lvzW5.default).unstarredToStarredOrder : undefined
        } : undefined,
        {
            title: (0, $lvzW5.default).name,
            Cell: (0, $f95M9.default),
            sortField: (0, $48oUo.NAME),
            width: accountId ? 25 : 35,
            ascendingSortTooltip: (0, $dCm1o.isVisualRefreshEnabled)() ? (0, $lvzW5.default).aToZOrder : undefined,
            descendingSortTooltip: (0, $dCm1o.isVisualRefreshEnabled)() ? (0, $lvzW5.default).zToAOrder : undefined
        },
        accountId !== null ? {
            title: (0, $lvzW5.default).owner,
            Cell: (0, $kLMvA.default),
            sortField: (0, $48oUo.OWNER),
            width: 19,
            ascendingSortTooltip: (0, $dCm1o.isVisualRefreshEnabled)() ? (0, $lvzW5.default).aToZOrder : undefined,
            descendingSortTooltip: (0, $dCm1o.isVisualRefreshEnabled)() ? (0, $lvzW5.default).zToAOrder : undefined
        } : undefined,
        {
            title: (0, $lvzW5.default).viewers,
            Cell: (0, $aXJFW.default),
            // eslint-disable-next-line no-nested-ternary
            width: accountId ? (0, $dCm1o.isVisualRefreshEnabled)() ? 19 : 19.5 : 25
        },
        {
            title: (0, $lvzW5.default).editors,
            Cell: (0, $7IGKJ.default),
            width: accountId ? 19 : 25
        },
        {
            title: (0, $lvzW5.default).popularity,
            Cell: accountId !== null && (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('blu-6801-dashboards-a11y-fix') ? (0, $cHbtV.default) : (0, $b8vgn.default),
            sortField: (0, $48oUo.POPULARITY),
            width: accountId !== null && (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('blu-6801-dashboards-a11y-fix') ? 15 : 9,
            ascendingSortTooltip: (0, $dCm1o.isVisualRefreshEnabled)() ? (0, $lvzW5.default).lowestToHighestOrder : undefined,
            descendingSortTooltip: (0, $dCm1o.isVisualRefreshEnabled)() ? (0, $lvzW5.default).highestToLowestOrder : undefined
        },
        // eslint-disable-next-line no-nested-ternary
        accountId !== null && !((0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('blu-6801-dashboards-a11y-fix')) ? (0, $dCm1o.isVisualRefreshEnabled)() ? {
            Cell: (0, $9aswz.default),
            width: 6,
            dataTestId: 'dashboards-main.content.headerCell.actions.container'
        } : {
            title: (0, $lvzW5.default).moreActions,
            Cell: (0, $9aswz.default),
            width: 6,
            dataTestId: 'dashboards-main.content.headerCell.actions.container'
        } : undefined
    ].filter(Boolean));
const $6b435257b6357de2$export$b2d196af18e06ad6 = ()=>(0, $lvzW5.default).tableAriaLabel;
const $6b435257b6357de2$export$64df75861e57fb7f = ()=>(0, $lvzW5.default).filterResultsAnnouncement;

});
parcelRegister("epVKM", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7b567d1c855c884$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5IcUR = parcelRequire("5IcUR");

var $koVbs = parcelRequire("koVbs");

var $75Uq1 = parcelRequire("75Uq1");
const $f7b567d1c855c884$var$StarTitleCell = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5IcUR))), {
        LEGACY_size: "small",
        label: formatMessage((0, $75Uq1.messages).starred)
    });
};
var $f7b567d1c855c884$export$2e2bcd8739ae039 = $f7b567d1c855c884$var$StarTitleCell;

});
parcelRegister("5IcUR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3b98083f7180ee5a6483375174c0842e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $428b14ab8e8af837$var$_react = $428b14ab8e8af837$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $428b14ab8e8af837$var$_starStarred = $428b14ab8e8af837$var$_interopRequireDefault((parcelRequire("dm1qi")));

var $428b14ab8e8af837$var$_starFilled = $428b14ab8e8af837$var$_interopRequireDefault((parcelRequire("bH1hf")));
function $428b14ab8e8af837$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StarStarredIcon.
 * This component is StarStarredIcon, with `UNSAFE_fallbackIcon` set to "StarFilledIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for starred or favourited objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $428b14ab8e8af837$var$StarStarredIcon = (props)=>/*#__PURE__*/ $428b14ab8e8af837$var$_react.default.createElement($428b14ab8e8af837$var$_starStarred.default, Object.assign({
        LEGACY_fallbackIcon: $428b14ab8e8af837$var$_starFilled.default
    }, props));
$428b14ab8e8af837$var$StarStarredIcon.Name = 'StarStarredIconMigration';
var $428b14ab8e8af837$var$_default = module.exports.default = $428b14ab8e8af837$var$StarStarredIcon;

});
parcelRegister("dm1qi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84298877a5ffec5302189e1356603055>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9b8e6f0febff8b04$var$_react = $9b8e6f0febff8b04$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $9b8e6f0febff8b04$var$_baseNew = $9b8e6f0febff8b04$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $9b8e6f0febff8b04$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StarStarred".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for starred or favourited objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9b8e6f0febff8b04$var$StarStarredIcon = (props)=>/*#__PURE__*/ $9b8e6f0febff8b04$var$_react.default.createElement($9b8e6f0febff8b04$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a.75.75 0 0 1 .7.48l1.705 4.434 4.403.338a.75.75 0 0 1 .422 1.324l-3.38 2.818 1.25 4.662a.75.75 0 0 1-1.148.813L8 12.159l-3.95 2.71a.75.75 0 0 1-1.15-.813l1.251-4.662L.77 6.576a.75.75 0 0 1 .422-1.324l4.403-.338L7.3.48A.75.75 0 0 1 8 0m0 2.84L6.655 6.335l-3.506.27 2.7 2.25-.973 3.627L8 10.341l3.124 2.142-.973-3.627 2.7-2.25-3.506-.27z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.655 6.336 8 2.84l1.345 3.497 3.506.27-2.7 2.25.973 3.627L8 10.341l-3.124 2.142.973-3.627-2.7-2.25z"/>`
    }, props));
$9b8e6f0febff8b04$var$StarStarredIcon.displayName = 'StarStarredIcon';
var $9b8e6f0febff8b04$var$_default = module.exports.default = $9b8e6f0febff8b04$var$StarStarredIcon;

});

parcelRegister("bH1hf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8834b3797a7b4177$var$_react = $8834b3797a7b4177$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $8834b3797a7b4177$var$_starStarred = $8834b3797a7b4177$var$_interopRequireDefault((parcelRequire("dm1qi")));
function $8834b3797a7b4177$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8834b3797a7b4177$var$StarFilledIcon = (props)=>/*#__PURE__*/ $8834b3797a7b4177$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m12.072 17.284-3.905 2.053a1 1 0 0 1-1.451-1.054l.745-4.349-3.159-3.08a1 1 0 0 1 .554-1.705l4.366-.635 1.953-3.956a1 1 0 0 1 1.794 0l1.952 3.956 4.366.635a1 1 0 0 1 .555 1.705l-3.16 3.08.746 4.349a1 1 0 0 1-1.45 1.054z"/></svg>`
    }, props, {
        newIcon: $8834b3797a7b4177$var$_starStarred.default
    }));
$8834b3797a7b4177$var$StarFilledIcon.displayName = 'StarFilledIcon';
var $8834b3797a7b4177$var$_default = module.exports.default = $8834b3797a7b4177$var$StarFilledIcon;

});


parcelRegister("75Uq1", function(module, exports) {

$parcel$export(module.exports, "messages", () => $8eb82dc6fef00b40$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $8eb82dc6fef00b40$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    starred: {
        "id": "directories.common.components.star-title-cell.starred",
        "defaultMessage": "Starred"
    }
});

});


parcelRegister("aXJFW", function(module, exports) {

$parcel$export(module.exports, "default", () => $961ac9f105b0b276$export$2e2bcd8739ae039);

var $3pUkE = parcelRequire("3pUkE");

var $bC2fB = parcelRequire("bC2fB");

var $dIWFt = parcelRequire("dIWFt");
const $961ac9f105b0b276$var$mapStateToProps = ()=>(state, ownProps)=>({
            shares: (0, $dIWFt.getShares)(state, ownProps.id)
        });
var $961ac9f105b0b276$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($961ac9f105b0b276$var$mapStateToProps, {})((0, $3pUkE.default));

});
parcelRegister("3pUkE", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f5f0405f4933c54$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ujWmd = parcelRequire("ujWmd");

var $a3mGm = parcelRequire("a3mGm");

var $jRceo = parcelRequire("jRceo");

var $ckyDP = parcelRequire("ckyDP");

var $guOIy = parcelRequire("guOIy");

var $az4zD = parcelRequire("az4zD");


var $3pSGI = parcelRequire("3pSGI");
const $6f5f0405f4933c54$var$assertUnreachable = (_x)=>{
    throw new Error("Didn't expect to get here");
};
class $6f5f0405f4933c54$export$3026e5a52c747d2c extends (0, $5uXOq.Component) {
    static{
        // go/jfe-eslint
        // eslint-disable-next-line react/sort-comp
        this.defaultProps = {
            shares: []
        };
    }
    static renderAvatar(text, avatarUrl, idx, appearance) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6f5f0405f4933c54$var$Container, {
            key: idx
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6f5f0405f4933c54$var$AvatarContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
            size: "small",
            src: avatarUrl,
            appearance: appearance
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6f5f0405f4933c54$var$TextContainer, null, text));
    }
    static renderIcon(text, IconComponent, idx = 1) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6f5f0405f4933c54$var$Container, {
            key: idx
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6f5f0405f4933c54$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(IconComponent, {
            label: "",
            spacing: "spacious"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6f5f0405f4933c54$var$TextContainer, null, text));
    }
    render() {
        const { shares: shares, intl: { formatMessage: formatMessage } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6f5f0405f4933c54$var$CellContainer, null, shares.length > 0 ? shares.map((share, idx)=>{
            switch(share.type){
                case 0, $a889b3091d5309c7$export$b0a0e62d9b1a8269:
                    return $6f5f0405f4933c54$export$3026e5a52c747d2c.renderIcon(formatMessage((0, $3pSGI.default).myOrganizationAccess), (0, (/*@__PURE__*/$parcel$interopDefault($jRceo))), idx);
                case 0, $a889b3091d5309c7$export$86517eb0163ef745:
                    return $6f5f0405f4933c54$export$3026e5a52c747d2c.renderIcon(formatMessage((0, $3pSGI.default).publicAccess), (0, (/*@__PURE__*/$parcel$interopDefault($guOIy))), idx);
                case 0, $a889b3091d5309c7$export$b02d7412182d1bce:
                    // @ts-expect-error - TS2345 - Type 'undefined' is not assignable to type 'string'
                    return $6f5f0405f4933c54$export$3026e5a52c747d2c.renderIcon(share.group.name, (0, (/*@__PURE__*/$parcel$interopDefault($ckyDP))), idx);
                case 0, $a889b3091d5309c7$export$aea0835048e1c730:
                    return $6f5f0405f4933c54$export$3026e5a52c747d2c.renderAvatar(share.user.displayName, share.user.avatarUrl, idx, 'circle');
                case 0, $a889b3091d5309c7$export$5ef95a67b8fd1ff6:
                    {
                        const roleName = share.role ? share.role.name : formatMessage((0, $3pSGI.default).allProjectRoles);
                        const text = `${share.project.name}, ${roleName}`;
                        return $6f5f0405f4933c54$export$3026e5a52c747d2c.renderAvatar(text, share.project.avatarUrl, idx, 'square');
                    }
                case 0, $a889b3091d5309c7$export$487da0972e3459fe:
                    return null;
                // hide from the list
                default:
                    $6f5f0405f4933c54$var$assertUnreachable(share);
                    return null;
            }
        }) : $6f5f0405f4933c54$export$3026e5a52c747d2c.renderIcon(formatMessage((0, $3pSGI.default).privateAccess), (0, (/*@__PURE__*/$parcel$interopDefault($a3mGm)))));
    }
}
var $6f5f0405f4933c54$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $az4zD.injectIntlV2)($6f5f0405f4933c54$export$3026e5a52c747d2c);
const $6f5f0405f4933c54$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _n3td1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6f5f0405f4933c54$var$AvatarContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_u5f3u2gc _vwz4kb7n _1o9zidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6f5f0405f4933c54$var$IconContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qv77o _u5f3utpp _n3tdv77o _19bvv77o _vwz4kb7n _1o9zidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6f5f0405f4933c54$var$TextContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _slp31hna _16jlkb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6f5f0405f4933c54$var$CellContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0q12x7 _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("a3mGm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::766864a6ad12ee0b57d7ed41e0a75cca>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $751bc76853fe58bc$var$_react = $751bc76853fe58bc$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $751bc76853fe58bc$var$_lockLocked = $751bc76853fe58bc$var$_interopRequireDefault((parcelRequire("bwyQI")));

var $751bc76853fe58bc$var$_lock = $751bc76853fe58bc$var$_interopRequireDefault((parcelRequire("3G2gB")));
function $751bc76853fe58bc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LockLockedIcon.
 * This component is LockLockedIcon, with `UNSAFE_fallbackIcon` set to "LockIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $751bc76853fe58bc$var$LockLockedIcon = (props)=>/*#__PURE__*/ $751bc76853fe58bc$var$_react.default.createElement($751bc76853fe58bc$var$_lockLocked.default, Object.assign({
        LEGACY_fallbackIcon: $751bc76853fe58bc$var$_lock.default
    }, props));
$751bc76853fe58bc$var$LockLockedIcon.Name = 'LockLockedIconMigration';
var $751bc76853fe58bc$var$_default = module.exports.default = $751bc76853fe58bc$var$LockLockedIcon;

});
parcelRegister("bwyQI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::86c9de42fef4ccbc35a6164a0094138a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $863db7350f859785$var$_react = $863db7350f859785$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $863db7350f859785$var$_baseNew = $863db7350f859785$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $863db7350f859785$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockLocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $863db7350f859785$var$LockLockedIcon = (props)=>/*#__PURE__*/ $863db7350f859785$var$_react.default.createElement($863db7350f859785$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3h5V4A2.5 2.5 0 0 0 8 1.5M12 7V4a4 4 0 0 0-8 0v3a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M4 8.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5zM7.25 13v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$863db7350f859785$var$LockLockedIcon.displayName = 'LockLockedIcon';
var $863db7350f859785$var$_default = module.exports.default = $863db7350f859785$var$LockLockedIcon;

});

parcelRegister("3G2gB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2ad70d7fd26028c0$var$_react = $2ad70d7fd26028c0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $2ad70d7fd26028c0$var$_lockLocked = $2ad70d7fd26028c0$var$_interopRequireDefault((parcelRequire("bwyQI")));
function $2ad70d7fd26028c0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2ad70d7fd26028c0$var$LockIcon = (props)=>/*#__PURE__*/ $2ad70d7fd26028c0$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M16 11V9h-2V7.002A2 2 0 0 0 12 5c-1.102 0-2 .898-2 2.002V9H8v2H7v8h10v-8zm-2 0h-4V9h4zM8 9V7.002A4.004 4.004 0 0 1 12 3a4 4 0 0 1 4 4.002V9h.994A2.01 2.01 0 0 1 19 11.009v7.982c0 1.11-.897 2.009-2.006 2.009H7.006A2.01 2.01 0 0 1 5 18.991V11.01C5 9.899 5.897 9 7.006 9zm0 0h2v2H8zm6 0h2v2h-2z"/><circle cx="12" cy="15" r="2"/></g></svg>`
    }, props, {
        newIcon: $2ad70d7fd26028c0$var$_lockLocked.default
    }));
$2ad70d7fd26028c0$var$LockIcon.displayName = 'LockIcon';
var $2ad70d7fd26028c0$var$_default = module.exports.default = $2ad70d7fd26028c0$var$LockIcon;

});


parcelRegister("jRceo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f7f55381552b3bb050a399d88ef8b3fd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e74c746303d0418a$var$_react = $e74c746303d0418a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e74c746303d0418a$var$_officeBuilding = $e74c746303d0418a$var$_interopRequireDefault((parcelRequire("4bTdk")));

var $e74c746303d0418a$var$_officeBuilding2 = $e74c746303d0418a$var$_interopRequireDefault((parcelRequire("icDh5")));
function $e74c746303d0418a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for OfficeBuildingIcon.
 * This component is OfficeBuildingIcon, with `UNSAFE_fallbackIcon` set to "OfficeBuildingIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: office in Atlas, company.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e74c746303d0418a$var$OfficeBuildingIcon = (props)=>/*#__PURE__*/ $e74c746303d0418a$var$_react.default.createElement($e74c746303d0418a$var$_officeBuilding.default, Object.assign({
        LEGACY_fallbackIcon: $e74c746303d0418a$var$_officeBuilding2.default
    }, props));
$e74c746303d0418a$var$OfficeBuildingIcon.Name = 'OfficeBuildingIconMigration';
var $e74c746303d0418a$var$_default = module.exports.default = $e74c746303d0418a$var$OfficeBuildingIcon;

});
parcelRegister("4bTdk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dfe75e26330f86b48e811f0d520fc5e3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $30d304d6d8375db3$var$_react = $30d304d6d8375db3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $30d304d6d8375db3$var$_baseNew = $30d304d6d8375db3$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $30d304d6d8375db3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "OfficeBuilding".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: office in Atlas, company.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $30d304d6d8375db3$var$OfficeBuildingIcon = (props)=>/*#__PURE__*/ $30d304d6d8375db3$var$_react.default.createElement($30d304d6d8375db3$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12.5h1V16H1v-1.5h1zm1.5 12.5h2v-3.75a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 .75.75v3.75h2V2a.5.5 0 0 0-.5-.5H4a.5.5 0 0 0-.5.5zm5.5 0v-3H7v3zm-2-10H5V3h2zm4 0H9V3h2zM5 6h2v1.5H5zm4 0h2v1.5H9z" clip-rule="evenodd"/>`
    }, props));
$30d304d6d8375db3$var$OfficeBuildingIcon.displayName = 'OfficeBuildingIcon';
var $30d304d6d8375db3$var$_default = module.exports.default = $30d304d6d8375db3$var$OfficeBuildingIcon;

});

parcelRegister("icDh5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d407d01834f2f44a$var$_react = $d407d01834f2f44a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $d407d01834f2f44a$var$_officeBuilding = $d407d01834f2f44a$var$_interopRequireDefault((parcelRequire("4bTdk")));
function $d407d01834f2f44a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d407d01834f2f44a$var$OfficeBuildingIcon = (props)=>/*#__PURE__*/ $d407d01834f2f44a$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M8 6H5.009C3.902 6 3 6.962 3 8.15v10.7C3 20.04 3.9 21 5.009 21h5.487H8v-2.145c-1.616-.001-3-.003-3-.004 0 0 .005-10.708.009-10.708L8 8.144z"/><path d="M12 7h2v2h-2zm-6 3h2v2H6zm0 3h2v2H6zm6-3h2v2h-2zm0 3h2v2h-2zm2 3h2v3h-2zm2-9h2v2h-2zm0 3h2v2h-2zm0 3h2v2h-2z"/><path fill-rule="nonzero" d="M18.991 19C18.998 19 19 4.995 19 4.995c0 .006-7.991.005-7.991.005C11.002 5 11 19 11 19zM9 4.995C9 3.893 9.902 3 11.009 3h7.982C20.101 3 21 3.893 21 4.995v14.01A2.004 2.004 0 0 1 18.991 21H9z"/></g></svg>`
    }, props, {
        newIcon: $d407d01834f2f44a$var$_officeBuilding.default
    }));
$d407d01834f2f44a$var$OfficeBuildingIcon.displayName = 'OfficeBuildingIcon';
var $d407d01834f2f44a$var$_default = module.exports.default = $d407d01834f2f44a$var$OfficeBuildingIcon;

});


parcelRegister("guOIy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bfa480f43d6d2cb52a0e0ba9712304a9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c026ca20e9e43a09$var$_react = $c026ca20e9e43a09$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c026ca20e9e43a09$var$_globe = $c026ca20e9e43a09$var$_interopRequireDefault((parcelRequire("9x5pH")));

var $c026ca20e9e43a09$var$_world = $c026ca20e9e43a09$var$_interopRequireDefault((parcelRequire("4GsX0")));
function $c026ca20e9e43a09$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for GlobeIcon.
 * This component is GlobeIcon, with `UNSAFE_fallbackIcon` set to "WorldIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: public link in Confluence share dialog, global rules in Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c026ca20e9e43a09$var$GlobeIcon = (props)=>/*#__PURE__*/ $c026ca20e9e43a09$var$_react.default.createElement($c026ca20e9e43a09$var$_globe.default, Object.assign({
        LEGACY_fallbackIcon: $c026ca20e9e43a09$var$_world.default
    }, props));
$c026ca20e9e43a09$var$GlobeIcon.Name = 'GlobeIconMigration';
var $c026ca20e9e43a09$var$_default = module.exports.default = $c026ca20e9e43a09$var$GlobeIcon;

});
parcelRegister("4GsX0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $36918aadf9f6e08c$var$_react = $36918aadf9f6e08c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $36918aadf9f6e08c$var$_globe = $36918aadf9f6e08c$var$_interopRequireDefault((parcelRequire("9x5pH")));
function $36918aadf9f6e08c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $36918aadf9f6e08c$var$WorldIcon = (props)=>/*#__PURE__*/ $36918aadf9f6e08c$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18m-.9-1.863A7.19 7.19 0 0 1 4.8 12c0-.558.072-1.089.189-1.611L9.3 14.7v.9c0 .99.81 1.8 1.8 1.8zm6.21-2.286A1.79 1.79 0 0 0 15.6 15.6h-.9v-2.7c0-.495-.405-.9-.9-.9H8.4v-1.8h1.8c.495 0 .9-.405.9-.9V7.5h1.8c.99 0 1.8-.81 1.8-1.8v-.369c2.637 1.071 4.5 3.654 4.5 6.669 0 1.872-.72 3.573-1.89 4.851"/></svg>`
    }, props, {
        newIcon: $36918aadf9f6e08c$var$_globe.default
    }));
$36918aadf9f6e08c$var$WorldIcon.displayName = 'WorldIcon';
var $36918aadf9f6e08c$var$_default = module.exports.default = $36918aadf9f6e08c$var$WorldIcon;

});


parcelRegister("3pSGI", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b7c2aa888a93a27$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9b7c2aa888a93a27$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    myOrganizationAccess: {
        "id": "directories.common.components.access-cell.my-organization-access",
        "defaultMessage": "My organization"
    },
    publicAccess: {
        "id": "directories.common.components.access-cell.public-access",
        "defaultMessage": "Public"
    },
    privateAccess: {
        "id": "directories.common.components.access-cell.private-access",
        "defaultMessage": "Private"
    },
    allProjectRoles: {
        "id": "directories.common.components.access-cell.all-project-roles",
        "defaultMessage": "All roles"
    }
});

});



parcelRegister("9aswz", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9bbe8678e9a4842$export$2e2bcd8739ae039);

var $basmW = parcelRequire("basmW");

var $8QpSo = parcelRequire("8QpSo");

var $iQv12 = parcelRequire("iQv12");


var $bC2fB = parcelRequire("bC2fB");

var $aDfxw = parcelRequire("aDfxw");

var $dIWFt = parcelRequire("dIWFt");

var $h1Cf7 = parcelRequire("h1Cf7");
const $f9bbe8678e9a4842$var$mapStateToPropsFactory = ()=>{
    const onCopyFactory = (0, $8QpSo.default)((onOperationRequested)=>()=>// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onOperationRequested((0, $088bf273559ead46$export$92f9e1ed9114d3a6)));
    const onEditFactory = (0, $8QpSo.default)((onOperationRequested)=>()=>// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onOperationRequested((0, $088bf273559ead46$export$250171a898bf7ef)));
    const onChangeOwnerFactory = (0, $8QpSo.default)((onOperationRequested)=>()=>// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onOperationRequested((0, $088bf273559ead46$export$39d2a7fb21967424)));
    const onDeleteFactory = (0, $8QpSo.default)((onOperationRequested)=>()=>// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onOperationRequested((0, $088bf273559ead46$export$4bd2facc4a3e6aa1)));
    return (state, ownProps)=>({
            owner: (0, $dIWFt.getOwner)(state, ownProps.id),
            caption: (0, $dIWFt.getName)(state, ownProps.id),
            loggedInUserAccountId: (0, $aDfxw.getLoggedInUserAccountId)(state),
            isWritable: (0, $dIWFt.getIsWritable)(state, ownProps.id),
            systemDashboard: (0, $dIWFt.getSystemDashboard)(state, ownProps.id),
            showSpinner: ownProps.isOperationInProgress,
            onCopy: onCopyFactory(ownProps.onOperationRequested),
            onEdit: onEditFactory(ownProps.onOperationRequested),
            onChangeOwner: onChangeOwnerFactory(ownProps.onOperationRequested),
            onDelete: onDeleteFactory(ownProps.onOperationRequested)
        });
};
var $f9bbe8678e9a4842$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $iQv12.default)({
    onCopyDashboardClick: 'copy',
    onEditDashboardClick: 'edit',
    onDeleteDashboardClick: 'delete',
    onChangeOwnerClick: 'changeOwner'
}), (0, $bC2fB.connect)($f9bbe8678e9a4842$var$mapStateToPropsFactory, {}))((0, $h1Cf7.default));

});
parcelRegister("h1Cf7", function(module, exports) {

$parcel$export(module.exports, "default", () => $a084f82f966f4949$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $42CjB = parcelRequire("42CjB");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $bJeNF = parcelRequire("bJeNF");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");

var $8oe80 = parcelRequire("8oe80");

var $koVbs = parcelRequire("koVbs");

var $4R6GH = parcelRequire("4R6GH");

var $lu5k0 = parcelRequire("lu5k0");

var $7mPT9 = parcelRequire("7mPT9");

var $c0ycT = parcelRequire("c0ycT");
const $a084f82f966f4949$var$DropdownMenuWithAnalytics = (0, $8oe80.default)('dropdownMenu', {
    onOpenChange: 'open'
})((0, $BLPHT.default));
const $a084f82f966f4949$var$DropdownItemWithAnalytics = (0, $8oe80.default)('dropdownItem', {
    onClick: 'clicked'
})((0, $6B7KL.default));
// eslint-disable-next-line jira/react/no-class-components
class $a084f82f966f4949$var$ActionsOld extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isWritable: false,
            systemDashboard: false,
            defaultOpen: false,
            showSpinner: false,
            owner: null,
            caption: '',
            onChangeOwner: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onCopy: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onEdit: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onDelete: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onCopyDashboardClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onEditDashboardClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onChangeOwnerClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onDeleteDashboardClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            setReturnFocusTo: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    /**
   * Close the menu with a minimal delay so the inner handlers are able to react on keypress properly.
   * In its current implementation if we close the menu right away it won't open the focused `href`.
   * Ideally we have to get right of this and few more methods when the bug linked below is fixed.
   * @see https://ecosystem.atlassian.net/browse/AK-4467
   */ delayedClose() {
        setTimeout(()=>this.setState(()=>({
                    isOpen: false
                })));
    }
    render() {
        const { showSpinner: showSpinner, loggedInUserAccountId: loggedInUserAccountId, owner: owner, isWritable: isWritable, systemDashboard: systemDashboard, caption: caption, intl: { formatMessage: formatMessage } } = this.props;
        const isOwnedByCurrentUser = owner && owner.accountId === loggedInUserAccountId;
        const { isOpen: isOpen } = this.state;
        // @ts-expect-error - TS7031 - Binding element 'triggerRef' implicitly has an 'any' type.
        const triggerFunction = ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
                ...props,
                testId: "dashboards-main.content.cells.actions.button",
                appearance: "subtle",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($bJeNF))),
                ref: (0, $7mPT9.mergeRefs)(triggerRef, this.triggerButtonRef),
                label: formatMessage((0, $c0ycT.default).moreActions, {
                    dashboardName: caption
                }),
                isLoading: showSpinner
            });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a084f82f966f4949$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a084f82f966f4949$var$DropdownMenuWithAnalytics, {
            // @ts-expect-error - Type '{ children: Element; position: string; isOpen: boolean; onOpenChange: ({ isOpen }: { isOpen: any; }) => void; trigger: ({ triggerRef, ...props }: { [x: string]: any; triggerRef: any; }) => Element; }' is not assignable to type 'IntrinsicAttributes & Omit<{ appearance?: "default" | "tall" | undefined; autoFocus?: boolean | undefined; children?: ReactNode; isLoading?: boolean | undefined; ... 11 more ...; label?: string | undefined; }, keyof WithAnalyticsEventsProps>'.
            position: "bottom right",
            isOpen: isOpen,
            onOpenChange: this.onOpenChange,
            trigger: triggerFunction,
            shouldRenderToParent: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a084f82f966f4949$var$DropdownItemWithAnalytics, {
            onClick: this.onCopyDashboardClick
        }, formatMessage((0, $c0ycT.default).copyAction)), isWritable === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a084f82f966f4949$var$DropdownItemWithAnalytics, {
            onClick: this.onEditDashboardClick
        }, formatMessage(systemDashboard ? (0, $c0ycT.default).shareAction : (0, $c0ycT.default).renameOrShareAction)), isOwnedByCurrentUser === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a084f82f966f4949$var$DropdownItemWithAnalytics, {
            onClick: this.onChangeOwnerClick
        }, formatMessage((0, $c0ycT.default).changeOwner)), isOwnedByCurrentUser === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a084f82f966f4949$var$DropdownItemWithAnalytics, {
            onClick: this.onDeleteDashboardClick
        }, formatMessage((0, $c0ycT.default).moveToTrashAction)))));
    }
    constructor(...args){
        super(...args), this.state = {
            isOpen: this.props.defaultOpen
        }, this.triggerButtonRef = /*#__PURE__*/ (0, $5uXOq.createRef)(), // @ts-expect-error - TS7031 - Binding element 'isOpen' implicitly has an 'any' type.
        this.onOpenChange = ({ isOpen: isOpen })=>{
            this.setState(()=>({
                    isOpen: isOpen
                }));
        }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onCopyDashboardClick = (e, analytics)=>{
            this.props.onCopyDashboardClick(analytics);
            this.props.onCopy();
            if ((0, $4R6GH.fg)('jfp_a11y_fix_dashboard_actions_modal_accessibility')) this.triggerButtonRef.current && this.props.setReturnFocusTo(this.triggerButtonRef);
        }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onEditDashboardClick = (e, analytics)=>{
            this.props.onEditDashboardClick(analytics);
            this.props.onEdit();
            if ((0, $4R6GH.fg)('jfp_a11y_fix_dashboard_actions_modal_accessibility')) this.triggerButtonRef.current && this.props.setReturnFocusTo(this.triggerButtonRef);
        }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onChangeOwnerClick = (e, analytics)=>{
            this.props.onChangeOwnerClick(analytics);
            this.props.onChangeOwner();
            if ((0, $4R6GH.fg)('jfp_a11y_fix_dashboard_actions_modal_accessibility')) this.triggerButtonRef.current && this.props.setReturnFocusTo(this.triggerButtonRef);
        }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onDeleteDashboardClick = (e, analytics)=>{
            this.props.onDeleteDashboardClick(analytics);
            this.props.onDelete();
            if ((0, $4R6GH.fg)('jfp_a11y_fix_dashboard_actions_modal_accessibility')) this.triggerButtonRef.current && this.props.setReturnFocusTo(this.triggerButtonRef);
        };
    }
}
const $a084f82f966f4949$var$ActionsWithReturnToFocus = (props)=>{
    const { setReturnFocusTo: setReturnFocusTo } = (0, $lu5k0.useModalDialogActions)();
    const intl = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a084f82f966f4949$var$ActionsOld, {
        ...props,
        intl: intl,
        setReturnFocusTo: setReturnFocusTo
    });
};
var $a084f82f966f4949$export$2e2bcd8739ae039 = $a084f82f966f4949$var$ActionsWithReturnToFocus;
const $a084f82f966f4949$var$Container = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        paddingBlockStart: "space.050",
        paddingInlineEnd: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0aEF.default), {
        alignInline: "end"
    }, children));

});
parcelRegister("c0ycT", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5f4ccb035c8a368$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c5f4ccb035c8a368$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    copyAction: {
        "id": "directories.dashboards-v2.main.content.cells.actions.copy-action",
        "defaultMessage": "Copy dashboard"
    },
    moveToTrashAction: {
        "id": "directories.dashboards-v2.main.content.cells.actions.move-to-trash-action",
        "defaultMessage": "Move to trash"
    },
    changeOwner: {
        "id": "directories.dashboards-v2.main.content.cells.actions.change-owner",
        "defaultMessage": "Change owner"
    },
    renameOrShareAction: {
        "id": "directories.dashboards-v2.main.content.cells.actions.rename-or-share-action",
        "defaultMessage": "Rename or share dashboard"
    },
    shareAction: {
        "id": "directories.dashboards-v2.main.content.cells.actions.share-action",
        "defaultMessage": "Share dashboard"
    },
    moreActions: {
        "id": "directories.dashboards-v2.main.content.cells.actions.more-actions",
        "defaultMessage": "More actions for {dashboardName}"
    }
});

});



parcelRegister("7IGKJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff9ae5c4520c0504$export$2e2bcd8739ae039);

var $3pUkE = parcelRequire("3pUkE");

var $bC2fB = parcelRequire("bC2fB");

var $dIWFt = parcelRequire("dIWFt");
const $ff9ae5c4520c0504$var$mapStateToProps = (state, ownProps)=>({
        shares: (0, $dIWFt.getEdits)(state, ownProps.id)
    });
var $ff9ae5c4520c0504$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($ff9ae5c4520c0504$var$mapStateToProps, // We attempted to fix the below FixFlowMe but ran into issue with cross package dependencies which we do not want
// to introduce. We believe the unused fields in Props causes the below issue.
{})((0, $3pUkE.default));

});

parcelRegister("bFDqU", function(module, exports) {

$parcel$export(module.exports, "default", () => $a484890f7b7a2131$export$2e2bcd8739ae039);

var $basmW = parcelRequire("basmW");

var $8QpSo = parcelRequire("8QpSo");

var $jzjy1 = parcelRequire("jzjy1");

var $in0Fz = parcelRequire("in0Fz");

var $bC2fB = parcelRequire("bC2fB");

var $dIWFt = parcelRequire("dIWFt");
const $a484890f7b7a2131$var$mapStateToPropsFactory = ()=>{
    const onClickFactory = (0, $8QpSo.default)((state, id)=>(analyticsEvent)=>{
            const changeFavorite = (0, $dIWFt.getChangeFavorite)(state);
            return changeFavorite({
                id: id,
                type: 'dashboards',
                value: !(0, $dIWFt.isFavorite)(state, id)
            }, analyticsEvent);
        });
    return (state, ownProps)=>({
            isFavorite: (0, $dIWFt.isFavorite)(state, ownProps.id),
            favoriteItemName: (0, $dIWFt.getName)(state, ownProps.id),
            pending: (0, $dIWFt.isPending)(state, ownProps.id),
            onClick: onClickFactory(state, ownProps.id),
            isShownInList: true
        });
};
var $a484890f7b7a2131$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $jzjy1.AnalyticsSubject)('dashboard'), // @ts-expect-error - TS2589 - Type instantiation is excessively deep and possibly infinite.
(0, $bC2fB.connect)($a484890f7b7a2131$var$mapStateToPropsFactory, {}))((0, $in0Fz.FavoriteCellView));

});
parcelRegister("in0Fz", function(module, exports) {

$parcel$export(module.exports, "FavoriteCellView", () => $6abb13e9102dee85$export$7e4dcb8ef4c4afcd);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $hcObS = parcelRequire("hcObS");

var $dCm1o = parcelRequire("dCm1o");
const $6abb13e9102dee85$var$styles = {
    root: "_1e0c1txw _1bah1h6o _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66"
};
function $6abb13e9102dee85$export$7e4dcb8ef4c4afcd(props) {
    return (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $6abb13e9102dee85$var$rootStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hcObS.default), props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $6abb13e9102dee85$var$styles.root
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hcObS.default), props));
}
$6abb13e9102dee85$export$7e4dcb8ef4c4afcd.defaultProps = {
    isFavorite: undefined
};
const $6abb13e9102dee85$var$rootStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    justifyContent: 'center',
    paddingInline: 'space.050',
    paddingBlock: 'space.100',
    alignItems: 'center',
    height: '40px',
    width: '32px'
});

});
parcelRegister("hcObS", function(module, exports) {

$parcel$export(module.exports, "FavoriteButtonWrapper", () => $0a68425ce3fc2fa8$export$bb1478fee6cd5f0c);
$parcel$export(module.exports, "default", () => $0a68425ce3fc2fa8$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $basmW = parcelRequire("basmW");

var $8Rkzz = parcelRequire("8Rkzz");

var $fVnbM = parcelRequire("fVnbM");

var $dm1qi = parcelRequire("dm1qi");

var $dAf5R = parcelRequire("dAf5R");

var $5oTeF = parcelRequire("5oTeF");

var $bH1hf = parcelRequire("bH1hf");

var $fNobW = parcelRequire("fNobW");

var $3bDjY = parcelRequire("3bDjY");

var $iQv12 = parcelRequire("iQv12");

var $7XYc4 = parcelRequire("7XYc4");

var $az4zD = parcelRequire("az4zD");

var $dCm1o = parcelRequire("dCm1o");

var $6fQ6A = parcelRequire("6fQ6A");
const $0a68425ce3fc2fa8$var$SKELETON_TEST_ID = 'favouriting.favorite-button-stateless.skeleton';
const $0a68425ce3fc2fa8$var$ICON_WRAPPER_TEST_ID_PREFIX = 'favouriting.favorite-button-stateless.icon-wrapper'; // eslint-disable-next-line jira/react/no-class-components
class $0a68425ce3fc2fa8$export$f8ad2acf0ec4860f extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isFavorite: undefined,
            favoriteItemName: undefined,
            isShownInList: false,
            isSmall: false,
            hideTooltip: false,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            tooltipPosition: 'bottom',
            skipAnimation: false
        };
    }
    componentDidUpdate(prevProps) {
        if (!this.props.skipAnimation && (!prevProps.pending && this.props.pending || !prevProps.isFavorite && this.props.isFavorite)) {
            this.onAnimationStart();
            this.onSettingAnimationEnd();
        }
    }
    onAnimationStart() {
        this.setState({
            isAnimating: !this.state.isAnimating
        });
    }
    onSettingAnimationEnd() {
        setTimeout(()=>{
            this.setState({
                isAnimating: false
            });
        }, $0a68425ce3fc2fa8$var$animationTime * 2);
    }
    render() {
        const { isFavorite: isFavorite, favoriteItemName: favoriteItemName, isShownInList: isShownInList, isSmall: isSmall, hideTooltip: hideTooltip, tooltipPosition: tooltipPosition, pending: pending, intl: { formatMessage: formatMessage } } = this.props;
        const { isAnimating: isAnimating } = this.state;
        if (isFavorite === undefined) // show skeleton as a space placeholder (to avoid layout recalculations in browser and visible "jump" when we got data)
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fNobW.default), {
            name: "favourite-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0a68425ce3fc2fa8$export$db65185b5889c83, {
            "data-testid": $0a68425ce3fc2fa8$var$SKELETON_TEST_ID,
            isSmall: isSmall
        }));
        const iconWrapperTestId = isShownInList ? `${$0a68425ce3fc2fa8$var$ICON_WRAPPER_TEST_ID_PREFIX}-list` : $0a68425ce3fc2fa8$var$ICON_WRAPPER_TEST_ID_PREFIX;
        const buttonContentOld = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0a68425ce3fc2fa8$var$FavIconWrapper, {
            isFavorite: isFavorite,
            isAnimating: isAnimating,
            "data-testid": iconWrapperTestId,
            isSmall: isSmall
        }, isFavorite ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dm1qi))), {
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($bH1hf))),
            LEGACY_size: isSmall ? 'small' : undefined,
            color: "currentColor",
            label: formatMessage((0, $6fQ6A.default).removeFromStarred)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dAf5R))), {
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($5oTeF))),
            LEGACY_size: isSmall ? 'small' : undefined,
            color: "currentColor",
            label: formatMessage((0, $6fQ6A.default).addToStarred)
        }));
        const renderIcon = ()=>{
            const label = isFavorite ? formatMessage((0, $6fQ6A.default).removeFromStarred) : formatMessage((0, $6fQ6A.default).addToStarred);
            const StarIconComponent = isFavorite ? (0, (/*@__PURE__*/$parcel$interopDefault($dm1qi))) : (0, (/*@__PURE__*/$parcel$interopDefault($dAf5R)));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(StarIconComponent, {
                color: "currentColor",
                label: label,
                size: isSmall ? 'small' : 'medium'
            });
        };
        const buttonContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0a68425ce3fc2fa8$var$FavIconWrapper, {
            isFavorite: isFavorite,
            isAnimating: isAnimating,
            "data-testid": iconWrapperTestId,
            isSmall: isSmall
        }, renderIcon());
        const tooltipContent = isFavorite ? formatMessage((0, $6fQ6A.default).removeFromStarred) : formatMessage((0, $6fQ6A.default).addToStarred);
        const ariaLabel = favoriteItemName ? formatMessage((0, $6fQ6A.default).toggleStarredWithItemName, {
            itemName: favoriteItemName
        }) : formatMessage((0, $6fQ6A.default).toggleStarred);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0a68425ce3fc2fa8$export$bb1478fee6cd5f0c, {
            role: "presentation",
            onClick: this.onBtnClickWrapper,
            onKeyPress: this.onBtnClickWrapper,
            "data-is-favorite": isFavorite
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: !hideTooltip && tooltipContent,
            hideTooltipOnClick: true,
            position: tooltipPosition
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: isShownInList ? 'subtle-link' : 'subtle',
            spacing: "none",
            "aria-label": ariaLabel,
            "aria-pressed": isFavorite,
            onClick: !pending ? this.onClick : (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        }, (0, $dCm1o.isVisualRefreshEnabled)() ? buttonContent : buttonContentOld)));
    }
    constructor(...args){
        super(...args), this.state = {
            isAnimating: false
        }, this.onBtnClickWrapper = (e)=>{
            e.stopPropagation(); // should not let this event get outside of the component, to prevent issue when, for example, star button is clicked in an item or row, which goes somewhere else on onClick handler. Cannot put it in onBtnClick, otherwise hideTooltipOnClick in <Tooltip> will not work
            e.preventDefault(); // same for cases when btn is inside a link - not to go to that link (e.g. in Star Drawer)
        }, this.onClick = (_, analyticsEvent)=>{
            this.props.onClick(analyticsEvent);
        };
    }
}
var $0a68425ce3fc2fa8$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $iQv12.default)({
    onClick: ()=>({
            name: 'star'
        })
}), (0, $az4zD.injectIntlV2))($0a68425ce3fc2fa8$export$f8ad2acf0ec4860f);
const $0a68425ce3fc2fa8$var$animationTime = 500; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $0a68425ce3fc2fa8$export$bb1478fee6cd5f0c = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0a68425ce3fc2fa8$var$FavoriteIconWrapperBaseOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, isAnimating: isAnimating, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.isAnimating && "_11vn1ssb _1px1fmmq _48hmq7pw _1uvf1e03",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0a68425ce3fc2fa8$var$FavoriteIconWrapperBaseNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, isAnimating: isAnimating, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.isAnimating && "_1px1fmmq _48hmq7pw _1uvf1e03",
            __cmplp.className
        ])
    });
});
const $0a68425ce3fc2fa8$var$FavoriteIconWrapperBase = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $0a68425ce3fc2fa8$var$FavoriteIconWrapperBaseNew, $0a68425ce3fc2fa8$var$FavoriteIconWrapperBaseOld); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0a68425ce3fc2fa8$var$FavIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $0a68425ce3fc2fa8$var$FavoriteIconWrapperBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.isFavorite ? "_syaz1oqg" : "_syaz1oju",
            __cmplp.isFavorite ? "_30l31vop" : "_30l3wdcn",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $0a68425ce3fc2fa8$export$db65185b5889c83 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5oTeF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3eea0a48351333dc$var$_react = $3eea0a48351333dc$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $3eea0a48351333dc$var$_starUnstarred = $3eea0a48351333dc$var$_interopRequireDefault((parcelRequire("dAf5R")));
function $3eea0a48351333dc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3eea0a48351333dc$var$StarIcon = (props)=>/*#__PURE__*/ $3eea0a48351333dc$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="m12 16.373 3.98 2.193-.76-4.655 3.276-3.347-4.524-.69L12 5.687l-1.972 4.189-4.524.689L8.78 13.91l-.762 4.655zm0 2.283-3.016 1.662a2 2 0 0 1-2.939-2.075l.599-3.656-2.57-2.624a2 2 0 0 1 1.129-3.377l3.47-.528 1.518-3.224a2 2 0 0 1 3.618 0l1.519 3.224 3.47.528a2 2 0 0 1 1.127 3.377l-2.569 2.624.599 3.656a2 2 0 0 1-2.94 2.075z"/></svg>`
    }, props, {
        newIcon: $3eea0a48351333dc$var$_starUnstarred.default
    }));
$3eea0a48351333dc$var$StarIcon.displayName = 'StarIcon';
var $3eea0a48351333dc$var$_default = module.exports.default = $3eea0a48351333dc$var$StarIcon;

});

parcelRegister("6fQ6A", function(module, exports) {

$parcel$export(module.exports, "default", () => $10bc2ec5d9a72db1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $10bc2ec5d9a72db1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    addToStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.add-to-starred",
        "defaultMessage": "Add to Starred"
    },
    removeFromStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.remove-from-starred",
        "defaultMessage": "Remove from Starred"
    },
    toggleStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.toggle-starred",
        "defaultMessage": "Star"
    },
    toggleStarredWithItemName: {
        "id": "platform.ui.favouriting.favourite-button-stateless.toggle-starred-with-item-name",
        "defaultMessage": "Star {itemName}"
    }
});

});




parcelRegister("kLMvA", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbf1fcba91c3bd83$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7dpkb = parcelRequire("7dpkb");

var $bC2fB = parcelRequire("bC2fB");

var $dIWFt = parcelRequire("dIWFt");
const $bbf1fcba91c3bd83$var$mapStateToProps = (state, ownProps)=>({
        user: (0, $dIWFt.getOwner)(state, ownProps.id)
    });
const $bbf1fcba91c3bd83$var$UserCell = (props)=>{
    const { user: user } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7dpkb.default), {
        user: user
    });
};
$bbf1fcba91c3bd83$var$UserCell.defaultProps = {
    onClick: null
};
var // @ts-expect-error - TS2345 - Argument of type '{ (props: UserCellProps): JSX.Element; defaultProps: { onClick: null; }; }' is not assignable to parameter of type 'Component<EntityCellProps & Props>'.
$bbf1fcba91c3bd83$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($bbf1fcba91c3bd83$var$mapStateToProps, {})($bbf1fcba91c3bd83$var$UserCell);

});
parcelRegister("7dpkb", function(module, exports) {

$parcel$export(module.exports, "default", () => $b027fe8ebdaa54a8$export$2e2bcd8739ae039);

var $iQv12 = parcelRequire("iQv12");

var $dqcdn = parcelRequire("dqcdn");
var $b027fe8ebdaa54a8$export$2e2bcd8739ae039 = (0, $iQv12.default)({
    onClick: 'userProfile'
})((0, $dqcdn.default));

});
parcelRegister("dqcdn", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc1d1c3ed200d230$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $2QW4M = parcelRequire("2QW4M");

var $9nJ7V = parcelRequire("9nJ7V");
function $dc1d1c3ed200d230$export$2e2bcd8739ae039(props) {
    const { user: user, isDeleting: isDeleting } = props;
    if (!user) return null;
    const { accountId: accountId, displayName: displayName, avatarUrl: avatarUrl } = user;
    const content = /*#__PURE__*/ $5uXOq.createElement((0, $9nJ7V.default), {
        displayName: displayName,
        avatarUrl: avatarUrl,
        isDeleting: isDeleting
    });
    return /*#__PURE__*/ $5uXOq.createElement((0, $2QW4M.AsyncProfileCardNext), {
        accountId: accountId,
        prepopulatedData: {
            fullName: displayName
        }
    }, content);
}

});
parcelRegister("2QW4M", function(module, exports) {

$parcel$export(module.exports, "AsyncProfileCardNext", () => $155c7596e61d6af0$export$a3c0845f856d4292);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $gcl1l = parcelRequire("gcl1l");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $155c7596e61d6af0$var$LazyComponent = (0, $kxZPA.lazy)(()=>(parcelRequire("3pLtv")).then((module)=>module.ProfileCard), {
    moduleId: "./src/packages/profilecard-next/src/ui/profilecard/index.tsx"
});
const $155c7596e61d6af0$export$a3c0845f856d4292 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "AsyncProfileCardNext",
        packageName: "jiraProfilecardNext",
        render: ()=>// props.children in this context is the code being wrapped
            // in a <ProfileCardTrigger> (I.e. it is the thing a user hovers over to
            // display a profile card).
            // In the event of an unexpected error within @atlaskit/profilecard,
            // just render the unwrapped children (I.e. they will render but nothing
            // happens on hover)
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.children),
        sendToPrivacyUnsafeSplunk: true,
        teamName: "empanada",
        attributes: (0, $gcl1l.isLoaderErrorAttributes)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-profile-card-next-view",
        fallback: props.children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($155c7596e61d6af0$var$LazyComponent, props)));
var /**
 * @deprecated Use synchronous ProfileCard from index.tsx instead. Async loading
 * is already handled inside the ProfileCard component.
 */ $155c7596e61d6af0$export$2e2bcd8739ae039 = $155c7596e61d6af0$export$a3c0845f856d4292;

});
parcelRegister("gcl1l", function(module, exports) {

$parcel$export(module.exports, "isLoaderErrorAttributes", () => $ecfe970d67067a10$export$c7209ce2e0d060ea);

var $bCf8q = parcelRequire("bCf8q");
const $ecfe970d67067a10$export$c7209ce2e0d060ea = (error)=>({
        isLoaderError: (0, $bCf8q.isLoaderError)(error)
    });

});

parcelRegister("3pLtv", function(module, exports) {

let $27c888729b25497d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $27c888729b25497d$var$load("czifk").then(()=>parcelRequire('kKeZ6'));

});


parcelRegister("9nJ7V", function(module, exports) {

$parcel$export(module.exports, "default", () => $37198d620d9c114f$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ujWmd = parcelRequire("ujWmd");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $41j30 = parcelRequire("41j30");

var $4R6GH = parcelRequire("4R6GH");

var $dCm1o = parcelRequire("dCm1o");

var $7caFU = parcelRequire("7caFU");
const $37198d620d9c114f$var$styles = {
    avatarContainer: "_16jlidpf _1o9zidpf _i0dl1wug _u5f3u2gc _vwz4idpf",
    avatarContainerNew: "_4cvr1h6o",
    container: "_16jlkb7n _1o9zkb7n _i0dl1wug _ca0q12x7 _n3td12x7 _1e0c1txw",
    contentContainer: "_16jlkb7n _1o9zkb7n _i0dl1wug _1reo15vq _18m915vq _1e0c1txw _4cvr1h6o _1bsb1osq",
    contentContainerOld: "_16jlkb7n _1o9zkb7n _i0dl1wug _1e0c1txw _4cvr1h6o _1bsb1osq",
    accessibleContentContainer: "_16jlkb7n _1o9zkb7n _i0dl1wug _ca0qu2gc _n3tdu2gc _1e0c1txw _4cvr1h6o _1bsb1osq",
    link: "_1bsb1osq",
    textContainer: "_1reo15vq _18m915vq _slp31hna _o5721q9c _1bto1l2s"
};
function $37198d620d9c114f$export$2e2bcd8739ae039(props) {
    const { avatarUrl: avatarUrl, displayName: displayName, href: href, appearance: appearance, isDeleting: isDeleting, onClick: onClick } = props;
    // To vertically align the avatar with the text and also change the height of the cell from 44px to 40px -  BLU-7380
    const applyVisualRefreshStyles = (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('blu-7380-update-directory-table-cell-height');
    const content = !href && (0, $4R6GH.fg)('blu-6080-directory-table-tooltips') ? /*#__PURE__*/ $5uXOq.createElement((0, $kgoHi.default), {
        alignItems: applyVisualRefreshStyles ? 'center' : 'start',
        xcss: applyVisualRefreshStyles ? $37198d620d9c114f$var$contentWrapperStyles : $37198d620d9c114f$var$contentWrapperStylesOld
    }, /*#__PURE__*/ $5uXOq.createElement("div", {
        className: (0, $bwpsq.default)([
            $37198d620d9c114f$var$styles.avatarContainer,
            applyVisualRefreshStyles && $37198d620d9c114f$var$styles.avatarContainerNew
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, $ujWmd.default), {
        src: avatarUrl,
        size: "small",
        appearance: appearance
    })), /*#__PURE__*/ $5uXOq.createElement((0, $f5TWP.default), {
        xcss: !applyVisualRefreshStyles ? $37198d620d9c114f$var$inlineTextStyles : undefined
    }, isDeleting && (0, $4R6GH.fg)('hix-6302_project_delete_improvements') ? /*#__PURE__*/ $5uXOq.createElement((0, $7caFU.default), null, displayName) : displayName)) : /*#__PURE__*/ $5uXOq.createElement($37198d620d9c114f$var$Content, null, /*#__PURE__*/ $5uXOq.createElement("div", {
        className: (0, $bwpsq.default)([
            $37198d620d9c114f$var$styles.avatarContainer,
            applyVisualRefreshStyles && $37198d620d9c114f$var$styles.avatarContainerNew
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, $ujWmd.default), {
        src: avatarUrl,
        size: "small",
        appearance: appearance
    })), /*#__PURE__*/ $5uXOq.createElement("div", {
        className: (0, $bwpsq.default)([
            $37198d620d9c114f$var$styles.textContainer
        ])
    }, isDeleting && (0, $4R6GH.fg)('hix-6302_project_delete_improvements') ? /*#__PURE__*/ $5uXOq.createElement((0, $7caFU.default), null, displayName, " ") : displayName));
    if (href) return /*#__PURE__*/ $5uXOq.createElement("div", {
        className: (0, $bwpsq.default)([
            $37198d620d9c114f$var$styles.container
        ])
    }, isDeleting && (0, $4R6GH.fg)('hix-6302_project_delete_improvements') ? content : /*#__PURE__*/ $5uXOq.createElement("div", {
        className: (0, $bwpsq.default)([
            $37198d620d9c114f$var$styles.link
        ])
    }, (0, $4R6GH.fg)('blu-6080-directory-table-tooltips') ? /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), {
        xcss: applyVisualRefreshStyles ? $37198d620d9c114f$var$contentWrapperStyles : $37198d620d9c114f$var$contentWrapperStylesOld
    }, /*#__PURE__*/ $5uXOq.createElement((0, $3bDjY.default), {
        content: displayName,
        isScreenReaderAnnouncementDisabled: true,
        delay: 1000,
        position: "bottom-start"
    }, /*#__PURE__*/ $5uXOq.createElement((0, $41j30.default), {
        href: href,
        onClick: onClick
    }, content))) : /*#__PURE__*/ $5uXOq.createElement((0, $41j30.default), {
        href: href,
        onClick: onClick
    }, content)));
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        className: (0, $bwpsq.default)([
            (0, $dCm1o.isVisualRefreshEnabled)() ? $37198d620d9c114f$var$styles.contentContainer : $37198d620d9c114f$var$styles.contentContainerOld
        ])
    }, content);
}
$37198d620d9c114f$export$2e2bcd8739ae039.defaultProps = {
    avatarUrl: undefined,
    href: undefined,
    appearance: 'circle',
    onClick: undefined
};
const $37198d620d9c114f$var$Content = (props)=>{
    return (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), {
        xcss: $37198d620d9c114f$var$accessibleContentContainerStyles
    }, props.children) : /*#__PURE__*/ $5uXOq.createElement("div", {
        className: (0, $bwpsq.default)([
            $37198d620d9c114f$var$styles.accessibleContentContainer
        ])
    }, props.children);
};
const $37198d620d9c114f$var$contentWrapperStyles = (0, $8CUq3.xcss)({
    maxWidth: '100%',
    paddingBlock: 'space.075'
});
const $37198d620d9c114f$var$contentWrapperStylesOld = (0, $8CUq3.xcss)({
    maxWidth: '100%',
    paddingBlock: 'space.100'
});
const $37198d620d9c114f$var$inlineTextStyles = (0, $8CUq3.xcss)({
    paddingBlockStart: 'space.025'
});
const $37198d620d9c114f$var$accessibleContentContainerStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.100',
    paddingBottom: 'space.100',
    display: 'flex',
    alignItems: 'center',
    flex: '1 1 auto',
    width: '100%',
    height: '40px'
});

});
parcelRegister("7caFU", function(module, exports) {

$parcel$export(module.exports, "default", () => $45a3f9892d56c955$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
function $45a3f9892d56c955$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $45a3f9892d56c955$var$disabledBoxStyles
    }, children);
}
const $45a3f9892d56c955$var$disabledBoxStyles = (0, $8CUq3.xcss)({
    display: 'contents',
    color: 'color.text.disabled',
    ':hover': {
        cursor: 'default'
    }
});

});





parcelRegister("cHbtV", function(module, exports) {

$parcel$export(module.exports, "default", () => $06a480617223b303$export$2e2bcd8739ae039);

var $basmW = parcelRequire("basmW");

var $8QpSo = parcelRequire("8QpSo");

var $iQv12 = parcelRequire("iQv12");


var $bC2fB = parcelRequire("bC2fB");

var $aDfxw = parcelRequire("aDfxw");

var $dIWFt = parcelRequire("dIWFt");

var $gq5ed = parcelRequire("gq5ed");
const $06a480617223b303$var$mapStateToPropsFactory = ()=>{
    const onCopyFactory = (0, $8QpSo.default)((onOperationRequested)=>()=>// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onOperationRequested((0, $088bf273559ead46$export$92f9e1ed9114d3a6)));
    const onEditFactory = (0, $8QpSo.default)((onOperationRequested)=>()=>// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onOperationRequested((0, $088bf273559ead46$export$250171a898bf7ef)));
    const onChangeOwnerFactory = (0, $8QpSo.default)((onOperationRequested)=>()=>// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onOperationRequested((0, $088bf273559ead46$export$39d2a7fb21967424)));
    const onDeleteFactory = (0, $8QpSo.default)((onOperationRequested)=>()=>// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onOperationRequested((0, $088bf273559ead46$export$4bd2facc4a3e6aa1)));
    return (state, ownProps)=>({
            owner: (0, $dIWFt.getOwner)(state, ownProps.id),
            caption: (0, $dIWFt.getName)(state, ownProps.id),
            loggedInUserAccountId: (0, $aDfxw.getLoggedInUserAccountId)(state),
            isWritable: (0, $dIWFt.getIsWritable)(state, ownProps.id),
            systemDashboard: (0, $dIWFt.getSystemDashboard)(state, ownProps.id),
            showSpinner: ownProps.isOperationInProgress,
            onCopy: onCopyFactory(ownProps.onOperationRequested),
            onEdit: onEditFactory(ownProps.onOperationRequested),
            onChangeOwner: onChangeOwnerFactory(ownProps.onOperationRequested),
            onDelete: onDeleteFactory(ownProps.onOperationRequested),
            popularity: (0, $dIWFt.getPopularity)(state, ownProps.id)
        });
};
var $06a480617223b303$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $iQv12.default)({
    onCopyDashboardClick: 'copy',
    onEditDashboardClick: 'edit',
    onDeleteDashboardClick: 'delete',
    onChangeOwnerClick: 'changeOwner'
}), (0, $bC2fB.connect)($06a480617223b303$var$mapStateToPropsFactory, {}))((0, $gq5ed.default));

});
parcelRegister("gq5ed", function(module, exports) {

$parcel$export(module.exports, "default", () => $81f6867bfd6b3a6a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $bUmQV = parcelRequire("bUmQV");

var $7kr1v = parcelRequire("7kr1v");

var $feCbq = parcelRequire("feCbq");
function $81f6867bfd6b3a6a$export$2e2bcd8739ae039(props) {
    const { popularity: popularity } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUmQV.default), {
        alignItems: "center",
        justifyContent: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7kr1v.default), {
        popularity: popularity
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $feCbq.default), props));
}

});
parcelRegister("7kr1v", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a039ace0dba95c8$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $4R6GH = parcelRequire("4R6GH");

var $dCm1o = parcelRequire("dCm1o");

var $fDVhV = parcelRequire("fDVhV");
function $9a039ace0dba95c8$var$Popularity(props) {
    const { popularity: popularity } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if ((0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('blu-7380-update-directory-table-cell-height')) {
        if ((0, $4R6GH.fg)('blu-6801-dashboards-a11y-fix')) return /*#__PURE__*/ $5uXOq.createElement("div", {
            className: (0, $bwpsq.default)([
                "_1e0c1txw _2lx2vrvc _4cvr1h6o _1tke1jfw _1ul91ejb"
            ])
        }, /*#__PURE__*/ $5uXOq.createElement("div", {
            className: (0, $bwpsq.default)([
                "_1reo15vq _18m915vq _slp31hna"
            ])
        }, formatMessage((0, $fDVhV.default).popularity, {
            popularity: popularity
        })));
        return /*#__PURE__*/ $5uXOq.createElement("div", {
            className: (0, $bwpsq.default)([
                "_16jlkb7n _1o9zkb7n _i0dl1wug _1reo15vq _18m915vq _1e0c1txw _2lx2vrvc _1bsb1osq _o5721q9c _1bto1l2s _4t3i1jfw _4cvr1h6o"
            ])
        }, formatMessage((0, $fDVhV.default).popularity, {
            popularity: popularity
        }));
    }
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1reo15vq _18m915vq _1e0c1txw _2lx2vrvc _1bsb1osq _o5721q9c _1bto1l2s _ca0qutpp _n3tdutpp"
        ])
    }, formatMessage((0, $fDVhV.default).popularity, {
        popularity: popularity
    }));
}
var $9a039ace0dba95c8$export$2e2bcd8739ae039 = $9a039ace0dba95c8$var$Popularity;
const $9a039ace0dba95c8$var$containerStyles = null;
const $9a039ace0dba95c8$var$textContainerStyles = null;
const $9a039ace0dba95c8$var$containerStylesOld = null;
const $9a039ace0dba95c8$var$containerStylesOldOld = null;

});
parcelRegister("fDVhV", function(module, exports) {

$parcel$export(module.exports, "default", () => $9525a99709b5bb06$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9525a99709b5bb06$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    popularity: {
        "id": "directories.common.components.popularity-cell.popularity",
        "defaultMessage": "{popularity, plural, one {{popularity} person} other {{popularity} people}}"
    }
});

});


parcelRegister("feCbq", function(module, exports) {

$parcel$export(module.exports, "default", () => $5af505f5a1ddfdbf$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $42CjB = parcelRequire("42CjB");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $bJeNF = parcelRequire("bJeNF");

var $bUmQV = parcelRequire("bUmQV");

var $8oe80 = parcelRequire("8oe80");

var $koVbs = parcelRequire("koVbs");

var $7mPT9 = parcelRequire("7mPT9");

var $lu5k0 = parcelRequire("lu5k0");

var $4R6GH = parcelRequire("4R6GH");

var $c0ycT = parcelRequire("c0ycT");
const $5af505f5a1ddfdbf$var$DropdownMenuWithAnalytics = (0, $8oe80.default)('dropdownMenu', {
    onOpenChange: 'open'
})((0, $BLPHT.default));
const $5af505f5a1ddfdbf$var$DropdownItemWithAnalytics = (0, $8oe80.default)('dropdownItem', {
    onClick: 'clicked'
})((0, $6B7KL.default));
function $5af505f5a1ddfdbf$export$2e2bcd8739ae039(props) {
    const { isWritable: isWritable = false, systemDashboard: systemDashboard = false, defaultOpen: defaultOpen = false, showSpinner: showSpinner = false, loggedInUserAccountId: loggedInUserAccountId = '', owner: owner = null, caption: caption = '', onChangeOwner: onChangeOwner = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onCopy: onCopy = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onEdit: onEdit = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onDelete: onDelete = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onCopyDashboardClick: onCopyDashboardClick = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onEditDashboardClick: onEditDashboardClick = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onChangeOwnerClick: onChangeOwnerClick = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onDeleteDashboardClick: onDeleteDashboardClick = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { setReturnFocusTo: setReturnFocusTo } = (0, $lu5k0.useModalDialogActions)();
    const [isDropdownOpen, setIsDropdownOpen] = (0, $5uXOq.useState)(defaultOpen);
    const triggerButtonRef = (0, $5uXOq.useRef)(null);
    const onOpenChange = (0, $5uXOq.useCallback)(({ isOpen: isOpen })=>{
        setIsDropdownOpen(isOpen);
    }, []); // /**
    //  * Close the menu with a minimal delay so the inner handlers are able to react on keypress properly.
    //  * In its current implementation if we close the menu right away it won't open the focused `href`.
    //  * Ideally we have to get right of this and few more methods when the bug linked below is fixed.
    //  * @see https://ecosystem.atlassian.net/browse/AK-4467
    //  */
    // const delayedClose = useCallback(() => {
    // 	setTimeout(() => setIsDropdownOpen(false));
    // }, []);
    const handleCopy = (0, $5uXOq.useCallback)((e, analytics)=>{
        onCopyDashboardClick(analytics);
        onCopy();
        if ((0, $4R6GH.fg)('jfp_a11y_fix_dashboard_actions_modal_accessibility')) triggerButtonRef.current && setReturnFocusTo(triggerButtonRef);
    }, [
        setReturnFocusTo,
        onCopy,
        onCopyDashboardClick
    ]);
    const handleEdit = (0, $5uXOq.useCallback)((e, analytics)=>{
        onEditDashboardClick(analytics);
        onEdit();
        if ((0, $4R6GH.fg)('jfp_a11y_fix_dashboard_actions_modal_accessibility')) triggerButtonRef.current && setReturnFocusTo(triggerButtonRef);
    }, [
        setReturnFocusTo,
        onEdit,
        onEditDashboardClick
    ]);
    const handleChangeOwner = (0, $5uXOq.useCallback)((e, analytics)=>{
        onChangeOwnerClick(analytics);
        onChangeOwner();
        if ((0, $4R6GH.fg)('jfp_a11y_fix_dashboard_actions_modal_accessibility')) triggerButtonRef.current && setReturnFocusTo(triggerButtonRef);
    }, [
        setReturnFocusTo,
        onChangeOwner,
        onChangeOwnerClick
    ]);
    const handleDelete = (0, $5uXOq.useCallback)((e, analytics)=>{
        onDeleteDashboardClick(analytics);
        onDelete();
        if ((0, $4R6GH.fg)('jfp_a11y_fix_dashboard_actions_modal_accessibility')) triggerButtonRef.current && setReturnFocusTo(triggerButtonRef);
    }, [
        setReturnFocusTo,
        onDelete,
        onDeleteDashboardClick
    ]); // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const triggerFunction = ({ triggerRef: triggerRef, ...buttonProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
            ...buttonProps,
            testId: "dashboards-main.content.cells.actions.button",
            appearance: "subtle",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($bJeNF))),
            spacing: "compact",
            ref: (0, $7mPT9.mergeRefs)(triggerRef, triggerButtonRef),
            label: formatMessage((0, $c0ycT.default).moreActions, {
                dashboardName: caption
            }),
            isLoading: showSpinner
        });
    const renderEditAction = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5af505f5a1ddfdbf$var$DropdownItemWithAnalytics, {
            onClick: handleEdit
        }, formatMessage(systemDashboard ? (0, $c0ycT.default).shareAction : (0, $c0ycT.default).renameOrShareAction));
    const renderCopyAction = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5af505f5a1ddfdbf$var$DropdownItemWithAnalytics, {
            onClick: handleCopy
        }, formatMessage((0, $c0ycT.default).copyAction));
    const renderChangeOwnerAction = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5af505f5a1ddfdbf$var$DropdownItemWithAnalytics, {
            onClick: handleChangeOwner
        }, formatMessage((0, $c0ycT.default).changeOwner));
    const renderDeleteAction = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5af505f5a1ddfdbf$var$DropdownItemWithAnalytics, {
            onClick: handleDelete
        }, formatMessage((0, $c0ycT.default).moveToTrashAction));
    const isOwnedByCurrentUser = owner && owner.accountId === loggedInUserAccountId;
    const copyItem = renderCopyAction();
    let editItem = null;
    let changeOwnerItem = null;
    let deleteItem = null;
    if (isWritable) editItem = renderEditAction();
    if (isOwnedByCurrentUser) {
        changeOwnerItem = renderChangeOwnerAction();
        deleteItem = renderDeleteAction();
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5af505f5a1ddfdbf$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5af505f5a1ddfdbf$var$DropdownMenuWithAnalytics, {
        placement: "bottom-end",
        isOpen: isDropdownOpen,
        onOpenChange: onOpenChange,
        trigger: triggerFunction,
        shouldRenderToParent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), null, copyItem, editItem, changeOwnerItem, deleteItem)));
}
const $5af505f5a1ddfdbf$var$Container = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUmQV.default), {
        xcss: $5af505f5a1ddfdbf$var$styles.container
    }, children);
const $5af505f5a1ddfdbf$var$styles = {
    container: "_1rjcu2gc _19bvu2gc _u5f3utpp"
};

});



parcelRegister("b8vgn", function(module, exports) {

$parcel$export(module.exports, "default", () => $796411b7b15ab7c0$export$2e2bcd8739ae039);

var $7kr1v = parcelRequire("7kr1v");

var $bC2fB = parcelRequire("bC2fB");

var $dIWFt = parcelRequire("dIWFt");
const $796411b7b15ab7c0$var$mapStateToProps = ()=>(state, ownProps)=>({
            popularity: (0, $dIWFt.getPopularity)(state, ownProps.id)
        });
var $796411b7b15ab7c0$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($796411b7b15ab7c0$var$mapStateToProps, {})((0, $7kr1v.default));

});

parcelRegister("f95M9", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b07685b533e6ebd$export$2e2bcd8739ae039);

var $basmW = parcelRequire("basmW");

var $iQv12 = parcelRequire("iQv12");

var $bC2fB = parcelRequire("bC2fB");

var $dIWFt = parcelRequire("dIWFt");

var $dvCWZ = parcelRequire("dvCWZ");
const $5b07685b533e6ebd$var$mapStateToProps = ()=>(state, ownProps)=>({
            caption: (0, $dIWFt.getName)(state, ownProps.id),
            href: (0, $dIWFt.getViewUrl)(state, ownProps.id)
        });
var $5b07685b533e6ebd$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $iQv12.default)({
    onClick: 'dashboard'
}), (0, $bC2fB.connect)($5b07685b533e6ebd$var$mapStateToProps, {}))((0, $dvCWZ.default));

});
parcelRegister("dvCWZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c75852185b0dc3d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ff0tU = parcelRequire("ff0tU");

var $asoHC = parcelRequire("asoHC");
function $4c75852185b0dc3d$export$2e2bcd8739ae039({ onClick: onClick, href: href, caption: caption }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $asoHC.TransitionComponent), {
        href: href,
        onClick: onClick
    }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ff0tU.default), {
            ...props,
            caption: caption
        }));
}

});
parcelRegister("ff0tU", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9c2d361e5e2d6e3$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $41j30 = parcelRequire("41j30");

var $4R6GH = parcelRequire("4R6GH");

var $dCm1o = parcelRequire("dCm1o");

var $cSD7y = parcelRequire("cSD7y");
const $c9c2d361e5e2d6e3$var$LinkCell = (0, $cSD7y.componentWithFG)('blu-6801-dashboards-a11y-fix', $c9c2d361e5e2d6e3$var$LinkCellWithA11yFix, $c9c2d361e5e2d6e3$var$LinkCellOld);
var $c9c2d361e5e2d6e3$export$2e2bcd8739ae039 = $c9c2d361e5e2d6e3$var$LinkCell;
function $c9c2d361e5e2d6e3$var$LinkCellWithA11yFix({ caption: caption, href: href, onClick: onClick, ...props }) {
    const content = (0, $5uXOq.useMemo)(()=>{
        const innerContent = href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $41j30.default), {
            href: href,
            onClick: onClick
        }, caption) : caption;
        if ((0, $dCm1o.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $c9c2d361e5e2d6e3$var$containerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $c9c2d361e5e2d6e3$var$wrapperStyles
        }, (0, $4R6GH.fg)('blu-6080-directory-table-tooltips') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: caption,
            isScreenReaderAnnouncementDisabled: true,
            delay: 1000,
            position: "bottom-start"
        }, innerContent) : innerContent));
        return (0, $4R6GH.fg)('blu-6080-directory-table-tooltips') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c9c2d361e5e2d6e3$var$Container, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: caption,
            isScreenReaderAnnouncementDisabled: true,
            delay: 1000,
            position: "bottom-start"
        }, innerContent)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c9c2d361e5e2d6e3$var$Container, props, innerContent);
    }, [
        caption,
        href,
        onClick,
        props
    ]);
    return content;
}
function $c9c2d361e5e2d6e3$var$LinkCellOld({ caption: caption, href: href, onClick: onClick, ...props }) {
    const content = (0, $5uXOq.useMemo)(()=>{
        const innerContent = href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $41j30.default), {
            href: href,
            onClick: onClick
        }, caption) : caption;
        if ((0, $dCm1o.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $c9c2d361e5e2d6e3$var$containerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $c9c2d361e5e2d6e3$var$wrapperStyles
        }, innerContent));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c9c2d361e5e2d6e3$var$Container, props, innerContent);
    }, [
        caption,
        href,
        onClick,
        props
    ]);
    return (0, $4R6GH.fg)('blu-6080-directory-table-tooltips') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: caption,
        isScreenReaderAnnouncementDisabled: true,
        delay: 1000,
        position: "bottom-start"
    }, content) : content;
}
const $c9c2d361e5e2d6e3$var$containerStyles = (0, $8CUq3.xcss)({
    width: '100%',
    paddingBlock: 'space.100',
    flex: '1 1 auto',
    flexDirection: 'row',
    display: 'flex',
    height: '40px'
});
const $c9c2d361e5e2d6e3$var$wrapperStyles = (0, $8CUq3.xcss)({
    paddingBlock: 'space.025',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $c9c2d361e5e2d6e3$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1reo15vq _18m915vq _1e0c1txw _2lx2vrvc _1bsb1osq _o5721q9c _1bto1l2s _ca0qutpp _n3tdutpp",
            __cmplp.className
        ])
    });
});

});

parcelRegister("asoHC", function(module, exports) {

$parcel$export(module.exports, "TransitionComponent", () => $f14567bdbac8ba9f$export$3c61ec5cd62a42f9);

var $5uXOq = parcelRequire("5uXOq");

var $5y0F0 = parcelRequire("5y0F0");
const $f14567bdbac8ba9f$export$3c61ec5cd62a42f9 = ({ children: children, onClick: onClick, href: href })=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5y0F0.RouterActions), null, ({ push: push })=>{
        const clickHandler = (e, analyticsEvent)=>{
            if (e.metaKey || e.ctrlKey || e.altKey || e.shiftKey || e.button === 1) return;
            e.preventDefault();
            onClick && onClick(e, analyticsEvent);
            push(href);
        };
        return children({
            href: href,
            onClick: clickHandler
        });
    }) : children({
        href: href,
        onClick: onClick
    });

});



parcelRegister("i2pg9", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1fc6b7c4e7414c0$export$2e2bcd8739ae039);

var $8QpSo = parcelRequire("8QpSo");

var $jQiPc = parcelRequire("jQiPc");

var $bC2fB = parcelRequire("bC2fB");
const $e1fc6b7c4e7414c0$var$mapStateToPropsFactory = ()=>{
    const onCancelFactory = (0, $8QpSo.default)((onCancel)=>onCancel);
    const onSuccessFactory = (0, $8QpSo.default)((onSuccess)=>onSuccess);
    const onInitiateSuccessFactory = (0, $8QpSo.default)((onDialogShown)=>onDialogShown);
    const onInitiateFailedFactory = (0, $8QpSo.default)((onDataRetrieveFailed)=>onDataRetrieveFailed);
    return (state, ownProps)=>({
            id: ownProps.entityId,
            onCancel: onCancelFactory(ownProps.onCancel),
            onSuccess: onSuccessFactory(ownProps.onUpdated),
            onInitiateSuccess: onInitiateSuccessFactory(ownProps.onDialogShown),
            onInitiateFailed: onInitiateFailedFactory(ownProps.onDataRetrieveFailed)
        });
};
var $e1fc6b7c4e7414c0$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($e1fc6b7c4e7414c0$var$mapStateToPropsFactory, {})((0, $jQiPc.default));

});
parcelRegister("jQiPc", function(module, exports) {

$parcel$export(module.exports, "default", () => $56bfd8270b812168$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $j55bS = parcelRequire("j55bS");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $56bfd8270b812168$var$NoLazyAsyncChangeOwnerDashboardModal = (0, $kxZPA.lazy)(()=>(parcelRequire("3DnlS")), {
    moduleId: "./src/packages/global-pages/directories/dashboards-directory-v2/change-owner-dashboard-modal/src/index.tsx"
});
const $56bfd8270b812168$var$AsyncChangeOwnerDashboardModal = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "configure-owner-modal",
        packageName: "dashboard",
        fallback: "flag",
        teamName: "endeavour"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "change-owner-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j55bS.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($56bfd8270b812168$var$NoLazyAsyncChangeOwnerDashboardModal, props)));
var $56bfd8270b812168$export$2e2bcd8739ae039 = $56bfd8270b812168$var$AsyncChangeOwnerDashboardModal;

});
parcelRegister("3DnlS", function(module, exports) {

let $2a5720c9d5e6dfe3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2a5720c9d5e6dfe3$var$load("eCFVa").then(()=>parcelRequire('bYmuE'));

});



parcelRegister("2jr3k", function(module, exports) {

$parcel$export(module.exports, "default", () => $d423adbfe8d5d6ff$export$2e2bcd8739ae039);

var $dGvGJ = parcelRequire("dGvGJ");

var $jtpul = parcelRequire("jtpul");

var $bC2fB = parcelRequire("bC2fB");

var $1bQGJ = parcelRequire("1bQGJ");

var $aDfxw = parcelRequire("aDfxw");
const $d423adbfe8d5d6ff$var$selectBaseUrl = (state)=>(0, $aDfxw.getBaseUrl)(state);
const $d423adbfe8d5d6ff$var$selectOwnProps = (_, ownProps)=>ownProps;
const $d423adbfe8d5d6ff$var$navigateToDashboard = (baseUrl, id, push)=>{
    push(`/jira/dashboards/${id}`);
};
const $d423adbfe8d5d6ff$var$makeMapStateToProps = ()=>(0, $dGvGJ.createSelector)([
        $d423adbfe8d5d6ff$var$selectBaseUrl,
        $d423adbfe8d5d6ff$var$selectOwnProps
    ], (baseUrl, ownProps)=>({
            id: ownProps.entityId,
            onCancel: ownProps.onCancel,
            onSuccess: (_, { id: id })=>{
                $d423adbfe8d5d6ff$var$navigateToDashboard(baseUrl, id, ownProps.push);
                // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
                ownProps.onUpdated();
            },
            onInitiateSuccess: ownProps.onDialogShown,
            onInitiateFailed: ownProps.onDataRetrieveFailed
        }));
const $d423adbfe8d5d6ff$var$ConnectedModal = (0, $bC2fB.connect)($d423adbfe8d5d6ff$var$makeMapStateToProps, null, (stateProps)=>stateProps)((0, $jtpul.default));
var $d423adbfe8d5d6ff$export$2e2bcd8739ae039 = (0, $1bQGJ.withRouter)($d423adbfe8d5d6ff$var$ConnectedModal);

});
parcelRegister("jtpul", function(module, exports) {

$parcel$export(module.exports, "default", () => $655f83b6f02718df$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $655f83b6f02718df$var$AsyncCopyDashboardModal = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("gSxsJ")), {
    ssr: false,
    moduleId: "./src/packages/global-pages/directories/dashboards-directory-v2/copy-dashboard-modal/src/index.tsx"
});
const $655f83b6f02718df$var$AsyncCopyDashboardModalContainer = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "dashboard-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($655f83b6f02718df$var$AsyncCopyDashboardModal, props));
var $655f83b6f02718df$export$2e2bcd8739ae039 = $655f83b6f02718df$var$AsyncCopyDashboardModalContainer;

});
parcelRegister("gSxsJ", function(module, exports) {

let $c49ba570a0c51648$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $c49ba570a0c51648$var$load("ffQaD"),
    $c49ba570a0c51648$var$load("kvRbA"),
    $c49ba570a0c51648$var$load("eGpN6")
]).then(()=>parcelRequire('a7HF6'));

});



parcelRegister("cHCoE", function(module, exports) {

$parcel$export(module.exports, "default", () => $505f455d41e403e8$export$2e2bcd8739ae039);

var $iDK7i = parcelRequire("iDK7i");

var $bC2fB = parcelRequire("bC2fB");
var $505f455d41e403e8$export$2e2bcd8739ae039 = (0, $bC2fB.connect)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
(state, ownProps)=>({
        id: ownProps.entityId,
        onCancel: ownProps.onCancel,
        onSuccess: ownProps.onUpdated,
        onInitiateSuccess: ownProps.onDialogShown,
        onInitiateFailed: ownProps.onDataRetrieveFailed
    }), {})((0, $iDK7i.default));

});
parcelRegister("iDK7i", function(module, exports) {

$parcel$export(module.exports, "default", () => $a69b1f2394f8a13c$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $a69b1f2394f8a13c$var$RLLAsyncDeleteDashboardModal = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("15WPf")), {
    ssr: false,
    moduleId: "./src/packages/global-pages/directories/dashboards-directory-v2/delete-dashboard-modal/src/index.tsx"
});
const $a69b1f2394f8a13c$var$RLLAsyncDeleteDashboardModalContainer = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "delete-dashboard-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a69b1f2394f8a13c$var$RLLAsyncDeleteDashboardModal, props));
var $a69b1f2394f8a13c$export$2e2bcd8739ae039 = $a69b1f2394f8a13c$var$RLLAsyncDeleteDashboardModalContainer;

});
parcelRegister("15WPf", function(module, exports) {

let $0cc3e3a00e0874cc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0cc3e3a00e0874cc$var$load("6GYm9").then(()=>parcelRequire('6ee1k'));

});



parcelRegister("bUIoU", function(module, exports) {

$parcel$export(module.exports, "default", () => $8661645678bc8d5a$export$2e2bcd8739ae039);

var $v2343 = parcelRequire("v2343");

var $bC2fB = parcelRequire("bC2fB");
const $8661645678bc8d5a$var$ConnectedModal = (0, $bC2fB.connect)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
(state, ownProps)=>({
        id: ownProps.entityId,
        onCancel: ownProps.onCancel,
        onSuccess: ownProps.onUpdated,
        onInitiateSuccess: ownProps.onDialogShown,
        onInitiateFailed: ownProps.onDataRetrieveFailed
    }), {})((0, $v2343.default));
var $8661645678bc8d5a$export$2e2bcd8739ae039 = $8661645678bc8d5a$var$ConnectedModal;

});
parcelRegister("v2343", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9ecc406e5c5c9b5$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $c9ecc406e5c5c9b5$var$AsyncEditDashboardModal = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("cdljo")), {
    ssr: false,
    moduleId: "./src/packages/global-pages/directories/dashboards-directory-v2/edit-dashboard-modal/src/index.tsx"
});
const $c9ecc406e5c5c9b5$var$AsyncEditDashboardModalContainer = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "edit-dashboard-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c9ecc406e5c5c9b5$var$AsyncEditDashboardModal, props));
var $c9ecc406e5c5c9b5$export$2e2bcd8739ae039 = $c9ecc406e5c5c9b5$var$AsyncEditDashboardModalContainer;

});
parcelRegister("cdljo", function(module, exports) {

let $8e473b061e44e00a$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $8e473b061e44e00a$var$load("ffQaD"),
    $8e473b061e44e00a$var$load("kvRbA"),
    $8e473b061e44e00a$var$load("73LVb")
]).then(()=>parcelRequire('fZpfn'));

});



parcelRegister("lvzW5", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3ecb6b20e4cb899$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c3ecb6b20e4cb899$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    name: {
        "id": "directories.dashboards-v2.main.name",
        "defaultMessage": "Name"
    },
    popularity: {
        "id": "directories.dashboards-v2.main.popularity",
        "defaultMessage": "Starred by"
    },
    owner: {
        "id": "directories.dashboards-v2.main.owner",
        "defaultMessage": "Owner"
    },
    access: {
        "id": "directories.dashboards-v2.main.access",
        "defaultMessage": "Access"
    },
    viewers: {
        "id": "directories.dashboards-v2.main.viewers",
        "defaultMessage": "Viewers"
    },
    editors: {
        "id": "directories.dashboards-v2.main.editors",
        "defaultMessage": "Editors"
    },
    emptyFilterResultMessage: {
        "id": "directories.dashboards-v2.main.empty-filter-result-message",
        "defaultMessage": "No dashboards were found that match your search"
    },
    tableAriaLabel: {
        "id": "directories.dashboards-v2.main.table-aria-label",
        "defaultMessage": "Dashboards details"
    },
    filterResultsAnnouncement: {
        "id": "directories.dashboards-v2.main.filter-results-announcement",
        "defaultMessage": "{itemCount, plural, =0 {No dashboards were found that match your search} one {{itemCount} dashboard found} other {{itemCount} dashboards found}}"
    },
    moreActions: {
        "id": "directories.dashboards-v2.main.more-actions",
        "defaultMessage": "More actions"
    },
    aToZOrder: {
        "id": "directories.dashboards-v2.main.a-to-z-order",
        "defaultMessage": "Sort A to Z"
    },
    zToAOrder: {
        "id": "directories.dashboards-v2.main.z-to-a-order",
        "defaultMessage": "Sort Z to A"
    },
    starredToUnstarredOrder: {
        "id": "directories.dashboards-v2.main.starred-to-unstarred-order",
        "defaultMessage": "Sort starred to unstarred"
    },
    unstarredToStarredOrder: {
        "id": "directories.dashboards-v2.main.unstarred-to-starred-order",
        "defaultMessage": "Sort unstarred to starred"
    },
    lowestToHighestOrder: {
        "id": "directories.dashboards-v2.main.lowest-to-highest-order",
        "defaultMessage": "Sort lowest to highest"
    },
    highestToLowestOrder: {
        "id": "directories.dashboards-v2.main.highest-to-lowest-order",
        "defaultMessage": "Sort highest to lowest"
    }
});

});




parcelRegister("dldm2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab9feaddf91858f9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cS37j = parcelRequire("cS37j");

var $id7K0 = parcelRequire("id7K0");

var $9S9Jv = parcelRequire("9S9Jv");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ab9feaddf91858f9$export$2e2bcd8739ae039 = (props)=>{
    const { CreateButton: CreateButton, DashboardsDirectory: DashboardsDirectory, intl: { formatMessage: formatMessage }, ...directoryProps } = props;
    const actions = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CreateButton, {
        baseUrl: props.baseUrl
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $id7K0.DocumentTitle), {
        title: formatMessage((0, $9S9Jv.default).pageTitle)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cS37j.default), {
        truncateTitle: true,
        actions: actions
    }, formatMessage((0, $9S9Jv.default).pageTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DashboardsDirectory, directoryProps));
};

});
parcelRegister("id7K0", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $938046587fdeeb52$export$dd5ad0b65cf665da);

var $5uXOq = parcelRequire("5uXOq");

var $cSD7y = parcelRequire("cSD7y");

var $4CAXd = parcelRequire("4CAXd");
// eslint-disable-next-line jira/react/no-class-components
class $938046587fdeeb52$var$DocumentTitleOld extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $4CAXd.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber = (0, $4CAXd.DocumentTitleSubscriber) } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CAXd.DocumentTitleHelperOld), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}
const $938046587fdeeb52$export$dd5ad0b65cf665da = (0, $cSD7y.componentWithFG)('jira-concurrent-document-title', (0, $4CAXd.DocumentTitleHelper), $938046587fdeeb52$var$DocumentTitleOld);

});

parcelRegister("9S9Jv", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b7fc572562cdfb7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6b7fc572562cdfb7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    pageTitle: {
        "id": "directories.dashboards-v2.page.page-title",
        "defaultMessage": "Dashboards"
    }
});

});



parcelRegister("5rqex", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $ab527e70454bab7e$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $ab527e70454bab7e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $ab527e70454bab7e$export$9b3029ee6188a41f);

var $5uXOq = parcelRequire("5uXOq");

var $99gkn = parcelRequire("99gkn");

var $aOr3t = parcelRequire("aOr3t");

var $1u4q7 = parcelRequire("1u4q7");

var $1AZST = parcelRequire("1AZST");

var $6G6w0 = parcelRequire("6G6w0");

var $3wLoG = parcelRequire("3wLoG");

var $gtdbK = parcelRequire("gtdbK");

var $zbAs4 = parcelRequire("zbAs4");

var $3B7oW = parcelRequire("3B7oW");
const $ab527e70454bab7e$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $ab527e70454bab7e$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        $ab527e70454bab7e$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $1AZST.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $zbAs4.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $gtdbK.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $3B7oW.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $99gkn.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aOr3t.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3wLoG.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $1u4q7.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6G6w0.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame
        }));
    }
}
const $ab527e70454bab7e$export$9b3029ee6188a41f = $ab527e70454bab7e$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("aOr3t", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $a3e67858f0c2f8da$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $a3e67858f0c2f8da$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $a3e67858f0c2f8da$export$d93d677ef2f33c5c);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");
function $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $a3e67858f0c2f8da$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $5uXOq.useContext)((0, $1tcYS.default));
    const interactionId = (0, $1u4q7.getInteractionId)().current;
    (0, $5uXOq.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $bFU4G.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $a3e67858f0c2f8da$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $1u4q7.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $bFU4G.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingsConfig);
        (0, $bFU4G.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("6G6w0", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $84d0d168ebb35c8a$export$575e93c0f9905999);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $21pfT = parcelRequire("21pfT");

var $x9xyg = parcelRequire("x9xyg");

var $7N30e = parcelRequire("7N30e");

var $4dRjY = parcelRequire("4dRjY");

var $2SVPM = parcelRequire("2SVPM");

var $6b6Tk = parcelRequire("6b6Tk");

const $84d0d168ebb35c8a$var$emitMetrics = (metric, customData, stopTime)=>{
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) metric.stop({
        customData: customData,
        stopTime: stopTime
    });
    else metric.stop({
        customData: customData
    });
    if ((0, $6b6Tk.isAutomaticExposureCollectionEnabled)()) (0, $7N30e.stopLowPriorityEventDelay)();
};
class $84d0d168ebb35c8a$export$575e93c0f9905999 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $21pfT.browserMetrics).getPageLoadMetric()?.getData()?.start || 0;
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_END');
        (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, $x9xyg.setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
                setTimeout(()=>{
                    $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                }, 500);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            $84d0d168ebb35c8a$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $1tcYS.default);
    }
    render() {
        return null;
    }
}

});
const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("3wLoG", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $bc9c50f4292c4530$export$d91154f099475c5);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $1AZST = parcelRequire("1AZST");
class $bc9c50f4292c4530$export$d91154f099475c5 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $1AZST.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $1AZST.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $1tcYS.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("gtdbK", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $9088c71f7c9189f4$export$bf239ac2bfb04967);

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");
function $9088c71f7c9189f4$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $bFU4G.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("zbAs4", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $30d390cd1767d57f$export$e63862cd888fe05a);

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");

var $1AZST = parcelRequire("1AZST");
var $49z18 = parcelRequire("49z18");
async function $30d390cd1767d57f$export$e63862cd888fe05a() {
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $1AZST.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $49z18.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $bFU4G.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("3B7oW", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $afa764d83f81f55e$export$f00f1e874ce869e9);

var $1u4q7 = parcelRequire("1u4q7");

var $y7eb2 = parcelRequire("y7eb2");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $afa764d83f81f55e$export$7b4abba432e57989 = (value)=>$afa764d83f81f55e$var$isString(value) && $afa764d83f81f55e$var$startsAsObject(value) || $afa764d83f81f55e$var$isObject(value);
const $afa764d83f81f55e$export$fcc03ee4c944962f = (featureFlagValue)=>$afa764d83f81f55e$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $afa764d83f81f55e$export$d2818866b4acbea4 = new Map();
const $afa764d83f81f55e$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $y7eb2.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $afa764d83f81f55e$export$fcc03ee4c944962f(value);
            $afa764d83f81f55e$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});


parcelRegister("fhVq7", function(module, exports) {

$parcel$export(module.exports, "ScrollablePage", () => $501f0ba909d41168$export$8d7a30196b47fe34);
$parcel$export(module.exports, "PageLayout", () => $501f0ba909d41168$export$6d1402fb58384e4f);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $dCm1o = parcelRequire("dCm1o");
const $501f0ba909d41168$export$8d7a30196b47fe34 = ({ children: children, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        testId: rest['data-testid'] || 'spa-apps-page-layout.page.scrollable-page',
        xcss: $501f0ba909d41168$var$scrollablePageStyles,
        paddingBlock: "space.0",
        paddingInline: (0, $dCm1o.isVisualRefreshEnabled)() ? 'space.300' : 'space.500'
    }, children);
const $501f0ba909d41168$export$6d1402fb58384e4f = ({ children: children, hideMargin: hideMargin, ...rest })=>{
    const isVisualRefresh = (0, $dCm1o.isVisualRefreshEnabled)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        testId: rest['data-testid'] || 'spa-apps-page-layout.page.page-layout',
        xcss: // eslint-disable-next-line no-nested-ternary
        hideMargin ? $501f0ba909d41168$var$pageLayoutWithoutMarginStyles : isVisualRefresh ? $501f0ba909d41168$var$pageLayoutWithMarginStyles : $501f0ba909d41168$var$pageLayoutWithMarginStylesOld
    }, children);
};
const $501f0ba909d41168$var$scrollablePageStyles = (0, $8CUq3.xcss)({
    minWidth: '800px',
    margin: 'space.0'
});
const $501f0ba909d41168$var$pageLayoutWithoutMarginStyles = (0, $8CUq3.xcss)({
    margin: 'space.0'
});
const $501f0ba909d41168$var$pageLayoutWithMarginStylesOld = (0, $8CUq3.xcss)({
    marginBlock: '0',
    marginInline: 'space.500'
});
const $501f0ba909d41168$var$pageLayoutWithMarginStyles = (0, $8CUq3.xcss)({
    marginBlock: '0',
    marginInline: 'space.300'
});

});

parcelRegister("dPVaE", function(module, exports) {

$parcel$export(module.exports, "dashboardsDirectoryPageLoad", () => $bff273b52fc204f1$export$91799dd22df54613);

var $dGrdR = parcelRequire("dGrdR");
const $bff273b52fc204f1$export$91799dd22df54613 = (0, $dGrdR.metrics).pageLoad({
    key: 'dashboards-directory',
    ssr: {
        doneAsFmp: true
    }
});

});





//# sourceMappingURL=async-dashboards-directory.f8aae0cd.js.map
